[
  {
    "centil": 1,
    "numero_total": 28564,
    "sme_total": 14061,
    "numero_home": 13438,
    "sme_home": 14061,
    "numero_dona": 15126,
    "sme_dona": 14062,
    "maxim": 14139,
    "percent_asalariat": 1.3,
    "percent_salari": 0.69,
    "comunitat": "andalusia"
  },
  {
    "centil": 2,
    "numero_total": 30008,
    "sme_total": 14219,
    "numero_home": 14182,
    "sme_home": 14219,
    "numero_dona": 15826,
    "sme_dona": 14219,
    "maxim": 14300,
    "percent_asalariat": 2.7,
    "percent_salari": 1.42,
    "comunitat": "andalusia"
  },
  {
    "centil": 3,
    "numero_total": 29085,
    "sme_total": 14379,
    "numero_home": 13895,
    "sme_home": 14380,
    "numero_dona": 15190,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 4,
    "percent_salari": 2.13,
    "comunitat": "andalusia"
  },
  {
    "centil": 4,
    "numero_total": 29902,
    "sme_total": 14537,
    "numero_home": 14058,
    "sme_home": 14537,
    "numero_dona": 15844,
    "sme_dona": 14537,
    "maxim": 14618,
    "percent_asalariat": 5.3,
    "percent_salari": 2.88,
    "comunitat": "andalusia"
  },
  {
    "centil": 5,
    "numero_total": 29132,
    "sme_total": 14697,
    "numero_home": 13775,
    "sme_home": 14697,
    "numero_dona": 15357,
    "sme_dona": 14697,
    "maxim": 14776,
    "percent_asalariat": 6.7,
    "percent_salari": 3.61,
    "comunitat": "andalusia"
  },
  {
    "centil": 6,
    "numero_total": 28137,
    "sme_total": 14856,
    "numero_home": 13424,
    "sme_home": 14856,
    "numero_dona": 14713,
    "sme_dona": 14856,
    "maxim": 14934,
    "percent_asalariat": 7.9,
    "percent_salari": 4.33,
    "comunitat": "andalusia"
  },
  {
    "centil": 7,
    "numero_total": 28283,
    "sme_total": 15012,
    "numero_home": 13778,
    "sme_home": 15013,
    "numero_dona": 14505,
    "sme_dona": 15012,
    "maxim": 15091,
    "percent_asalariat": 9.2,
    "percent_salari": 5.06,
    "comunitat": "andalusia"
  },
  {
    "centil": 8,
    "numero_total": 27712,
    "sme_total": 15170,
    "numero_home": 13592,
    "sme_home": 15170,
    "numero_dona": 14120,
    "sme_dona": 15170,
    "maxim": 15248,
    "percent_asalariat": 10.5,
    "percent_salari": 5.78,
    "comunitat": "andalusia"
  },
  {
    "centil": 9,
    "numero_total": 28118,
    "sme_total": 15328,
    "numero_home": 13921,
    "sme_home": 15328,
    "numero_dona": 14197,
    "sme_dona": 15329,
    "maxim": 15407,
    "percent_asalariat": 11.7,
    "percent_salari": 6.51,
    "comunitat": "andalusia"
  },
  {
    "centil": 10,
    "numero_total": 27531,
    "sme_total": 15487,
    "numero_home": 13840,
    "sme_home": 15486,
    "numero_dona": 13691,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 13,
    "percent_salari": 7.24,
    "comunitat": "andalusia"
  },
  {
    "centil": 11,
    "numero_total": 27730,
    "sme_total": 15646,
    "numero_home": 13865,
    "sme_home": 15646,
    "numero_dona": 13865,
    "sme_dona": 15646,
    "maxim": 15726,
    "percent_asalariat": 14.3,
    "percent_salari": 7.99,
    "comunitat": "andalusia"
  },
  {
    "centil": 12,
    "numero_total": 26899,
    "sme_total": 15806,
    "numero_home": 13699,
    "sme_home": 15806,
    "numero_dona": 13200,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 15.5,
    "percent_salari": 8.71,
    "comunitat": "andalusia"
  },
  {
    "centil": 13,
    "numero_total": 26465,
    "sme_total": 15966,
    "numero_home": 13889,
    "sme_home": 15966,
    "numero_dona": 12576,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 16.7,
    "percent_salari": 9.44,
    "comunitat": "andalusia"
  },
  {
    "centil": 14,
    "numero_total": 26169,
    "sme_total": 16126,
    "numero_home": 13938,
    "sme_home": 16126,
    "numero_dona": 12231,
    "sme_dona": 16126,
    "maxim": 16207,
    "percent_asalariat": 17.9,
    "percent_salari": 10.16,
    "comunitat": "andalusia"
  },
  {
    "centil": 15,
    "numero_total": 26285,
    "sme_total": 16289,
    "numero_home": 13940,
    "sme_home": 16289,
    "numero_dona": 12345,
    "sme_dona": 16290,
    "maxim": 16371,
    "percent_asalariat": 19.1,
    "percent_salari": 10.89,
    "comunitat": "andalusia"
  },
  {
    "centil": 16,
    "numero_total": 26118,
    "sme_total": 16452,
    "numero_home": 14072,
    "sme_home": 16452,
    "numero_dona": 12046,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 20.2,
    "percent_salari": 11.63,
    "comunitat": "andalusia"
  },
  {
    "centil": 17,
    "numero_total": 26261,
    "sme_total": 16611,
    "numero_home": 14376,
    "sme_home": 16611,
    "numero_dona": 11885,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 21.4,
    "percent_salari": 12.38,
    "comunitat": "andalusia"
  },
  {
    "centil": 18,
    "numero_total": 26815,
    "sme_total": 16774,
    "numero_home": 14787,
    "sme_home": 16774,
    "numero_dona": 12028,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 22.6,
    "percent_salari": 13.15,
    "comunitat": "andalusia"
  },
  {
    "centil": 19,
    "numero_total": 26032,
    "sme_total": 16939,
    "numero_home": 14507,
    "sme_home": 16940,
    "numero_dona": 11525,
    "sme_dona": 16939,
    "maxim": 17023,
    "percent_asalariat": 23.8,
    "percent_salari": 13.9,
    "comunitat": "andalusia"
  },
  {
    "centil": 20,
    "numero_total": 25949,
    "sme_total": 17109,
    "numero_home": 14825,
    "sme_home": 17109,
    "numero_dona": 11124,
    "sme_dona": 17109,
    "maxim": 17196,
    "percent_asalariat": 25,
    "percent_salari": 14.66,
    "comunitat": "andalusia"
  },
  {
    "centil": 21,
    "numero_total": 25947,
    "sme_total": 17281,
    "numero_home": 14891,
    "sme_home": 17281,
    "numero_dona": 11056,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 26.2,
    "percent_salari": 15.43,
    "comunitat": "andalusia"
  },
  {
    "centil": 22,
    "numero_total": 25104,
    "sme_total": 17456,
    "numero_home": 14505,
    "sme_home": 17456,
    "numero_dona": 10599,
    "sme_dona": 17456,
    "maxim": 17543,
    "percent_asalariat": 27.3,
    "percent_salari": 16.18,
    "comunitat": "andalusia"
  },
  {
    "centil": 23,
    "numero_total": 24686,
    "sme_total": 17630,
    "numero_home": 14459,
    "sme_home": 17630,
    "numero_dona": 10227,
    "sme_dona": 17630,
    "maxim": 17718,
    "percent_asalariat": 28.4,
    "percent_salari": 16.93,
    "comunitat": "andalusia"
  },
  {
    "centil": 24,
    "numero_total": 24757,
    "sme_total": 17804,
    "numero_home": 13985,
    "sme_home": 17805,
    "numero_dona": 10772,
    "sme_dona": 17802,
    "maxim": 17891,
    "percent_asalariat": 29.6,
    "percent_salari": 17.68,
    "comunitat": "andalusia"
  },
  {
    "centil": 25,
    "numero_total": 24245,
    "sme_total": 17976,
    "numero_home": 14295,
    "sme_home": 17977,
    "numero_dona": 9950,
    "sme_dona": 17975,
    "maxim": 18060,
    "percent_asalariat": 30.7,
    "percent_salari": 18.43,
    "comunitat": "andalusia"
  },
  {
    "centil": 26,
    "numero_total": 24869,
    "sme_total": 18149,
    "numero_home": 14784,
    "sme_home": 18149,
    "numero_dona": 10085,
    "sme_dona": 18148,
    "maxim": 18239,
    "percent_asalariat": 31.8,
    "percent_salari": 19.2,
    "comunitat": "andalusia"
  },
  {
    "centil": 27,
    "numero_total": 24845,
    "sme_total": 18328,
    "numero_home": 15225,
    "sme_home": 18329,
    "numero_dona": 9620,
    "sme_dona": 18326,
    "maxim": 18417,
    "percent_asalariat": 32.9,
    "percent_salari": 19.98,
    "comunitat": "andalusia"
  },
  {
    "centil": 28,
    "numero_total": 24572,
    "sme_total": 18506,
    "numero_home": 15091,
    "sme_home": 18507,
    "numero_dona": 9481,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 34,
    "percent_salari": 20.76,
    "comunitat": "andalusia"
  },
  {
    "centil": 29,
    "numero_total": 23872,
    "sme_total": 18687,
    "numero_home": 14800,
    "sme_home": 18686,
    "numero_dona": 9072,
    "sme_dona": 18687,
    "maxim": 18778,
    "percent_asalariat": 35.1,
    "percent_salari": 21.52,
    "comunitat": "andalusia"
  },
  {
    "centil": 30,
    "numero_total": 23548,
    "sme_total": 18866,
    "numero_home": 14864,
    "sme_home": 18866,
    "numero_dona": 8684,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 36.2,
    "percent_salari": 22.28,
    "comunitat": "andalusia"
  },
  {
    "centil": 31,
    "numero_total": 23015,
    "sme_total": 19043,
    "numero_home": 14651,
    "sme_home": 19043,
    "numero_dona": 8364,
    "sme_dona": 19043,
    "maxim": 19133,
    "percent_asalariat": 37.2,
    "percent_salari": 23.03,
    "comunitat": "andalusia"
  },
  {
    "centil": 32,
    "numero_total": 23822,
    "sme_total": 19224,
    "numero_home": 15272,
    "sme_home": 19224,
    "numero_dona": 8550,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 38.3,
    "percent_salari": 23.82,
    "comunitat": "andalusia"
  },
  {
    "centil": 33,
    "numero_total": 23509,
    "sme_total": 19411,
    "numero_home": 15276,
    "sme_home": 19410,
    "numero_dona": 8233,
    "sme_dona": 19412,
    "maxim": 19503,
    "percent_asalariat": 39.4,
    "percent_salari": 24.6,
    "comunitat": "andalusia"
  },
  {
    "centil": 34,
    "numero_total": 22951,
    "sme_total": 19598,
    "numero_home": 15069,
    "sme_home": 19598,
    "numero_dona": 7882,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 40.4,
    "percent_salari": 25.37,
    "comunitat": "andalusia"
  },
  {
    "centil": 35,
    "numero_total": 23322,
    "sme_total": 19785,
    "numero_home": 15266,
    "sme_home": 19785,
    "numero_dona": 8056,
    "sme_dona": 19784,
    "maxim": 19879,
    "percent_asalariat": 41.5,
    "percent_salari": 26.16,
    "comunitat": "andalusia"
  },
  {
    "centil": 36,
    "numero_total": 23223,
    "sme_total": 19974,
    "numero_home": 15487,
    "sme_home": 19975,
    "numero_dona": 7736,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 42.5,
    "percent_salari": 26.95,
    "comunitat": "andalusia"
  },
  {
    "centil": 37,
    "numero_total": 22915,
    "sme_total": 20165,
    "numero_home": 15461,
    "sme_home": 20166,
    "numero_dona": 7454,
    "sme_dona": 20165,
    "maxim": 20263,
    "percent_asalariat": 43.6,
    "percent_salari": 27.75,
    "comunitat": "andalusia"
  },
  {
    "centil": 38,
    "numero_total": 23964,
    "sme_total": 20361,
    "numero_home": 16537,
    "sme_home": 20361,
    "numero_dona": 7427,
    "sme_dona": 20360,
    "maxim": 20459,
    "percent_asalariat": 44.7,
    "percent_salari": 28.58,
    "comunitat": "andalusia"
  },
  {
    "centil": 39,
    "numero_total": 23577,
    "sme_total": 20557,
    "numero_home": 16374,
    "sme_home": 20557,
    "numero_dona": 7203,
    "sme_dona": 20557,
    "maxim": 20653,
    "percent_asalariat": 45.7,
    "percent_salari": 29.41,
    "comunitat": "andalusia"
  },
  {
    "centil": 40,
    "numero_total": 24214,
    "sme_total": 20753,
    "numero_home": 16636,
    "sme_home": 20754,
    "numero_dona": 7578,
    "sme_dona": 20751,
    "maxim": 20854,
    "percent_asalariat": 46.8,
    "percent_salari": 30.27,
    "comunitat": "andalusia"
  },
  {
    "centil": 41,
    "numero_total": 24189,
    "sme_total": 20955,
    "numero_home": 16917,
    "sme_home": 20955,
    "numero_dona": 7272,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 47.9,
    "percent_salari": 31.14,
    "comunitat": "andalusia"
  },
  {
    "centil": 42,
    "numero_total": 24295,
    "sme_total": 21160,
    "numero_home": 16886,
    "sme_home": 21160,
    "numero_dona": 7409,
    "sme_dona": 21161,
    "maxim": 21267,
    "percent_asalariat": 49,
    "percent_salari": 32.02,
    "comunitat": "andalusia"
  },
  {
    "centil": 43,
    "numero_total": 23103,
    "sme_total": 21375,
    "numero_home": 15722,
    "sme_home": 21374,
    "numero_dona": 7381,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 50.1,
    "percent_salari": 32.87,
    "comunitat": "andalusia"
  },
  {
    "centil": 44,
    "numero_total": 23226,
    "sme_total": 21591,
    "numero_home": 15678,
    "sme_home": 21591,
    "numero_dona": 7548,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 51.1,
    "percent_salari": 33.72,
    "comunitat": "andalusia"
  },
  {
    "centil": 45,
    "numero_total": 22972,
    "sme_total": 21814,
    "numero_home": 15403,
    "sme_home": 21813,
    "numero_dona": 7569,
    "sme_dona": 21815,
    "maxim": 21927,
    "percent_asalariat": 52.2,
    "percent_salari": 34.58,
    "comunitat": "andalusia"
  },
  {
    "centil": 46,
    "numero_total": 22202,
    "sme_total": 22038,
    "numero_home": 14826,
    "sme_home": 22038,
    "numero_dona": 7376,
    "sme_dona": 22038,
    "maxim": 22151,
    "percent_asalariat": 53.2,
    "percent_salari": 35.42,
    "comunitat": "andalusia"
  },
  {
    "centil": 47,
    "numero_total": 22390,
    "sme_total": 22264,
    "numero_home": 14992,
    "sme_home": 22264,
    "numero_dona": 7398,
    "sme_dona": 22265,
    "maxim": 22380,
    "percent_asalariat": 54.2,
    "percent_salari": 36.27,
    "comunitat": "andalusia"
  },
  {
    "centil": 48,
    "numero_total": 22454,
    "sme_total": 22498,
    "numero_home": 14894,
    "sme_home": 22497,
    "numero_dona": 7560,
    "sme_dona": 22501,
    "maxim": 22616,
    "percent_asalariat": 55.2,
    "percent_salari": 37.14,
    "comunitat": "andalusia"
  },
  {
    "centil": 49,
    "numero_total": 22398,
    "sme_total": 22740,
    "numero_home": 14706,
    "sme_home": 22739,
    "numero_dona": 7692,
    "sme_dona": 22741,
    "maxim": 22865,
    "percent_asalariat": 56.2,
    "percent_salari": 38.01,
    "comunitat": "andalusia"
  },
  {
    "centil": 50,
    "numero_total": 21696,
    "sme_total": 22989,
    "numero_home": 14168,
    "sme_home": 22989,
    "numero_dona": 7528,
    "sme_dona": 22989,
    "maxim": 23114,
    "percent_asalariat": 57.2,
    "percent_salari": 38.87,
    "comunitat": "andalusia"
  },
  {
    "centil": 51,
    "numero_total": 22039,
    "sme_total": 23245,
    "numero_home": 14109,
    "sme_home": 23245,
    "numero_dona": 7930,
    "sme_dona": 23246,
    "maxim": 23377,
    "percent_asalariat": 58.2,
    "percent_salari": 39.74,
    "comunitat": "andalusia"
  },
  {
    "centil": 52,
    "numero_total": 21312,
    "sme_total": 23510,
    "numero_home": 13631,
    "sme_home": 23509,
    "numero_dona": 7681,
    "sme_dona": 23511,
    "maxim": 23645,
    "percent_asalariat": 59.2,
    "percent_salari": 40.6,
    "comunitat": "andalusia"
  },
  {
    "centil": 53,
    "numero_total": 20617,
    "sme_total": 23784,
    "numero_home": 12969,
    "sme_home": 23783,
    "numero_dona": 7648,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 60.1,
    "percent_salari": 41.44,
    "comunitat": "andalusia"
  },
  {
    "centil": 54,
    "numero_total": 19857,
    "sme_total": 24058,
    "numero_home": 12534,
    "sme_home": 24057,
    "numero_dona": 7323,
    "sme_dona": 24058,
    "maxim": 24198,
    "percent_asalariat": 61,
    "percent_salari": 42.26,
    "comunitat": "andalusia"
  },
  {
    "centil": 55,
    "numero_total": 20197,
    "sme_total": 24348,
    "numero_home": 12563,
    "sme_home": 24348,
    "numero_dona": 7634,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 61.9,
    "percent_salari": 43.1,
    "comunitat": "andalusia"
  },
  {
    "centil": 56,
    "numero_total": 19764,
    "sme_total": 24654,
    "numero_home": 12381,
    "sme_home": 24654,
    "numero_dona": 7383,
    "sme_dona": 24654,
    "maxim": 24811,
    "percent_asalariat": 62.8,
    "percent_salari": 43.93,
    "comunitat": "andalusia"
  },
  {
    "centil": 57,
    "numero_total": 20061,
    "sme_total": 24967,
    "numero_home": 12296,
    "sme_home": 24967,
    "numero_dona": 7765,
    "sme_dona": 24968,
    "maxim": 25122,
    "percent_asalariat": 63.7,
    "percent_salari": 44.79,
    "comunitat": "andalusia"
  },
  {
    "centil": 58,
    "numero_total": 20746,
    "sme_total": 25284,
    "numero_home": 12320,
    "sme_home": 25282,
    "numero_dona": 8426,
    "sme_dona": 25286,
    "maxim": 25450,
    "percent_asalariat": 64.7,
    "percent_salari": 45.69,
    "comunitat": "andalusia"
  },
  {
    "centil": 59,
    "numero_total": 19937,
    "sme_total": 25620,
    "numero_home": 11786,
    "sme_home": 25620,
    "numero_dona": 8151,
    "sme_dona": 25619,
    "maxim": 25792,
    "percent_asalariat": 65.6,
    "percent_salari": 46.57,
    "comunitat": "andalusia"
  },
  {
    "centil": 60,
    "numero_total": 20126,
    "sme_total": 25963,
    "numero_home": 12185,
    "sme_home": 25963,
    "numero_dona": 7941,
    "sme_dona": 25963,
    "maxim": 26139,
    "percent_asalariat": 66.5,
    "percent_salari": 47.46,
    "comunitat": "andalusia"
  },
  {
    "centil": 61,
    "numero_total": 19168,
    "sme_total": 26322,
    "numero_home": 11433,
    "sme_home": 26323,
    "numero_dona": 7735,
    "sme_dona": 26322,
    "maxim": 26509,
    "percent_asalariat": 67.4,
    "percent_salari": 48.32,
    "comunitat": "andalusia"
  },
  {
    "centil": 62,
    "numero_total": 20490,
    "sme_total": 26705,
    "numero_home": 12129,
    "sme_home": 26704,
    "numero_dona": 8361,
    "sme_dona": 26707,
    "maxim": 26874,
    "percent_asalariat": 68.3,
    "percent_salari": 49.26,
    "comunitat": "andalusia"
  },
  {
    "centil": 63,
    "numero_total": 20453,
    "sme_total": 27038,
    "numero_home": 12031,
    "sme_home": 27039,
    "numero_dona": 8422,
    "sme_dona": 27038,
    "maxim": 27221,
    "percent_asalariat": 69.2,
    "percent_salari": 50.21,
    "comunitat": "andalusia"
  },
  {
    "centil": 64,
    "numero_total": 18943,
    "sme_total": 27416,
    "numero_home": 11312,
    "sme_home": 27415,
    "numero_dona": 7631,
    "sme_dona": 27416,
    "maxim": 27616,
    "percent_asalariat": 70.1,
    "percent_salari": 51.1,
    "comunitat": "andalusia"
  },
  {
    "centil": 65,
    "numero_total": 18780,
    "sme_total": 27822,
    "numero_home": 11133,
    "sme_home": 27824,
    "numero_dona": 7647,
    "sme_dona": 27820,
    "maxim": 28031,
    "percent_asalariat": 70.9,
    "percent_salari": 51.99,
    "comunitat": "andalusia"
  },
  {
    "centil": 66,
    "numero_total": 19012,
    "sme_total": 28248,
    "numero_home": 11124,
    "sme_home": 28248,
    "numero_dona": 7888,
    "sme_dona": 28249,
    "maxim": 28476,
    "percent_asalariat": 71.8,
    "percent_salari": 52.91,
    "comunitat": "andalusia"
  },
  {
    "centil": 67,
    "numero_total": 18954,
    "sme_total": 28711,
    "numero_home": 11329,
    "sme_home": 28711,
    "numero_dona": 7625,
    "sme_dona": 28711,
    "maxim": 28951,
    "percent_asalariat": 72.6,
    "percent_salari": 53.84,
    "comunitat": "andalusia"
  },
  {
    "centil": 68,
    "numero_total": 18410,
    "sme_total": 29199,
    "numero_home": 11020,
    "sme_home": 29198,
    "numero_dona": 7390,
    "sme_dona": 29200,
    "maxim": 29450,
    "percent_asalariat": 73.5,
    "percent_salari": 54.76,
    "comunitat": "andalusia"
  },
  {
    "centil": 69,
    "numero_total": 18255,
    "sme_total": 29707,
    "numero_home": 10933,
    "sme_home": 29704,
    "numero_dona": 7322,
    "sme_dona": 29710,
    "maxim": 29970,
    "percent_asalariat": 74.3,
    "percent_salari": 55.69,
    "comunitat": "andalusia"
  },
  {
    "centil": 70,
    "numero_total": 18621,
    "sme_total": 30219,
    "numero_home": 10941,
    "sme_home": 30219,
    "numero_dona": 7680,
    "sme_dona": 30218,
    "maxim": 30487,
    "percent_asalariat": 75.2,
    "percent_salari": 56.66,
    "comunitat": "andalusia"
  },
  {
    "centil": 71,
    "numero_total": 19239,
    "sme_total": 30765,
    "numero_home": 10879,
    "sme_home": 30763,
    "numero_dona": 8360,
    "sme_dona": 30767,
    "maxim": 31037,
    "percent_asalariat": 76,
    "percent_salari": 57.67,
    "comunitat": "andalusia"
  },
  {
    "centil": 72,
    "numero_total": 19582,
    "sme_total": 31316,
    "numero_home": 11185,
    "sme_home": 31318,
    "numero_dona": 8397,
    "sme_dona": 31313,
    "maxim": 31602,
    "percent_asalariat": 76.9,
    "percent_salari": 58.72,
    "comunitat": "andalusia"
  },
  {
    "centil": 73,
    "numero_total": 19585,
    "sme_total": 31884,
    "numero_home": 10828,
    "sme_home": 31882,
    "numero_dona": 8757,
    "sme_dona": 31886,
    "maxim": 32176,
    "percent_asalariat": 77.8,
    "percent_salari": 59.79,
    "comunitat": "andalusia"
  },
  {
    "centil": 74,
    "numero_total": 18964,
    "sme_total": 32469,
    "numero_home": 10433,
    "sme_home": 32473,
    "numero_dona": 8531,
    "sme_dona": 32464,
    "maxim": 32786,
    "percent_asalariat": 78.7,
    "percent_salari": 60.84,
    "comunitat": "andalusia"
  },
  {
    "centil": 75,
    "numero_total": 18303,
    "sme_total": 33092,
    "numero_home": 10293,
    "sme_home": 33094,
    "numero_dona": 8010,
    "sme_dona": 33091,
    "maxim": 33413,
    "percent_asalariat": 79.5,
    "percent_salari": 61.88,
    "comunitat": "andalusia"
  },
  {
    "centil": 76,
    "numero_total": 21232,
    "sme_total": 33733,
    "numero_home": 10991,
    "sme_home": 33734,
    "numero_dona": 10241,
    "sme_dona": 33731,
    "maxim": 34056,
    "percent_asalariat": 80.5,
    "percent_salari": 63.11,
    "comunitat": "andalusia"
  },
  {
    "centil": 77,
    "numero_total": 22188,
    "sme_total": 34380,
    "numero_home": 11005,
    "sme_home": 34384,
    "numero_dona": 11183,
    "sme_dona": 34375,
    "maxim": 34722,
    "percent_asalariat": 81.5,
    "percent_salari": 64.41,
    "comunitat": "andalusia"
  },
  {
    "centil": 78,
    "numero_total": 20742,
    "sme_total": 35057,
    "numero_home": 11326,
    "sme_home": 35058,
    "numero_dona": 9416,
    "sme_dona": 35056,
    "maxim": 35374,
    "percent_asalariat": 82.4,
    "percent_salari": 65.66,
    "comunitat": "andalusia"
  },
  {
    "centil": 79,
    "numero_total": 22441,
    "sme_total": 35708,
    "numero_home": 11906,
    "sme_home": 35704,
    "numero_dona": 10535,
    "sme_dona": 35712,
    "maxim": 36027,
    "percent_asalariat": 83.4,
    "percent_salari": 67.03,
    "comunitat": "andalusia"
  },
  {
    "centil": 80,
    "numero_total": 21850,
    "sme_total": 36347,
    "numero_home": 11403,
    "sme_home": 36360,
    "numero_dona": 10447,
    "sme_dona": 36332,
    "maxim": 36730,
    "percent_asalariat": 84.4,
    "percent_salari": 68.39,
    "comunitat": "andalusia"
  },
  {
    "centil": 81,
    "numero_total": 18864,
    "sme_total": 37111,
    "numero_home": 10483,
    "sme_home": 37109,
    "numero_dona": 8381,
    "sme_dona": 37115,
    "maxim": 37490,
    "percent_asalariat": 85.3,
    "percent_salari": 69.59,
    "comunitat": "andalusia"
  },
  {
    "centil": 82,
    "numero_total": 20106,
    "sme_total": 37897,
    "numero_home": 10995,
    "sme_home": 37897,
    "numero_dona": 9111,
    "sme_dona": 37898,
    "maxim": 38304,
    "percent_asalariat": 86.2,
    "percent_salari": 70.9,
    "comunitat": "andalusia"
  },
  {
    "centil": 83,
    "numero_total": 19221,
    "sme_total": 38734,
    "numero_home": 10590,
    "sme_home": 38741,
    "numero_dona": 8631,
    "sme_dona": 38725,
    "maxim": 39197,
    "percent_asalariat": 87.1,
    "percent_salari": 72.17,
    "comunitat": "andalusia"
  },
  {
    "centil": 84,
    "numero_total": 18460,
    "sme_total": 39674,
    "numero_home": 10586,
    "sme_home": 39676,
    "numero_dona": 7874,
    "sme_dona": 39671,
    "maxim": 40137,
    "percent_asalariat": 87.9,
    "percent_salari": 73.42,
    "comunitat": "andalusia"
  },
  {
    "centil": 85,
    "numero_total": 18518,
    "sme_total": 40635,
    "numero_home": 10662,
    "sme_home": 40642,
    "numero_dona": 7856,
    "sme_dona": 40627,
    "maxim": 41170,
    "percent_asalariat": 88.7,
    "percent_salari": 74.71,
    "comunitat": "andalusia"
  },
  {
    "centil": 86,
    "numero_total": 17800,
    "sme_total": 41744,
    "numero_home": 10439,
    "sme_home": 41742,
    "numero_dona": 7361,
    "sme_dona": 41745,
    "maxim": 42306,
    "percent_asalariat": 89.5,
    "percent_salari": 75.99,
    "comunitat": "andalusia"
  },
  {
    "centil": 87,
    "numero_total": 17853,
    "sme_total": 42911,
    "numero_home": 10327,
    "sme_home": 42912,
    "numero_dona": 7526,
    "sme_dona": 42909,
    "maxim": 43519,
    "percent_asalariat": 90.3,
    "percent_salari": 77.3,
    "comunitat": "andalusia"
  },
  {
    "centil": 88,
    "numero_total": 17621,
    "sme_total": 44173,
    "numero_home": 10584,
    "sme_home": 44173,
    "numero_dona": 7037,
    "sme_dona": 44172,
    "maxim": 44857,
    "percent_asalariat": 91.1,
    "percent_salari": 78.63,
    "comunitat": "andalusia"
  },
  {
    "centil": 89,
    "numero_total": 17345,
    "sme_total": 45574,
    "numero_home": 10683,
    "sme_home": 45578,
    "numero_dona": 6662,
    "sme_dona": 45568,
    "maxim": 46326,
    "percent_asalariat": 91.9,
    "percent_salari": 79.98,
    "comunitat": "andalusia"
  },
  {
    "centil": 90,
    "numero_total": 17537,
    "sme_total": 47153,
    "numero_home": 10797,
    "sme_home": 47149,
    "numero_dona": 6740,
    "sme_dona": 47158,
    "maxim": 48005,
    "percent_asalariat": 92.7,
    "percent_salari": 81.4,
    "comunitat": "andalusia"
  },
  {
    "centil": 91,
    "numero_total": 17325,
    "sme_total": 48922,
    "numero_home": 10817,
    "sme_home": 48926,
    "numero_dona": 6508,
    "sme_dona": 48914,
    "maxim": 49888,
    "percent_asalariat": 93.5,
    "percent_salari": 82.85,
    "comunitat": "andalusia"
  },
  {
    "centil": 92,
    "numero_total": 17235,
    "sme_total": 50937,
    "numero_home": 11140,
    "sme_home": 50944,
    "numero_dona": 6095,
    "sme_dona": 50926,
    "maxim": 52064,
    "percent_asalariat": 94.3,
    "percent_salari": 84.36,
    "comunitat": "andalusia"
  },
  {
    "centil": 93,
    "numero_total": 17660,
    "sme_total": 53361,
    "numero_home": 11547,
    "sme_home": 53362,
    "numero_dona": 6113,
    "sme_dona": 53358,
    "maxim": 54742,
    "percent_asalariat": 95.1,
    "percent_salari": 85.97,
    "comunitat": "andalusia"
  },
  {
    "centil": 94,
    "numero_total": 17432,
    "sme_total": 56312,
    "numero_home": 11441,
    "sme_home": 56314,
    "numero_dona": 5991,
    "sme_dona": 56309,
    "maxim": 57976,
    "percent_asalariat": 95.9,
    "percent_salari": 87.65,
    "comunitat": "andalusia"
  },
  {
    "centil": 95,
    "numero_total": 17946,
    "sme_total": 59894,
    "numero_home": 11616,
    "sme_home": 59891,
    "numero_dona": 6330,
    "sme_dona": 59900,
    "maxim": 61939,
    "percent_asalariat": 96.7,
    "percent_salari": 89.49,
    "comunitat": "andalusia"
  },
  {
    "centil": 96,
    "numero_total": 17221,
    "sme_total": 64294,
    "numero_home": 11442,
    "sme_home": 64285,
    "numero_dona": 5779,
    "sme_dona": 64311,
    "maxim": 66966,
    "percent_asalariat": 97.5,
    "percent_salari": 91.39,
    "comunitat": "andalusia"
  },
  {
    "centil": 97,
    "numero_total": 15808,
    "sme_total": 70127,
    "numero_home": 10531,
    "sme_home": 70139,
    "numero_dona": 5277,
    "sme_dona": 70102,
    "maxim": 73778,
    "percent_asalariat": 98.2,
    "percent_salari": 93.28,
    "comunitat": "andalusia"
  },
  {
    "centil": 98,
    "numero_total": 15583,
    "sme_total": 78412,
    "numero_home": 10612,
    "sme_home": 78405,
    "numero_dona": 4971,
    "sme_dona": 78428,
    "maxim": 83931,
    "percent_asalariat": 98.9,
    "percent_salari": 95.38,
    "comunitat": "andalusia"
  },
  {
    "centil": 99,
    "numero_total": 15151,
    "sme_total": 92151,
    "numero_home": 10377,
    "sme_home": 92275,
    "numero_dona": 4774,
    "sme_dona": 91881,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.77,
    "comunitat": "andalusia"
  },
  {
    "centil": 100,
    "numero_total": 8962,
    "sme_total": 145418,
    "numero_home": 7154,
    "sme_home": 147951,
    "numero_dona": 1808,
    "sme_dona": 135395,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "andalusia"
  },
  {
    "centil": 1,
    "numero_total": 3079,
    "sme_total": 14062,
    "numero_home": 1310,
    "sme_home": 14061,
    "numero_dona": 1769,
    "sme_dona": 14062,
    "maxim": 14139,
    "percent_asalariat": 0.7,
    "percent_salari": 0.36,
    "comunitat": "arago"
  },
  {
    "centil": 2,
    "numero_total": 3213,
    "sme_total": 14221,
    "numero_home": 1197,
    "sme_home": 14220,
    "numero_dona": 2016,
    "sme_dona": 14221,
    "maxim": 14300,
    "percent_asalariat": 1.4,
    "percent_salari": 0.74,
    "comunitat": "arago"
  },
  {
    "centil": 3,
    "numero_total": 3384,
    "sme_total": 14380,
    "numero_home": 1315,
    "sme_home": 14380,
    "numero_dona": 2069,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 2.2,
    "percent_salari": 1.14,
    "comunitat": "arago"
  },
  {
    "centil": 4,
    "numero_total": 3576,
    "sme_total": 14539,
    "numero_home": 1338,
    "sme_home": 14540,
    "numero_dona": 2238,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 3,
    "percent_salari": 1.57,
    "comunitat": "arago"
  },
  {
    "centil": 5,
    "numero_total": 3578,
    "sme_total": 14697,
    "numero_home": 1370,
    "sme_home": 14698,
    "numero_dona": 2208,
    "sme_dona": 14696,
    "maxim": 14776,
    "percent_asalariat": 3.9,
    "percent_salari": 2.01,
    "comunitat": "arago"
  },
  {
    "centil": 6,
    "numero_total": 3715,
    "sme_total": 14855,
    "numero_home": 1417,
    "sme_home": 14854,
    "numero_dona": 2298,
    "sme_dona": 14856,
    "maxim": 14934,
    "percent_asalariat": 4.7,
    "percent_salari": 2.47,
    "comunitat": "arago"
  },
  {
    "centil": 7,
    "numero_total": 3676,
    "sme_total": 15013,
    "numero_home": 1420,
    "sme_home": 15014,
    "numero_dona": 2256,
    "sme_dona": 15012,
    "maxim": 15091,
    "percent_asalariat": 5.6,
    "percent_salari": 2.92,
    "comunitat": "arago"
  },
  {
    "centil": 8,
    "numero_total": 3734,
    "sme_total": 15171,
    "numero_home": 1452,
    "sme_home": 15171,
    "numero_dona": 2282,
    "sme_dona": 15171,
    "maxim": 15248,
    "percent_asalariat": 6.4,
    "percent_salari": 3.39,
    "comunitat": "arago"
  },
  {
    "centil": 9,
    "numero_total": 3758,
    "sme_total": 15327,
    "numero_home": 1503,
    "sme_home": 15328,
    "numero_dona": 2255,
    "sme_dona": 15327,
    "maxim": 15407,
    "percent_asalariat": 7.3,
    "percent_salari": 3.87,
    "comunitat": "arago"
  },
  {
    "centil": 10,
    "numero_total": 3922,
    "sme_total": 15486,
    "numero_home": 1508,
    "sme_home": 15485,
    "numero_dona": 2414,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 8.2,
    "percent_salari": 4.37,
    "comunitat": "arago"
  },
  {
    "centil": 11,
    "numero_total": 3666,
    "sme_total": 15646,
    "numero_home": 1452,
    "sme_home": 15644,
    "numero_dona": 2214,
    "sme_dona": 15647,
    "maxim": 15726,
    "percent_asalariat": 9,
    "percent_salari": 4.85,
    "comunitat": "arago"
  },
  {
    "centil": 12,
    "numero_total": 3897,
    "sme_total": 15806,
    "numero_home": 1571,
    "sme_home": 15806,
    "numero_dona": 2326,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 9.9,
    "percent_salari": 5.36,
    "comunitat": "arago"
  },
  {
    "centil": 13,
    "numero_total": 3958,
    "sme_total": 15967,
    "numero_home": 1580,
    "sme_home": 15968,
    "numero_dona": 2378,
    "sme_dona": 15967,
    "maxim": 16046,
    "percent_asalariat": 10.9,
    "percent_salari": 5.88,
    "comunitat": "arago"
  },
  {
    "centil": 14,
    "numero_total": 3840,
    "sme_total": 16126,
    "numero_home": 1616,
    "sme_home": 16124,
    "numero_dona": 2224,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 11.7,
    "percent_salari": 6.4,
    "comunitat": "arago"
  },
  {
    "centil": 15,
    "numero_total": 3912,
    "sme_total": 16290,
    "numero_home": 1680,
    "sme_home": 16290,
    "numero_dona": 2232,
    "sme_dona": 16289,
    "maxim": 16371,
    "percent_asalariat": 12.6,
    "percent_salari": 6.93,
    "comunitat": "arago"
  },
  {
    "centil": 16,
    "numero_total": 3819,
    "sme_total": 16453,
    "numero_home": 1628,
    "sme_home": 16453,
    "numero_dona": 2191,
    "sme_dona": 16453,
    "maxim": 16533,
    "percent_asalariat": 13.5,
    "percent_salari": 7.45,
    "comunitat": "arago"
  },
  {
    "centil": 17,
    "numero_total": 4032,
    "sme_total": 16610,
    "numero_home": 1710,
    "sme_home": 16609,
    "numero_dona": 2322,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 14.4,
    "percent_salari": 8,
    "comunitat": "arago"
  },
  {
    "centil": 18,
    "numero_total": 3890,
    "sme_total": 16774,
    "numero_home": 1736,
    "sme_home": 16774,
    "numero_dona": 2154,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 15.3,
    "percent_salari": 8.54,
    "comunitat": "arago"
  },
  {
    "centil": 19,
    "numero_total": 3952,
    "sme_total": 16939,
    "numero_home": 1764,
    "sme_home": 16941,
    "numero_dona": 2188,
    "sme_dona": 16937,
    "maxim": 17023,
    "percent_asalariat": 16.2,
    "percent_salari": 9.1,
    "comunitat": "arago"
  },
  {
    "centil": 20,
    "numero_total": 4045,
    "sme_total": 17109,
    "numero_home": 1832,
    "sme_home": 17111,
    "numero_dona": 2213,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 17.2,
    "percent_salari": 9.67,
    "comunitat": "arago"
  },
  {
    "centil": 21,
    "numero_total": 4452,
    "sme_total": 17281,
    "numero_home": 2088,
    "sme_home": 17281,
    "numero_dona": 2364,
    "sme_dona": 17281,
    "maxim": 17369,
    "percent_asalariat": 18.2,
    "percent_salari": 10.31,
    "comunitat": "arago"
  },
  {
    "centil": 22,
    "numero_total": 4481,
    "sme_total": 17457,
    "numero_home": 2127,
    "sme_home": 17457,
    "numero_dona": 2354,
    "sme_dona": 17456,
    "maxim": 17543,
    "percent_asalariat": 19.2,
    "percent_salari": 10.96,
    "comunitat": "arago"
  },
  {
    "centil": 23,
    "numero_total": 4399,
    "sme_total": 17630,
    "numero_home": 2156,
    "sme_home": 17631,
    "numero_dona": 2243,
    "sme_dona": 17630,
    "maxim": 17718,
    "percent_asalariat": 20.2,
    "percent_salari": 11.6,
    "comunitat": "arago"
  },
  {
    "centil": 24,
    "numero_total": 4434,
    "sme_total": 17805,
    "numero_home": 2215,
    "sme_home": 17804,
    "numero_dona": 2219,
    "sme_dona": 17805,
    "maxim": 17891,
    "percent_asalariat": 21.3,
    "percent_salari": 12.26,
    "comunitat": "arago"
  },
  {
    "centil": 25,
    "numero_total": 4494,
    "sme_total": 17977,
    "numero_home": 2256,
    "sme_home": 17977,
    "numero_dona": 2238,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 22.3,
    "percent_salari": 12.93,
    "comunitat": "arago"
  },
  {
    "centil": 26,
    "numero_total": 4268,
    "sme_total": 18149,
    "numero_home": 2220,
    "sme_home": 18150,
    "numero_dona": 2048,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 23.3,
    "percent_salari": 13.57,
    "comunitat": "arago"
  },
  {
    "centil": 27,
    "numero_total": 4221,
    "sme_total": 18328,
    "numero_home": 2214,
    "sme_home": 18331,
    "numero_dona": 2007,
    "sme_dona": 18326,
    "maxim": 18417,
    "percent_asalariat": 24.3,
    "percent_salari": 14.21,
    "comunitat": "arago"
  },
  {
    "centil": 28,
    "numero_total": 4444,
    "sme_total": 18505,
    "numero_home": 2367,
    "sme_home": 18506,
    "numero_dona": 2077,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 25.3,
    "percent_salari": 14.89,
    "comunitat": "arago"
  },
  {
    "centil": 29,
    "numero_total": 4563,
    "sme_total": 18686,
    "numero_home": 2474,
    "sme_home": 18687,
    "numero_dona": 2089,
    "sme_dona": 18686,
    "maxim": 18778,
    "percent_asalariat": 26.3,
    "percent_salari": 15.6,
    "comunitat": "arago"
  },
  {
    "centil": 30,
    "numero_total": 4374,
    "sme_total": 18865,
    "numero_home": 2327,
    "sme_home": 18865,
    "numero_dona": 2047,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 27.3,
    "percent_salari": 16.28,
    "comunitat": "arago"
  },
  {
    "centil": 31,
    "numero_total": 4348,
    "sme_total": 19042,
    "numero_home": 2378,
    "sme_home": 19042,
    "numero_dona": 1970,
    "sme_dona": 19042,
    "maxim": 19133,
    "percent_asalariat": 28.3,
    "percent_salari": 16.97,
    "comunitat": "arago"
  },
  {
    "centil": 32,
    "numero_total": 4429,
    "sme_total": 19224,
    "numero_home": 2523,
    "sme_home": 19225,
    "numero_dona": 1906,
    "sme_dona": 19223,
    "maxim": 19317,
    "percent_asalariat": 29.4,
    "percent_salari": 17.67,
    "comunitat": "arago"
  },
  {
    "centil": 33,
    "numero_total": 4472,
    "sme_total": 19408,
    "numero_home": 2540,
    "sme_home": 19407,
    "numero_dona": 1932,
    "sme_dona": 19410,
    "maxim": 19503,
    "percent_asalariat": 30.4,
    "percent_salari": 18.39,
    "comunitat": "arago"
  },
  {
    "centil": 34,
    "numero_total": 4556,
    "sme_total": 19598,
    "numero_home": 2612,
    "sme_home": 19600,
    "numero_dona": 1944,
    "sme_dona": 19596,
    "maxim": 19691,
    "percent_asalariat": 31.4,
    "percent_salari": 19.13,
    "comunitat": "arago"
  },
  {
    "centil": 35,
    "numero_total": 4466,
    "sme_total": 19786,
    "numero_home": 2494,
    "sme_home": 19787,
    "numero_dona": 1972,
    "sme_dona": 19784,
    "maxim": 19879,
    "percent_asalariat": 32.5,
    "percent_salari": 19.87,
    "comunitat": "arago"
  },
  {
    "centil": 36,
    "numero_total": 4667,
    "sme_total": 19974,
    "numero_home": 2744,
    "sme_home": 19974,
    "numero_dona": 1923,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 33.5,
    "percent_salari": 20.64,
    "comunitat": "arago"
  },
  {
    "centil": 37,
    "numero_total": 4568,
    "sme_total": 20166,
    "numero_home": 2684,
    "sme_home": 20168,
    "numero_dona": 1884,
    "sme_dona": 20164,
    "maxim": 20263,
    "percent_asalariat": 34.6,
    "percent_salari": 21.4,
    "comunitat": "arago"
  },
  {
    "centil": 38,
    "numero_total": 4654,
    "sme_total": 20362,
    "numero_home": 2770,
    "sme_home": 20362,
    "numero_dona": 1884,
    "sme_dona": 20361,
    "maxim": 20459,
    "percent_asalariat": 35.7,
    "percent_salari": 22.19,
    "comunitat": "arago"
  },
  {
    "centil": 39,
    "numero_total": 4737,
    "sme_total": 20557,
    "numero_home": 2862,
    "sme_home": 20557,
    "numero_dona": 1875,
    "sme_dona": 20556,
    "maxim": 20653,
    "percent_asalariat": 36.7,
    "percent_salari": 23,
    "comunitat": "arago"
  },
  {
    "centil": 40,
    "numero_total": 4554,
    "sme_total": 20753,
    "numero_home": 2742,
    "sme_home": 20753,
    "numero_dona": 1812,
    "sme_dona": 20753,
    "maxim": 20854,
    "percent_asalariat": 37.8,
    "percent_salari": 23.78,
    "comunitat": "arago"
  },
  {
    "centil": 41,
    "numero_total": 4593,
    "sme_total": 20955,
    "numero_home": 2738,
    "sme_home": 20955,
    "numero_dona": 1855,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 38.9,
    "percent_salari": 24.58,
    "comunitat": "arago"
  },
  {
    "centil": 42,
    "numero_total": 4651,
    "sme_total": 21162,
    "numero_home": 2796,
    "sme_home": 21161,
    "numero_dona": 1855,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 39.9,
    "percent_salari": 25.39,
    "comunitat": "arago"
  },
  {
    "centil": 43,
    "numero_total": 4619,
    "sme_total": 21373,
    "numero_home": 2769,
    "sme_home": 21374,
    "numero_dona": 1850,
    "sme_dona": 21372,
    "maxim": 21483,
    "percent_asalariat": 41,
    "percent_salari": 26.21,
    "comunitat": "arago"
  },
  {
    "centil": 44,
    "numero_total": 4644,
    "sme_total": 21590,
    "numero_home": 2756,
    "sme_home": 21589,
    "numero_dona": 1888,
    "sme_dona": 21591,
    "maxim": 21701,
    "percent_asalariat": 42.1,
    "percent_salari": 27.04,
    "comunitat": "arago"
  },
  {
    "centil": 45,
    "numero_total": 4938,
    "sme_total": 21815,
    "numero_home": 3043,
    "sme_home": 21816,
    "numero_dona": 1895,
    "sme_dona": 21814,
    "maxim": 21927,
    "percent_asalariat": 43.2,
    "percent_salari": 27.94,
    "comunitat": "arago"
  },
  {
    "centil": 46,
    "numero_total": 4933,
    "sme_total": 22038,
    "numero_home": 3005,
    "sme_home": 22040,
    "numero_dona": 1928,
    "sme_dona": 22036,
    "maxim": 22151,
    "percent_asalariat": 44.3,
    "percent_salari": 28.84,
    "comunitat": "arago"
  },
  {
    "centil": 47,
    "numero_total": 4799,
    "sme_total": 22266,
    "numero_home": 2912,
    "sme_home": 22265,
    "numero_dona": 1887,
    "sme_dona": 22267,
    "maxim": 22380,
    "percent_asalariat": 45.4,
    "percent_salari": 29.72,
    "comunitat": "arago"
  },
  {
    "centil": 48,
    "numero_total": 4958,
    "sme_total": 22500,
    "numero_home": 2990,
    "sme_home": 22500,
    "numero_dona": 1968,
    "sme_dona": 22499,
    "maxim": 22616,
    "percent_asalariat": 46.6,
    "percent_salari": 30.65,
    "comunitat": "arago"
  },
  {
    "centil": 49,
    "numero_total": 4806,
    "sme_total": 22741,
    "numero_home": 3007,
    "sme_home": 22741,
    "numero_dona": 1799,
    "sme_dona": 22741,
    "maxim": 22865,
    "percent_asalariat": 47.7,
    "percent_salari": 31.56,
    "comunitat": "arago"
  },
  {
    "centil": 50,
    "numero_total": 4893,
    "sme_total": 22989,
    "numero_home": 2872,
    "sme_home": 22989,
    "numero_dona": 2021,
    "sme_dona": 22989,
    "maxim": 23114,
    "percent_asalariat": 48.8,
    "percent_salari": 32.49,
    "comunitat": "arago"
  },
  {
    "centil": 51,
    "numero_total": 4910,
    "sme_total": 23245,
    "numero_home": 2958,
    "sme_home": 23245,
    "numero_dona": 1952,
    "sme_dona": 23246,
    "maxim": 23377,
    "percent_asalariat": 49.9,
    "percent_salari": 33.43,
    "comunitat": "arago"
  },
  {
    "centil": 52,
    "numero_total": 5067,
    "sme_total": 23511,
    "numero_home": 3143,
    "sme_home": 23510,
    "numero_dona": 1924,
    "sme_dona": 23511,
    "maxim": 23645,
    "percent_asalariat": 51.1,
    "percent_salari": 34.42,
    "comunitat": "arago"
  },
  {
    "centil": 53,
    "numero_total": 5036,
    "sme_total": 23784,
    "numero_home": 3119,
    "sme_home": 23784,
    "numero_dona": 1917,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 52.3,
    "percent_salari": 35.41,
    "comunitat": "arago"
  },
  {
    "centil": 54,
    "numero_total": 4913,
    "sme_total": 24056,
    "numero_home": 3049,
    "sme_home": 24057,
    "numero_dona": 1864,
    "sme_dona": 24056,
    "maxim": 24198,
    "percent_asalariat": 53.4,
    "percent_salari": 36.39,
    "comunitat": "arago"
  },
  {
    "centil": 55,
    "numero_total": 5035,
    "sme_total": 24350,
    "numero_home": 3116,
    "sme_home": 24348,
    "numero_dona": 1919,
    "sme_dona": 24353,
    "maxim": 24501,
    "percent_asalariat": 54.5,
    "percent_salari": 37.41,
    "comunitat": "arago"
  },
  {
    "centil": 56,
    "numero_total": 5035,
    "sme_total": 24655,
    "numero_home": 3087,
    "sme_home": 24655,
    "numero_dona": 1948,
    "sme_dona": 24655,
    "maxim": 24811,
    "percent_asalariat": 55.7,
    "percent_salari": 38.44,
    "comunitat": "arago"
  },
  {
    "centil": 57,
    "numero_total": 5066,
    "sme_total": 24968,
    "numero_home": 3126,
    "sme_home": 24966,
    "numero_dona": 1940,
    "sme_dona": 24971,
    "maxim": 25122,
    "percent_asalariat": 56.9,
    "percent_salari": 39.49,
    "comunitat": "arago"
  },
  {
    "centil": 58,
    "numero_total": 5018,
    "sme_total": 25285,
    "numero_home": 3065,
    "sme_home": 25285,
    "numero_dona": 1953,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 58,
    "percent_salari": 40.54,
    "comunitat": "arago"
  },
  {
    "centil": 59,
    "numero_total": 5143,
    "sme_total": 25619,
    "numero_home": 3198,
    "sme_home": 25620,
    "numero_dona": 1945,
    "sme_dona": 25616,
    "maxim": 25792,
    "percent_asalariat": 59.2,
    "percent_salari": 41.63,
    "comunitat": "arago"
  },
  {
    "centil": 60,
    "numero_total": 5078,
    "sme_total": 25965,
    "numero_home": 3121,
    "sme_home": 25965,
    "numero_dona": 1957,
    "sme_dona": 25964,
    "maxim": 26139,
    "percent_asalariat": 60.4,
    "percent_salari": 42.73,
    "comunitat": "arago"
  },
  {
    "centil": 61,
    "numero_total": 5122,
    "sme_total": 26327,
    "numero_home": 3194,
    "sme_home": 26327,
    "numero_dona": 1928,
    "sme_dona": 26326,
    "maxim": 26509,
    "percent_asalariat": 61.6,
    "percent_salari": 43.84,
    "comunitat": "arago"
  },
  {
    "centil": 62,
    "numero_total": 5090,
    "sme_total": 26696,
    "numero_home": 3179,
    "sme_home": 26693,
    "numero_dona": 1911,
    "sme_dona": 26701,
    "maxim": 26874,
    "percent_asalariat": 62.7,
    "percent_salari": 44.97,
    "comunitat": "arago"
  },
  {
    "centil": 63,
    "numero_total": 4943,
    "sme_total": 27043,
    "numero_home": 3009,
    "sme_home": 27046,
    "numero_dona": 1934,
    "sme_dona": 27037,
    "maxim": 27221,
    "percent_asalariat": 63.9,
    "percent_salari": 46.08,
    "comunitat": "arago"
  },
  {
    "centil": 64,
    "numero_total": 4925,
    "sme_total": 27418,
    "numero_home": 3265,
    "sme_home": 27419,
    "numero_dona": 1660,
    "sme_dona": 27416,
    "maxim": 27616,
    "percent_asalariat": 65,
    "percent_salari": 47.2,
    "comunitat": "arago"
  },
  {
    "centil": 65,
    "numero_total": 4974,
    "sme_total": 27823,
    "numero_home": 3348,
    "sme_home": 27821,
    "numero_dona": 1626,
    "sme_dona": 27826,
    "maxim": 28031,
    "percent_asalariat": 66.1,
    "percent_salari": 48.35,
    "comunitat": "arago"
  },
  {
    "centil": 66,
    "numero_total": 4961,
    "sme_total": 28250,
    "numero_home": 3185,
    "sme_home": 28248,
    "numero_dona": 1776,
    "sme_dona": 28254,
    "maxim": 28476,
    "percent_asalariat": 67.3,
    "percent_salari": 49.51,
    "comunitat": "arago"
  },
  {
    "centil": 67,
    "numero_total": 5225,
    "sme_total": 28714,
    "numero_home": 3319,
    "sme_home": 28715,
    "numero_dona": 1906,
    "sme_dona": 28714,
    "maxim": 28951,
    "percent_asalariat": 68.5,
    "percent_salari": 50.75,
    "comunitat": "arago"
  },
  {
    "centil": 68,
    "numero_total": 5313,
    "sme_total": 29198,
    "numero_home": 3381,
    "sme_home": 29195,
    "numero_dona": 1932,
    "sme_dona": 29203,
    "maxim": 29450,
    "percent_asalariat": 69.7,
    "percent_salari": 52.04,
    "comunitat": "arago"
  },
  {
    "centil": 69,
    "numero_total": 5169,
    "sme_total": 29710,
    "numero_home": 3288,
    "sme_home": 29712,
    "numero_dona": 1881,
    "sme_dona": 29708,
    "maxim": 29970,
    "percent_asalariat": 70.9,
    "percent_salari": 53.31,
    "comunitat": "arago"
  },
  {
    "centil": 70,
    "numero_total": 5014,
    "sme_total": 30222,
    "numero_home": 3106,
    "sme_home": 30221,
    "numero_dona": 1908,
    "sme_dona": 30224,
    "maxim": 30487,
    "percent_asalariat": 72.1,
    "percent_salari": 54.57,
    "comunitat": "arago"
  },
  {
    "centil": 71,
    "numero_total": 5502,
    "sme_total": 30760,
    "numero_home": 3356,
    "sme_home": 30761,
    "numero_dona": 2146,
    "sme_dona": 30760,
    "maxim": 31037,
    "percent_asalariat": 73.3,
    "percent_salari": 55.97,
    "comunitat": "arago"
  },
  {
    "centil": 72,
    "numero_total": 5264,
    "sme_total": 31317,
    "numero_home": 3173,
    "sme_home": 31319,
    "numero_dona": 2091,
    "sme_dona": 31314,
    "maxim": 31602,
    "percent_asalariat": 74.5,
    "percent_salari": 57.34,
    "comunitat": "arago"
  },
  {
    "centil": 73,
    "numero_total": 5042,
    "sme_total": 31889,
    "numero_home": 3159,
    "sme_home": 31886,
    "numero_dona": 1883,
    "sme_dona": 31895,
    "maxim": 32176,
    "percent_asalariat": 75.7,
    "percent_salari": 58.67,
    "comunitat": "arago"
  },
  {
    "centil": 74,
    "numero_total": 5081,
    "sme_total": 32475,
    "numero_home": 3140,
    "sme_home": 32475,
    "numero_dona": 1941,
    "sme_dona": 32476,
    "maxim": 32786,
    "percent_asalariat": 76.9,
    "percent_salari": 60.04,
    "comunitat": "arago"
  },
  {
    "centil": 75,
    "numero_total": 5106,
    "sme_total": 33100,
    "numero_home": 3136,
    "sme_home": 33099,
    "numero_dona": 1970,
    "sme_dona": 33100,
    "maxim": 33413,
    "percent_asalariat": 78,
    "percent_salari": 61.44,
    "comunitat": "arago"
  },
  {
    "centil": 76,
    "numero_total": 5064,
    "sme_total": 33736,
    "numero_home": 3014,
    "sme_home": 33736,
    "numero_dona": 2050,
    "sme_dona": 33736,
    "maxim": 34056,
    "percent_asalariat": 79.2,
    "percent_salari": 62.86,
    "comunitat": "arago"
  },
  {
    "centil": 77,
    "numero_total": 4842,
    "sme_total": 34381,
    "numero_home": 2980,
    "sme_home": 34384,
    "numero_dona": 1862,
    "sme_dona": 34375,
    "maxim": 34722,
    "percent_asalariat": 80.3,
    "percent_salari": 64.24,
    "comunitat": "arago"
  },
  {
    "centil": 78,
    "numero_total": 4674,
    "sme_total": 35041,
    "numero_home": 2862,
    "sme_home": 35040,
    "numero_dona": 1812,
    "sme_dona": 35043,
    "maxim": 35374,
    "percent_asalariat": 81.4,
    "percent_salari": 65.59,
    "comunitat": "arago"
  },
  {
    "centil": 79,
    "numero_total": 4662,
    "sme_total": 35701,
    "numero_home": 2762,
    "sme_home": 35701,
    "numero_dona": 1900,
    "sme_dona": 35700,
    "maxim": 36027,
    "percent_asalariat": 82.5,
    "percent_salari": 66.97,
    "comunitat": "arago"
  },
  {
    "centil": 80,
    "numero_total": 4364,
    "sme_total": 36372,
    "numero_home": 2663,
    "sme_home": 36372,
    "numero_dona": 1701,
    "sme_dona": 36372,
    "maxim": 36730,
    "percent_asalariat": 83.5,
    "percent_salari": 68.29,
    "comunitat": "arago"
  },
  {
    "centil": 81,
    "numero_total": 4485,
    "sme_total": 37106,
    "numero_home": 2718,
    "sme_home": 37101,
    "numero_dona": 1767,
    "sme_dona": 37113,
    "maxim": 37490,
    "percent_asalariat": 84.5,
    "percent_salari": 69.67,
    "comunitat": "arago"
  },
  {
    "centil": 82,
    "numero_total": 4354,
    "sme_total": 37901,
    "numero_home": 2651,
    "sme_home": 37900,
    "numero_dona": 1703,
    "sme_dona": 37903,
    "maxim": 38304,
    "percent_asalariat": 85.5,
    "percent_salari": 71.04,
    "comunitat": "arago"
  },
  {
    "centil": 83,
    "numero_total": 4315,
    "sme_total": 38747,
    "numero_home": 2593,
    "sme_home": 38748,
    "numero_dona": 1722,
    "sme_dona": 38746,
    "maxim": 39197,
    "percent_asalariat": 86.5,
    "percent_salari": 72.42,
    "comunitat": "arago"
  },
  {
    "centil": 84,
    "numero_total": 4105,
    "sme_total": 39676,
    "numero_home": 2565,
    "sme_home": 39672,
    "numero_dona": 1540,
    "sme_dona": 39682,
    "maxim": 40137,
    "percent_asalariat": 87.4,
    "percent_salari": 73.77,
    "comunitat": "arago"
  },
  {
    "centil": 85,
    "numero_total": 4465,
    "sme_total": 40632,
    "numero_home": 2874,
    "sme_home": 40636,
    "numero_dona": 1591,
    "sme_dona": 40624,
    "maxim": 41170,
    "percent_asalariat": 88.5,
    "percent_salari": 75.28,
    "comunitat": "arago"
  },
  {
    "centil": 86,
    "numero_total": 3861,
    "sme_total": 41733,
    "numero_home": 2452,
    "sme_home": 41726,
    "numero_dona": 1409,
    "sme_dona": 41745,
    "maxim": 42306,
    "percent_asalariat": 89.4,
    "percent_salari": 76.61,
    "comunitat": "arago"
  },
  {
    "centil": 87,
    "numero_total": 3617,
    "sme_total": 42911,
    "numero_home": 2242,
    "sme_home": 42911,
    "numero_dona": 1375,
    "sme_dona": 42910,
    "maxim": 43519,
    "percent_asalariat": 90.2,
    "percent_salari": 77.9,
    "comunitat": "arago"
  },
  {
    "centil": 88,
    "numero_total": 3632,
    "sme_total": 44164,
    "numero_home": 2154,
    "sme_home": 44164,
    "numero_dona": 1478,
    "sme_dona": 44163,
    "maxim": 44857,
    "percent_asalariat": 91,
    "percent_salari": 79.23,
    "comunitat": "arago"
  },
  {
    "centil": 89,
    "numero_total": 3462,
    "sme_total": 45570,
    "numero_home": 2115,
    "sme_home": 45563,
    "numero_dona": 1347,
    "sme_dona": 45580,
    "maxim": 46326,
    "percent_asalariat": 91.8,
    "percent_salari": 80.54,
    "comunitat": "arago"
  },
  {
    "centil": 90,
    "numero_total": 3613,
    "sme_total": 47147,
    "numero_home": 2164,
    "sme_home": 47139,
    "numero_dona": 1449,
    "sme_dona": 47159,
    "maxim": 48005,
    "percent_asalariat": 92.7,
    "percent_salari": 81.95,
    "comunitat": "arago"
  },
  {
    "centil": 91,
    "numero_total": 3681,
    "sme_total": 48916,
    "numero_home": 2199,
    "sme_home": 48916,
    "numero_dona": 1482,
    "sme_dona": 48916,
    "maxim": 49888,
    "percent_asalariat": 93.5,
    "percent_salari": 83.44,
    "comunitat": "arago"
  },
  {
    "centil": 92,
    "numero_total": 3412,
    "sme_total": 50940,
    "numero_home": 2102,
    "sme_home": 50937,
    "numero_dona": 1310,
    "sme_dona": 50944,
    "maxim": 52064,
    "percent_asalariat": 94.3,
    "percent_salari": 84.89,
    "comunitat": "arago"
  },
  {
    "centil": 93,
    "numero_total": 3468,
    "sme_total": 53355,
    "numero_home": 2217,
    "sme_home": 53369,
    "numero_dona": 1251,
    "sme_dona": 53331,
    "maxim": 54742,
    "percent_asalariat": 95.1,
    "percent_salari": 86.42,
    "comunitat": "arago"
  },
  {
    "centil": 94,
    "numero_total": 3446,
    "sme_total": 56288,
    "numero_home": 2165,
    "sme_home": 56305,
    "numero_dona": 1281,
    "sme_dona": 56258,
    "maxim": 57976,
    "percent_asalariat": 95.9,
    "percent_salari": 88.03,
    "comunitat": "arago"
  },
  {
    "centil": 95,
    "numero_total": 3362,
    "sme_total": 59881,
    "numero_home": 2172,
    "sme_home": 59890,
    "numero_dona": 1190,
    "sme_dona": 59866,
    "maxim": 61939,
    "percent_asalariat": 96.7,
    "percent_salari": 89.7,
    "comunitat": "arago"
  },
  {
    "centil": 96,
    "numero_total": 3312,
    "sme_total": 64298,
    "numero_home": 2175,
    "sme_home": 64275,
    "numero_dona": 1137,
    "sme_dona": 64342,
    "maxim": 66966,
    "percent_asalariat": 97.4,
    "percent_salari": 91.46,
    "comunitat": "arago"
  },
  {
    "centil": 97,
    "numero_total": 3240,
    "sme_total": 70163,
    "numero_home": 1979,
    "sme_home": 70149,
    "numero_dona": 1261,
    "sme_dona": 70186,
    "maxim": 73778,
    "percent_asalariat": 98.2,
    "percent_salari": 93.35,
    "comunitat": "arago"
  },
  {
    "centil": 98,
    "numero_total": 3153,
    "sme_total": 78485,
    "numero_home": 2017,
    "sme_home": 78506,
    "numero_dona": 1136,
    "sme_dona": 78448,
    "maxim": 83931,
    "percent_asalariat": 98.9,
    "percent_salari": 95.4,
    "comunitat": "arago"
  },
  {
    "centil": 99,
    "numero_total": 2942,
    "sme_total": 92041,
    "numero_home": 2080,
    "sme_home": 92241,
    "numero_dona": 862,
    "sme_dona": 91560,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.64,
    "comunitat": "arago"
  },
  {
    "centil": 100,
    "numero_total": 1906,
    "sme_total": 149092,
    "numero_home": 1580,
    "sme_home": 151741,
    "numero_dona": 326,
    "sme_dona": 136251,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "arago"
  },
  {
    "centil": 1,
    "numero_total": 2114,
    "sme_total": 14059,
    "numero_home": 818,
    "sme_home": 14057,
    "numero_dona": 1296,
    "sme_dona": 14061,
    "maxim": 14139,
    "percent_asalariat": 0.8,
    "percent_salari": 0.38,
    "comunitat": "asturies"
  },
  {
    "centil": 2,
    "numero_total": 2185,
    "sme_total": 14217,
    "numero_home": 811,
    "sme_home": 14219,
    "numero_dona": 1374,
    "sme_dona": 14216,
    "maxim": 14300,
    "percent_asalariat": 1.6,
    "percent_salari": 0.77,
    "comunitat": "asturies"
  },
  {
    "centil": 3,
    "numero_total": 4288,
    "sme_total": 14371,
    "numero_home": 1131,
    "sme_home": 14372,
    "numero_dona": 3157,
    "sme_dona": 14370,
    "maxim": 14458,
    "percent_asalariat": 3.2,
    "percent_salari": 1.55,
    "comunitat": "asturies"
  },
  {
    "centil": 4,
    "numero_total": 2562,
    "sme_total": 14536,
    "numero_home": 773,
    "sme_home": 14535,
    "numero_dona": 1789,
    "sme_dona": 14536,
    "maxim": 14618,
    "percent_asalariat": 4.1,
    "percent_salari": 2.02,
    "comunitat": "asturies"
  },
  {
    "centil": 5,
    "numero_total": 2488,
    "sme_total": 14698,
    "numero_home": 833,
    "sme_home": 14702,
    "numero_dona": 1655,
    "sme_dona": 14696,
    "maxim": 14776,
    "percent_asalariat": 5.1,
    "percent_salari": 2.48,
    "comunitat": "asturies"
  },
  {
    "centil": 6,
    "numero_total": 2545,
    "sme_total": 14857,
    "numero_home": 837,
    "sme_home": 14857,
    "numero_dona": 1708,
    "sme_dona": 14856,
    "maxim": 14934,
    "percent_asalariat": 6,
    "percent_salari": 2.96,
    "comunitat": "asturies"
  },
  {
    "centil": 7,
    "numero_total": 2602,
    "sme_total": 15012,
    "numero_home": 960,
    "sme_home": 15011,
    "numero_dona": 1642,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 7,
    "percent_salari": 3.46,
    "comunitat": "asturies"
  },
  {
    "centil": 8,
    "numero_total": 2478,
    "sme_total": 15172,
    "numero_home": 917,
    "sme_home": 15172,
    "numero_dona": 1561,
    "sme_dona": 15173,
    "maxim": 15248,
    "percent_asalariat": 7.9,
    "percent_salari": 3.93,
    "comunitat": "asturies"
  },
  {
    "centil": 9,
    "numero_total": 2397,
    "sme_total": 15328,
    "numero_home": 921,
    "sme_home": 15327,
    "numero_dona": 1476,
    "sme_dona": 15329,
    "maxim": 15407,
    "percent_asalariat": 8.8,
    "percent_salari": 4.4,
    "comunitat": "asturies"
  },
  {
    "centil": 10,
    "numero_total": 2819,
    "sme_total": 15480,
    "numero_home": 1023,
    "sme_home": 15482,
    "numero_dona": 1796,
    "sme_dona": 15479,
    "maxim": 15567,
    "percent_asalariat": 9.8,
    "percent_salari": 4.95,
    "comunitat": "asturies"
  },
  {
    "centil": 11,
    "numero_total": 2789,
    "sme_total": 15654,
    "numero_home": 1060,
    "sme_home": 15657,
    "numero_dona": 1729,
    "sme_dona": 15652,
    "maxim": 15726,
    "percent_asalariat": 10.9,
    "percent_salari": 5.5,
    "comunitat": "asturies"
  },
  {
    "centil": 12,
    "numero_total": 2584,
    "sme_total": 15805,
    "numero_home": 960,
    "sme_home": 15806,
    "numero_dona": 1624,
    "sme_dona": 15805,
    "maxim": 15885,
    "percent_asalariat": 11.8,
    "percent_salari": 6.02,
    "comunitat": "asturies"
  },
  {
    "centil": 13,
    "numero_total": 2396,
    "sme_total": 15966,
    "numero_home": 965,
    "sme_home": 15966,
    "numero_dona": 1431,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 12.7,
    "percent_salari": 6.51,
    "comunitat": "asturies"
  },
  {
    "centil": 14,
    "numero_total": 2773,
    "sme_total": 16120,
    "numero_home": 1138,
    "sme_home": 16121,
    "numero_dona": 1635,
    "sme_dona": 16120,
    "maxim": 16207,
    "percent_asalariat": 13.7,
    "percent_salari": 7.07,
    "comunitat": "asturies"
  },
  {
    "centil": 15,
    "numero_total": 2541,
    "sme_total": 16290,
    "numero_home": 1089,
    "sme_home": 16289,
    "numero_dona": 1452,
    "sme_dona": 16290,
    "maxim": 16371,
    "percent_asalariat": 14.7,
    "percent_salari": 7.6,
    "comunitat": "asturies"
  },
  {
    "centil": 16,
    "numero_total": 2522,
    "sme_total": 16452,
    "numero_home": 1057,
    "sme_home": 16454,
    "numero_dona": 1465,
    "sme_dona": 16451,
    "maxim": 16533,
    "percent_asalariat": 15.6,
    "percent_salari": 8.12,
    "comunitat": "asturies"
  },
  {
    "centil": 17,
    "numero_total": 2744,
    "sme_total": 16615,
    "numero_home": 1226,
    "sme_home": 16618,
    "numero_dona": 1518,
    "sme_dona": 16613,
    "maxim": 16692,
    "percent_asalariat": 16.6,
    "percent_salari": 8.7,
    "comunitat": "asturies"
  },
  {
    "centil": 18,
    "numero_total": 2372,
    "sme_total": 16773,
    "numero_home": 1008,
    "sme_home": 16772,
    "numero_dona": 1364,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 17.5,
    "percent_salari": 9.2,
    "comunitat": "asturies"
  },
  {
    "centil": 19,
    "numero_total": 2663,
    "sme_total": 16944,
    "numero_home": 1201,
    "sme_home": 16945,
    "numero_dona": 1462,
    "sme_dona": 16944,
    "maxim": 17023,
    "percent_asalariat": 18.5,
    "percent_salari": 9.77,
    "comunitat": "asturies"
  },
  {
    "centil": 20,
    "numero_total": 2284,
    "sme_total": 17108,
    "numero_home": 1009,
    "sme_home": 17109,
    "numero_dona": 1275,
    "sme_dona": 17106,
    "maxim": 17196,
    "percent_asalariat": 19.3,
    "percent_salari": 10.27,
    "comunitat": "asturies"
  },
  {
    "centil": 21,
    "numero_total": 2292,
    "sme_total": 17281,
    "numero_home": 1020,
    "sme_home": 17283,
    "numero_dona": 1272,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 20.2,
    "percent_salari": 10.77,
    "comunitat": "asturies"
  },
  {
    "centil": 22,
    "numero_total": 2209,
    "sme_total": 17455,
    "numero_home": 1038,
    "sme_home": 17455,
    "numero_dona": 1171,
    "sme_dona": 17455,
    "maxim": 17543,
    "percent_asalariat": 21,
    "percent_salari": 11.26,
    "comunitat": "asturies"
  },
  {
    "centil": 23,
    "numero_total": 2272,
    "sme_total": 17632,
    "numero_home": 1066,
    "sme_home": 17632,
    "numero_dona": 1206,
    "sme_dona": 17633,
    "maxim": 17718,
    "percent_asalariat": 21.8,
    "percent_salari": 11.76,
    "comunitat": "asturies"
  },
  {
    "centil": 24,
    "numero_total": 2159,
    "sme_total": 17807,
    "numero_home": 1033,
    "sme_home": 17807,
    "numero_dona": 1126,
    "sme_dona": 17807,
    "maxim": 17891,
    "percent_asalariat": 22.6,
    "percent_salari": 12.25,
    "comunitat": "asturies"
  },
  {
    "centil": 25,
    "numero_total": 2074,
    "sme_total": 17977,
    "numero_home": 1032,
    "sme_home": 17977,
    "numero_dona": 1042,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 23.4,
    "percent_salari": 12.72,
    "comunitat": "asturies"
  },
  {
    "centil": 26,
    "numero_total": 2030,
    "sme_total": 18148,
    "numero_home": 991,
    "sme_home": 18146,
    "numero_dona": 1039,
    "sme_dona": 18150,
    "maxim": 18239,
    "percent_asalariat": 24.2,
    "percent_salari": 13.19,
    "comunitat": "asturies"
  },
  {
    "centil": 27,
    "numero_total": 2034,
    "sme_total": 18325,
    "numero_home": 1000,
    "sme_home": 18325,
    "numero_dona": 1034,
    "sme_dona": 18324,
    "maxim": 18417,
    "percent_asalariat": 24.9,
    "percent_salari": 13.66,
    "comunitat": "asturies"
  },
  {
    "centil": 28,
    "numero_total": 1912,
    "sme_total": 18506,
    "numero_home": 925,
    "sme_home": 18506,
    "numero_dona": 987,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 25.6,
    "percent_salari": 14.11,
    "comunitat": "asturies"
  },
  {
    "centil": 29,
    "numero_total": 2128,
    "sme_total": 18695,
    "numero_home": 1000,
    "sme_home": 18689,
    "numero_dona": 1128,
    "sme_dona": 18700,
    "maxim": 18778,
    "percent_asalariat": 26.4,
    "percent_salari": 14.61,
    "comunitat": "asturies"
  },
  {
    "centil": 30,
    "numero_total": 1938,
    "sme_total": 18865,
    "numero_home": 1015,
    "sme_home": 18866,
    "numero_dona": 923,
    "sme_dona": 18864,
    "maxim": 18953,
    "percent_asalariat": 27.1,
    "percent_salari": 15.08,
    "comunitat": "asturies"
  },
  {
    "centil": 31,
    "numero_total": 1941,
    "sme_total": 19044,
    "numero_home": 941,
    "sme_home": 19044,
    "numero_dona": 1000,
    "sme_dona": 19044,
    "maxim": 19133,
    "percent_asalariat": 27.9,
    "percent_salari": 15.54,
    "comunitat": "asturies"
  },
  {
    "centil": 32,
    "numero_total": 1886,
    "sme_total": 19224,
    "numero_home": 1004,
    "sme_home": 19224,
    "numero_dona": 882,
    "sme_dona": 19223,
    "maxim": 19317,
    "percent_asalariat": 28.6,
    "percent_salari": 16,
    "comunitat": "asturies"
  },
  {
    "centil": 33,
    "numero_total": 1968,
    "sme_total": 19414,
    "numero_home": 1016,
    "sme_home": 19413,
    "numero_dona": 952,
    "sme_dona": 19415,
    "maxim": 19503,
    "percent_asalariat": 29.3,
    "percent_salari": 16.49,
    "comunitat": "asturies"
  },
  {
    "centil": 34,
    "numero_total": 1940,
    "sme_total": 19597,
    "numero_home": 1036,
    "sme_home": 19597,
    "numero_dona": 904,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 30,
    "percent_salari": 16.97,
    "comunitat": "asturies"
  },
  {
    "centil": 35,
    "numero_total": 1948,
    "sme_total": 19786,
    "numero_home": 1098,
    "sme_home": 19786,
    "numero_dona": 850,
    "sme_dona": 19786,
    "maxim": 19879,
    "percent_asalariat": 30.7,
    "percent_salari": 17.46,
    "comunitat": "asturies"
  },
  {
    "centil": 36,
    "numero_total": 2015,
    "sme_total": 19975,
    "numero_home": 1106,
    "sme_home": 19975,
    "numero_dona": 909,
    "sme_dona": 19975,
    "maxim": 20069,
    "percent_asalariat": 31.5,
    "percent_salari": 17.97,
    "comunitat": "asturies"
  },
  {
    "centil": 37,
    "numero_total": 2177,
    "sme_total": 20167,
    "numero_home": 1219,
    "sme_home": 20168,
    "numero_dona": 958,
    "sme_dona": 20167,
    "maxim": 20263,
    "percent_asalariat": 32.3,
    "percent_salari": 18.52,
    "comunitat": "asturies"
  },
  {
    "centil": 38,
    "numero_total": 2205,
    "sme_total": 20361,
    "numero_home": 1309,
    "sme_home": 20361,
    "numero_dona": 896,
    "sme_dona": 20362,
    "maxim": 20459,
    "percent_asalariat": 33.1,
    "percent_salari": 19.09,
    "comunitat": "asturies"
  },
  {
    "centil": 39,
    "numero_total": 2255,
    "sme_total": 20555,
    "numero_home": 1294,
    "sme_home": 20557,
    "numero_dona": 961,
    "sme_dona": 20552,
    "maxim": 20653,
    "percent_asalariat": 33.9,
    "percent_salari": 19.68,
    "comunitat": "asturies"
  },
  {
    "centil": 40,
    "numero_total": 2288,
    "sme_total": 20753,
    "numero_home": 1309,
    "sme_home": 20752,
    "numero_dona": 979,
    "sme_dona": 20753,
    "maxim": 20854,
    "percent_asalariat": 34.8,
    "percent_salari": 20.28,
    "comunitat": "asturies"
  },
  {
    "centil": 41,
    "numero_total": 2320,
    "sme_total": 20955,
    "numero_home": 1410,
    "sme_home": 20957,
    "numero_dona": 910,
    "sme_dona": 20953,
    "maxim": 21055,
    "percent_asalariat": 35.6,
    "percent_salari": 20.89,
    "comunitat": "asturies"
  },
  {
    "centil": 42,
    "numero_total": 2509,
    "sme_total": 21161,
    "numero_home": 1550,
    "sme_home": 21159,
    "numero_dona": 959,
    "sme_dona": 21164,
    "maxim": 21267,
    "percent_asalariat": 36.6,
    "percent_salari": 21.57,
    "comunitat": "asturies"
  },
  {
    "centil": 43,
    "numero_total": 2575,
    "sme_total": 21375,
    "numero_home": 1585,
    "sme_home": 21375,
    "numero_dona": 990,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 37.5,
    "percent_salari": 22.26,
    "comunitat": "asturies"
  },
  {
    "centil": 44,
    "numero_total": 2576,
    "sme_total": 21592,
    "numero_home": 1627,
    "sme_home": 21590,
    "numero_dona": 949,
    "sme_dona": 21595,
    "maxim": 21701,
    "percent_asalariat": 38.5,
    "percent_salari": 22.97,
    "comunitat": "asturies"
  },
  {
    "centil": 45,
    "numero_total": 2515,
    "sme_total": 21813,
    "numero_home": 1518,
    "sme_home": 21814,
    "numero_dona": 997,
    "sme_dona": 21811,
    "maxim": 21927,
    "percent_asalariat": 39.4,
    "percent_salari": 23.66,
    "comunitat": "asturies"
  },
  {
    "centil": 46,
    "numero_total": 2684,
    "sme_total": 22039,
    "numero_home": 1616,
    "sme_home": 22038,
    "numero_dona": 1068,
    "sme_dona": 22039,
    "maxim": 22151,
    "percent_asalariat": 40.4,
    "percent_salari": 24.41,
    "comunitat": "asturies"
  },
  {
    "centil": 47,
    "numero_total": 2744,
    "sme_total": 22267,
    "numero_home": 1703,
    "sme_home": 22266,
    "numero_dona": 1041,
    "sme_dona": 22267,
    "maxim": 22380,
    "percent_asalariat": 41.4,
    "percent_salari": 25.18,
    "comunitat": "asturies"
  },
  {
    "centil": 48,
    "numero_total": 2935,
    "sme_total": 22501,
    "numero_home": 1837,
    "sme_home": 22504,
    "numero_dona": 1098,
    "sme_dona": 22497,
    "maxim": 22616,
    "percent_asalariat": 42.5,
    "percent_salari": 26.02,
    "comunitat": "asturies"
  },
  {
    "centil": 49,
    "numero_total": 2910,
    "sme_total": 22741,
    "numero_home": 1809,
    "sme_home": 22740,
    "numero_dona": 1101,
    "sme_dona": 22743,
    "maxim": 22865,
    "percent_asalariat": 43.6,
    "percent_salari": 26.86,
    "comunitat": "asturies"
  },
  {
    "centil": 50,
    "numero_total": 3095,
    "sme_total": 22986,
    "numero_home": 1994,
    "sme_home": 22985,
    "numero_dona": 1101,
    "sme_dona": 22988,
    "maxim": 23114,
    "percent_asalariat": 44.7,
    "percent_salari": 27.76,
    "comunitat": "asturies"
  },
  {
    "centil": 51,
    "numero_total": 2976,
    "sme_total": 23246,
    "numero_home": 1818,
    "sme_home": 23247,
    "numero_dona": 1158,
    "sme_dona": 23244,
    "maxim": 23377,
    "percent_asalariat": 45.9,
    "percent_salari": 28.63,
    "comunitat": "asturies"
  },
  {
    "centil": 52,
    "numero_total": 2901,
    "sme_total": 23510,
    "numero_home": 1802,
    "sme_home": 23507,
    "numero_dona": 1099,
    "sme_dona": 23513,
    "maxim": 23645,
    "percent_asalariat": 46.9,
    "percent_salari": 29.5,
    "comunitat": "asturies"
  },
  {
    "centil": 53,
    "numero_total": 2863,
    "sme_total": 23785,
    "numero_home": 1760,
    "sme_home": 23784,
    "numero_dona": 1103,
    "sme_dona": 23787,
    "maxim": 23925,
    "percent_asalariat": 48,
    "percent_salari": 30.36,
    "comunitat": "asturies"
  },
  {
    "centil": 54,
    "numero_total": 3012,
    "sme_total": 24058,
    "numero_home": 1836,
    "sme_home": 24057,
    "numero_dona": 1176,
    "sme_dona": 24059,
    "maxim": 24198,
    "percent_asalariat": 49.1,
    "percent_salari": 31.28,
    "comunitat": "asturies"
  },
  {
    "centil": 55,
    "numero_total": 3079,
    "sme_total": 24346,
    "numero_home": 1818,
    "sme_home": 24345,
    "numero_dona": 1261,
    "sme_dona": 24347,
    "maxim": 24501,
    "percent_asalariat": 50.2,
    "percent_salari": 32.23,
    "comunitat": "asturies"
  },
  {
    "centil": 56,
    "numero_total": 3132,
    "sme_total": 24655,
    "numero_home": 1894,
    "sme_home": 24656,
    "numero_dona": 1238,
    "sme_dona": 24655,
    "maxim": 24811,
    "percent_asalariat": 51.4,
    "percent_salari": 33.2,
    "comunitat": "asturies"
  },
  {
    "centil": 57,
    "numero_total": 3033,
    "sme_total": 24963,
    "numero_home": 1820,
    "sme_home": 24961,
    "numero_dona": 1213,
    "sme_dona": 24966,
    "maxim": 25122,
    "percent_asalariat": 52.5,
    "percent_salari": 34.16,
    "comunitat": "asturies"
  },
  {
    "centil": 58,
    "numero_total": 2974,
    "sme_total": 25283,
    "numero_home": 1733,
    "sme_home": 25287,
    "numero_dona": 1241,
    "sme_dona": 25277,
    "maxim": 25450,
    "percent_asalariat": 53.6,
    "percent_salari": 35.12,
    "comunitat": "asturies"
  },
  {
    "centil": 59,
    "numero_total": 3072,
    "sme_total": 25617,
    "numero_home": 1795,
    "sme_home": 25617,
    "numero_dona": 1277,
    "sme_dona": 25617,
    "maxim": 25792,
    "percent_asalariat": 54.8,
    "percent_salari": 36.11,
    "comunitat": "asturies"
  },
  {
    "centil": 60,
    "numero_total": 3024,
    "sme_total": 25965,
    "numero_home": 1816,
    "sme_home": 25962,
    "numero_dona": 1208,
    "sme_dona": 25969,
    "maxim": 26139,
    "percent_asalariat": 55.9,
    "percent_salari": 37.11,
    "comunitat": "asturies"
  },
  {
    "centil": 61,
    "numero_total": 3259,
    "sme_total": 26323,
    "numero_home": 1959,
    "sme_home": 26321,
    "numero_dona": 1300,
    "sme_dona": 26326,
    "maxim": 26509,
    "percent_asalariat": 57.1,
    "percent_salari": 38.19,
    "comunitat": "asturies"
  },
  {
    "centil": 62,
    "numero_total": 2921,
    "sme_total": 26692,
    "numero_home": 1755,
    "sme_home": 26693,
    "numero_dona": 1166,
    "sme_dona": 26691,
    "maxim": 26874,
    "percent_asalariat": 58.2,
    "percent_salari": 39.18,
    "comunitat": "asturies"
  },
  {
    "centil": 63,
    "numero_total": 2869,
    "sme_total": 27046,
    "numero_home": 1700,
    "sme_home": 27046,
    "numero_dona": 1169,
    "sme_dona": 27046,
    "maxim": 27221,
    "percent_asalariat": 59.3,
    "percent_salari": 40.16,
    "comunitat": "asturies"
  },
  {
    "centil": 64,
    "numero_total": 3080,
    "sme_total": 27419,
    "numero_home": 1865,
    "sme_home": 27421,
    "numero_dona": 1215,
    "sme_dona": 27415,
    "maxim": 27616,
    "percent_asalariat": 60.4,
    "percent_salari": 41.23,
    "comunitat": "asturies"
  },
  {
    "centil": 65,
    "numero_total": 2872,
    "sme_total": 27822,
    "numero_home": 1837,
    "sme_home": 27823,
    "numero_dona": 1035,
    "sme_dona": 27821,
    "maxim": 28031,
    "percent_asalariat": 61.5,
    "percent_salari": 42.24,
    "comunitat": "asturies"
  },
  {
    "centil": 66,
    "numero_total": 2969,
    "sme_total": 28252,
    "numero_home": 1873,
    "sme_home": 28252,
    "numero_dona": 1096,
    "sme_dona": 28252,
    "maxim": 28476,
    "percent_asalariat": 62.6,
    "percent_salari": 43.3,
    "comunitat": "asturies"
  },
  {
    "centil": 67,
    "numero_total": 3035,
    "sme_total": 28711,
    "numero_home": 1977,
    "sme_home": 28714,
    "numero_dona": 1058,
    "sme_dona": 28705,
    "maxim": 28951,
    "percent_asalariat": 63.7,
    "percent_salari": 44.41,
    "comunitat": "asturies"
  },
  {
    "centil": 68,
    "numero_total": 3301,
    "sme_total": 29196,
    "numero_home": 2063,
    "sme_home": 29198,
    "numero_dona": 1238,
    "sme_dona": 29192,
    "maxim": 29450,
    "percent_asalariat": 64.9,
    "percent_salari": 45.63,
    "comunitat": "asturies"
  },
  {
    "centil": 69,
    "numero_total": 3153,
    "sme_total": 29703,
    "numero_home": 1987,
    "sme_home": 29703,
    "numero_dona": 1166,
    "sme_dona": 29702,
    "maxim": 29970,
    "percent_asalariat": 66.1,
    "percent_salari": 46.81,
    "comunitat": "asturies"
  },
  {
    "centil": 70,
    "numero_total": 3214,
    "sme_total": 30220,
    "numero_home": 1950,
    "sme_home": 30221,
    "numero_dona": 1264,
    "sme_dona": 30218,
    "maxim": 30487,
    "percent_asalariat": 67.3,
    "percent_salari": 48.04,
    "comunitat": "asturies"
  },
  {
    "centil": 71,
    "numero_total": 3278,
    "sme_total": 30763,
    "numero_home": 1929,
    "sme_home": 30762,
    "numero_dona": 1349,
    "sme_dona": 30764,
    "maxim": 31037,
    "percent_asalariat": 68.5,
    "percent_salari": 49.32,
    "comunitat": "asturies"
  },
  {
    "centil": 72,
    "numero_total": 3073,
    "sme_total": 31322,
    "numero_home": 1873,
    "sme_home": 31324,
    "numero_dona": 1200,
    "sme_dona": 31319,
    "maxim": 31602,
    "percent_asalariat": 69.6,
    "percent_salari": 50.54,
    "comunitat": "asturies"
  },
  {
    "centil": 73,
    "numero_total": 3051,
    "sme_total": 31892,
    "numero_home": 1854,
    "sme_home": 31892,
    "numero_dona": 1197,
    "sme_dona": 31894,
    "maxim": 32176,
    "percent_asalariat": 70.8,
    "percent_salari": 51.77,
    "comunitat": "asturies"
  },
  {
    "centil": 74,
    "numero_total": 3157,
    "sme_total": 32480,
    "numero_home": 1893,
    "sme_home": 32474,
    "numero_dona": 1264,
    "sme_dona": 32490,
    "maxim": 32786,
    "percent_asalariat": 71.9,
    "percent_salari": 53.07,
    "comunitat": "asturies"
  },
  {
    "centil": 75,
    "numero_total": 2978,
    "sme_total": 33092,
    "numero_home": 1826,
    "sme_home": 33093,
    "numero_dona": 1152,
    "sme_dona": 33090,
    "maxim": 33413,
    "percent_asalariat": 73,
    "percent_salari": 54.32,
    "comunitat": "asturies"
  },
  {
    "centil": 76,
    "numero_total": 3079,
    "sme_total": 33734,
    "numero_home": 1831,
    "sme_home": 33728,
    "numero_dona": 1248,
    "sme_dona": 33744,
    "maxim": 34056,
    "percent_asalariat": 74.2,
    "percent_salari": 55.63,
    "comunitat": "asturies"
  },
  {
    "centil": 77,
    "numero_total": 3242,
    "sme_total": 34381,
    "numero_home": 1783,
    "sme_home": 34385,
    "numero_dona": 1459,
    "sme_dona": 34376,
    "maxim": 34722,
    "percent_asalariat": 75.4,
    "percent_salari": 57.04,
    "comunitat": "asturies"
  },
  {
    "centil": 78,
    "numero_total": 3197,
    "sme_total": 35035,
    "numero_home": 1784,
    "sme_home": 35041,
    "numero_dona": 1413,
    "sme_dona": 35027,
    "maxim": 35374,
    "percent_asalariat": 76.6,
    "percent_salari": 58.46,
    "comunitat": "asturies"
  },
  {
    "centil": 79,
    "numero_total": 2846,
    "sme_total": 35698,
    "numero_home": 1577,
    "sme_home": 35702,
    "numero_dona": 1269,
    "sme_dona": 35694,
    "maxim": 36027,
    "percent_asalariat": 77.6,
    "percent_salari": 59.75,
    "comunitat": "asturies"
  },
  {
    "centil": 80,
    "numero_total": 2999,
    "sme_total": 36380,
    "numero_home": 1668,
    "sme_home": 36383,
    "numero_dona": 1331,
    "sme_dona": 36376,
    "maxim": 36730,
    "percent_asalariat": 78.7,
    "percent_salari": 61.13,
    "comunitat": "asturies"
  },
  {
    "centil": 81,
    "numero_total": 3113,
    "sme_total": 37114,
    "numero_home": 1754,
    "sme_home": 37113,
    "numero_dona": 1359,
    "sme_dona": 37115,
    "maxim": 37490,
    "percent_asalariat": 79.9,
    "percent_salari": 62.59,
    "comunitat": "asturies"
  },
  {
    "centil": 82,
    "numero_total": 3001,
    "sme_total": 37889,
    "numero_home": 1753,
    "sme_home": 37894,
    "numero_dona": 1248,
    "sme_dona": 37882,
    "maxim": 38304,
    "percent_asalariat": 81,
    "percent_salari": 64.03,
    "comunitat": "asturies"
  },
  {
    "centil": 83,
    "numero_total": 3062,
    "sme_total": 38753,
    "numero_home": 1770,
    "sme_home": 38754,
    "numero_dona": 1292,
    "sme_dona": 38751,
    "maxim": 39197,
    "percent_asalariat": 82.1,
    "percent_salari": 65.53,
    "comunitat": "asturies"
  },
  {
    "centil": 84,
    "numero_total": 3040,
    "sme_total": 39668,
    "numero_home": 1798,
    "sme_home": 39672,
    "numero_dona": 1242,
    "sme_dona": 39662,
    "maxim": 40137,
    "percent_asalariat": 83.3,
    "percent_salari": 67.06,
    "comunitat": "asturies"
  },
  {
    "centil": 85,
    "numero_total": 3155,
    "sme_total": 40647,
    "numero_home": 1917,
    "sme_home": 40644,
    "numero_dona": 1238,
    "sme_dona": 40651,
    "maxim": 41170,
    "percent_asalariat": 84.4,
    "percent_salari": 68.68,
    "comunitat": "asturies"
  },
  {
    "centil": 86,
    "numero_total": 3070,
    "sme_total": 41737,
    "numero_home": 1843,
    "sme_home": 41747,
    "numero_dona": 1227,
    "sme_dona": 41723,
    "maxim": 42306,
    "percent_asalariat": 85.6,
    "percent_salari": 70.31,
    "comunitat": "asturies"
  },
  {
    "centil": 87,
    "numero_total": 3218,
    "sme_total": 42924,
    "numero_home": 2001,
    "sme_home": 42920,
    "numero_dona": 1217,
    "sme_dona": 42931,
    "maxim": 43519,
    "percent_asalariat": 86.8,
    "percent_salari": 72.05,
    "comunitat": "asturies"
  },
  {
    "centil": 88,
    "numero_total": 3151,
    "sme_total": 44187,
    "numero_home": 2034,
    "sme_home": 44188,
    "numero_dona": 1117,
    "sme_dona": 44187,
    "maxim": 44857,
    "percent_asalariat": 87.9,
    "percent_salari": 73.82,
    "comunitat": "asturies"
  },
  {
    "centil": 89,
    "numero_total": 3277,
    "sme_total": 45569,
    "numero_home": 2138,
    "sme_home": 45572,
    "numero_dona": 1139,
    "sme_dona": 45564,
    "maxim": 46326,
    "percent_asalariat": 89.1,
    "percent_salari": 75.71,
    "comunitat": "asturies"
  },
  {
    "centil": 90,
    "numero_total": 3232,
    "sme_total": 47134,
    "numero_home": 2199,
    "sme_home": 47136,
    "numero_dona": 1033,
    "sme_dona": 47129,
    "maxim": 48005,
    "percent_asalariat": 90.3,
    "percent_salari": 77.64,
    "comunitat": "asturies"
  },
  {
    "centil": 91,
    "numero_total": 3138,
    "sme_total": 48904,
    "numero_home": 2103,
    "sme_home": 48903,
    "numero_dona": 1035,
    "sme_dona": 48907,
    "maxim": 49888,
    "percent_asalariat": 91.5,
    "percent_salari": 79.58,
    "comunitat": "asturies"
  },
  {
    "centil": 92,
    "numero_total": 2940,
    "sme_total": 50907,
    "numero_home": 2089,
    "sme_home": 50922,
    "numero_dona": 851,
    "sme_dona": 50872,
    "maxim": 52064,
    "percent_asalariat": 92.6,
    "percent_salari": 81.47,
    "comunitat": "asturies"
  },
  {
    "centil": 93,
    "numero_total": 2892,
    "sme_total": 53359,
    "numero_home": 2048,
    "sme_home": 53357,
    "numero_dona": 844,
    "sme_dona": 53365,
    "maxim": 54742,
    "percent_asalariat": 93.7,
    "percent_salari": 83.43,
    "comunitat": "asturies"
  },
  {
    "centil": 94,
    "numero_total": 2783,
    "sme_total": 56287,
    "numero_home": 1930,
    "sme_home": 56271,
    "numero_dona": 853,
    "sme_dona": 56324,
    "maxim": 57976,
    "percent_asalariat": 94.7,
    "percent_salari": 85.41,
    "comunitat": "asturies"
  },
  {
    "centil": 95,
    "numero_total": 2714,
    "sme_total": 59870,
    "numero_home": 1812,
    "sme_home": 59856,
    "numero_dona": 902,
    "sme_dona": 59897,
    "maxim": 61939,
    "percent_asalariat": 95.7,
    "percent_salari": 87.47,
    "comunitat": "asturies"
  },
  {
    "centil": 96,
    "numero_total": 2657,
    "sme_total": 64403,
    "numero_home": 1729,
    "sme_home": 64364,
    "numero_dona": 928,
    "sme_dona": 64474,
    "maxim": 66966,
    "percent_asalariat": 96.7,
    "percent_salari": 89.64,
    "comunitat": "asturies"
  },
  {
    "centil": 97,
    "numero_total": 2592,
    "sme_total": 70235,
    "numero_home": 1631,
    "sme_home": 70204,
    "numero_dona": 961,
    "sme_dona": 70289,
    "maxim": 73778,
    "percent_asalariat": 97.6,
    "percent_salari": 91.94,
    "comunitat": "asturies"
  },
  {
    "centil": 98,
    "numero_total": 2464,
    "sme_total": 78398,
    "numero_home": 1471,
    "sme_home": 78483,
    "numero_dona": 993,
    "sme_dona": 78272,
    "maxim": 83931,
    "percent_asalariat": 98.6,
    "percent_salari": 94.39,
    "comunitat": "asturies"
  },
  {
    "centil": 99,
    "numero_total": 2303,
    "sme_total": 92195,
    "numero_home": 1495,
    "sme_home": 92442,
    "numero_dona": 808,
    "sme_dona": 91737,
    "maxim": 104199,
    "percent_asalariat": 99.4,
    "percent_salari": 97.07,
    "comunitat": "asturies"
  },
  {
    "centil": 100,
    "numero_total": 1572,
    "sme_total": 147008,
    "numero_home": 1225,
    "sme_home": 150588,
    "numero_dona": 347,
    "sme_dona": 134371,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "asturies"
  },
  {
    "centil": 1,
    "numero_total": 2428,
    "sme_total": 14062,
    "numero_home": 1063,
    "sme_home": 14058,
    "numero_dona": 1365,
    "sme_dona": 14065,
    "maxim": 14139,
    "percent_asalariat": 0.6,
    "percent_salari": 0.28,
    "comunitat": "balears"
  },
  {
    "centil": 2,
    "numero_total": 2369,
    "sme_total": 14218,
    "numero_home": 975,
    "sme_home": 14220,
    "numero_dona": 1394,
    "sme_dona": 14217,
    "maxim": 14300,
    "percent_asalariat": 1.1,
    "percent_salari": 0.56,
    "comunitat": "balears"
  },
  {
    "centil": 3,
    "numero_total": 2404,
    "sme_total": 14380,
    "numero_home": 998,
    "sme_home": 14380,
    "numero_dona": 1406,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 1.6,
    "percent_salari": 0.84,
    "comunitat": "balears"
  },
  {
    "centil": 4,
    "numero_total": 2536,
    "sme_total": 14539,
    "numero_home": 1070,
    "sme_home": 14538,
    "numero_dona": 1466,
    "sme_dona": 14540,
    "maxim": 14618,
    "percent_asalariat": 2.2,
    "percent_salari": 1.14,
    "comunitat": "balears"
  },
  {
    "centil": 5,
    "numero_total": 2799,
    "sme_total": 14700,
    "numero_home": 1217,
    "sme_home": 14702,
    "numero_dona": 1582,
    "sme_dona": 14698,
    "maxim": 14776,
    "percent_asalariat": 2.9,
    "percent_salari": 1.48,
    "comunitat": "balears"
  },
  {
    "centil": 6,
    "numero_total": 2782,
    "sme_total": 14854,
    "numero_home": 1158,
    "sme_home": 14856,
    "numero_dona": 1624,
    "sme_dona": 14853,
    "maxim": 14934,
    "percent_asalariat": 3.5,
    "percent_salari": 1.82,
    "comunitat": "balears"
  },
  {
    "centil": 7,
    "numero_total": 2629,
    "sme_total": 15013,
    "numero_home": 1134,
    "sme_home": 15014,
    "numero_dona": 1495,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 4.1,
    "percent_salari": 2.15,
    "comunitat": "balears"
  },
  {
    "centil": 8,
    "numero_total": 2629,
    "sme_total": 15169,
    "numero_home": 1197,
    "sme_home": 15170,
    "numero_dona": 1432,
    "sme_dona": 15168,
    "maxim": 15248,
    "percent_asalariat": 4.7,
    "percent_salari": 2.47,
    "comunitat": "balears"
  },
  {
    "centil": 9,
    "numero_total": 2693,
    "sme_total": 15328,
    "numero_home": 1177,
    "sme_home": 15328,
    "numero_dona": 1516,
    "sme_dona": 15328,
    "maxim": 15407,
    "percent_asalariat": 5.3,
    "percent_salari": 2.81,
    "comunitat": "balears"
  },
  {
    "centil": 10,
    "numero_total": 2689,
    "sme_total": 15487,
    "numero_home": 1172,
    "sme_home": 15486,
    "numero_dona": 1517,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 5.9,
    "percent_salari": 3.15,
    "comunitat": "balears"
  },
  {
    "centil": 11,
    "numero_total": 2829,
    "sme_total": 15644,
    "numero_home": 1240,
    "sme_home": 15643,
    "numero_dona": 1589,
    "sme_dona": 15645,
    "maxim": 15726,
    "percent_asalariat": 6.6,
    "percent_salari": 3.52,
    "comunitat": "balears"
  },
  {
    "centil": 12,
    "numero_total": 3055,
    "sme_total": 15806,
    "numero_home": 1431,
    "sme_home": 15806,
    "numero_dona": 1624,
    "sme_dona": 15805,
    "maxim": 15885,
    "percent_asalariat": 7.3,
    "percent_salari": 3.91,
    "comunitat": "balears"
  },
  {
    "centil": 13,
    "numero_total": 3428,
    "sme_total": 15969,
    "numero_home": 1663,
    "sme_home": 15970,
    "numero_dona": 1765,
    "sme_dona": 15968,
    "maxim": 16046,
    "percent_asalariat": 8.1,
    "percent_salari": 4.36,
    "comunitat": "balears"
  },
  {
    "centil": 14,
    "numero_total": 4002,
    "sme_total": 16125,
    "numero_home": 1832,
    "sme_home": 16127,
    "numero_dona": 2170,
    "sme_dona": 16123,
    "maxim": 16207,
    "percent_asalariat": 9,
    "percent_salari": 4.89,
    "comunitat": "balears"
  },
  {
    "centil": 15,
    "numero_total": 3840,
    "sme_total": 16292,
    "numero_home": 1804,
    "sme_home": 16292,
    "numero_dona": 2036,
    "sme_dona": 16293,
    "maxim": 16371,
    "percent_asalariat": 9.9,
    "percent_salari": 5.41,
    "comunitat": "balears"
  },
  {
    "centil": 16,
    "numero_total": 3423,
    "sme_total": 16450,
    "numero_home": 1704,
    "sme_home": 16450,
    "numero_dona": 1719,
    "sme_dona": 16450,
    "maxim": 16533,
    "percent_asalariat": 10.6,
    "percent_salari": 5.87,
    "comunitat": "balears"
  },
  {
    "centil": 17,
    "numero_total": 3672,
    "sme_total": 16610,
    "numero_home": 1775,
    "sme_home": 16611,
    "numero_dona": 1897,
    "sme_dona": 16610,
    "maxim": 16692,
    "percent_asalariat": 11.5,
    "percent_salari": 6.37,
    "comunitat": "balears"
  },
  {
    "centil": 18,
    "numero_total": 3517,
    "sme_total": 16771,
    "numero_home": 1672,
    "sme_home": 16771,
    "numero_dona": 1845,
    "sme_dona": 16772,
    "maxim": 16855,
    "percent_asalariat": 12.3,
    "percent_salari": 6.86,
    "comunitat": "balears"
  },
  {
    "centil": 19,
    "numero_total": 3624,
    "sme_total": 16936,
    "numero_home": 1733,
    "sme_home": 16939,
    "numero_dona": 1891,
    "sme_dona": 16933,
    "maxim": 17023,
    "percent_asalariat": 13.1,
    "percent_salari": 7.36,
    "comunitat": "balears"
  },
  {
    "centil": 20,
    "numero_total": 3675,
    "sme_total": 17110,
    "numero_home": 1848,
    "sme_home": 17110,
    "numero_dona": 1827,
    "sme_dona": 17109,
    "maxim": 17196,
    "percent_asalariat": 14,
    "percent_salari": 7.88,
    "comunitat": "balears"
  },
  {
    "centil": 21,
    "numero_total": 3981,
    "sme_total": 17285,
    "numero_home": 2139,
    "sme_home": 17288,
    "numero_dona": 1842,
    "sme_dona": 17282,
    "maxim": 17369,
    "percent_asalariat": 14.9,
    "percent_salari": 8.44,
    "comunitat": "balears"
  },
  {
    "centil": 22,
    "numero_total": 4022,
    "sme_total": 17457,
    "numero_home": 2056,
    "sme_home": 17457,
    "numero_dona": 1966,
    "sme_dona": 17458,
    "maxim": 17543,
    "percent_asalariat": 15.8,
    "percent_salari": 9.02,
    "comunitat": "balears"
  },
  {
    "centil": 23,
    "numero_total": 4185,
    "sme_total": 17627,
    "numero_home": 2046,
    "sme_home": 17628,
    "numero_dona": 2139,
    "sme_dona": 17626,
    "maxim": 17718,
    "percent_asalariat": 16.7,
    "percent_salari": 9.62,
    "comunitat": "balears"
  },
  {
    "centil": 24,
    "numero_total": 4348,
    "sme_total": 17805,
    "numero_home": 2162,
    "sme_home": 17806,
    "numero_dona": 2186,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 17.7,
    "percent_salari": 10.26,
    "comunitat": "balears"
  },
  {
    "centil": 25,
    "numero_total": 3917,
    "sme_total": 17977,
    "numero_home": 2037,
    "sme_home": 17977,
    "numero_dona": 1880,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 18.6,
    "percent_salari": 10.84,
    "comunitat": "balears"
  },
  {
    "centil": 26,
    "numero_total": 4058,
    "sme_total": 18149,
    "numero_home": 2152,
    "sme_home": 18150,
    "numero_dona": 1906,
    "sme_dona": 18148,
    "maxim": 18239,
    "percent_asalariat": 19.6,
    "percent_salari": 11.44,
    "comunitat": "balears"
  },
  {
    "centil": 27,
    "numero_total": 5089,
    "sme_total": 18326,
    "numero_home": 3175,
    "sme_home": 18325,
    "numero_dona": 1914,
    "sme_dona": 18327,
    "maxim": 18417,
    "percent_asalariat": 20.7,
    "percent_salari": 12.21,
    "comunitat": "balears"
  },
  {
    "centil": 28,
    "numero_total": 4911,
    "sme_total": 18511,
    "numero_home": 3134,
    "sme_home": 18514,
    "numero_dona": 1777,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 21.9,
    "percent_salari": 12.96,
    "comunitat": "balears"
  },
  {
    "centil": 29,
    "numero_total": 4232,
    "sme_total": 18685,
    "numero_home": 2408,
    "sme_home": 18683,
    "numero_dona": 1824,
    "sme_dona": 18687,
    "maxim": 18778,
    "percent_asalariat": 22.8,
    "percent_salari": 13.61,
    "comunitat": "balears"
  },
  {
    "centil": 30,
    "numero_total": 4347,
    "sme_total": 18867,
    "numero_home": 2373,
    "sme_home": 18869,
    "numero_dona": 1974,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 23.8,
    "percent_salari": 14.28,
    "comunitat": "balears"
  },
  {
    "centil": 31,
    "numero_total": 4123,
    "sme_total": 19040,
    "numero_home": 2335,
    "sme_home": 19039,
    "numero_dona": 1788,
    "sme_dona": 19040,
    "maxim": 19133,
    "percent_asalariat": 24.8,
    "percent_salari": 14.92,
    "comunitat": "balears"
  },
  {
    "centil": 32,
    "numero_total": 4249,
    "sme_total": 19224,
    "numero_home": 2498,
    "sme_home": 19223,
    "numero_dona": 1751,
    "sme_dona": 19224,
    "maxim": 19317,
    "percent_asalariat": 25.7,
    "percent_salari": 15.59,
    "comunitat": "balears"
  },
  {
    "centil": 33,
    "numero_total": 4385,
    "sme_total": 19412,
    "numero_home": 2523,
    "sme_home": 19412,
    "numero_dona": 1862,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 26.7,
    "percent_salari": 16.29,
    "comunitat": "balears"
  },
  {
    "centil": 34,
    "numero_total": 4114,
    "sme_total": 19596,
    "numero_home": 2344,
    "sme_home": 19596,
    "numero_dona": 1770,
    "sme_dona": 19595,
    "maxim": 19691,
    "percent_asalariat": 27.7,
    "percent_salari": 16.96,
    "comunitat": "balears"
  },
  {
    "centil": 35,
    "numero_total": 4387,
    "sme_total": 19788,
    "numero_home": 2486,
    "sme_home": 19788,
    "numero_dona": 1901,
    "sme_dona": 19789,
    "maxim": 19879,
    "percent_asalariat": 28.7,
    "percent_salari": 17.67,
    "comunitat": "balears"
  },
  {
    "centil": 36,
    "numero_total": 4799,
    "sme_total": 19974,
    "numero_home": 2693,
    "sme_home": 19974,
    "numero_dona": 2106,
    "sme_dona": 19973,
    "maxim": 20069,
    "percent_asalariat": 29.8,
    "percent_salari": 18.46,
    "comunitat": "balears"
  },
  {
    "centil": 37,
    "numero_total": 5299,
    "sme_total": 20168,
    "numero_home": 3156,
    "sme_home": 20169,
    "numero_dona": 2143,
    "sme_dona": 20165,
    "maxim": 20263,
    "percent_asalariat": 31,
    "percent_salari": 19.33,
    "comunitat": "balears"
  },
  {
    "centil": 38,
    "numero_total": 5212,
    "sme_total": 20365,
    "numero_home": 3213,
    "sme_home": 20367,
    "numero_dona": 1999,
    "sme_dona": 20361,
    "maxim": 20459,
    "percent_asalariat": 32.2,
    "percent_salari": 20.21,
    "comunitat": "balears"
  },
  {
    "centil": 39,
    "numero_total": 5037,
    "sme_total": 20553,
    "numero_home": 3041,
    "sme_home": 20549,
    "numero_dona": 1996,
    "sme_dona": 20560,
    "maxim": 20653,
    "percent_asalariat": 33.3,
    "percent_salari": 21.06,
    "comunitat": "balears"
  },
  {
    "centil": 40,
    "numero_total": 5316,
    "sme_total": 20759,
    "numero_home": 2873,
    "sme_home": 20759,
    "numero_dona": 2443,
    "sme_dona": 20759,
    "maxim": 20854,
    "percent_asalariat": 34.6,
    "percent_salari": 21.96,
    "comunitat": "balears"
  },
  {
    "centil": 41,
    "numero_total": 5944,
    "sme_total": 20951,
    "numero_home": 3212,
    "sme_home": 20950,
    "numero_dona": 2732,
    "sme_dona": 20953,
    "maxim": 21055,
    "percent_asalariat": 35.9,
    "percent_salari": 22.99,
    "comunitat": "balears"
  },
  {
    "centil": 42,
    "numero_total": 5964,
    "sme_total": 21155,
    "numero_home": 3215,
    "sme_home": 21156,
    "numero_dona": 2749,
    "sme_dona": 21155,
    "maxim": 21267,
    "percent_asalariat": 37.3,
    "percent_salari": 24.02,
    "comunitat": "balears"
  },
  {
    "centil": 43,
    "numero_total": 5215,
    "sme_total": 21375,
    "numero_home": 2955,
    "sme_home": 21374,
    "numero_dona": 2260,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 38.5,
    "percent_salari": 24.94,
    "comunitat": "balears"
  },
  {
    "centil": 44,
    "numero_total": 4992,
    "sme_total": 21591,
    "numero_home": 2822,
    "sme_home": 21592,
    "numero_dona": 2170,
    "sme_dona": 21590,
    "maxim": 21701,
    "percent_asalariat": 39.6,
    "percent_salari": 25.82,
    "comunitat": "balears"
  },
  {
    "centil": 45,
    "numero_total": 5650,
    "sme_total": 21816,
    "numero_home": 3276,
    "sme_home": 21819,
    "numero_dona": 2374,
    "sme_dona": 21813,
    "maxim": 21927,
    "percent_asalariat": 40.9,
    "percent_salari": 26.84,
    "comunitat": "balears"
  },
  {
    "centil": 46,
    "numero_total": 6465,
    "sme_total": 22035,
    "numero_home": 3597,
    "sme_home": 22037,
    "numero_dona": 2868,
    "sme_dona": 22034,
    "maxim": 22151,
    "percent_asalariat": 42.4,
    "percent_salari": 28.01,
    "comunitat": "balears"
  },
  {
    "centil": 47,
    "numero_total": 7173,
    "sme_total": 22262,
    "numero_home": 3979,
    "sme_home": 22262,
    "numero_dona": 3194,
    "sme_dona": 22262,
    "maxim": 22380,
    "percent_asalariat": 44,
    "percent_salari": 29.32,
    "comunitat": "balears"
  },
  {
    "centil": 48,
    "numero_total": 6726,
    "sme_total": 22499,
    "numero_home": 3840,
    "sme_home": 22499,
    "numero_dona": 2886,
    "sme_dona": 22498,
    "maxim": 22616,
    "percent_asalariat": 45.6,
    "percent_salari": 30.56,
    "comunitat": "balears"
  },
  {
    "centil": 49,
    "numero_total": 7212,
    "sme_total": 22738,
    "numero_home": 4222,
    "sme_home": 22737,
    "numero_dona": 2990,
    "sme_dona": 22739,
    "maxim": 22865,
    "percent_asalariat": 47.2,
    "percent_salari": 31.91,
    "comunitat": "balears"
  },
  {
    "centil": 50,
    "numero_total": 7637,
    "sme_total": 22988,
    "numero_home": 4836,
    "sme_home": 22989,
    "numero_dona": 2801,
    "sme_dona": 22988,
    "maxim": 23114,
    "percent_asalariat": 49,
    "percent_salari": 33.35,
    "comunitat": "balears"
  },
  {
    "centil": 51,
    "numero_total": 6080,
    "sme_total": 23244,
    "numero_home": 3269,
    "sme_home": 23242,
    "numero_dona": 2811,
    "sme_dona": 23247,
    "maxim": 23377,
    "percent_asalariat": 50.3,
    "percent_salari": 34.51,
    "comunitat": "balears"
  },
  {
    "centil": 52,
    "numero_total": 5937,
    "sme_total": 23513,
    "numero_home": 3176,
    "sme_home": 23512,
    "numero_dona": 2761,
    "sme_dona": 23515,
    "maxim": 23645,
    "percent_asalariat": 51.7,
    "percent_salari": 35.66,
    "comunitat": "balears"
  },
  {
    "centil": 53,
    "numero_total": 5970,
    "sme_total": 23783,
    "numero_home": 3198,
    "sme_home": 23781,
    "numero_dona": 2772,
    "sme_dona": 23785,
    "maxim": 23925,
    "percent_asalariat": 53.1,
    "percent_salari": 36.82,
    "comunitat": "balears"
  },
  {
    "centil": 54,
    "numero_total": 5910,
    "sme_total": 24058,
    "numero_home": 3064,
    "sme_home": 24057,
    "numero_dona": 2846,
    "sme_dona": 24059,
    "maxim": 24198,
    "percent_asalariat": 54.4,
    "percent_salari": 37.99,
    "comunitat": "balears"
  },
  {
    "centil": 55,
    "numero_total": 6304,
    "sme_total": 24347,
    "numero_home": 3220,
    "sme_home": 24347,
    "numero_dona": 3084,
    "sme_dona": 24347,
    "maxim": 24501,
    "percent_asalariat": 55.9,
    "percent_salari": 39.25,
    "comunitat": "balears"
  },
  {
    "centil": 56,
    "numero_total": 6269,
    "sme_total": 24655,
    "numero_home": 3090,
    "sme_home": 24653,
    "numero_dona": 3179,
    "sme_dona": 24657,
    "maxim": 24811,
    "percent_asalariat": 57.3,
    "percent_salari": 40.52,
    "comunitat": "balears"
  },
  {
    "centil": 57,
    "numero_total": 6446,
    "sme_total": 24964,
    "numero_home": 3036,
    "sme_home": 24962,
    "numero_dona": 3410,
    "sme_dona": 24965,
    "maxim": 25122,
    "percent_asalariat": 58.8,
    "percent_salari": 41.84,
    "comunitat": "balears"
  },
  {
    "centil": 58,
    "numero_total": 6472,
    "sme_total": 25284,
    "numero_home": 3045,
    "sme_home": 25284,
    "numero_dona": 3427,
    "sme_dona": 25284,
    "maxim": 25450,
    "percent_asalariat": 60.3,
    "percent_salari": 43.19,
    "comunitat": "balears"
  },
  {
    "centil": 59,
    "numero_total": 6544,
    "sme_total": 25621,
    "numero_home": 2961,
    "sme_home": 25620,
    "numero_dona": 3583,
    "sme_dona": 25621,
    "maxim": 25792,
    "percent_asalariat": 61.8,
    "percent_salari": 44.56,
    "comunitat": "balears"
  },
  {
    "centil": 60,
    "numero_total": 6304,
    "sme_total": 25963,
    "numero_home": 2892,
    "sme_home": 25962,
    "numero_dona": 3412,
    "sme_dona": 25963,
    "maxim": 26139,
    "percent_asalariat": 63.2,
    "percent_salari": 45.91,
    "comunitat": "balears"
  },
  {
    "centil": 61,
    "numero_total": 5703,
    "sme_total": 26323,
    "numero_home": 2783,
    "sme_home": 26324,
    "numero_dona": 2920,
    "sme_dona": 26321,
    "maxim": 26509,
    "percent_asalariat": 64.5,
    "percent_salari": 47.14,
    "comunitat": "balears"
  },
  {
    "centil": 62,
    "numero_total": 5365,
    "sme_total": 26692,
    "numero_home": 2651,
    "sme_home": 26693,
    "numero_dona": 2714,
    "sme_dona": 26691,
    "maxim": 26874,
    "percent_asalariat": 65.7,
    "percent_salari": 48.32,
    "comunitat": "balears"
  },
  {
    "centil": 63,
    "numero_total": 5155,
    "sme_total": 27048,
    "numero_home": 2547,
    "sme_home": 27046,
    "numero_dona": 2608,
    "sme_dona": 27051,
    "maxim": 27221,
    "percent_asalariat": 66.9,
    "percent_salari": 49.46,
    "comunitat": "balears"
  },
  {
    "centil": 64,
    "numero_total": 5470,
    "sme_total": 27413,
    "numero_home": 2840,
    "sme_home": 27417,
    "numero_dona": 2630,
    "sme_dona": 27409,
    "maxim": 27616,
    "percent_asalariat": 68.2,
    "percent_salari": 50.69,
    "comunitat": "balears"
  },
  {
    "centil": 65,
    "numero_total": 5203,
    "sme_total": 27817,
    "numero_home": 2730,
    "sme_home": 27818,
    "numero_dona": 2473,
    "sme_dona": 27816,
    "maxim": 28031,
    "percent_asalariat": 69.3,
    "percent_salari": 51.88,
    "comunitat": "balears"
  },
  {
    "centil": 66,
    "numero_total": 5222,
    "sme_total": 28251,
    "numero_home": 2780,
    "sme_home": 28248,
    "numero_dona": 2442,
    "sme_dona": 28255,
    "maxim": 28476,
    "percent_asalariat": 70.5,
    "percent_salari": 53.09,
    "comunitat": "balears"
  },
  {
    "centil": 67,
    "numero_total": 5091,
    "sme_total": 28711,
    "numero_home": 2640,
    "sme_home": 28708,
    "numero_dona": 2451,
    "sme_dona": 28713,
    "maxim": 28951,
    "percent_asalariat": 71.7,
    "percent_salari": 54.3,
    "comunitat": "balears"
  },
  {
    "centil": 68,
    "numero_total": 5032,
    "sme_total": 29196,
    "numero_home": 2691,
    "sme_home": 29196,
    "numero_dona": 2341,
    "sme_dona": 29197,
    "maxim": 29450,
    "percent_asalariat": 72.9,
    "percent_salari": 55.5,
    "comunitat": "balears"
  },
  {
    "centil": 69,
    "numero_total": 4815,
    "sme_total": 29706,
    "numero_home": 2507,
    "sme_home": 29707,
    "numero_dona": 2308,
    "sme_dona": 29705,
    "maxim": 29970,
    "percent_asalariat": 74,
    "percent_salari": 56.68,
    "comunitat": "balears"
  },
  {
    "centil": 70,
    "numero_total": 4594,
    "sme_total": 30218,
    "numero_home": 2479,
    "sme_home": 30217,
    "numero_dona": 2115,
    "sme_dona": 30219,
    "maxim": 30487,
    "percent_asalariat": 75,
    "percent_salari": 57.82,
    "comunitat": "balears"
  },
  {
    "centil": 71,
    "numero_total": 4444,
    "sme_total": 30758,
    "numero_home": 2380,
    "sme_home": 30756,
    "numero_dona": 2064,
    "sme_dona": 30760,
    "maxim": 31037,
    "percent_asalariat": 76,
    "percent_salari": 58.94,
    "comunitat": "balears"
  },
  {
    "centil": 72,
    "numero_total": 4341,
    "sme_total": 31314,
    "numero_home": 2333,
    "sme_home": 31316,
    "numero_dona": 2008,
    "sme_dona": 31312,
    "maxim": 31602,
    "percent_asalariat": 77,
    "percent_salari": 60.06,
    "comunitat": "balears"
  },
  {
    "centil": 73,
    "numero_total": 3981,
    "sme_total": 31888,
    "numero_home": 2072,
    "sme_home": 31887,
    "numero_dona": 1909,
    "sme_dona": 31888,
    "maxim": 32176,
    "percent_asalariat": 77.9,
    "percent_salari": 61.1,
    "comunitat": "balears"
  },
  {
    "centil": 74,
    "numero_total": 4007,
    "sme_total": 32479,
    "numero_home": 2079,
    "sme_home": 32478,
    "numero_dona": 1928,
    "sme_dona": 32479,
    "maxim": 32786,
    "percent_asalariat": 78.8,
    "percent_salari": 62.17,
    "comunitat": "balears"
  },
  {
    "centil": 75,
    "numero_total": 4002,
    "sme_total": 33097,
    "numero_home": 1995,
    "sme_home": 33091,
    "numero_dona": 2007,
    "sme_dona": 33102,
    "maxim": 33413,
    "percent_asalariat": 79.8,
    "percent_salari": 63.26,
    "comunitat": "balears"
  },
  {
    "centil": 76,
    "numero_total": 4063,
    "sme_total": 33735,
    "numero_home": 2019,
    "sme_home": 33738,
    "numero_dona": 2044,
    "sme_dona": 33733,
    "maxim": 34056,
    "percent_asalariat": 80.7,
    "percent_salari": 64.38,
    "comunitat": "balears"
  },
  {
    "centil": 77,
    "numero_total": 3762,
    "sme_total": 34378,
    "numero_home": 1948,
    "sme_home": 34380,
    "numero_dona": 1814,
    "sme_dona": 34375,
    "maxim": 34722,
    "percent_asalariat": 81.6,
    "percent_salari": 65.44,
    "comunitat": "balears"
  },
  {
    "centil": 78,
    "numero_total": 3710,
    "sme_total": 35046,
    "numero_home": 1928,
    "sme_home": 35048,
    "numero_dona": 1782,
    "sme_dona": 35044,
    "maxim": 35374,
    "percent_asalariat": 82.4,
    "percent_salari": 66.51,
    "comunitat": "balears"
  },
  {
    "centil": 79,
    "numero_total": 3517,
    "sme_total": 35711,
    "numero_home": 1787,
    "sme_home": 35715,
    "numero_dona": 1730,
    "sme_dona": 35707,
    "maxim": 36027,
    "percent_asalariat": 83.2,
    "percent_salari": 67.54,
    "comunitat": "balears"
  },
  {
    "centil": 80,
    "numero_total": 3866,
    "sme_total": 36383,
    "numero_home": 1951,
    "sme_home": 36384,
    "numero_dona": 1915,
    "sme_dona": 36381,
    "maxim": 36730,
    "percent_asalariat": 84.1,
    "percent_salari": 68.7,
    "comunitat": "balears"
  },
  {
    "centil": 81,
    "numero_total": 4064,
    "sme_total": 37104,
    "numero_home": 1965,
    "sme_home": 37098,
    "numero_dona": 2099,
    "sme_dona": 37110,
    "maxim": 37490,
    "percent_asalariat": 85,
    "percent_salari": 69.94,
    "comunitat": "balears"
  },
  {
    "centil": 82,
    "numero_total": 4042,
    "sme_total": 37886,
    "numero_home": 1994,
    "sme_home": 37887,
    "numero_dona": 2048,
    "sme_dona": 37885,
    "maxim": 38304,
    "percent_asalariat": 85.9,
    "percent_salari": 71.19,
    "comunitat": "balears"
  },
  {
    "centil": 83,
    "numero_total": 3960,
    "sme_total": 38751,
    "numero_home": 2036,
    "sme_home": 38754,
    "numero_dona": 1924,
    "sme_dona": 38748,
    "maxim": 39197,
    "percent_asalariat": 86.9,
    "percent_salari": 72.46,
    "comunitat": "balears"
  },
  {
    "centil": 84,
    "numero_total": 3868,
    "sme_total": 39665,
    "numero_home": 2054,
    "sme_home": 39664,
    "numero_dona": 1814,
    "sme_dona": 39667,
    "maxim": 40137,
    "percent_asalariat": 87.7,
    "percent_salari": 73.72,
    "comunitat": "balears"
  },
  {
    "centil": 85,
    "numero_total": 3863,
    "sme_total": 40643,
    "numero_home": 2031,
    "sme_home": 40646,
    "numero_dona": 1832,
    "sme_dona": 40640,
    "maxim": 41170,
    "percent_asalariat": 88.6,
    "percent_salari": 75.01,
    "comunitat": "balears"
  },
  {
    "centil": 86,
    "numero_total": 3858,
    "sme_total": 41729,
    "numero_home": 2052,
    "sme_home": 41734,
    "numero_dona": 1806,
    "sme_dona": 41724,
    "maxim": 42306,
    "percent_asalariat": 89.5,
    "percent_salari": 76.33,
    "comunitat": "balears"
  },
  {
    "centil": 87,
    "numero_total": 3847,
    "sme_total": 42901,
    "numero_home": 2099,
    "sme_home": 42899,
    "numero_dona": 1748,
    "sme_dona": 42904,
    "maxim": 43519,
    "percent_asalariat": 90.4,
    "percent_salari": 77.68,
    "comunitat": "balears"
  },
  {
    "centil": 88,
    "numero_total": 3701,
    "sme_total": 44171,
    "numero_home": 2079,
    "sme_home": 44160,
    "numero_dona": 1622,
    "sme_dona": 44185,
    "maxim": 44857,
    "percent_asalariat": 91.2,
    "percent_salari": 79.03,
    "comunitat": "balears"
  },
  {
    "centil": 89,
    "numero_total": 3654,
    "sme_total": 45575,
    "numero_home": 2053,
    "sme_home": 45578,
    "numero_dona": 1601,
    "sme_dona": 45572,
    "maxim": 46326,
    "percent_asalariat": 92.1,
    "percent_salari": 80.39,
    "comunitat": "balears"
  },
  {
    "centil": 90,
    "numero_total": 3587,
    "sme_total": 47129,
    "numero_home": 1968,
    "sme_home": 47130,
    "numero_dona": 1619,
    "sme_dona": 47128,
    "maxim": 48005,
    "percent_asalariat": 92.9,
    "percent_salari": 81.78,
    "comunitat": "balears"
  },
  {
    "centil": 91,
    "numero_total": 3378,
    "sme_total": 48928,
    "numero_home": 1930,
    "sme_home": 48943,
    "numero_dona": 1448,
    "sme_dona": 48909,
    "maxim": 49888,
    "percent_asalariat": 93.7,
    "percent_salari": 83.14,
    "comunitat": "balears"
  },
  {
    "centil": 92,
    "numero_total": 3398,
    "sme_total": 50941,
    "numero_home": 1946,
    "sme_home": 50943,
    "numero_dona": 1452,
    "sme_dona": 50940,
    "maxim": 52064,
    "percent_asalariat": 94.4,
    "percent_salari": 84.56,
    "comunitat": "balears"
  },
  {
    "centil": 93,
    "numero_total": 3239,
    "sme_total": 53356,
    "numero_home": 1960,
    "sme_home": 53336,
    "numero_dona": 1279,
    "sme_dona": 53387,
    "maxim": 54742,
    "percent_asalariat": 95.2,
    "percent_salari": 85.98,
    "comunitat": "balears"
  },
  {
    "centil": 94,
    "numero_total": 3126,
    "sme_total": 56288,
    "numero_home": 1882,
    "sme_home": 56300,
    "numero_dona": 1244,
    "sme_dona": 56269,
    "maxim": 57976,
    "percent_asalariat": 95.9,
    "percent_salari": 87.43,
    "comunitat": "balears"
  },
  {
    "centil": 95,
    "numero_total": 3072,
    "sme_total": 59852,
    "numero_home": 1919,
    "sme_home": 59866,
    "numero_dona": 1153,
    "sme_dona": 59830,
    "maxim": 61939,
    "percent_asalariat": 96.6,
    "percent_salari": 88.94,
    "comunitat": "balears"
  },
  {
    "centil": 96,
    "numero_total": 3028,
    "sme_total": 64328,
    "numero_home": 1849,
    "sme_home": 64347,
    "numero_dona": 1179,
    "sme_dona": 64298,
    "maxim": 66966,
    "percent_asalariat": 97.3,
    "percent_salari": 90.54,
    "comunitat": "balears"
  },
  {
    "centil": 97,
    "numero_total": 3079,
    "sme_total": 70182,
    "numero_home": 1877,
    "sme_home": 70151,
    "numero_dona": 1202,
    "sme_dona": 70231,
    "maxim": 73778,
    "percent_asalariat": 98,
    "percent_salari": 92.31,
    "comunitat": "balears"
  },
  {
    "centil": 98,
    "numero_total": 3025,
    "sme_total": 78432,
    "numero_home": 1898,
    "sme_home": 78443,
    "numero_dona": 1127,
    "sme_dona": 78414,
    "maxim": 83931,
    "percent_asalariat": 98.7,
    "percent_salari": 94.26,
    "comunitat": "balears"
  },
  {
    "centil": 99,
    "numero_total": 3035,
    "sme_total": 92262,
    "numero_home": 1999,
    "sme_home": 92234,
    "numero_dona": 1036,
    "sme_dona": 92317,
    "maxim": 104199,
    "percent_asalariat": 99.4,
    "percent_salari": 96.56,
    "comunitat": "balears"
  },
  {
    "centil": 100,
    "numero_total": 2714,
    "sme_total": 154322,
    "numero_home": 2078,
    "sme_home": 157434,
    "numero_dona": 636,
    "sme_dona": 144157,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "balears"
  },
  {
    "centil": 1,
    "numero_total": 12308,
    "sme_total": 14044,
    "numero_home": 5931,
    "sme_home": 14043,
    "numero_dona": 6377,
    "sme_dona": 14045,
    "maxim": 14139,
    "percent_asalariat": 2,
    "percent_salari": 1.07,
    "comunitat": "canaries"
  },
  {
    "centil": 2,
    "numero_total": 9519,
    "sme_total": 14218,
    "numero_home": 4514,
    "sme_home": 14218,
    "numero_dona": 5005,
    "sme_dona": 14218,
    "maxim": 14300,
    "percent_asalariat": 3.5,
    "percent_salari": 1.9,
    "comunitat": "canaries"
  },
  {
    "centil": 3,
    "numero_total": 9036,
    "sme_total": 14380,
    "numero_home": 4315,
    "sme_home": 14381,
    "numero_dona": 4721,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 4.9,
    "percent_salari": 2.71,
    "comunitat": "canaries"
  },
  {
    "centil": 4,
    "numero_total": 8854,
    "sme_total": 14537,
    "numero_home": 4198,
    "sme_home": 14537,
    "numero_dona": 4656,
    "sme_dona": 14537,
    "maxim": 14618,
    "percent_asalariat": 6.3,
    "percent_salari": 3.5,
    "comunitat": "canaries"
  },
  {
    "centil": 5,
    "numero_total": 8512,
    "sme_total": 14696,
    "numero_home": 3973,
    "sme_home": 14696,
    "numero_dona": 4539,
    "sme_dona": 14696,
    "maxim": 14776,
    "percent_asalariat": 7.6,
    "percent_salari": 4.28,
    "comunitat": "canaries"
  },
  {
    "centil": 6,
    "numero_total": 7852,
    "sme_total": 14856,
    "numero_home": 3868,
    "sme_home": 14857,
    "numero_dona": 3984,
    "sme_dona": 14856,
    "maxim": 14934,
    "percent_asalariat": 8.9,
    "percent_salari": 5,
    "comunitat": "canaries"
  },
  {
    "centil": 7,
    "numero_total": 8067,
    "sme_total": 15012,
    "numero_home": 4085,
    "sme_home": 15011,
    "numero_dona": 3982,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 10.2,
    "percent_salari": 5.75,
    "comunitat": "canaries"
  },
  {
    "centil": 8,
    "numero_total": 7685,
    "sme_total": 15169,
    "numero_home": 3829,
    "sme_home": 15169,
    "numero_dona": 3856,
    "sme_dona": 15169,
    "maxim": 15248,
    "percent_asalariat": 11.4,
    "percent_salari": 6.47,
    "comunitat": "canaries"
  },
  {
    "centil": 9,
    "numero_total": 7756,
    "sme_total": 15329,
    "numero_home": 3955,
    "sme_home": 15330,
    "numero_dona": 3801,
    "sme_dona": 15327,
    "maxim": 15407,
    "percent_asalariat": 12.6,
    "percent_salari": 7.2,
    "comunitat": "canaries"
  },
  {
    "centil": 10,
    "numero_total": 7636,
    "sme_total": 15487,
    "numero_home": 3998,
    "sme_home": 15487,
    "numero_dona": 3638,
    "sme_dona": 15486,
    "maxim": 15567,
    "percent_asalariat": 13.8,
    "percent_salari": 7.93,
    "comunitat": "canaries"
  },
  {
    "centil": 11,
    "numero_total": 7764,
    "sme_total": 15646,
    "numero_home": 4073,
    "sme_home": 15647,
    "numero_dona": 3691,
    "sme_dona": 15645,
    "maxim": 15726,
    "percent_asalariat": 15.1,
    "percent_salari": 8.68,
    "comunitat": "canaries"
  },
  {
    "centil": 12,
    "numero_total": 7418,
    "sme_total": 15806,
    "numero_home": 3951,
    "sme_home": 15806,
    "numero_dona": 3467,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 16.2,
    "percent_salari": 9.41,
    "comunitat": "canaries"
  },
  {
    "centil": 13,
    "numero_total": 7908,
    "sme_total": 15966,
    "numero_home": 4334,
    "sme_home": 15967,
    "numero_dona": 3574,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 17.5,
    "percent_salari": 10.19,
    "comunitat": "canaries"
  },
  {
    "centil": 14,
    "numero_total": 7607,
    "sme_total": 16126,
    "numero_home": 4074,
    "sme_home": 16126,
    "numero_dona": 3533,
    "sme_dona": 16125,
    "maxim": 16207,
    "percent_asalariat": 18.7,
    "percent_salari": 10.94,
    "comunitat": "canaries"
  },
  {
    "centil": 15,
    "numero_total": 7597,
    "sme_total": 16290,
    "numero_home": 4129,
    "sme_home": 16289,
    "numero_dona": 3468,
    "sme_dona": 16291,
    "maxim": 16371,
    "percent_asalariat": 19.9,
    "percent_salari": 11.71,
    "comunitat": "canaries"
  },
  {
    "centil": 16,
    "numero_total": 7492,
    "sme_total": 16452,
    "numero_home": 4245,
    "sme_home": 16452,
    "numero_dona": 3247,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 21.1,
    "percent_salari": 12.47,
    "comunitat": "canaries"
  },
  {
    "centil": 17,
    "numero_total": 7829,
    "sme_total": 16608,
    "numero_home": 4458,
    "sme_home": 16608,
    "numero_dona": 3371,
    "sme_dona": 16607,
    "maxim": 16692,
    "percent_asalariat": 22.3,
    "percent_salari": 13.27,
    "comunitat": "canaries"
  },
  {
    "centil": 18,
    "numero_total": 7772,
    "sme_total": 16774,
    "numero_home": 4430,
    "sme_home": 16773,
    "numero_dona": 3342,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 23.6,
    "percent_salari": 14.08,
    "comunitat": "canaries"
  },
  {
    "centil": 19,
    "numero_total": 7875,
    "sme_total": 16940,
    "numero_home": 4638,
    "sme_home": 16940,
    "numero_dona": 3237,
    "sme_dona": 16941,
    "maxim": 17023,
    "percent_asalariat": 24.8,
    "percent_salari": 14.9,
    "comunitat": "canaries"
  },
  {
    "centil": 20,
    "numero_total": 8109,
    "sme_total": 17108,
    "numero_home": 4821,
    "sme_home": 17109,
    "numero_dona": 3288,
    "sme_dona": 17107,
    "maxim": 17196,
    "percent_asalariat": 26.1,
    "percent_salari": 15.76,
    "comunitat": "canaries"
  },
  {
    "centil": 21,
    "numero_total": 8296,
    "sme_total": 17282,
    "numero_home": 5030,
    "sme_home": 17281,
    "numero_dona": 3266,
    "sme_dona": 17282,
    "maxim": 17369,
    "percent_asalariat": 27.4,
    "percent_salari": 16.65,
    "comunitat": "canaries"
  },
  {
    "centil": 22,
    "numero_total": 8061,
    "sme_total": 17454,
    "numero_home": 4888,
    "sme_home": 17454,
    "numero_dona": 3173,
    "sme_dona": 17455,
    "maxim": 17543,
    "percent_asalariat": 28.7,
    "percent_salari": 17.52,
    "comunitat": "canaries"
  },
  {
    "centil": 23,
    "numero_total": 8220,
    "sme_total": 17631,
    "numero_home": 5156,
    "sme_home": 17631,
    "numero_dona": 3064,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 30,
    "percent_salari": 18.41,
    "comunitat": "canaries"
  },
  {
    "centil": 24,
    "numero_total": 8223,
    "sme_total": 17803,
    "numero_home": 5114,
    "sme_home": 17804,
    "numero_dona": 3109,
    "sme_dona": 17803,
    "maxim": 17891,
    "percent_asalariat": 31.3,
    "percent_salari": 19.32,
    "comunitat": "canaries"
  },
  {
    "centil": 25,
    "numero_total": 8517,
    "sme_total": 17977,
    "numero_home": 5319,
    "sme_home": 17977,
    "numero_dona": 3198,
    "sme_dona": 17976,
    "maxim": 18060,
    "percent_asalariat": 32.6,
    "percent_salari": 20.26,
    "comunitat": "canaries"
  },
  {
    "centil": 26,
    "numero_total": 8745,
    "sme_total": 18148,
    "numero_home": 5644,
    "sme_home": 18148,
    "numero_dona": 3101,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 34,
    "percent_salari": 21.24,
    "comunitat": "canaries"
  },
  {
    "centil": 27,
    "numero_total": 9466,
    "sme_total": 18330,
    "numero_home": 6135,
    "sme_home": 18329,
    "numero_dona": 3331,
    "sme_dona": 18331,
    "maxim": 18417,
    "percent_asalariat": 35.5,
    "percent_salari": 22.32,
    "comunitat": "canaries"
  },
  {
    "centil": 28,
    "numero_total": 8707,
    "sme_total": 18506,
    "numero_home": 5580,
    "sme_home": 18506,
    "numero_dona": 3127,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 36.9,
    "percent_salari": 23.31,
    "comunitat": "canaries"
  },
  {
    "centil": 29,
    "numero_total": 8296,
    "sme_total": 18686,
    "numero_home": 5212,
    "sme_home": 18686,
    "numero_dona": 3084,
    "sme_dona": 18687,
    "maxim": 18778,
    "percent_asalariat": 38.2,
    "percent_salari": 24.27,
    "comunitat": "canaries"
  },
  {
    "centil": 30,
    "numero_total": 8818,
    "sme_total": 18868,
    "numero_home": 5572,
    "sme_home": 18869,
    "numero_dona": 3246,
    "sme_dona": 18867,
    "maxim": 18953,
    "percent_asalariat": 39.6,
    "percent_salari": 25.3,
    "comunitat": "canaries"
  },
  {
    "centil": 31,
    "numero_total": 8335,
    "sme_total": 19037,
    "numero_home": 5166,
    "sme_home": 19036,
    "numero_dona": 3169,
    "sme_dona": 19038,
    "maxim": 19133,
    "percent_asalariat": 40.9,
    "percent_salari": 26.28,
    "comunitat": "canaries"
  },
  {
    "centil": 32,
    "numero_total": 7622,
    "sme_total": 19224,
    "numero_home": 4780,
    "sme_home": 19223,
    "numero_dona": 2842,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 42.2,
    "percent_salari": 27.18,
    "comunitat": "canaries"
  },
  {
    "centil": 33,
    "numero_total": 7489,
    "sme_total": 19411,
    "numero_home": 4539,
    "sme_home": 19411,
    "numero_dona": 2950,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 43.3,
    "percent_salari": 28.08,
    "comunitat": "canaries"
  },
  {
    "centil": 34,
    "numero_total": 7498,
    "sme_total": 19596,
    "numero_home": 4430,
    "sme_home": 19596,
    "numero_dona": 3068,
    "sme_dona": 19598,
    "maxim": 19691,
    "percent_asalariat": 44.5,
    "percent_salari": 28.99,
    "comunitat": "canaries"
  },
  {
    "centil": 35,
    "numero_total": 7422,
    "sme_total": 19784,
    "numero_home": 4410,
    "sme_home": 19783,
    "numero_dona": 3012,
    "sme_dona": 19786,
    "maxim": 19879,
    "percent_asalariat": 45.7,
    "percent_salari": 29.9,
    "comunitat": "canaries"
  },
  {
    "centil": 36,
    "numero_total": 7059,
    "sme_total": 19973,
    "numero_home": 4084,
    "sme_home": 19973,
    "numero_dona": 2975,
    "sme_dona": 19973,
    "maxim": 20069,
    "percent_asalariat": 46.8,
    "percent_salari": 30.77,
    "comunitat": "canaries"
  },
  {
    "centil": 37,
    "numero_total": 7172,
    "sme_total": 20167,
    "numero_home": 4100,
    "sme_home": 20167,
    "numero_dona": 3072,
    "sme_dona": 20168,
    "maxim": 20263,
    "percent_asalariat": 48,
    "percent_salari": 31.66,
    "comunitat": "canaries"
  },
  {
    "centil": 38,
    "numero_total": 7296,
    "sme_total": 20361,
    "numero_home": 4253,
    "sme_home": 20361,
    "numero_dona": 3043,
    "sme_dona": 20362,
    "maxim": 20459,
    "percent_asalariat": 49.1,
    "percent_salari": 32.58,
    "comunitat": "canaries"
  },
  {
    "centil": 39,
    "numero_total": 7042,
    "sme_total": 20557,
    "numero_home": 4121,
    "sme_home": 20558,
    "numero_dona": 2921,
    "sme_dona": 20557,
    "maxim": 20653,
    "percent_asalariat": 50.2,
    "percent_salari": 33.48,
    "comunitat": "canaries"
  },
  {
    "centil": 40,
    "numero_total": 7389,
    "sme_total": 20754,
    "numero_home": 4093,
    "sme_home": 20753,
    "numero_dona": 3296,
    "sme_dona": 20755,
    "maxim": 20854,
    "percent_asalariat": 51.4,
    "percent_salari": 34.42,
    "comunitat": "canaries"
  },
  {
    "centil": 41,
    "numero_total": 6980,
    "sme_total": 20955,
    "numero_home": 3918,
    "sme_home": 20955,
    "numero_dona": 3062,
    "sme_dona": 20955,
    "maxim": 21055,
    "percent_asalariat": 52.5,
    "percent_salari": 35.33,
    "comunitat": "canaries"
  },
  {
    "centil": 42,
    "numero_total": 6892,
    "sme_total": 21163,
    "numero_home": 3937,
    "sme_home": 21163,
    "numero_dona": 2955,
    "sme_dona": 21164,
    "maxim": 21267,
    "percent_asalariat": 53.6,
    "percent_salari": 36.23,
    "comunitat": "canaries"
  },
  {
    "centil": 43,
    "numero_total": 7150,
    "sme_total": 21373,
    "numero_home": 4044,
    "sme_home": 21374,
    "numero_dona": 3106,
    "sme_dona": 21373,
    "maxim": 21483,
    "percent_asalariat": 54.7,
    "percent_salari": 37.17,
    "comunitat": "canaries"
  },
  {
    "centil": 44,
    "numero_total": 6671,
    "sme_total": 21591,
    "numero_home": 3841,
    "sme_home": 21591,
    "numero_dona": 2830,
    "sme_dona": 21591,
    "maxim": 21701,
    "percent_asalariat": 55.8,
    "percent_salari": 38.06,
    "comunitat": "canaries"
  },
  {
    "centil": 45,
    "numero_total": 6420,
    "sme_total": 21815,
    "numero_home": 3623,
    "sme_home": 21815,
    "numero_dona": 2797,
    "sme_dona": 21816,
    "maxim": 21927,
    "percent_asalariat": 56.8,
    "percent_salari": 38.93,
    "comunitat": "canaries"
  },
  {
    "centil": 46,
    "numero_total": 6266,
    "sme_total": 22035,
    "numero_home": 3528,
    "sme_home": 22036,
    "numero_dona": 2738,
    "sme_dona": 22035,
    "maxim": 22151,
    "percent_asalariat": 57.8,
    "percent_salari": 39.78,
    "comunitat": "canaries"
  },
  {
    "centil": 47,
    "numero_total": 6217,
    "sme_total": 22265,
    "numero_home": 3638,
    "sme_home": 22265,
    "numero_dona": 2579,
    "sme_dona": 22264,
    "maxim": 22380,
    "percent_asalariat": 58.8,
    "percent_salari": 40.64,
    "comunitat": "canaries"
  },
  {
    "centil": 48,
    "numero_total": 6046,
    "sme_total": 22497,
    "numero_home": 3411,
    "sme_home": 22498,
    "numero_dona": 2635,
    "sme_dona": 22496,
    "maxim": 22616,
    "percent_asalariat": 59.7,
    "percent_salari": 41.48,
    "comunitat": "canaries"
  },
  {
    "centil": 49,
    "numero_total": 5945,
    "sme_total": 22737,
    "numero_home": 3316,
    "sme_home": 22736,
    "numero_dona": 2629,
    "sme_dona": 22738,
    "maxim": 22865,
    "percent_asalariat": 60.7,
    "percent_salari": 42.31,
    "comunitat": "canaries"
  },
  {
    "centil": 50,
    "numero_total": 5610,
    "sme_total": 22989,
    "numero_home": 3126,
    "sme_home": 22990,
    "numero_dona": 2484,
    "sme_dona": 22988,
    "maxim": 23114,
    "percent_asalariat": 61.6,
    "percent_salari": 43.11,
    "comunitat": "canaries"
  },
  {
    "centil": 51,
    "numero_total": 5762,
    "sme_total": 23244,
    "numero_home": 3206,
    "sme_home": 23245,
    "numero_dona": 2556,
    "sme_dona": 23243,
    "maxim": 23377,
    "percent_asalariat": 62.5,
    "percent_salari": 43.94,
    "comunitat": "canaries"
  },
  {
    "centil": 52,
    "numero_total": 5466,
    "sme_total": 23511,
    "numero_home": 3136,
    "sme_home": 23512,
    "numero_dona": 2330,
    "sme_dona": 23510,
    "maxim": 23645,
    "percent_asalariat": 63.4,
    "percent_salari": 44.73,
    "comunitat": "canaries"
  },
  {
    "centil": 53,
    "numero_total": 5428,
    "sme_total": 23782,
    "numero_home": 3122,
    "sme_home": 23781,
    "numero_dona": 2306,
    "sme_dona": 23783,
    "maxim": 23925,
    "percent_asalariat": 64.2,
    "percent_salari": 45.53,
    "comunitat": "canaries"
  },
  {
    "centil": 54,
    "numero_total": 5435,
    "sme_total": 24058,
    "numero_home": 3010,
    "sme_home": 24058,
    "numero_dona": 2425,
    "sme_dona": 24059,
    "maxim": 24198,
    "percent_asalariat": 65.1,
    "percent_salari": 46.34,
    "comunitat": "canaries"
  },
  {
    "centil": 55,
    "numero_total": 5331,
    "sme_total": 24349,
    "numero_home": 2881,
    "sme_home": 24349,
    "numero_dona": 2450,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 65.9,
    "percent_salari": 47.14,
    "comunitat": "canaries"
  },
  {
    "centil": 56,
    "numero_total": 5255,
    "sme_total": 24655,
    "numero_home": 2900,
    "sme_home": 24654,
    "numero_dona": 2355,
    "sme_dona": 24656,
    "maxim": 24811,
    "percent_asalariat": 66.8,
    "percent_salari": 47.94,
    "comunitat": "canaries"
  },
  {
    "centil": 57,
    "numero_total": 5306,
    "sme_total": 24967,
    "numero_home": 2882,
    "sme_home": 24965,
    "numero_dona": 2424,
    "sme_dona": 24970,
    "maxim": 25122,
    "percent_asalariat": 67.6,
    "percent_salari": 48.76,
    "comunitat": "canaries"
  },
  {
    "centil": 58,
    "numero_total": 5237,
    "sme_total": 25285,
    "numero_home": 2816,
    "sme_home": 25286,
    "numero_dona": 2421,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 68.4,
    "percent_salari": 49.58,
    "comunitat": "canaries"
  },
  {
    "centil": 59,
    "numero_total": 5315,
    "sme_total": 25618,
    "numero_home": 2805,
    "sme_home": 25620,
    "numero_dona": 2510,
    "sme_dona": 25617,
    "maxim": 25792,
    "percent_asalariat": 69.3,
    "percent_salari": 50.42,
    "comunitat": "canaries"
  },
  {
    "centil": 60,
    "numero_total": 5298,
    "sme_total": 25961,
    "numero_home": 2779,
    "sme_home": 25962,
    "numero_dona": 2519,
    "sme_dona": 25960,
    "maxim": 26139,
    "percent_asalariat": 70.1,
    "percent_salari": 51.27,
    "comunitat": "canaries"
  },
  {
    "centil": 61,
    "numero_total": 5147,
    "sme_total": 26324,
    "numero_home": 2639,
    "sme_home": 26327,
    "numero_dona": 2508,
    "sme_dona": 26321,
    "maxim": 26509,
    "percent_asalariat": 70.9,
    "percent_salari": 52.11,
    "comunitat": "canaries"
  },
  {
    "centil": 62,
    "numero_total": 5172,
    "sme_total": 26698,
    "numero_home": 2801,
    "sme_home": 26699,
    "numero_dona": 2371,
    "sme_dona": 26696,
    "maxim": 26874,
    "percent_asalariat": 71.7,
    "percent_salari": 52.96,
    "comunitat": "canaries"
  },
  {
    "centil": 63,
    "numero_total": 5459,
    "sme_total": 27043,
    "numero_home": 2769,
    "sme_home": 27042,
    "numero_dona": 2690,
    "sme_dona": 27043,
    "maxim": 27221,
    "percent_asalariat": 72.6,
    "percent_salari": 53.87,
    "comunitat": "canaries"
  },
  {
    "centil": 64,
    "numero_total": 5006,
    "sme_total": 27416,
    "numero_home": 2555,
    "sme_home": 27413,
    "numero_dona": 2451,
    "sme_dona": 27420,
    "maxim": 27616,
    "percent_asalariat": 73.4,
    "percent_salari": 54.72,
    "comunitat": "canaries"
  },
  {
    "centil": 65,
    "numero_total": 5239,
    "sme_total": 27821,
    "numero_home": 2754,
    "sme_home": 27818,
    "numero_dona": 2485,
    "sme_dona": 27825,
    "maxim": 28031,
    "percent_asalariat": 74.2,
    "percent_salari": 55.62,
    "comunitat": "canaries"
  },
  {
    "centil": 66,
    "numero_total": 5105,
    "sme_total": 28251,
    "numero_home": 2549,
    "sme_home": 28254,
    "numero_dona": 2556,
    "sme_dona": 28249,
    "maxim": 28476,
    "percent_asalariat": 75,
    "percent_salari": 56.51,
    "comunitat": "canaries"
  },
  {
    "centil": 67,
    "numero_total": 5009,
    "sme_total": 28714,
    "numero_home": 2699,
    "sme_home": 28712,
    "numero_dona": 2310,
    "sme_dona": 28715,
    "maxim": 28951,
    "percent_asalariat": 75.8,
    "percent_salari": 57.4,
    "comunitat": "canaries"
  },
  {
    "centil": 68,
    "numero_total": 5036,
    "sme_total": 29200,
    "numero_home": 2613,
    "sme_home": 29200,
    "numero_dona": 2423,
    "sme_dona": 29201,
    "maxim": 29450,
    "percent_asalariat": 76.6,
    "percent_salari": 58.31,
    "comunitat": "canaries"
  },
  {
    "centil": 69,
    "numero_total": 5176,
    "sme_total": 29704,
    "numero_home": 2659,
    "sme_home": 29701,
    "numero_dona": 2517,
    "sme_dona": 29706,
    "maxim": 29970,
    "percent_asalariat": 77.5,
    "percent_salari": 59.26,
    "comunitat": "canaries"
  },
  {
    "centil": 70,
    "numero_total": 4983,
    "sme_total": 30214,
    "numero_home": 2544,
    "sme_home": 30216,
    "numero_dona": 2439,
    "sme_dona": 30213,
    "maxim": 30487,
    "percent_asalariat": 78.2,
    "percent_salari": 60.19,
    "comunitat": "canaries"
  },
  {
    "centil": 71,
    "numero_total": 4883,
    "sme_total": 30761,
    "numero_home": 2585,
    "sme_home": 30760,
    "numero_dona": 2298,
    "sme_dona": 30761,
    "maxim": 31037,
    "percent_asalariat": 79,
    "percent_salari": 61.12,
    "comunitat": "canaries"
  },
  {
    "centil": 72,
    "numero_total": 4607,
    "sme_total": 31319,
    "numero_home": 2485,
    "sme_home": 31322,
    "numero_dona": 2122,
    "sme_dona": 31316,
    "maxim": 31602,
    "percent_asalariat": 79.8,
    "percent_salari": 62.01,
    "comunitat": "canaries"
  },
  {
    "centil": 73,
    "numero_total": 4187,
    "sme_total": 31889,
    "numero_home": 2293,
    "sme_home": 31892,
    "numero_dona": 1894,
    "sme_dona": 31887,
    "maxim": 32176,
    "percent_asalariat": 80.4,
    "percent_salari": 62.83,
    "comunitat": "canaries"
  },
  {
    "centil": 74,
    "numero_total": 4157,
    "sme_total": 32480,
    "numero_home": 2344,
    "sme_home": 32478,
    "numero_dona": 1813,
    "sme_dona": 32482,
    "maxim": 32786,
    "percent_asalariat": 81.1,
    "percent_salari": 63.67,
    "comunitat": "canaries"
  },
  {
    "centil": 75,
    "numero_total": 4260,
    "sme_total": 33100,
    "numero_home": 2315,
    "sme_home": 33104,
    "numero_dona": 1945,
    "sme_dona": 33096,
    "maxim": 33413,
    "percent_asalariat": 81.8,
    "percent_salari": 64.54,
    "comunitat": "canaries"
  },
  {
    "centil": 76,
    "numero_total": 4078,
    "sme_total": 33735,
    "numero_home": 2127,
    "sme_home": 33728,
    "numero_dona": 1951,
    "sme_dona": 33742,
    "maxim": 34056,
    "percent_asalariat": 82.4,
    "percent_salari": 65.39,
    "comunitat": "canaries"
  },
  {
    "centil": 77,
    "numero_total": 4503,
    "sme_total": 34400,
    "numero_home": 2229,
    "sme_home": 34398,
    "numero_dona": 2274,
    "sme_dona": 34403,
    "maxim": 34722,
    "percent_asalariat": 83.1,
    "percent_salari": 66.35,
    "comunitat": "canaries"
  },
  {
    "centil": 78,
    "numero_total": 4373,
    "sme_total": 35038,
    "numero_home": 2097,
    "sme_home": 35041,
    "numero_dona": 2276,
    "sme_dona": 35035,
    "maxim": 35374,
    "percent_asalariat": 83.8,
    "percent_salari": 67.29,
    "comunitat": "canaries"
  },
  {
    "centil": 79,
    "numero_total": 4150,
    "sme_total": 35713,
    "numero_home": 2064,
    "sme_home": 35705,
    "numero_dona": 2086,
    "sme_dona": 35721,
    "maxim": 36027,
    "percent_asalariat": 84.5,
    "percent_salari": 68.21,
    "comunitat": "canaries"
  },
  {
    "centil": 80,
    "numero_total": 4618,
    "sme_total": 36368,
    "numero_home": 2082,
    "sme_home": 36366,
    "numero_dona": 2536,
    "sme_dona": 36369,
    "maxim": 36730,
    "percent_asalariat": 85.2,
    "percent_salari": 69.25,
    "comunitat": "canaries"
  },
  {
    "centil": 81,
    "numero_total": 4760,
    "sme_total": 37119,
    "numero_home": 2337,
    "sme_home": 37118,
    "numero_dona": 2423,
    "sme_dona": 37120,
    "maxim": 37490,
    "percent_asalariat": 85.9,
    "percent_salari": 70.34,
    "comunitat": "canaries"
  },
  {
    "centil": 82,
    "numero_total": 5617,
    "sme_total": 37901,
    "numero_home": 2586,
    "sme_home": 37898,
    "numero_dona": 3031,
    "sme_dona": 37904,
    "maxim": 38304,
    "percent_asalariat": 86.8,
    "percent_salari": 71.66,
    "comunitat": "canaries"
  },
  {
    "centil": 83,
    "numero_total": 5658,
    "sme_total": 38742,
    "numero_home": 2599,
    "sme_home": 38744,
    "numero_dona": 3059,
    "sme_dona": 38740,
    "maxim": 39197,
    "percent_asalariat": 87.7,
    "percent_salari": 73.01,
    "comunitat": "canaries"
  },
  {
    "centil": 84,
    "numero_total": 5963,
    "sme_total": 39688,
    "numero_home": 2717,
    "sme_home": 39682,
    "numero_dona": 3246,
    "sme_dona": 39693,
    "maxim": 40137,
    "percent_asalariat": 88.7,
    "percent_salari": 74.47,
    "comunitat": "canaries"
  },
  {
    "centil": 85,
    "numero_total": 5463,
    "sme_total": 40623,
    "numero_home": 2523,
    "sme_home": 40636,
    "numero_dona": 2940,
    "sme_dona": 40611,
    "maxim": 41170,
    "percent_asalariat": 89.5,
    "percent_salari": 75.84,
    "comunitat": "canaries"
  },
  {
    "centil": 86,
    "numero_total": 5353,
    "sme_total": 41730,
    "numero_home": 2514,
    "sme_home": 41732,
    "numero_dona": 2839,
    "sme_dona": 41728,
    "maxim": 42306,
    "percent_asalariat": 90.4,
    "percent_salari": 77.22,
    "comunitat": "canaries"
  },
  {
    "centil": 87,
    "numero_total": 5026,
    "sme_total": 42894,
    "numero_home": 2374,
    "sme_home": 42897,
    "numero_dona": 2652,
    "sme_dona": 42891,
    "maxim": 43519,
    "percent_asalariat": 91.2,
    "percent_salari": 78.56,
    "comunitat": "canaries"
  },
  {
    "centil": 88,
    "numero_total": 5007,
    "sme_total": 44189,
    "numero_home": 2425,
    "sme_home": 44185,
    "numero_dona": 2582,
    "sme_dona": 44193,
    "maxim": 44857,
    "percent_asalariat": 92,
    "percent_salari": 79.92,
    "comunitat": "canaries"
  },
  {
    "centil": 89,
    "numero_total": 4843,
    "sme_total": 45571,
    "numero_home": 2333,
    "sme_home": 45567,
    "numero_dona": 2510,
    "sme_dona": 45575,
    "maxim": 46326,
    "percent_asalariat": 92.8,
    "percent_salari": 81.29,
    "comunitat": "canaries"
  },
  {
    "centil": 90,
    "numero_total": 4660,
    "sme_total": 47160,
    "numero_home": 2254,
    "sme_home": 47163,
    "numero_dona": 2406,
    "sme_dona": 47158,
    "maxim": 48005,
    "percent_asalariat": 93.5,
    "percent_salari": 82.65,
    "comunitat": "canaries"
  },
  {
    "centil": 91,
    "numero_total": 4731,
    "sme_total": 48922,
    "numero_home": 2370,
    "sme_home": 48932,
    "numero_dona": 2361,
    "sme_dona": 48912,
    "maxim": 49888,
    "percent_asalariat": 94.2,
    "percent_salari": 84.08,
    "comunitat": "canaries"
  },
  {
    "centil": 92,
    "numero_total": 4750,
    "sme_total": 50920,
    "numero_home": 2432,
    "sme_home": 50919,
    "numero_dona": 2318,
    "sme_dona": 50920,
    "maxim": 52064,
    "percent_asalariat": 95,
    "percent_salari": 85.57,
    "comunitat": "canaries"
  },
  {
    "centil": 93,
    "numero_total": 4252,
    "sme_total": 53338,
    "numero_home": 2205,
    "sme_home": 53359,
    "numero_dona": 2047,
    "sme_dona": 53315,
    "maxim": 54742,
    "percent_asalariat": 95.7,
    "percent_salari": 86.97,
    "comunitat": "canaries"
  },
  {
    "centil": 94,
    "numero_total": 4000,
    "sme_total": 56285,
    "numero_home": 2203,
    "sme_home": 56291,
    "numero_dona": 1797,
    "sme_dona": 56278,
    "maxim": 57976,
    "percent_asalariat": 96.3,
    "percent_salari": 88.36,
    "comunitat": "canaries"
  },
  {
    "centil": 95,
    "numero_total": 4200,
    "sme_total": 59916,
    "numero_home": 2297,
    "sme_home": 59901,
    "numero_dona": 1903,
    "sme_dona": 59934,
    "maxim": 61939,
    "percent_asalariat": 97,
    "percent_salari": 89.92,
    "comunitat": "canaries"
  },
  {
    "centil": 96,
    "numero_total": 4395,
    "sme_total": 64376,
    "numero_home": 2397,
    "sme_home": 64364,
    "numero_dona": 1998,
    "sme_dona": 64390,
    "maxim": 66966,
    "percent_asalariat": 97.7,
    "percent_salari": 91.67,
    "comunitat": "canaries"
  },
  {
    "centil": 97,
    "numero_total": 4321,
    "sme_total": 70245,
    "numero_home": 2389,
    "sme_home": 70231,
    "numero_dona": 1932,
    "sme_dona": 70262,
    "maxim": 73778,
    "percent_asalariat": 98.4,
    "percent_salari": 93.54,
    "comunitat": "canaries"
  },
  {
    "centil": 98,
    "numero_total": 4032,
    "sme_total": 78331,
    "numero_home": 2359,
    "sme_home": 78414,
    "numero_dona": 1673,
    "sme_dona": 78214,
    "maxim": 83931,
    "percent_asalariat": 99,
    "percent_salari": 95.49,
    "comunitat": "canaries"
  },
  {
    "centil": 99,
    "numero_total": 3699,
    "sme_total": 92311,
    "numero_home": 2327,
    "sme_home": 92583,
    "numero_dona": 1372,
    "sme_dona": 91850,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.6,
    "comunitat": "canaries"
  },
  {
    "centil": 100,
    "numero_total": 2669,
    "sme_total": 145280,
    "numero_home": 2006,
    "sme_home": 147879,
    "numero_dona": 663,
    "sme_dona": 137415,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "canaries"
  },
  {
    "centil": 1,
    "numero_total": 1477,
    "sme_total": 14061,
    "numero_home": 605,
    "sme_home": 14058,
    "numero_dona": 872,
    "sme_dona": 14063,
    "maxim": 14139,
    "percent_asalariat": 1,
    "percent_salari": 0.5,
    "comunitat": "cantabria"
  },
  {
    "centil": 2,
    "numero_total": 1665,
    "sme_total": 14216,
    "numero_home": 676,
    "sme_home": 14215,
    "numero_dona": 989,
    "sme_dona": 14217,
    "maxim": 14300,
    "percent_asalariat": 2.1,
    "percent_salari": 1.07,
    "comunitat": "cantabria"
  },
  {
    "centil": 3,
    "numero_total": 1588,
    "sme_total": 14381,
    "numero_home": 575,
    "sme_home": 14385,
    "numero_dona": 1013,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 3.1,
    "percent_salari": 1.63,
    "comunitat": "cantabria"
  },
  {
    "centil": 4,
    "numero_total": 1664,
    "sme_total": 14536,
    "numero_home": 653,
    "sme_home": 14536,
    "numero_dona": 1011,
    "sme_dona": 14536,
    "maxim": 14618,
    "percent_asalariat": 4.2,
    "percent_salari": 2.21,
    "comunitat": "cantabria"
  },
  {
    "centil": 5,
    "numero_total": 1764,
    "sme_total": 14701,
    "numero_home": 660,
    "sme_home": 14698,
    "numero_dona": 1104,
    "sme_dona": 14702,
    "maxim": 14776,
    "percent_asalariat": 5.3,
    "percent_salari": 2.84,
    "comunitat": "cantabria"
  },
  {
    "centil": 6,
    "numero_total": 1779,
    "sme_total": 14854,
    "numero_home": 609,
    "sme_home": 14852,
    "numero_dona": 1170,
    "sme_dona": 14854,
    "maxim": 14934,
    "percent_asalariat": 6.5,
    "percent_salari": 3.48,
    "comunitat": "cantabria"
  },
  {
    "centil": 7,
    "numero_total": 1670,
    "sme_total": 15012,
    "numero_home": 605,
    "sme_home": 15013,
    "numero_dona": 1065,
    "sme_dona": 15011,
    "maxim": 15091,
    "percent_asalariat": 7.6,
    "percent_salari": 4.08,
    "comunitat": "cantabria"
  },
  {
    "centil": 8,
    "numero_total": 1661,
    "sme_total": 15168,
    "numero_home": 599,
    "sme_home": 15168,
    "numero_dona": 1062,
    "sme_dona": 15169,
    "maxim": 15248,
    "percent_asalariat": 8.7,
    "percent_salari": 4.69,
    "comunitat": "cantabria"
  },
  {
    "centil": 9,
    "numero_total": 1786,
    "sme_total": 15331,
    "numero_home": 688,
    "sme_home": 15334,
    "numero_dona": 1098,
    "sme_dona": 15329,
    "maxim": 15407,
    "percent_asalariat": 9.9,
    "percent_salari": 5.35,
    "comunitat": "cantabria"
  },
  {
    "centil": 10,
    "numero_total": 1674,
    "sme_total": 15486,
    "numero_home": 647,
    "sme_home": 15485,
    "numero_dona": 1027,
    "sme_dona": 15486,
    "maxim": 15567,
    "percent_asalariat": 10.9,
    "percent_salari": 5.98,
    "comunitat": "cantabria"
  },
  {
    "centil": 11,
    "numero_total": 1691,
    "sme_total": 15649,
    "numero_home": 641,
    "sme_home": 15649,
    "numero_dona": 1050,
    "sme_dona": 15649,
    "maxim": 15726,
    "percent_asalariat": 12.1,
    "percent_salari": 6.62,
    "comunitat": "cantabria"
  },
  {
    "centil": 12,
    "numero_total": 1774,
    "sme_total": 15804,
    "numero_home": 685,
    "sme_home": 15805,
    "numero_dona": 1089,
    "sme_dona": 15803,
    "maxim": 15885,
    "percent_asalariat": 13.2,
    "percent_salari": 7.3,
    "comunitat": "cantabria"
  },
  {
    "centil": 13,
    "numero_total": 1774,
    "sme_total": 15965,
    "numero_home": 652,
    "sme_home": 15965,
    "numero_dona": 1122,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 14.4,
    "percent_salari": 7.98,
    "comunitat": "cantabria"
  },
  {
    "centil": 14,
    "numero_total": 1690,
    "sme_total": 16125,
    "numero_home": 646,
    "sme_home": 16127,
    "numero_dona": 1044,
    "sme_dona": 16123,
    "maxim": 16207,
    "percent_asalariat": 15.5,
    "percent_salari": 8.64,
    "comunitat": "cantabria"
  },
  {
    "centil": 15,
    "numero_total": 1772,
    "sme_total": 16288,
    "numero_home": 740,
    "sme_home": 16288,
    "numero_dona": 1032,
    "sme_dona": 16289,
    "maxim": 16371,
    "percent_asalariat": 16.6,
    "percent_salari": 9.34,
    "comunitat": "cantabria"
  },
  {
    "centil": 16,
    "numero_total": 1738,
    "sme_total": 16450,
    "numero_home": 710,
    "sme_home": 16450,
    "numero_dona": 1028,
    "sme_dona": 16450,
    "maxim": 16533,
    "percent_asalariat": 17.8,
    "percent_salari": 10.03,
    "comunitat": "cantabria"
  },
  {
    "centil": 17,
    "numero_total": 1627,
    "sme_total": 16612,
    "numero_home": 705,
    "sme_home": 16614,
    "numero_dona": 922,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 18.8,
    "percent_salari": 10.68,
    "comunitat": "cantabria"
  },
  {
    "centil": 18,
    "numero_total": 1735,
    "sme_total": 16772,
    "numero_home": 776,
    "sme_home": 16772,
    "numero_dona": 959,
    "sme_dona": 16772,
    "maxim": 16855,
    "percent_asalariat": 20,
    "percent_salari": 11.39,
    "comunitat": "cantabria"
  },
  {
    "centil": 19,
    "numero_total": 1672,
    "sme_total": 16937,
    "numero_home": 733,
    "sme_home": 16939,
    "numero_dona": 939,
    "sme_dona": 16936,
    "maxim": 17023,
    "percent_asalariat": 21.1,
    "percent_salari": 12.07,
    "comunitat": "cantabria"
  },
  {
    "centil": 20,
    "numero_total": 1590,
    "sme_total": 17109,
    "numero_home": 778,
    "sme_home": 17111,
    "numero_dona": 812,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 22.1,
    "percent_salari": 12.73,
    "comunitat": "cantabria"
  },
  {
    "centil": 21,
    "numero_total": 1668,
    "sme_total": 17282,
    "numero_home": 811,
    "sme_home": 17282,
    "numero_dona": 857,
    "sme_dona": 17282,
    "maxim": 17369,
    "percent_asalariat": 23.2,
    "percent_salari": 13.43,
    "comunitat": "cantabria"
  },
  {
    "centil": 22,
    "numero_total": 1627,
    "sme_total": 17456,
    "numero_home": 835,
    "sme_home": 17456,
    "numero_dona": 792,
    "sme_dona": 17457,
    "maxim": 17543,
    "percent_asalariat": 24.3,
    "percent_salari": 14.11,
    "comunitat": "cantabria"
  },
  {
    "centil": 23,
    "numero_total": 1586,
    "sme_total": 17633,
    "numero_home": 807,
    "sme_home": 17633,
    "numero_dona": 779,
    "sme_dona": 17633,
    "maxim": 17718,
    "percent_asalariat": 25.3,
    "percent_salari": 14.79,
    "comunitat": "cantabria"
  },
  {
    "centil": 24,
    "numero_total": 1509,
    "sme_total": 17804,
    "numero_home": 757,
    "sme_home": 17804,
    "numero_dona": 752,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 26.3,
    "percent_salari": 15.44,
    "comunitat": "cantabria"
  },
  {
    "centil": 25,
    "numero_total": 1391,
    "sme_total": 17979,
    "numero_home": 717,
    "sme_home": 17980,
    "numero_dona": 674,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 27.2,
    "percent_salari": 16.04,
    "comunitat": "cantabria"
  },
  {
    "centil": 26,
    "numero_total": 1373,
    "sme_total": 18150,
    "numero_home": 690,
    "sme_home": 18149,
    "numero_dona": 683,
    "sme_dona": 18151,
    "maxim": 18239,
    "percent_asalariat": 28.1,
    "percent_salari": 16.64,
    "comunitat": "cantabria"
  },
  {
    "centil": 27,
    "numero_total": 1467,
    "sme_total": 18326,
    "numero_home": 788,
    "sme_home": 18326,
    "numero_dona": 679,
    "sme_dona": 18325,
    "maxim": 18417,
    "percent_asalariat": 29.1,
    "percent_salari": 17.29,
    "comunitat": "cantabria"
  },
  {
    "centil": 28,
    "numero_total": 1526,
    "sme_total": 18505,
    "numero_home": 808,
    "sme_home": 18504,
    "numero_dona": 718,
    "sme_dona": 18507,
    "maxim": 18596,
    "percent_asalariat": 30.1,
    "percent_salari": 17.98,
    "comunitat": "cantabria"
  },
  {
    "centil": 29,
    "numero_total": 1391,
    "sme_total": 18688,
    "numero_home": 761,
    "sme_home": 18688,
    "numero_dona": 630,
    "sme_dona": 18689,
    "maxim": 18778,
    "percent_asalariat": 31,
    "percent_salari": 18.61,
    "comunitat": "cantabria"
  },
  {
    "centil": 30,
    "numero_total": 1298,
    "sme_total": 18867,
    "numero_home": 726,
    "sme_home": 18868,
    "numero_dona": 572,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 31.8,
    "percent_salari": 19.2,
    "comunitat": "cantabria"
  },
  {
    "centil": 31,
    "numero_total": 1374,
    "sme_total": 19040,
    "numero_home": 764,
    "sme_home": 19040,
    "numero_dona": 610,
    "sme_dona": 19040,
    "maxim": 19133,
    "percent_asalariat": 32.7,
    "percent_salari": 19.83,
    "comunitat": "cantabria"
  },
  {
    "centil": 32,
    "numero_total": 1360,
    "sme_total": 19226,
    "numero_home": 797,
    "sme_home": 19227,
    "numero_dona": 563,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 33.6,
    "percent_salari": 20.46,
    "comunitat": "cantabria"
  },
  {
    "centil": 33,
    "numero_total": 1351,
    "sme_total": 19407,
    "numero_home": 793,
    "sme_home": 19407,
    "numero_dona": 558,
    "sme_dona": 19409,
    "maxim": 19503,
    "percent_asalariat": 34.5,
    "percent_salari": 21.1,
    "comunitat": "cantabria"
  },
  {
    "centil": 34,
    "numero_total": 1422,
    "sme_total": 19598,
    "numero_home": 872,
    "sme_home": 19600,
    "numero_dona": 550,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 35.4,
    "percent_salari": 21.77,
    "comunitat": "cantabria"
  },
  {
    "centil": 35,
    "numero_total": 1579,
    "sme_total": 19785,
    "numero_home": 1012,
    "sme_home": 19785,
    "numero_dona": 567,
    "sme_dona": 19785,
    "maxim": 19879,
    "percent_asalariat": 36.5,
    "percent_salari": 22.52,
    "comunitat": "cantabria"
  },
  {
    "centil": 36,
    "numero_total": 1650,
    "sme_total": 19973,
    "numero_home": 1105,
    "sme_home": 19973,
    "numero_dona": 545,
    "sme_dona": 19973,
    "maxim": 20069,
    "percent_asalariat": 37.5,
    "percent_salari": 23.32,
    "comunitat": "cantabria"
  },
  {
    "centil": 37,
    "numero_total": 1637,
    "sme_total": 20168,
    "numero_home": 1103,
    "sme_home": 20169,
    "numero_dona": 534,
    "sme_dona": 20165,
    "maxim": 20263,
    "percent_asalariat": 38.6,
    "percent_salari": 24.12,
    "comunitat": "cantabria"
  },
  {
    "centil": 38,
    "numero_total": 1719,
    "sme_total": 20359,
    "numero_home": 1172,
    "sme_home": 20360,
    "numero_dona": 547,
    "sme_dona": 20356,
    "maxim": 20459,
    "percent_asalariat": 39.7,
    "percent_salari": 24.97,
    "comunitat": "cantabria"
  },
  {
    "centil": 39,
    "numero_total": 1590,
    "sme_total": 20555,
    "numero_home": 1090,
    "sme_home": 20555,
    "numero_dona": 500,
    "sme_dona": 20556,
    "maxim": 20653,
    "percent_asalariat": 40.8,
    "percent_salari": 25.76,
    "comunitat": "cantabria"
  },
  {
    "centil": 40,
    "numero_total": 1680,
    "sme_total": 20756,
    "numero_home": 1166,
    "sme_home": 20755,
    "numero_dona": 514,
    "sme_dona": 20757,
    "maxim": 20854,
    "percent_asalariat": 41.9,
    "percent_salari": 26.6,
    "comunitat": "cantabria"
  },
  {
    "centil": 41,
    "numero_total": 1847,
    "sme_total": 20955,
    "numero_home": 1326,
    "sme_home": 20956,
    "numero_dona": 521,
    "sme_dona": 20955,
    "maxim": 21055,
    "percent_asalariat": 43.1,
    "percent_salari": 27.53,
    "comunitat": "cantabria"
  },
  {
    "centil": 42,
    "numero_total": 1821,
    "sme_total": 21163,
    "numero_home": 1289,
    "sme_home": 21163,
    "numero_dona": 532,
    "sme_dona": 21163,
    "maxim": 21267,
    "percent_asalariat": 44.3,
    "percent_salari": 28.47,
    "comunitat": "cantabria"
  },
  {
    "centil": 43,
    "numero_total": 1937,
    "sme_total": 21372,
    "numero_home": 1308,
    "sme_home": 21375,
    "numero_dona": 629,
    "sme_dona": 21368,
    "maxim": 21483,
    "percent_asalariat": 45.6,
    "percent_salari": 29.47,
    "comunitat": "cantabria"
  },
  {
    "centil": 44,
    "numero_total": 1877,
    "sme_total": 21589,
    "numero_home": 1388,
    "sme_home": 21587,
    "numero_dona": 489,
    "sme_dona": 21593,
    "maxim": 21701,
    "percent_asalariat": 46.8,
    "percent_salari": 30.45,
    "comunitat": "cantabria"
  },
  {
    "centil": 45,
    "numero_total": 1719,
    "sme_total": 21814,
    "numero_home": 1230,
    "sme_home": 21815,
    "numero_dona": 489,
    "sme_dona": 21812,
    "maxim": 21927,
    "percent_asalariat": 47.9,
    "percent_salari": 31.35,
    "comunitat": "cantabria"
  },
  {
    "centil": 46,
    "numero_total": 1655,
    "sme_total": 22036,
    "numero_home": 1181,
    "sme_home": 22036,
    "numero_dona": 474,
    "sme_dona": 22036,
    "maxim": 22151,
    "percent_asalariat": 49,
    "percent_salari": 32.23,
    "comunitat": "cantabria"
  },
  {
    "centil": 47,
    "numero_total": 1697,
    "sme_total": 22265,
    "numero_home": 1135,
    "sme_home": 22266,
    "numero_dona": 562,
    "sme_dona": 22264,
    "maxim": 22380,
    "percent_asalariat": 50.1,
    "percent_salari": 33.15,
    "comunitat": "cantabria"
  },
  {
    "centil": 48,
    "numero_total": 1675,
    "sme_total": 22497,
    "numero_home": 1172,
    "sme_home": 22498,
    "numero_dona": 503,
    "sme_dona": 22494,
    "maxim": 22616,
    "percent_asalariat": 51.2,
    "percent_salari": 34.06,
    "comunitat": "cantabria"
  },
  {
    "centil": 49,
    "numero_total": 1589,
    "sme_total": 22739,
    "numero_home": 1092,
    "sme_home": 22740,
    "numero_dona": 497,
    "sme_dona": 22736,
    "maxim": 22865,
    "percent_asalariat": 52.2,
    "percent_salari": 34.93,
    "comunitat": "cantabria"
  },
  {
    "centil": 50,
    "numero_total": 1549,
    "sme_total": 22993,
    "numero_home": 1038,
    "sme_home": 22993,
    "numero_dona": 511,
    "sme_dona": 22994,
    "maxim": 23114,
    "percent_asalariat": 53.2,
    "percent_salari": 35.79,
    "comunitat": "cantabria"
  },
  {
    "centil": 51,
    "numero_total": 1558,
    "sme_total": 23245,
    "numero_home": 1025,
    "sme_home": 23245,
    "numero_dona": 533,
    "sme_dona": 23245,
    "maxim": 23377,
    "percent_asalariat": 54.3,
    "percent_salari": 36.67,
    "comunitat": "cantabria"
  },
  {
    "centil": 52,
    "numero_total": 1502,
    "sme_total": 23511,
    "numero_home": 979,
    "sme_home": 23511,
    "numero_dona": 523,
    "sme_dona": 23511,
    "maxim": 23645,
    "percent_asalariat": 55.3,
    "percent_salari": 37.52,
    "comunitat": "cantabria"
  },
  {
    "centil": 53,
    "numero_total": 1552,
    "sme_total": 23782,
    "numero_home": 1049,
    "sme_home": 23783,
    "numero_dona": 503,
    "sme_dona": 23781,
    "maxim": 23925,
    "percent_asalariat": 56.3,
    "percent_salari": 38.41,
    "comunitat": "cantabria"
  },
  {
    "centil": 54,
    "numero_total": 1504,
    "sme_total": 24058,
    "numero_home": 1028,
    "sme_home": 24057,
    "numero_dona": 476,
    "sme_dona": 24062,
    "maxim": 24198,
    "percent_asalariat": 57.3,
    "percent_salari": 39.29,
    "comunitat": "cantabria"
  },
  {
    "centil": 55,
    "numero_total": 1613,
    "sme_total": 24350,
    "numero_home": 1080,
    "sme_home": 24351,
    "numero_dona": 533,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 58.3,
    "percent_salari": 40.24,
    "comunitat": "cantabria"
  },
  {
    "centil": 56,
    "numero_total": 1626,
    "sme_total": 24653,
    "numero_home": 1112,
    "sme_home": 24652,
    "numero_dona": 514,
    "sme_dona": 24653,
    "maxim": 24811,
    "percent_asalariat": 59.4,
    "percent_salari": 41.21,
    "comunitat": "cantabria"
  },
  {
    "centil": 57,
    "numero_total": 1444,
    "sme_total": 24966,
    "numero_home": 976,
    "sme_home": 24965,
    "numero_dona": 468,
    "sme_dona": 24968,
    "maxim": 25122,
    "percent_asalariat": 60.3,
    "percent_salari": 42.08,
    "comunitat": "cantabria"
  },
  {
    "centil": 58,
    "numero_total": 1486,
    "sme_total": 25285,
    "numero_home": 1007,
    "sme_home": 25285,
    "numero_dona": 479,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 61.3,
    "percent_salari": 42.99,
    "comunitat": "cantabria"
  },
  {
    "centil": 59,
    "numero_total": 1542,
    "sme_total": 25617,
    "numero_home": 1039,
    "sme_home": 25616,
    "numero_dona": 503,
    "sme_dona": 25618,
    "maxim": 25792,
    "percent_asalariat": 62.3,
    "percent_salari": 43.94,
    "comunitat": "cantabria"
  },
  {
    "centil": 60,
    "numero_total": 1531,
    "sme_total": 25959,
    "numero_home": 1017,
    "sme_home": 25961,
    "numero_dona": 514,
    "sme_dona": 25956,
    "maxim": 26139,
    "percent_asalariat": 63.3,
    "percent_salari": 44.9,
    "comunitat": "cantabria"
  },
  {
    "centil": 61,
    "numero_total": 1481,
    "sme_total": 26321,
    "numero_home": 1000,
    "sme_home": 26324,
    "numero_dona": 481,
    "sme_dona": 26316,
    "maxim": 26509,
    "percent_asalariat": 64.3,
    "percent_salari": 45.84,
    "comunitat": "cantabria"
  },
  {
    "centil": 62,
    "numero_total": 1391,
    "sme_total": 26690,
    "numero_home": 946,
    "sme_home": 26689,
    "numero_dona": 445,
    "sme_dona": 26692,
    "maxim": 26874,
    "percent_asalariat": 65.2,
    "percent_salari": 46.74,
    "comunitat": "cantabria"
  },
  {
    "centil": 63,
    "numero_total": 1291,
    "sme_total": 27050,
    "numero_home": 862,
    "sme_home": 27048,
    "numero_dona": 429,
    "sme_dona": 27053,
    "maxim": 27221,
    "percent_asalariat": 66,
    "percent_salari": 47.59,
    "comunitat": "cantabria"
  },
  {
    "centil": 64,
    "numero_total": 1471,
    "sme_total": 27416,
    "numero_home": 965,
    "sme_home": 27419,
    "numero_dona": 506,
    "sme_dona": 27409,
    "maxim": 27616,
    "percent_asalariat": 67,
    "percent_salari": 48.56,
    "comunitat": "cantabria"
  },
  {
    "centil": 65,
    "numero_total": 1417,
    "sme_total": 27825,
    "numero_home": 954,
    "sme_home": 27824,
    "numero_dona": 463,
    "sme_dona": 27827,
    "maxim": 28031,
    "percent_asalariat": 67.9,
    "percent_salari": 49.51,
    "comunitat": "cantabria"
  },
  {
    "centil": 66,
    "numero_total": 1440,
    "sme_total": 28242,
    "numero_home": 931,
    "sme_home": 28241,
    "numero_dona": 509,
    "sme_dona": 28244,
    "maxim": 28476,
    "percent_asalariat": 68.9,
    "percent_salari": 50.5,
    "comunitat": "cantabria"
  },
  {
    "centil": 67,
    "numero_total": 1457,
    "sme_total": 28713,
    "numero_home": 978,
    "sme_home": 28713,
    "numero_dona": 479,
    "sme_dona": 28712,
    "maxim": 28951,
    "percent_asalariat": 69.8,
    "percent_salari": 51.51,
    "comunitat": "cantabria"
  },
  {
    "centil": 68,
    "numero_total": 1458,
    "sme_total": 29208,
    "numero_home": 968,
    "sme_home": 29202,
    "numero_dona": 490,
    "sme_dona": 29218,
    "maxim": 29450,
    "percent_asalariat": 70.8,
    "percent_salari": 52.54,
    "comunitat": "cantabria"
  },
  {
    "centil": 69,
    "numero_total": 1524,
    "sme_total": 29708,
    "numero_home": 1007,
    "sme_home": 29711,
    "numero_dona": 517,
    "sme_dona": 29702,
    "maxim": 29970,
    "percent_asalariat": 71.8,
    "percent_salari": 53.63,
    "comunitat": "cantabria"
  },
  {
    "centil": 70,
    "numero_total": 1529,
    "sme_total": 30220,
    "numero_home": 973,
    "sme_home": 30213,
    "numero_dona": 556,
    "sme_dona": 30233,
    "maxim": 30487,
    "percent_asalariat": 72.8,
    "percent_salari": 54.75,
    "comunitat": "cantabria"
  },
  {
    "centil": 71,
    "numero_total": 1384,
    "sme_total": 30759,
    "numero_home": 907,
    "sme_home": 30766,
    "numero_dona": 477,
    "sme_dona": 30746,
    "maxim": 31037,
    "percent_asalariat": 73.7,
    "percent_salari": 55.78,
    "comunitat": "cantabria"
  },
  {
    "centil": 72,
    "numero_total": 1402,
    "sme_total": 31318,
    "numero_home": 925,
    "sme_home": 31322,
    "numero_dona": 477,
    "sme_dona": 31311,
    "maxim": 31602,
    "percent_asalariat": 74.6,
    "percent_salari": 56.84,
    "comunitat": "cantabria"
  },
  {
    "centil": 73,
    "numero_total": 1424,
    "sme_total": 31892,
    "numero_home": 902,
    "sme_home": 31888,
    "numero_dona": 522,
    "sme_dona": 31900,
    "maxim": 32176,
    "percent_asalariat": 75.5,
    "percent_salari": 57.94,
    "comunitat": "cantabria"
  },
  {
    "centil": 74,
    "numero_total": 1507,
    "sme_total": 32479,
    "numero_home": 946,
    "sme_home": 32477,
    "numero_dona": 561,
    "sme_dona": 32482,
    "maxim": 32786,
    "percent_asalariat": 76.5,
    "percent_salari": 59.12,
    "comunitat": "cantabria"
  },
  {
    "centil": 75,
    "numero_total": 1467,
    "sme_total": 33095,
    "numero_home": 928,
    "sme_home": 33092,
    "numero_dona": 539,
    "sme_dona": 33099,
    "maxim": 33413,
    "percent_asalariat": 77.5,
    "percent_salari": 60.29,
    "comunitat": "cantabria"
  },
  {
    "centil": 76,
    "numero_total": 1384,
    "sme_total": 33730,
    "numero_home": 832,
    "sme_home": 33732,
    "numero_dona": 552,
    "sme_dona": 33727,
    "maxim": 34056,
    "percent_asalariat": 78.4,
    "percent_salari": 61.42,
    "comunitat": "cantabria"
  },
  {
    "centil": 77,
    "numero_total": 1563,
    "sme_total": 34395,
    "numero_home": 872,
    "sme_home": 34392,
    "numero_dona": 691,
    "sme_dona": 34400,
    "maxim": 34722,
    "percent_asalariat": 79.4,
    "percent_salari": 62.72,
    "comunitat": "cantabria"
  },
  {
    "centil": 78,
    "numero_total": 1409,
    "sme_total": 35042,
    "numero_home": 849,
    "sme_home": 35048,
    "numero_dona": 560,
    "sme_dona": 35032,
    "maxim": 35374,
    "percent_asalariat": 80.3,
    "percent_salari": 63.92,
    "comunitat": "cantabria"
  },
  {
    "centil": 79,
    "numero_total": 1449,
    "sme_total": 35713,
    "numero_home": 882,
    "sme_home": 35710,
    "numero_dona": 567,
    "sme_dona": 35718,
    "maxim": 36027,
    "percent_asalariat": 81.3,
    "percent_salari": 65.17,
    "comunitat": "cantabria"
  },
  {
    "centil": 80,
    "numero_total": 1663,
    "sme_total": 36380,
    "numero_home": 941,
    "sme_home": 36383,
    "numero_dona": 722,
    "sme_dona": 36376,
    "maxim": 36730,
    "percent_asalariat": 82.4,
    "percent_salari": 66.63,
    "comunitat": "cantabria"
  },
  {
    "centil": 81,
    "numero_total": 1516,
    "sme_total": 37108,
    "numero_home": 987,
    "sme_home": 37106,
    "numero_dona": 529,
    "sme_dona": 37111,
    "maxim": 37490,
    "percent_asalariat": 83.3,
    "percent_salari": 67.99,
    "comunitat": "cantabria"
  },
  {
    "centil": 82,
    "numero_total": 1705,
    "sme_total": 37896,
    "numero_home": 1011,
    "sme_home": 37890,
    "numero_dona": 694,
    "sme_dona": 37904,
    "maxim": 38304,
    "percent_asalariat": 84.5,
    "percent_salari": 69.55,
    "comunitat": "cantabria"
  },
  {
    "centil": 83,
    "numero_total": 2111,
    "sme_total": 38708,
    "numero_home": 1136,
    "sme_home": 38736,
    "numero_dona": 975,
    "sme_dona": 38674,
    "maxim": 39197,
    "percent_asalariat": 85.8,
    "percent_salari": 71.53,
    "comunitat": "cantabria"
  },
  {
    "centil": 84,
    "numero_total": 1755,
    "sme_total": 39694,
    "numero_home": 1080,
    "sme_home": 39694,
    "numero_dona": 675,
    "sme_dona": 39694,
    "maxim": 40137,
    "percent_asalariat": 87,
    "percent_salari": 73.21,
    "comunitat": "cantabria"
  },
  {
    "centil": 85,
    "numero_total": 1772,
    "sme_total": 40644,
    "numero_home": 1114,
    "sme_home": 40632,
    "numero_dona": 658,
    "sme_dona": 40664,
    "maxim": 41170,
    "percent_asalariat": 88.2,
    "percent_salari": 74.95,
    "comunitat": "cantabria"
  },
  {
    "centil": 86,
    "numero_total": 1653,
    "sme_total": 41719,
    "numero_home": 1088,
    "sme_home": 41727,
    "numero_dona": 565,
    "sme_dona": 41703,
    "maxim": 42306,
    "percent_asalariat": 89.2,
    "percent_salari": 76.62,
    "comunitat": "cantabria"
  },
  {
    "centil": 87,
    "numero_total": 1652,
    "sme_total": 42900,
    "numero_home": 1055,
    "sme_home": 42905,
    "numero_dona": 597,
    "sme_dona": 42891,
    "maxim": 43519,
    "percent_asalariat": 90.3,
    "percent_salari": 78.33,
    "comunitat": "cantabria"
  },
  {
    "centil": 88,
    "numero_total": 1447,
    "sme_total": 44165,
    "numero_home": 976,
    "sme_home": 44168,
    "numero_dona": 471,
    "sme_dona": 44159,
    "maxim": 44857,
    "percent_asalariat": 91.3,
    "percent_salari": 79.88,
    "comunitat": "cantabria"
  },
  {
    "centil": 89,
    "numero_total": 1427,
    "sme_total": 45580,
    "numero_home": 990,
    "sme_home": 45576,
    "numero_dona": 437,
    "sme_dona": 45589,
    "maxim": 46326,
    "percent_asalariat": 92.2,
    "percent_salari": 81.45,
    "comunitat": "cantabria"
  },
  {
    "centil": 90,
    "numero_total": 1420,
    "sme_total": 47158,
    "numero_home": 994,
    "sme_home": 47151,
    "numero_dona": 426,
    "sme_dona": 47174,
    "maxim": 48005,
    "percent_asalariat": 93.1,
    "percent_salari": 83.07,
    "comunitat": "cantabria"
  },
  {
    "centil": 91,
    "numero_total": 1324,
    "sme_total": 48927,
    "numero_home": 945,
    "sme_home": 48936,
    "numero_dona": 379,
    "sme_dona": 48904,
    "maxim": 49888,
    "percent_asalariat": 94,
    "percent_salari": 84.63,
    "comunitat": "cantabria"
  },
  {
    "centil": 92,
    "numero_total": 1256,
    "sme_total": 50919,
    "numero_home": 894,
    "sme_home": 50912,
    "numero_dona": 362,
    "sme_dona": 50938,
    "maxim": 52064,
    "percent_asalariat": 94.8,
    "percent_salari": 86.18,
    "comunitat": "cantabria"
  },
  {
    "centil": 93,
    "numero_total": 1199,
    "sme_total": 53331,
    "numero_home": 836,
    "sme_home": 53329,
    "numero_dona": 363,
    "sme_dona": 53337,
    "maxim": 54742,
    "percent_asalariat": 95.6,
    "percent_salari": 87.73,
    "comunitat": "cantabria"
  },
  {
    "centil": 94,
    "numero_total": 1157,
    "sme_total": 56290,
    "numero_home": 814,
    "sme_home": 56259,
    "numero_dona": 343,
    "sme_dona": 56362,
    "maxim": 57976,
    "percent_asalariat": 96.4,
    "percent_salari": 89.3,
    "comunitat": "cantabria"
  },
  {
    "centil": 95,
    "numero_total": 1154,
    "sme_total": 59889,
    "numero_home": 795,
    "sme_home": 59890,
    "numero_dona": 359,
    "sme_dona": 59889,
    "maxim": 61939,
    "percent_asalariat": 97.1,
    "percent_salari": 90.97,
    "comunitat": "cantabria"
  },
  {
    "centil": 96,
    "numero_total": 1230,
    "sme_total": 64450,
    "numero_home": 864,
    "sme_home": 64432,
    "numero_dona": 366,
    "sme_dona": 64494,
    "maxim": 66966,
    "percent_asalariat": 97.9,
    "percent_salari": 92.89,
    "comunitat": "cantabria"
  },
  {
    "centil": 97,
    "numero_total": 1069,
    "sme_total": 70049,
    "numero_home": 790,
    "sme_home": 70059,
    "numero_dona": 279,
    "sme_dona": 70021,
    "maxim": 73778,
    "percent_asalariat": 98.6,
    "percent_salari": 94.7,
    "comunitat": "cantabria"
  },
  {
    "centil": 98,
    "numero_total": 791,
    "sme_total": 78259,
    "numero_home": 616,
    "sme_home": 78217,
    "numero_dona": 175,
    "sme_dona": 78409,
    "maxim": 83931,
    "percent_asalariat": 99.1,
    "percent_salari": 96.19,
    "comunitat": "cantabria"
  },
  {
    "centil": 99,
    "numero_total": 720,
    "sme_total": 91909,
    "numero_home": 566,
    "sme_home": 91966,
    "numero_dona": 154,
    "sme_dona": 91700,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.79,
    "comunitat": "cantabria"
  },
  {
    "centil": 100,
    "numero_total": 599,
    "sme_total": 152410,
    "numero_home": 496,
    "sme_home": 154621,
    "numero_dona": 103,
    "sme_dona": 141764,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "cantabria"
  },
  {
    "centil": 1,
    "numero_total": 6673,
    "sme_total": 14057,
    "numero_home": 3039,
    "sme_home": 14057,
    "numero_dona": 3634,
    "sme_dona": 14058,
    "maxim": 14139,
    "percent_asalariat": 1.1,
    "percent_salari": 0.58,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 2,
    "numero_total": 7595,
    "sme_total": 14216,
    "numero_home": 3311,
    "sme_home": 14216,
    "numero_dona": 4284,
    "sme_dona": 14216,
    "maxim": 14300,
    "percent_asalariat": 2.3,
    "percent_salari": 1.25,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 3,
    "numero_total": 6469,
    "sme_total": 14379,
    "numero_home": 2949,
    "sme_home": 14379,
    "numero_dona": 3520,
    "sme_dona": 14378,
    "maxim": 14458,
    "percent_asalariat": 3.4,
    "percent_salari": 1.83,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 4,
    "numero_total": 6391,
    "sme_total": 14537,
    "numero_home": 2888,
    "sme_home": 14538,
    "numero_dona": 3503,
    "sme_dona": 14537,
    "maxim": 14618,
    "percent_asalariat": 4.4,
    "percent_salari": 2.41,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 5,
    "numero_total": 6534,
    "sme_total": 14698,
    "numero_home": 2937,
    "sme_home": 14698,
    "numero_dona": 3597,
    "sme_dona": 14697,
    "maxim": 14776,
    "percent_asalariat": 5.5,
    "percent_salari": 3.01,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 6,
    "numero_total": 6562,
    "sme_total": 14856,
    "numero_home": 2951,
    "sme_home": 14857,
    "numero_dona": 3611,
    "sme_dona": 14855,
    "maxim": 14934,
    "percent_asalariat": 6.5,
    "percent_salari": 3.61,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 7,
    "numero_total": 6350,
    "sme_total": 15013,
    "numero_home": 2969,
    "sme_home": 15012,
    "numero_dona": 3381,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 7.6,
    "percent_salari": 4.21,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 8,
    "numero_total": 6301,
    "sme_total": 15170,
    "numero_home": 2919,
    "sme_home": 15171,
    "numero_dona": 3382,
    "sme_dona": 15170,
    "maxim": 15248,
    "percent_asalariat": 8.6,
    "percent_salari": 4.8,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 9,
    "numero_total": 6779,
    "sme_total": 15329,
    "numero_home": 3187,
    "sme_home": 15330,
    "numero_dona": 3592,
    "sme_dona": 15329,
    "maxim": 15407,
    "percent_asalariat": 9.7,
    "percent_salari": 5.45,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 10,
    "numero_total": 6822,
    "sme_total": 15487,
    "numero_home": 3319,
    "sme_home": 15486,
    "numero_dona": 3503,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 10.8,
    "percent_salari": 6.1,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 11,
    "numero_total": 6874,
    "sme_total": 15647,
    "numero_home": 3247,
    "sme_home": 15648,
    "numero_dona": 3627,
    "sme_dona": 15647,
    "maxim": 15726,
    "percent_asalariat": 11.9,
    "percent_salari": 6.77,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 12,
    "numero_total": 6857,
    "sme_total": 15807,
    "numero_home": 3235,
    "sme_home": 15807,
    "numero_dona": 3622,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 13,
    "percent_salari": 7.45,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 13,
    "numero_total": 6995,
    "sme_total": 15966,
    "numero_home": 3371,
    "sme_home": 15967,
    "numero_dona": 3624,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 14.2,
    "percent_salari": 8.14,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 14,
    "numero_total": 6980,
    "sme_total": 16127,
    "numero_home": 3481,
    "sme_home": 16127,
    "numero_dona": 3499,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 15.3,
    "percent_salari": 8.84,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 15,
    "numero_total": 7404,
    "sme_total": 16288,
    "numero_home": 3873,
    "sme_home": 16288,
    "numero_dona": 3531,
    "sme_dona": 16288,
    "maxim": 16371,
    "percent_asalariat": 16.5,
    "percent_salari": 9.59,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 16,
    "numero_total": 7378,
    "sme_total": 16453,
    "numero_home": 3790,
    "sme_home": 16454,
    "numero_dona": 3588,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 17.7,
    "percent_salari": 10.34,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 17,
    "numero_total": 7073,
    "sme_total": 16611,
    "numero_home": 3789,
    "sme_home": 16610,
    "numero_dona": 3284,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 18.9,
    "percent_salari": 11.08,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 18,
    "numero_total": 7303,
    "sme_total": 16774,
    "numero_home": 3910,
    "sme_home": 16775,
    "numero_dona": 3393,
    "sme_dona": 16772,
    "maxim": 16855,
    "percent_asalariat": 20,
    "percent_salari": 11.84,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 19,
    "numero_total": 7075,
    "sme_total": 16939,
    "numero_home": 3869,
    "sme_home": 16939,
    "numero_dona": 3206,
    "sme_dona": 16938,
    "maxim": 17023,
    "percent_asalariat": 21.2,
    "percent_salari": 12.58,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 20,
    "numero_total": 6957,
    "sme_total": 17109,
    "numero_home": 3907,
    "sme_home": 17109,
    "numero_dona": 3050,
    "sme_dona": 17109,
    "maxim": 17196,
    "percent_asalariat": 22.3,
    "percent_salari": 13.32,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 21,
    "numero_total": 7106,
    "sme_total": 17283,
    "numero_home": 4022,
    "sme_home": 17283,
    "numero_dona": 3084,
    "sme_dona": 17283,
    "maxim": 17369,
    "percent_asalariat": 23.5,
    "percent_salari": 14.09,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 22,
    "numero_total": 7214,
    "sme_total": 17456,
    "numero_home": 4334,
    "sme_home": 17457,
    "numero_dona": 2880,
    "sme_dona": 17454,
    "maxim": 17543,
    "percent_asalariat": 24.7,
    "percent_salari": 14.87,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 23,
    "numero_total": 6979,
    "sme_total": 17629,
    "numero_home": 4216,
    "sme_home": 17629,
    "numero_dona": 2763,
    "sme_dona": 17628,
    "maxim": 17718,
    "percent_asalariat": 25.8,
    "percent_salari": 15.63,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 24,
    "numero_total": 7385,
    "sme_total": 17803,
    "numero_home": 4354,
    "sme_home": 17805,
    "numero_dona": 3031,
    "sme_dona": 17800,
    "maxim": 17891,
    "percent_asalariat": 27,
    "percent_salari": 16.45,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 25,
    "numero_total": 7260,
    "sme_total": 17977,
    "numero_home": 4487,
    "sme_home": 17978,
    "numero_dona": 2773,
    "sme_dona": 17976,
    "maxim": 18060,
    "percent_asalariat": 28.2,
    "percent_salari": 17.26,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 26,
    "numero_total": 7188,
    "sme_total": 18151,
    "numero_home": 4518,
    "sme_home": 18151,
    "numero_dona": 2670,
    "sme_dona": 18151,
    "maxim": 18239,
    "percent_asalariat": 29.3,
    "percent_salari": 18.07,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 27,
    "numero_total": 7343,
    "sme_total": 18328,
    "numero_home": 4776,
    "sme_home": 18328,
    "numero_dona": 2567,
    "sme_dona": 18327,
    "maxim": 18417,
    "percent_asalariat": 30.5,
    "percent_salari": 18.91,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 28,
    "numero_total": 7560,
    "sme_total": 18507,
    "numero_home": 4923,
    "sme_home": 18507,
    "numero_dona": 2637,
    "sme_dona": 18506,
    "maxim": 18596,
    "percent_asalariat": 31.8,
    "percent_salari": 19.78,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 29,
    "numero_total": 7959,
    "sme_total": 18683,
    "numero_home": 5212,
    "sme_home": 18685,
    "numero_dona": 2747,
    "sme_dona": 18681,
    "maxim": 18778,
    "percent_asalariat": 33.1,
    "percent_salari": 20.7,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 30,
    "numero_total": 7599,
    "sme_total": 18865,
    "numero_home": 5019,
    "sme_home": 18865,
    "numero_dona": 2580,
    "sme_dona": 18866,
    "maxim": 18953,
    "percent_asalariat": 34.3,
    "percent_salari": 21.6,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 31,
    "numero_total": 7671,
    "sme_total": 19044,
    "numero_home": 5165,
    "sme_home": 19044,
    "numero_dona": 2506,
    "sme_dona": 19044,
    "maxim": 19133,
    "percent_asalariat": 35.5,
    "percent_salari": 22.5,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 32,
    "numero_total": 7682,
    "sme_total": 19225,
    "numero_home": 5266,
    "sme_home": 19225,
    "numero_dona": 2416,
    "sme_dona": 19224,
    "maxim": 19317,
    "percent_asalariat": 36.8,
    "percent_salari": 23.42,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 33,
    "numero_total": 7475,
    "sme_total": 19408,
    "numero_home": 5112,
    "sme_home": 19408,
    "numero_dona": 2363,
    "sme_dona": 19408,
    "maxim": 19503,
    "percent_asalariat": 38,
    "percent_salari": 24.32,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 34,
    "numero_total": 7273,
    "sme_total": 19596,
    "numero_home": 4981,
    "sme_home": 19596,
    "numero_dona": 2292,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 39.2,
    "percent_salari": 25.21,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 35,
    "numero_total": 7057,
    "sme_total": 19783,
    "numero_home": 4733,
    "sme_home": 19785,
    "numero_dona": 2324,
    "sme_dona": 19780,
    "maxim": 19879,
    "percent_asalariat": 40.3,
    "percent_salari": 26.08,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 36,
    "numero_total": 6955,
    "sme_total": 19973,
    "numero_home": 4676,
    "sme_home": 19973,
    "numero_dona": 2279,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 41.5,
    "percent_salari": 26.94,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 37,
    "numero_total": 6823,
    "sme_total": 20167,
    "numero_home": 4458,
    "sme_home": 20168,
    "numero_dona": 2365,
    "sme_dona": 20165,
    "maxim": 20263,
    "percent_asalariat": 42.6,
    "percent_salari": 27.8,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 38,
    "numero_total": 6968,
    "sme_total": 20359,
    "numero_home": 4627,
    "sme_home": 20358,
    "numero_dona": 2341,
    "sme_dona": 20360,
    "maxim": 20459,
    "percent_asalariat": 43.7,
    "percent_salari": 28.68,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 39,
    "numero_total": 6846,
    "sme_total": 20558,
    "numero_home": 4608,
    "sme_home": 20559,
    "numero_dona": 2238,
    "sme_dona": 20555,
    "maxim": 20653,
    "percent_asalariat": 44.8,
    "percent_salari": 29.55,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 40,
    "numero_total": 6723,
    "sme_total": 20753,
    "numero_home": 4391,
    "sme_home": 20753,
    "numero_dona": 2332,
    "sme_dona": 20752,
    "maxim": 20854,
    "percent_asalariat": 45.9,
    "percent_salari": 30.42,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 41,
    "numero_total": 6732,
    "sme_total": 20954,
    "numero_home": 4462,
    "sme_home": 20953,
    "numero_dona": 2270,
    "sme_dona": 20954,
    "maxim": 21055,
    "percent_asalariat": 47,
    "percent_salari": 31.3,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 42,
    "numero_total": 6868,
    "sme_total": 21162,
    "numero_home": 4487,
    "sme_home": 21163,
    "numero_dona": 2381,
    "sme_dona": 21161,
    "maxim": 21267,
    "percent_asalariat": 48.1,
    "percent_salari": 32.2,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 43,
    "numero_total": 7033,
    "sme_total": 21374,
    "numero_home": 4743,
    "sme_home": 21374,
    "numero_dona": 2290,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 49.3,
    "percent_salari": 33.14,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 44,
    "numero_total": 7001,
    "sme_total": 21591,
    "numero_home": 4489,
    "sme_home": 21592,
    "numero_dona": 2512,
    "sme_dona": 21589,
    "maxim": 21701,
    "percent_asalariat": 50.4,
    "percent_salari": 34.08,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 45,
    "numero_total": 6814,
    "sme_total": 21812,
    "numero_home": 4367,
    "sme_home": 21813,
    "numero_dona": 2447,
    "sme_dona": 21811,
    "maxim": 21927,
    "percent_asalariat": 51.5,
    "percent_salari": 35,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 46,
    "numero_total": 6605,
    "sme_total": 22037,
    "numero_home": 4340,
    "sme_home": 22039,
    "numero_dona": 2265,
    "sme_dona": 22034,
    "maxim": 22151,
    "percent_asalariat": 52.6,
    "percent_salari": 35.91,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 47,
    "numero_total": 6687,
    "sme_total": 22267,
    "numero_home": 4465,
    "sme_home": 22266,
    "numero_dona": 2222,
    "sme_dona": 22267,
    "maxim": 22380,
    "percent_asalariat": 53.7,
    "percent_salari": 36.83,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 48,
    "numero_total": 6653,
    "sme_total": 22499,
    "numero_home": 4297,
    "sme_home": 22497,
    "numero_dona": 2356,
    "sme_dona": 22502,
    "maxim": 22616,
    "percent_asalariat": 54.8,
    "percent_salari": 37.76,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 49,
    "numero_total": 6671,
    "sme_total": 22739,
    "numero_home": 4302,
    "sme_home": 22739,
    "numero_dona": 2369,
    "sme_dona": 22739,
    "maxim": 22865,
    "percent_asalariat": 55.8,
    "percent_salari": 38.71,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 50,
    "numero_total": 6456,
    "sme_total": 22986,
    "numero_home": 4134,
    "sme_home": 22988,
    "numero_dona": 2322,
    "sme_dona": 22984,
    "maxim": 23114,
    "percent_asalariat": 56.9,
    "percent_salari": 39.63,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 51,
    "numero_total": 6543,
    "sme_total": 23246,
    "numero_home": 4196,
    "sme_home": 23246,
    "numero_dona": 2347,
    "sme_dona": 23245,
    "maxim": 23377,
    "percent_asalariat": 57.9,
    "percent_salari": 40.57,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 52,
    "numero_total": 6390,
    "sme_total": 23511,
    "numero_home": 4137,
    "sme_home": 23510,
    "numero_dona": 2253,
    "sme_dona": 23512,
    "maxim": 23645,
    "percent_asalariat": 59,
    "percent_salari": 41.51,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 53,
    "numero_total": 6223,
    "sme_total": 23783,
    "numero_home": 3998,
    "sme_home": 23783,
    "numero_dona": 2225,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 60,
    "percent_salari": 42.43,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 54,
    "numero_total": 6304,
    "sme_total": 24060,
    "numero_home": 4135,
    "sme_home": 24060,
    "numero_dona": 2169,
    "sme_dona": 24060,
    "maxim": 24198,
    "percent_asalariat": 61,
    "percent_salari": 43.37,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 55,
    "numero_total": 6591,
    "sme_total": 24348,
    "numero_home": 4187,
    "sme_home": 24348,
    "numero_dona": 2404,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 62.1,
    "percent_salari": 44.37,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 56,
    "numero_total": 6363,
    "sme_total": 24653,
    "numero_home": 3993,
    "sme_home": 24653,
    "numero_dona": 2370,
    "sme_dona": 24652,
    "maxim": 24811,
    "percent_asalariat": 63.1,
    "percent_salari": 45.34,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 57,
    "numero_total": 6103,
    "sme_total": 24964,
    "numero_home": 3812,
    "sme_home": 24963,
    "numero_dona": 2291,
    "sme_dona": 24966,
    "maxim": 25122,
    "percent_asalariat": 64.1,
    "percent_salari": 46.29,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 58,
    "numero_total": 5878,
    "sme_total": 25283,
    "numero_home": 3694,
    "sme_home": 25283,
    "numero_dona": 2184,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 65.1,
    "percent_salari": 47.22,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 59,
    "numero_total": 6233,
    "sme_total": 25622,
    "numero_home": 3887,
    "sme_home": 25622,
    "numero_dona": 2346,
    "sme_dona": 25623,
    "maxim": 25792,
    "percent_asalariat": 66.1,
    "percent_salari": 48.21,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 60,
    "numero_total": 6173,
    "sme_total": 25962,
    "numero_home": 3721,
    "sme_home": 25963,
    "numero_dona": 2452,
    "sme_dona": 25960,
    "maxim": 26139,
    "percent_asalariat": 67.1,
    "percent_salari": 49.2,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 61,
    "numero_total": 6162,
    "sme_total": 26325,
    "numero_home": 3779,
    "sme_home": 26326,
    "numero_dona": 2383,
    "sme_dona": 26322,
    "maxim": 26509,
    "percent_asalariat": 68.1,
    "percent_salari": 50.21,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 62,
    "numero_total": 6281,
    "sme_total": 26701,
    "numero_home": 3733,
    "sme_home": 26699,
    "numero_dona": 2548,
    "sme_dona": 26703,
    "maxim": 26874,
    "percent_asalariat": 69.1,
    "percent_salari": 51.26,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 63,
    "numero_total": 6198,
    "sme_total": 27039,
    "numero_home": 3660,
    "sme_home": 27042,
    "numero_dona": 2538,
    "sme_dona": 27034,
    "maxim": 27221,
    "percent_asalariat": 70.1,
    "percent_salari": 52.3,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 64,
    "numero_total": 5705,
    "sme_total": 27418,
    "numero_home": 3526,
    "sme_home": 27420,
    "numero_dona": 2179,
    "sme_dona": 27415,
    "maxim": 27616,
    "percent_asalariat": 71.1,
    "percent_salari": 53.27,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 65,
    "numero_total": 5845,
    "sme_total": 27822,
    "numero_home": 3679,
    "sme_home": 27822,
    "numero_dona": 2166,
    "sme_dona": 27821,
    "maxim": 28031,
    "percent_asalariat": 72,
    "percent_salari": 54.28,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 66,
    "numero_total": 5750,
    "sme_total": 28250,
    "numero_home": 3507,
    "sme_home": 28251,
    "numero_dona": 2243,
    "sme_dona": 28249,
    "maxim": 28476,
    "percent_asalariat": 72.9,
    "percent_salari": 55.29,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 67,
    "numero_total": 5822,
    "sme_total": 28713,
    "numero_home": 3651,
    "sme_home": 28714,
    "numero_dona": 2171,
    "sme_dona": 28713,
    "maxim": 28951,
    "percent_asalariat": 73.9,
    "percent_salari": 56.33,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 68,
    "numero_total": 5817,
    "sme_total": 29197,
    "numero_home": 3677,
    "sme_home": 29196,
    "numero_dona": 2140,
    "sme_dona": 29198,
    "maxim": 29450,
    "percent_asalariat": 74.8,
    "percent_salari": 57.39,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 69,
    "numero_total": 5898,
    "sme_total": 29708,
    "numero_home": 3705,
    "sme_home": 29707,
    "numero_dona": 2193,
    "sme_dona": 29710,
    "maxim": 29970,
    "percent_asalariat": 75.8,
    "percent_salari": 58.48,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 70,
    "numero_total": 5807,
    "sme_total": 30216,
    "numero_home": 3625,
    "sme_home": 30212,
    "numero_dona": 2182,
    "sme_dona": 30223,
    "maxim": 30487,
    "percent_asalariat": 76.7,
    "percent_salari": 59.57,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 71,
    "numero_total": 5566,
    "sme_total": 30756,
    "numero_home": 3451,
    "sme_home": 30754,
    "numero_dona": 2115,
    "sme_dona": 30760,
    "maxim": 31037,
    "percent_asalariat": 77.6,
    "percent_salari": 60.63,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 72,
    "numero_total": 5446,
    "sme_total": 31318,
    "numero_home": 3357,
    "sme_home": 31318,
    "numero_dona": 2089,
    "sme_dona": 31318,
    "maxim": 31602,
    "percent_asalariat": 78.5,
    "percent_salari": 61.69,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 73,
    "numero_total": 5365,
    "sme_total": 31885,
    "numero_home": 3280,
    "sme_home": 31886,
    "numero_dona": 2085,
    "sme_dona": 31884,
    "maxim": 32176,
    "percent_asalariat": 79.4,
    "percent_salari": 62.76,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 74,
    "numero_total": 5348,
    "sme_total": 32478,
    "numero_home": 3269,
    "sme_home": 32480,
    "numero_dona": 2079,
    "sme_dona": 32474,
    "maxim": 32786,
    "percent_asalariat": 80.3,
    "percent_salari": 63.84,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 75,
    "numero_total": 5080,
    "sme_total": 33096,
    "numero_home": 2986,
    "sme_home": 33095,
    "numero_dona": 2094,
    "sme_dona": 33097,
    "maxim": 33413,
    "percent_asalariat": 81.1,
    "percent_salari": 64.88,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 76,
    "numero_total": 4983,
    "sme_total": 33736,
    "numero_home": 2873,
    "sme_home": 33740,
    "numero_dona": 2110,
    "sme_dona": 33731,
    "maxim": 34056,
    "percent_asalariat": 81.9,
    "percent_salari": 65.93,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 77,
    "numero_total": 5233,
    "sme_total": 34384,
    "numero_home": 3048,
    "sme_home": 34387,
    "numero_dona": 2185,
    "sme_dona": 34380,
    "maxim": 34722,
    "percent_asalariat": 82.7,
    "percent_salari": 67.04,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 78,
    "numero_total": 5122,
    "sme_total": 35046,
    "numero_home": 3006,
    "sme_home": 35046,
    "numero_dona": 2116,
    "sme_dona": 35047,
    "maxim": 35374,
    "percent_asalariat": 83.6,
    "percent_salari": 68.16,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 79,
    "numero_total": 5370,
    "sme_total": 35710,
    "numero_home": 2886,
    "sme_home": 35703,
    "numero_dona": 2484,
    "sme_dona": 35717,
    "maxim": 36027,
    "percent_asalariat": 84.5,
    "percent_salari": 69.35,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 80,
    "numero_total": 5488,
    "sme_total": 36374,
    "numero_home": 2912,
    "sme_home": 36377,
    "numero_dona": 2576,
    "sme_dona": 36371,
    "maxim": 36730,
    "percent_asalariat": 85.3,
    "percent_salari": 70.59,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 81,
    "numero_total": 5580,
    "sme_total": 37124,
    "numero_home": 3023,
    "sme_home": 37121,
    "numero_dona": 2557,
    "sme_dona": 37127,
    "maxim": 37490,
    "percent_asalariat": 86.3,
    "percent_salari": 71.88,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 82,
    "numero_total": 5817,
    "sme_total": 37901,
    "numero_home": 3134,
    "sme_home": 37896,
    "numero_dona": 2683,
    "sme_dona": 37908,
    "maxim": 38304,
    "percent_asalariat": 87.2,
    "percent_salari": 73.25,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 83,
    "numero_total": 5715,
    "sme_total": 38741,
    "numero_home": 3100,
    "sme_home": 38746,
    "numero_dona": 2615,
    "sme_dona": 38735,
    "maxim": 39197,
    "percent_asalariat": 88.1,
    "percent_salari": 74.63,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 84,
    "numero_total": 5306,
    "sme_total": 39669,
    "numero_home": 2950,
    "sme_home": 39674,
    "numero_dona": 2356,
    "sme_dona": 39664,
    "maxim": 40137,
    "percent_asalariat": 89,
    "percent_salari": 75.94,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 85,
    "numero_total": 5286,
    "sme_total": 40646,
    "numero_home": 3020,
    "sme_home": 40648,
    "numero_dona": 2266,
    "sme_dona": 40644,
    "maxim": 41170,
    "percent_asalariat": 89.8,
    "percent_salari": 77.27,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 86,
    "numero_total": 4975,
    "sme_total": 41731,
    "numero_home": 2931,
    "sme_home": 41735,
    "numero_dona": 2044,
    "sme_dona": 41725,
    "maxim": 42306,
    "percent_asalariat": 90.7,
    "percent_salari": 78.56,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 87,
    "numero_total": 4926,
    "sme_total": 42906,
    "numero_home": 2912,
    "sme_home": 42908,
    "numero_dona": 2014,
    "sme_dona": 42903,
    "maxim": 43519,
    "percent_asalariat": 91.5,
    "percent_salari": 79.88,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 88,
    "numero_total": 4574,
    "sme_total": 44162,
    "numero_home": 2785,
    "sme_home": 44166,
    "numero_dona": 1789,
    "sme_dona": 44155,
    "maxim": 44857,
    "percent_asalariat": 92.2,
    "percent_salari": 81.13,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 89,
    "numero_total": 4642,
    "sme_total": 45581,
    "numero_home": 2924,
    "sme_home": 45578,
    "numero_dona": 1718,
    "sme_dona": 45586,
    "maxim": 46326,
    "percent_asalariat": 93,
    "percent_salari": 82.45,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 90,
    "numero_total": 4516,
    "sme_total": 47123,
    "numero_home": 2823,
    "sme_home": 47136,
    "numero_dona": 1693,
    "sme_dona": 47101,
    "maxim": 48005,
    "percent_asalariat": 93.7,
    "percent_salari": 83.77,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 91,
    "numero_total": 4321,
    "sme_total": 48942,
    "numero_home": 2757,
    "sme_home": 48941,
    "numero_dona": 1564,
    "sme_dona": 48945,
    "maxim": 49888,
    "percent_asalariat": 94.4,
    "percent_salari": 85.09,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 92,
    "numero_total": 4348,
    "sme_total": 50920,
    "numero_home": 2828,
    "sme_home": 50926,
    "numero_dona": 1520,
    "sme_dona": 50910,
    "maxim": 52064,
    "percent_asalariat": 95.1,
    "percent_salari": 86.46,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 93,
    "numero_total": 4284,
    "sme_total": 53360,
    "numero_home": 2740,
    "sme_home": 53375,
    "numero_dona": 1544,
    "sme_dona": 53332,
    "maxim": 54742,
    "percent_asalariat": 95.8,
    "percent_salari": 87.89,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 94,
    "numero_total": 4297,
    "sme_total": 56283,
    "numero_home": 2782,
    "sme_home": 56270,
    "numero_dona": 1515,
    "sme_dona": 56306,
    "maxim": 57976,
    "percent_asalariat": 96.5,
    "percent_salari": 89.39,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 95,
    "numero_total": 4155,
    "sme_total": 59869,
    "numero_home": 2783,
    "sme_home": 59884,
    "numero_dona": 1372,
    "sme_dona": 59838,
    "maxim": 61939,
    "percent_asalariat": 97.2,
    "percent_salari": 90.94,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 96,
    "numero_total": 4202,
    "sme_total": 64293,
    "numero_home": 2814,
    "sme_home": 64293,
    "numero_dona": 1388,
    "sme_dona": 64294,
    "maxim": 66966,
    "percent_asalariat": 97.9,
    "percent_salari": 92.62,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 97,
    "numero_total": 3825,
    "sme_total": 70129,
    "numero_home": 2601,
    "sme_home": 70103,
    "numero_dona": 1224,
    "sme_dona": 70183,
    "maxim": 73778,
    "percent_asalariat": 98.5,
    "percent_salari": 94.28,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 98,
    "numero_total": 3783,
    "sme_total": 78397,
    "numero_home": 2549,
    "sme_home": 78323,
    "numero_dona": 1234,
    "sme_dona": 78552,
    "maxim": 83931,
    "percent_asalariat": 99.1,
    "percent_salari": 96.13,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 99,
    "numero_total": 3432,
    "sme_total": 91963,
    "numero_home": 2360,
    "sme_home": 92265,
    "numero_dona": 1072,
    "sme_dona": 91301,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 98.09,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 100,
    "numero_total": 2162,
    "sme_total": 142153,
    "numero_home": 1765,
    "sme_home": 143527,
    "numero_dona": 397,
    "sme_dona": 136043,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "castella-la-manxa"
  },
  {
    "centil": 1,
    "numero_total": 6197,
    "sme_total": 14057,
    "numero_home": 2724,
    "sme_home": 14052,
    "numero_dona": 3473,
    "sme_dona": 14060,
    "maxim": 14139,
    "percent_asalariat": 0.9,
    "percent_salari": 0.47,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 2,
    "numero_total": 6087,
    "sme_total": 14219,
    "numero_home": 2531,
    "sme_home": 14218,
    "numero_dona": 3556,
    "sme_dona": 14220,
    "maxim": 14300,
    "percent_asalariat": 1.8,
    "percent_salari": 0.95,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 3,
    "numero_total": 6430,
    "sme_total": 14380,
    "numero_home": 2663,
    "sme_home": 14381,
    "numero_dona": 3767,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 2.8,
    "percent_salari": 1.45,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 4,
    "numero_total": 6710,
    "sme_total": 14540,
    "numero_home": 2756,
    "sme_home": 14541,
    "numero_dona": 3954,
    "sme_dona": 14539,
    "maxim": 14618,
    "percent_asalariat": 3.8,
    "percent_salari": 1.98,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 5,
    "numero_total": 6737,
    "sme_total": 14697,
    "numero_home": 2728,
    "sme_home": 14696,
    "numero_dona": 4009,
    "sme_dona": 14697,
    "maxim": 14776,
    "percent_asalariat": 4.8,
    "percent_salari": 2.52,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 6,
    "numero_total": 6900,
    "sme_total": 14856,
    "numero_home": 2756,
    "sme_home": 14856,
    "numero_dona": 4144,
    "sme_dona": 14855,
    "maxim": 14934,
    "percent_asalariat": 5.8,
    "percent_salari": 3.08,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 7,
    "numero_total": 6906,
    "sme_total": 15012,
    "numero_home": 2843,
    "sme_home": 15014,
    "numero_dona": 4063,
    "sme_dona": 15011,
    "maxim": 15091,
    "percent_asalariat": 6.8,
    "percent_salari": 3.64,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 8,
    "numero_total": 6755,
    "sme_total": 15170,
    "numero_home": 2821,
    "sme_home": 15171,
    "numero_dona": 3934,
    "sme_dona": 15169,
    "maxim": 15248,
    "percent_asalariat": 7.8,
    "percent_salari": 4.2,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 9,
    "numero_total": 6849,
    "sme_total": 15328,
    "numero_home": 2907,
    "sme_home": 15329,
    "numero_dona": 3942,
    "sme_dona": 15327,
    "maxim": 15407,
    "percent_asalariat": 8.8,
    "percent_salari": 4.77,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 10,
    "numero_total": 6745,
    "sme_total": 15487,
    "numero_home": 2933,
    "sme_home": 15487,
    "numero_dona": 3812,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 9.8,
    "percent_salari": 5.34,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 11,
    "numero_total": 7112,
    "sme_total": 15646,
    "numero_home": 3099,
    "sme_home": 15646,
    "numero_dona": 4013,
    "sme_dona": 15646,
    "maxim": 15726,
    "percent_asalariat": 10.9,
    "percent_salari": 5.94,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 12,
    "numero_total": 7143,
    "sme_total": 15805,
    "numero_home": 3175,
    "sme_home": 15805,
    "numero_dona": 3968,
    "sme_dona": 15805,
    "maxim": 15885,
    "percent_asalariat": 12,
    "percent_salari": 6.56,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 13,
    "numero_total": 6865,
    "sme_total": 15965,
    "numero_home": 3118,
    "sme_home": 15966,
    "numero_dona": 3747,
    "sme_dona": 15965,
    "maxim": 16046,
    "percent_asalariat": 13,
    "percent_salari": 7.15,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 14,
    "numero_total": 6692,
    "sme_total": 16126,
    "numero_home": 2998,
    "sme_home": 16125,
    "numero_dona": 3694,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 14,
    "percent_salari": 7.74,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 15,
    "numero_total": 6572,
    "sme_total": 16289,
    "numero_home": 2980,
    "sme_home": 16288,
    "numero_dona": 3592,
    "sme_dona": 16289,
    "maxim": 16371,
    "percent_asalariat": 15,
    "percent_salari": 8.32,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 16,
    "numero_total": 6815,
    "sme_total": 16452,
    "numero_home": 3288,
    "sme_home": 16451,
    "numero_dona": 3527,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 16,
    "percent_salari": 8.93,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 17,
    "numero_total": 6694,
    "sme_total": 16610,
    "numero_home": 3169,
    "sme_home": 16609,
    "numero_dona": 3525,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 17,
    "percent_salari": 9.54,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 18,
    "numero_total": 7062,
    "sme_total": 16773,
    "numero_home": 3195,
    "sme_home": 16773,
    "numero_dona": 3867,
    "sme_dona": 16772,
    "maxim": 16855,
    "percent_asalariat": 18,
    "percent_salari": 10.18,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 19,
    "numero_total": 6687,
    "sme_total": 16940,
    "numero_home": 3217,
    "sme_home": 16941,
    "numero_dona": 3470,
    "sme_dona": 16939,
    "maxim": 17023,
    "percent_asalariat": 19,
    "percent_salari": 10.8,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 20,
    "numero_total": 7355,
    "sme_total": 17112,
    "numero_home": 3576,
    "sme_home": 17111,
    "numero_dona": 3779,
    "sme_dona": 17112,
    "maxim": 17196,
    "percent_asalariat": 20.1,
    "percent_salari": 11.49,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 21,
    "numero_total": 7264,
    "sme_total": 17282,
    "numero_home": 3523,
    "sme_home": 17283,
    "numero_dona": 3741,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 21.2,
    "percent_salari": 12.17,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 22,
    "numero_total": 7093,
    "sme_total": 17454,
    "numero_home": 3768,
    "sme_home": 17454,
    "numero_dona": 3325,
    "sme_dona": 17454,
    "maxim": 17543,
    "percent_asalariat": 22.2,
    "percent_salari": 12.84,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 23,
    "numero_total": 7357,
    "sme_total": 17631,
    "numero_home": 3879,
    "sme_home": 17631,
    "numero_dona": 3478,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 23.3,
    "percent_salari": 13.55,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 24,
    "numero_total": 7429,
    "sme_total": 17804,
    "numero_home": 4022,
    "sme_home": 17805,
    "numero_dona": 3407,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 24.4,
    "percent_salari": 14.27,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 25,
    "numero_total": 7123,
    "sme_total": 17976,
    "numero_home": 3982,
    "sme_home": 17977,
    "numero_dona": 3141,
    "sme_dona": 17975,
    "maxim": 18060,
    "percent_asalariat": 25.5,
    "percent_salari": 14.97,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 26,
    "numero_total": 7299,
    "sme_total": 18150,
    "numero_home": 4309,
    "sme_home": 18150,
    "numero_dona": 2990,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 26.6,
    "percent_salari": 15.69,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 27,
    "numero_total": 7511,
    "sme_total": 18326,
    "numero_home": 4432,
    "sme_home": 18327,
    "numero_dona": 3079,
    "sme_dona": 18325,
    "maxim": 18417,
    "percent_asalariat": 27.7,
    "percent_salari": 16.44,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 28,
    "numero_total": 7508,
    "sme_total": 18506,
    "numero_home": 4481,
    "sme_home": 18506,
    "numero_dona": 3027,
    "sme_dona": 18506,
    "maxim": 18596,
    "percent_asalariat": 28.8,
    "percent_salari": 17.19,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 29,
    "numero_total": 7768,
    "sme_total": 18685,
    "numero_home": 4782,
    "sme_home": 18685,
    "numero_dona": 2986,
    "sme_dona": 18685,
    "maxim": 18778,
    "percent_asalariat": 29.9,
    "percent_salari": 17.98,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 30,
    "numero_total": 7775,
    "sme_total": 18865,
    "numero_home": 4821,
    "sme_home": 18866,
    "numero_dona": 2954,
    "sme_dona": 18864,
    "maxim": 18953,
    "percent_asalariat": 31.1,
    "percent_salari": 18.78,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 31,
    "numero_total": 7518,
    "sme_total": 19045,
    "numero_home": 4602,
    "sme_home": 19046,
    "numero_dona": 2916,
    "sme_dona": 19044,
    "maxim": 19133,
    "percent_asalariat": 32.2,
    "percent_salari": 19.56,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 32,
    "numero_total": 7286,
    "sme_total": 19224,
    "numero_home": 4467,
    "sme_home": 19223,
    "numero_dona": 2819,
    "sme_dona": 19224,
    "maxim": 19317,
    "percent_asalariat": 33.3,
    "percent_salari": 20.32,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 33,
    "numero_total": 7328,
    "sme_total": 19409,
    "numero_home": 4546,
    "sme_home": 19408,
    "numero_dona": 2782,
    "sme_dona": 19410,
    "maxim": 19503,
    "percent_asalariat": 34.4,
    "percent_salari": 21.1,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 34,
    "numero_total": 7369,
    "sme_total": 19596,
    "numero_home": 4654,
    "sme_home": 19595,
    "numero_dona": 2715,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 35.5,
    "percent_salari": 21.88,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 35,
    "numero_total": 7123,
    "sme_total": 19784,
    "numero_home": 4260,
    "sme_home": 19785,
    "numero_dona": 2863,
    "sme_dona": 19784,
    "maxim": 19879,
    "percent_asalariat": 36.5,
    "percent_salari": 22.65,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 36,
    "numero_total": 7212,
    "sme_total": 19975,
    "numero_home": 4449,
    "sme_home": 19975,
    "numero_dona": 2763,
    "sme_dona": 19975,
    "maxim": 20069,
    "percent_asalariat": 37.6,
    "percent_salari": 23.43,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 37,
    "numero_total": 7185,
    "sme_total": 20165,
    "numero_home": 4360,
    "sme_home": 20165,
    "numero_dona": 2825,
    "sme_dona": 20165,
    "maxim": 20263,
    "percent_asalariat": 38.7,
    "percent_salari": 24.22,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 38,
    "numero_total": 7362,
    "sme_total": 20360,
    "numero_home": 4547,
    "sme_home": 20360,
    "numero_dona": 2815,
    "sme_dona": 20360,
    "maxim": 20459,
    "percent_asalariat": 39.8,
    "percent_salari": 25.04,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 39,
    "numero_total": 7408,
    "sme_total": 20555,
    "numero_home": 4618,
    "sme_home": 20555,
    "numero_dona": 2790,
    "sme_dona": 20556,
    "maxim": 20653,
    "percent_asalariat": 40.9,
    "percent_salari": 25.87,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 40,
    "numero_total": 7075,
    "sme_total": 20754,
    "numero_home": 4451,
    "sme_home": 20754,
    "numero_dona": 2624,
    "sme_dona": 20754,
    "maxim": 20854,
    "percent_asalariat": 41.9,
    "percent_salari": 26.67,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 41,
    "numero_total": 7002,
    "sme_total": 20955,
    "numero_home": 4363,
    "sme_home": 20954,
    "numero_dona": 2639,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 43,
    "percent_salari": 27.46,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 42,
    "numero_total": 7131,
    "sme_total": 21162,
    "numero_home": 4479,
    "sme_home": 21162,
    "numero_dona": 2652,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 44,
    "percent_salari": 28.29,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 43,
    "numero_total": 6954,
    "sme_total": 21376,
    "numero_home": 4291,
    "sme_home": 21376,
    "numero_dona": 2663,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 45,
    "percent_salari": 29.09,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 44,
    "numero_total": 7376,
    "sme_total": 21592,
    "numero_home": 4598,
    "sme_home": 21591,
    "numero_dona": 2778,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 46.1,
    "percent_salari": 29.96,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 45,
    "numero_total": 7345,
    "sme_total": 21815,
    "numero_home": 4641,
    "sme_home": 21815,
    "numero_dona": 2704,
    "sme_dona": 21816,
    "maxim": 21927,
    "percent_asalariat": 47.2,
    "percent_salari": 30.83,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 46,
    "numero_total": 7305,
    "sme_total": 22037,
    "numero_home": 4625,
    "sme_home": 22037,
    "numero_dona": 2680,
    "sme_dona": 22037,
    "maxim": 22151,
    "percent_asalariat": 48.3,
    "percent_salari": 31.71,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 47,
    "numero_total": 7384,
    "sme_total": 22266,
    "numero_home": 4506,
    "sme_home": 22266,
    "numero_dona": 2878,
    "sme_dona": 22266,
    "maxim": 22380,
    "percent_asalariat": 49.4,
    "percent_salari": 32.6,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 48,
    "numero_total": 7149,
    "sme_total": 22498,
    "numero_home": 4342,
    "sme_home": 22498,
    "numero_dona": 2807,
    "sme_dona": 22499,
    "maxim": 22616,
    "percent_asalariat": 50.5,
    "percent_salari": 33.48,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 49,
    "numero_total": 7146,
    "sme_total": 22739,
    "numero_home": 4321,
    "sme_home": 22740,
    "numero_dona": 2825,
    "sme_dona": 22739,
    "maxim": 22865,
    "percent_asalariat": 51.5,
    "percent_salari": 34.36,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 50,
    "numero_total": 7122,
    "sme_total": 22989,
    "numero_home": 4239,
    "sme_home": 22988,
    "numero_dona": 2883,
    "sme_dona": 22990,
    "maxim": 23114,
    "percent_asalariat": 52.6,
    "percent_salari": 35.26,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 51,
    "numero_total": 6882,
    "sme_total": 23244,
    "numero_home": 4125,
    "sme_home": 23244,
    "numero_dona": 2757,
    "sme_dona": 23244,
    "maxim": 23377,
    "percent_asalariat": 53.6,
    "percent_salari": 36.13,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 52,
    "numero_total": 6875,
    "sme_total": 23510,
    "numero_home": 4200,
    "sme_home": 23510,
    "numero_dona": 2675,
    "sme_dona": 23509,
    "maxim": 23645,
    "percent_asalariat": 54.6,
    "percent_salari": 37.01,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 53,
    "numero_total": 7056,
    "sme_total": 23784,
    "numero_home": 4311,
    "sme_home": 23784,
    "numero_dona": 2745,
    "sme_dona": 23783,
    "maxim": 23925,
    "percent_asalariat": 55.7,
    "percent_salari": 37.92,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 54,
    "numero_total": 6691,
    "sme_total": 24059,
    "numero_home": 4106,
    "sme_home": 24057,
    "numero_dona": 2585,
    "sme_dona": 24061,
    "maxim": 24198,
    "percent_asalariat": 56.7,
    "percent_salari": 38.8,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 55,
    "numero_total": 6891,
    "sme_total": 24350,
    "numero_home": 4121,
    "sme_home": 24350,
    "numero_dona": 2770,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 57.7,
    "percent_salari": 39.71,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 56,
    "numero_total": 6954,
    "sme_total": 24655,
    "numero_home": 4090,
    "sme_home": 24653,
    "numero_dona": 2864,
    "sme_dona": 24657,
    "maxim": 24811,
    "percent_asalariat": 58.7,
    "percent_salari": 40.64,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 57,
    "numero_total": 6967,
    "sme_total": 24968,
    "numero_home": 4077,
    "sme_home": 24967,
    "numero_dona": 2890,
    "sme_dona": 24969,
    "maxim": 25122,
    "percent_asalariat": 59.8,
    "percent_salari": 41.59,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 58,
    "numero_total": 6883,
    "sme_total": 25285,
    "numero_home": 4212,
    "sme_home": 25287,
    "numero_dona": 2671,
    "sme_dona": 25281,
    "maxim": 25450,
    "percent_asalariat": 60.8,
    "percent_salari": 42.54,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 59,
    "numero_total": 6861,
    "sme_total": 25620,
    "numero_home": 4184,
    "sme_home": 25621,
    "numero_dona": 2677,
    "sme_dona": 25619,
    "maxim": 25792,
    "percent_asalariat": 61.8,
    "percent_salari": 43.49,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 60,
    "numero_total": 6721,
    "sme_total": 25965,
    "numero_home": 4132,
    "sme_home": 25964,
    "numero_dona": 2589,
    "sme_dona": 25967,
    "maxim": 26139,
    "percent_asalariat": 62.8,
    "percent_salari": 44.44,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 61,
    "numero_total": 6941,
    "sme_total": 26322,
    "numero_home": 4289,
    "sme_home": 26324,
    "numero_dona": 2652,
    "sme_dona": 26319,
    "maxim": 26509,
    "percent_asalariat": 63.8,
    "percent_salari": 45.44,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 62,
    "numero_total": 6685,
    "sme_total": 26693,
    "numero_home": 4073,
    "sme_home": 26694,
    "numero_dona": 2612,
    "sme_dona": 26692,
    "maxim": 26874,
    "percent_asalariat": 64.8,
    "percent_salari": 46.41,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 63,
    "numero_total": 6569,
    "sme_total": 27048,
    "numero_home": 3967,
    "sme_home": 27046,
    "numero_dona": 2602,
    "sme_dona": 27050,
    "maxim": 27221,
    "percent_asalariat": 65.8,
    "percent_salari": 47.38,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 64,
    "numero_total": 6980,
    "sme_total": 27413,
    "numero_home": 4304,
    "sme_home": 27413,
    "numero_dona": 2676,
    "sme_dona": 27412,
    "maxim": 27616,
    "percent_asalariat": 66.8,
    "percent_salari": 48.42,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 65,
    "numero_total": 6795,
    "sme_total": 27824,
    "numero_home": 4206,
    "sme_home": 27825,
    "numero_dona": 2589,
    "sme_dona": 27822,
    "maxim": 28031,
    "percent_asalariat": 67.8,
    "percent_salari": 49.45,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 66,
    "numero_total": 6744,
    "sme_total": 28253,
    "numero_home": 4056,
    "sme_home": 28252,
    "numero_dona": 2688,
    "sme_dona": 28254,
    "maxim": 28476,
    "percent_asalariat": 68.8,
    "percent_salari": 50.48,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 67,
    "numero_total": 7035,
    "sme_total": 28710,
    "numero_home": 4236,
    "sme_home": 28711,
    "numero_dona": 2799,
    "sme_dona": 28709,
    "maxim": 28951,
    "percent_asalariat": 69.9,
    "percent_salari": 51.58,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 68,
    "numero_total": 6973,
    "sme_total": 29197,
    "numero_home": 4271,
    "sme_home": 29195,
    "numero_dona": 2702,
    "sme_dona": 29201,
    "maxim": 29450,
    "percent_asalariat": 70.9,
    "percent_salari": 52.69,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 69,
    "numero_total": 6994,
    "sme_total": 29705,
    "numero_home": 4310,
    "sme_home": 29705,
    "numero_dona": 2684,
    "sme_dona": 29706,
    "maxim": 29970,
    "percent_asalariat": 72,
    "percent_salari": 53.82,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 70,
    "numero_total": 6849,
    "sme_total": 30220,
    "numero_home": 4179,
    "sme_home": 30220,
    "numero_dona": 2670,
    "sme_dona": 30219,
    "maxim": 30487,
    "percent_asalariat": 73,
    "percent_salari": 54.95,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 71,
    "numero_total": 6979,
    "sme_total": 30760,
    "numero_home": 4271,
    "sme_home": 30760,
    "numero_dona": 2708,
    "sme_dona": 30760,
    "maxim": 31037,
    "percent_asalariat": 74,
    "percent_salari": 56.12,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 72,
    "numero_total": 6845,
    "sme_total": 31323,
    "numero_home": 4220,
    "sme_home": 31324,
    "numero_dona": 2625,
    "sme_dona": 31321,
    "maxim": 31602,
    "percent_asalariat": 75,
    "percent_salari": 57.28,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 73,
    "numero_total": 7107,
    "sme_total": 31889,
    "numero_home": 4218,
    "sme_home": 31891,
    "numero_dona": 2889,
    "sme_dona": 31886,
    "maxim": 32176,
    "percent_asalariat": 76.1,
    "percent_salari": 58.52,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 74,
    "numero_total": 6988,
    "sme_total": 32479,
    "numero_home": 4218,
    "sme_home": 32477,
    "numero_dona": 2770,
    "sme_dona": 32483,
    "maxim": 32786,
    "percent_asalariat": 77.1,
    "percent_salari": 59.75,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 75,
    "numero_total": 6806,
    "sme_total": 33099,
    "numero_home": 3978,
    "sme_home": 33098,
    "numero_dona": 2828,
    "sme_dona": 33100,
    "maxim": 33413,
    "percent_asalariat": 78.1,
    "percent_salari": 60.98,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 76,
    "numero_total": 6820,
    "sme_total": 33728,
    "numero_home": 3847,
    "sme_home": 33727,
    "numero_dona": 2973,
    "sme_dona": 33730,
    "maxim": 34056,
    "percent_asalariat": 79.1,
    "percent_salari": 62.23,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 77,
    "numero_total": 6737,
    "sme_total": 34394,
    "numero_home": 3792,
    "sme_home": 34394,
    "numero_dona": 2945,
    "sme_dona": 34394,
    "maxim": 34722,
    "percent_asalariat": 80.1,
    "percent_salari": 63.49,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 78,
    "numero_total": 6630,
    "sme_total": 35051,
    "numero_home": 3711,
    "sme_home": 35053,
    "numero_dona": 2919,
    "sme_dona": 35048,
    "maxim": 35374,
    "percent_asalariat": 81.1,
    "percent_salari": 64.76,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 79,
    "numero_total": 6842,
    "sme_total": 35711,
    "numero_home": 3699,
    "sme_home": 35708,
    "numero_dona": 3143,
    "sme_dona": 35715,
    "maxim": 36027,
    "percent_asalariat": 82.1,
    "percent_salari": 66.09,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 80,
    "numero_total": 6527,
    "sme_total": 36372,
    "numero_home": 3510,
    "sme_home": 36374,
    "numero_dona": 3017,
    "sme_dona": 36370,
    "maxim": 36730,
    "percent_asalariat": 83.1,
    "percent_salari": 67.38,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 81,
    "numero_total": 6294,
    "sme_total": 37109,
    "numero_home": 3414,
    "sme_home": 37108,
    "numero_dona": 2880,
    "sme_dona": 37110,
    "maxim": 37490,
    "percent_asalariat": 84.1,
    "percent_salari": 68.65,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 82,
    "numero_total": 6314,
    "sme_total": 37902,
    "numero_home": 3475,
    "sme_home": 37898,
    "numero_dona": 2839,
    "sme_dona": 37907,
    "maxim": 38304,
    "percent_asalariat": 85,
    "percent_salari": 69.95,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 83,
    "numero_total": 6447,
    "sme_total": 38757,
    "numero_home": 3640,
    "sme_home": 38762,
    "numero_dona": 2807,
    "sme_dona": 38750,
    "maxim": 39197,
    "percent_asalariat": 85.9,
    "percent_salari": 71.31,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 84,
    "numero_total": 6509,
    "sme_total": 39674,
    "numero_home": 3625,
    "sme_home": 39671,
    "numero_dona": 2884,
    "sme_dona": 39678,
    "maxim": 40137,
    "percent_asalariat": 86.9,
    "percent_salari": 72.72,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 85,
    "numero_total": 6787,
    "sme_total": 40637,
    "numero_home": 3861,
    "sme_home": 40637,
    "numero_dona": 2926,
    "sme_dona": 40636,
    "maxim": 41170,
    "percent_asalariat": 87.9,
    "percent_salari": 74.22,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 86,
    "numero_total": 6371,
    "sme_total": 41720,
    "numero_home": 3807,
    "sme_home": 41719,
    "numero_dona": 2564,
    "sme_dona": 41722,
    "maxim": 42306,
    "percent_asalariat": 88.9,
    "percent_salari": 75.66,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 87,
    "numero_total": 6371,
    "sme_total": 42907,
    "numero_home": 3744,
    "sme_home": 42910,
    "numero_dona": 2627,
    "sme_dona": 42902,
    "maxim": 43519,
    "percent_asalariat": 89.8,
    "percent_salari": 77.15,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 88,
    "numero_total": 6305,
    "sme_total": 44171,
    "numero_home": 3686,
    "sme_home": 44166,
    "numero_dona": 2619,
    "sme_dona": 44178,
    "maxim": 44857,
    "percent_asalariat": 90.7,
    "percent_salari": 78.67,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 89,
    "numero_total": 6456,
    "sme_total": 45568,
    "numero_home": 3926,
    "sme_home": 45571,
    "numero_dona": 2530,
    "sme_dona": 45565,
    "maxim": 46326,
    "percent_asalariat": 91.7,
    "percent_salari": 80.27,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 90,
    "numero_total": 6319,
    "sme_total": 47141,
    "numero_home": 3807,
    "sme_home": 47145,
    "numero_dona": 2512,
    "sme_dona": 47134,
    "maxim": 48005,
    "percent_asalariat": 92.6,
    "percent_salari": 81.89,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 91,
    "numero_total": 5995,
    "sme_total": 48933,
    "numero_home": 3603,
    "sme_home": 48929,
    "numero_dona": 2392,
    "sme_dona": 48940,
    "maxim": 49888,
    "percent_asalariat": 93.5,
    "percent_salari": 83.49,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 92,
    "numero_total": 5734,
    "sme_total": 50912,
    "numero_home": 3535,
    "sme_home": 50916,
    "numero_dona": 2199,
    "sme_dona": 50906,
    "maxim": 52064,
    "percent_asalariat": 94.4,
    "percent_salari": 85.08,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 93,
    "numero_total": 5463,
    "sme_total": 53348,
    "numero_home": 3389,
    "sme_home": 53351,
    "numero_dona": 2074,
    "sme_dona": 53344,
    "maxim": 54742,
    "percent_asalariat": 95.2,
    "percent_salari": 86.66,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 94,
    "numero_total": 5165,
    "sme_total": 56305,
    "numero_home": 3196,
    "sme_home": 56302,
    "numero_dona": 1969,
    "sme_dona": 56310,
    "maxim": 57976,
    "percent_asalariat": 96,
    "percent_salari": 88.24,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 95,
    "numero_total": 5085,
    "sme_total": 59907,
    "numero_home": 3048,
    "sme_home": 59903,
    "numero_dona": 2037,
    "sme_dona": 59914,
    "maxim": 61939,
    "percent_asalariat": 96.7,
    "percent_salari": 89.9,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 96,
    "numero_total": 5205,
    "sme_total": 64319,
    "numero_home": 3193,
    "sme_home": 64302,
    "numero_dona": 2012,
    "sme_dona": 64346,
    "maxim": 66966,
    "percent_asalariat": 97.5,
    "percent_salari": 91.72,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 97,
    "numero_total": 4753,
    "sme_total": 70179,
    "numero_home": 2906,
    "sme_home": 70151,
    "numero_dona": 1847,
    "sme_dona": 70223,
    "maxim": 73778,
    "percent_asalariat": 98.2,
    "percent_salari": 93.54,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 98,
    "numero_total": 4729,
    "sme_total": 78446,
    "numero_home": 2833,
    "sme_home": 78437,
    "numero_dona": 1896,
    "sme_dona": 78461,
    "maxim": 83931,
    "percent_asalariat": 98.9,
    "percent_salari": 95.56,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 99,
    "numero_total": 4736,
    "sme_total": 92129,
    "numero_home": 2922,
    "sme_home": 92421,
    "numero_dona": 1814,
    "sme_dona": 91659,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.93,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 100,
    "numero_total": 2687,
    "sme_total": 141267,
    "numero_home": 2059,
    "sme_home": 145449,
    "numero_dona": 628,
    "sme_dona": 127554,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "castella-lleo"
  },
  {
    "centil": 1,
    "numero_total": 18173,
    "sme_total": 14060,
    "numero_home": 7968,
    "sme_home": 14057,
    "numero_dona": 10205,
    "sme_dona": 14062,
    "maxim": 14139,
    "percent_asalariat": 0.7,
    "percent_salari": 0.3,
    "comunitat": "catalunya"
  },
  {
    "centil": 2,
    "numero_total": 19443,
    "sme_total": 14221,
    "numero_home": 8150,
    "sme_home": 14220,
    "numero_dona": 11293,
    "sme_dona": 14221,
    "maxim": 14300,
    "percent_asalariat": 1.4,
    "percent_salari": 0.63,
    "comunitat": "catalunya"
  },
  {
    "centil": 3,
    "numero_total": 19161,
    "sme_total": 14380,
    "numero_home": 8259,
    "sme_home": 14380,
    "numero_dona": 10902,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 2.1,
    "percent_salari": 0.95,
    "comunitat": "catalunya"
  },
  {
    "centil": 4,
    "numero_total": 19981,
    "sme_total": 14539,
    "numero_home": 8407,
    "sme_home": 14539,
    "numero_dona": 11574,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 2.9,
    "percent_salari": 1.3,
    "comunitat": "catalunya"
  },
  {
    "centil": 5,
    "numero_total": 19300,
    "sme_total": 14699,
    "numero_home": 8282,
    "sme_home": 14699,
    "numero_dona": 11018,
    "sme_dona": 14699,
    "maxim": 14776,
    "percent_asalariat": 3.6,
    "percent_salari": 1.63,
    "comunitat": "catalunya"
  },
  {
    "centil": 6,
    "numero_total": 20479,
    "sme_total": 14853,
    "numero_home": 8988,
    "sme_home": 14854,
    "numero_dona": 11491,
    "sme_dona": 14852,
    "maxim": 14934,
    "percent_asalariat": 4.4,
    "percent_salari": 1.99,
    "comunitat": "catalunya"
  },
  {
    "centil": 7,
    "numero_total": 20310,
    "sme_total": 15013,
    "numero_home": 8773,
    "sme_home": 15013,
    "numero_dona": 11537,
    "sme_dona": 15012,
    "maxim": 15091,
    "percent_asalariat": 5.1,
    "percent_salari": 2.35,
    "comunitat": "catalunya"
  },
  {
    "centil": 8,
    "numero_total": 20036,
    "sme_total": 15168,
    "numero_home": 8994,
    "sme_home": 15167,
    "numero_dona": 11042,
    "sme_dona": 15169,
    "maxim": 15248,
    "percent_asalariat": 5.9,
    "percent_salari": 2.71,
    "comunitat": "catalunya"
  },
  {
    "centil": 9,
    "numero_total": 20362,
    "sme_total": 15330,
    "numero_home": 8747,
    "sme_home": 15331,
    "numero_dona": 11615,
    "sme_dona": 15330,
    "maxim": 15407,
    "percent_asalariat": 6.6,
    "percent_salari": 3.08,
    "comunitat": "catalunya"
  },
  {
    "centil": 10,
    "numero_total": 20178,
    "sme_total": 15487,
    "numero_home": 8727,
    "sme_home": 15486,
    "numero_dona": 11451,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 7.4,
    "percent_salari": 3.45,
    "comunitat": "catalunya"
  },
  {
    "centil": 11,
    "numero_total": 19425,
    "sme_total": 15647,
    "numero_home": 8442,
    "sme_home": 15647,
    "numero_dona": 10983,
    "sme_dona": 15647,
    "maxim": 15726,
    "percent_asalariat": 8.1,
    "percent_salari": 3.81,
    "comunitat": "catalunya"
  },
  {
    "centil": 12,
    "numero_total": 19438,
    "sme_total": 15805,
    "numero_home": 8407,
    "sme_home": 15805,
    "numero_dona": 11031,
    "sme_dona": 15805,
    "maxim": 15885,
    "percent_asalariat": 8.8,
    "percent_salari": 4.17,
    "comunitat": "catalunya"
  },
  {
    "centil": 13,
    "numero_total": 20014,
    "sme_total": 15966,
    "numero_home": 8611,
    "sme_home": 15966,
    "numero_dona": 11403,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 9.6,
    "percent_salari": 4.55,
    "comunitat": "catalunya"
  },
  {
    "centil": 14,
    "numero_total": 19486,
    "sme_total": 16127,
    "numero_home": 8507,
    "sme_home": 16128,
    "numero_dona": 10979,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 10.3,
    "percent_salari": 4.92,
    "comunitat": "catalunya"
  },
  {
    "centil": 15,
    "numero_total": 20177,
    "sme_total": 16289,
    "numero_home": 8836,
    "sme_home": 16289,
    "numero_dona": 11341,
    "sme_dona": 16289,
    "maxim": 16371,
    "percent_asalariat": 11.1,
    "percent_salari": 5.31,
    "comunitat": "catalunya"
  },
  {
    "centil": 16,
    "numero_total": 20190,
    "sme_total": 16453,
    "numero_home": 8749,
    "sme_home": 16454,
    "numero_dona": 11441,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 11.8,
    "percent_salari": 5.7,
    "comunitat": "catalunya"
  },
  {
    "centil": 17,
    "numero_total": 20443,
    "sme_total": 16609,
    "numero_home": 8999,
    "sme_home": 16609,
    "numero_dona": 11444,
    "sme_dona": 16609,
    "maxim": 16692,
    "percent_asalariat": 12.6,
    "percent_salari": 6.11,
    "comunitat": "catalunya"
  },
  {
    "centil": 18,
    "numero_total": 20591,
    "sme_total": 16773,
    "numero_home": 9164,
    "sme_home": 16773,
    "numero_dona": 11427,
    "sme_dona": 16773,
    "maxim": 16855,
    "percent_asalariat": 13.3,
    "percent_salari": 6.51,
    "comunitat": "catalunya"
  },
  {
    "centil": 19,
    "numero_total": 20264,
    "sme_total": 16939,
    "numero_home": 9040,
    "sme_home": 16940,
    "numero_dona": 11224,
    "sme_dona": 16939,
    "maxim": 17023,
    "percent_asalariat": 14.1,
    "percent_salari": 6.92,
    "comunitat": "catalunya"
  },
  {
    "centil": 20,
    "numero_total": 20816,
    "sme_total": 17110,
    "numero_home": 9530,
    "sme_home": 17110,
    "numero_dona": 11286,
    "sme_dona": 17110,
    "maxim": 17196,
    "percent_asalariat": 14.9,
    "percent_salari": 7.34,
    "comunitat": "catalunya"
  },
  {
    "centil": 21,
    "numero_total": 21351,
    "sme_total": 17281,
    "numero_home": 10024,
    "sme_home": 17281,
    "numero_dona": 11327,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 15.7,
    "percent_salari": 7.78,
    "comunitat": "catalunya"
  },
  {
    "centil": 22,
    "numero_total": 22021,
    "sme_total": 17457,
    "numero_home": 10138,
    "sme_home": 17456,
    "numero_dona": 11883,
    "sme_dona": 17457,
    "maxim": 17543,
    "percent_asalariat": 16.5,
    "percent_salari": 8.23,
    "comunitat": "catalunya"
  },
  {
    "centil": 23,
    "numero_total": 21607,
    "sme_total": 17632,
    "numero_home": 10140,
    "sme_home": 17632,
    "numero_dona": 11467,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 17.3,
    "percent_salari": 8.68,
    "comunitat": "catalunya"
  },
  {
    "centil": 24,
    "numero_total": 21329,
    "sme_total": 17804,
    "numero_home": 10069,
    "sme_home": 17804,
    "numero_dona": 11260,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 18.1,
    "percent_salari": 9.13,
    "comunitat": "catalunya"
  },
  {
    "centil": 25,
    "numero_total": 21285,
    "sme_total": 17976,
    "numero_home": 10094,
    "sme_home": 17976,
    "numero_dona": 11191,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 18.9,
    "percent_salari": 9.58,
    "comunitat": "catalunya"
  },
  {
    "centil": 26,
    "numero_total": 21164,
    "sme_total": 18149,
    "numero_home": 10212,
    "sme_home": 18150,
    "numero_dona": 10952,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 19.7,
    "percent_salari": 10.04,
    "comunitat": "catalunya"
  },
  {
    "centil": 27,
    "numero_total": 21200,
    "sme_total": 18327,
    "numero_home": 10364,
    "sme_home": 18327,
    "numero_dona": 10836,
    "sme_dona": 18328,
    "maxim": 18417,
    "percent_asalariat": 20.5,
    "percent_salari": 10.5,
    "comunitat": "catalunya"
  },
  {
    "centil": 28,
    "numero_total": 21508,
    "sme_total": 18506,
    "numero_home": 10874,
    "sme_home": 18507,
    "numero_dona": 10634,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 21.3,
    "percent_salari": 10.97,
    "comunitat": "catalunya"
  },
  {
    "centil": 29,
    "numero_total": 22619,
    "sme_total": 18686,
    "numero_home": 11325,
    "sme_home": 18685,
    "numero_dona": 11294,
    "sme_dona": 18686,
    "maxim": 18778,
    "percent_asalariat": 22.1,
    "percent_salari": 11.47,
    "comunitat": "catalunya"
  },
  {
    "centil": 30,
    "numero_total": 22418,
    "sme_total": 18867,
    "numero_home": 11647,
    "sme_home": 18867,
    "numero_dona": 10771,
    "sme_dona": 18866,
    "maxim": 18953,
    "percent_asalariat": 23,
    "percent_salari": 11.97,
    "comunitat": "catalunya"
  },
  {
    "centil": 31,
    "numero_total": 22920,
    "sme_total": 19042,
    "numero_home": 11616,
    "sme_home": 19042,
    "numero_dona": 11304,
    "sme_dona": 19042,
    "maxim": 19133,
    "percent_asalariat": 23.8,
    "percent_salari": 12.48,
    "comunitat": "catalunya"
  },
  {
    "centil": 32,
    "numero_total": 22988,
    "sme_total": 19224,
    "numero_home": 11957,
    "sme_home": 19224,
    "numero_dona": 11031,
    "sme_dona": 19224,
    "maxim": 19317,
    "percent_asalariat": 24.7,
    "percent_salari": 13,
    "comunitat": "catalunya"
  },
  {
    "centil": 33,
    "numero_total": 23325,
    "sme_total": 19411,
    "numero_home": 12145,
    "sme_home": 19412,
    "numero_dona": 11180,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 25.6,
    "percent_salari": 13.54,
    "comunitat": "catalunya"
  },
  {
    "centil": 34,
    "numero_total": 23242,
    "sme_total": 19598,
    "numero_home": 12217,
    "sme_home": 19598,
    "numero_dona": 11025,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 26.4,
    "percent_salari": 14.08,
    "comunitat": "catalunya"
  },
  {
    "centil": 35,
    "numero_total": 23327,
    "sme_total": 19785,
    "numero_home": 12591,
    "sme_home": 19785,
    "numero_dona": 10736,
    "sme_dona": 19784,
    "maxim": 19879,
    "percent_asalariat": 27.3,
    "percent_salari": 14.62,
    "comunitat": "catalunya"
  },
  {
    "centil": 36,
    "numero_total": 22990,
    "sme_total": 19975,
    "numero_home": 12218,
    "sme_home": 19975,
    "numero_dona": 10772,
    "sme_dona": 19975,
    "maxim": 20069,
    "percent_asalariat": 28.2,
    "percent_salari": 15.17,
    "comunitat": "catalunya"
  },
  {
    "centil": 37,
    "numero_total": 23028,
    "sme_total": 20167,
    "numero_home": 12438,
    "sme_home": 20167,
    "numero_dona": 10590,
    "sme_dona": 20167,
    "maxim": 20263,
    "percent_asalariat": 29,
    "percent_salari": 15.72,
    "comunitat": "catalunya"
  },
  {
    "centil": 38,
    "numero_total": 21861,
    "sme_total": 20361,
    "numero_home": 11638,
    "sme_home": 20361,
    "numero_dona": 10223,
    "sme_dona": 20361,
    "maxim": 20459,
    "percent_asalariat": 29.8,
    "percent_salari": 16.24,
    "comunitat": "catalunya"
  },
  {
    "centil": 39,
    "numero_total": 23073,
    "sme_total": 20556,
    "numero_home": 12628,
    "sme_home": 20557,
    "numero_dona": 10445,
    "sme_dona": 20556,
    "maxim": 20653,
    "percent_asalariat": 30.7,
    "percent_salari": 16.8,
    "comunitat": "catalunya"
  },
  {
    "centil": 40,
    "numero_total": 22597,
    "sme_total": 20753,
    "numero_home": 12192,
    "sme_home": 20754,
    "numero_dona": 10405,
    "sme_dona": 20752,
    "maxim": 20854,
    "percent_asalariat": 31.5,
    "percent_salari": 17.36,
    "comunitat": "catalunya"
  },
  {
    "centil": 41,
    "numero_total": 22938,
    "sme_total": 20956,
    "numero_home": 12267,
    "sme_home": 20955,
    "numero_dona": 10671,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 32.4,
    "percent_salari": 17.93,
    "comunitat": "catalunya"
  },
  {
    "centil": 42,
    "numero_total": 22842,
    "sme_total": 21161,
    "numero_home": 12456,
    "sme_home": 21161,
    "numero_dona": 10386,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 33.3,
    "percent_salari": 18.5,
    "comunitat": "catalunya"
  },
  {
    "centil": 43,
    "numero_total": 23523,
    "sme_total": 21375,
    "numero_home": 12829,
    "sme_home": 21374,
    "numero_dona": 10694,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 34.1,
    "percent_salari": 19.09,
    "comunitat": "catalunya"
  },
  {
    "centil": 44,
    "numero_total": 23737,
    "sme_total": 21592,
    "numero_home": 12918,
    "sme_home": 21592,
    "numero_dona": 10819,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 35,
    "percent_salari": 19.7,
    "comunitat": "catalunya"
  },
  {
    "centil": 45,
    "numero_total": 24135,
    "sme_total": 21814,
    "numero_home": 13333,
    "sme_home": 21813,
    "numero_dona": 10802,
    "sme_dona": 21814,
    "maxim": 21927,
    "percent_asalariat": 35.9,
    "percent_salari": 20.32,
    "comunitat": "catalunya"
  },
  {
    "centil": 46,
    "numero_total": 24857,
    "sme_total": 22038,
    "numero_home": 14076,
    "sme_home": 22038,
    "numero_dona": 10781,
    "sme_dona": 22037,
    "maxim": 22151,
    "percent_asalariat": 36.9,
    "percent_salari": 20.97,
    "comunitat": "catalunya"
  },
  {
    "centil": 47,
    "numero_total": 25362,
    "sme_total": 22265,
    "numero_home": 14404,
    "sme_home": 22266,
    "numero_dona": 10958,
    "sme_dona": 22263,
    "maxim": 22380,
    "percent_asalariat": 37.8,
    "percent_salari": 21.63,
    "comunitat": "catalunya"
  },
  {
    "centil": 48,
    "numero_total": 26619,
    "sme_total": 22497,
    "numero_home": 15161,
    "sme_home": 22497,
    "numero_dona": 11458,
    "sme_dona": 22498,
    "maxim": 22616,
    "percent_asalariat": 38.8,
    "percent_salari": 22.34,
    "comunitat": "catalunya"
  },
  {
    "centil": 49,
    "numero_total": 26503,
    "sme_total": 22741,
    "numero_home": 15217,
    "sme_home": 22741,
    "numero_dona": 11286,
    "sme_dona": 22740,
    "maxim": 22865,
    "percent_asalariat": 39.8,
    "percent_salari": 23.05,
    "comunitat": "catalunya"
  },
  {
    "centil": 50,
    "numero_total": 27535,
    "sme_total": 22992,
    "numero_home": 16334,
    "sme_home": 22992,
    "numero_dona": 11201,
    "sme_dona": 22991,
    "maxim": 23114,
    "percent_asalariat": 40.8,
    "percent_salari": 23.8,
    "comunitat": "catalunya"
  },
  {
    "centil": 51,
    "numero_total": 28881,
    "sme_total": 23246,
    "numero_home": 17272,
    "sme_home": 23246,
    "numero_dona": 11609,
    "sme_dona": 23245,
    "maxim": 23377,
    "percent_asalariat": 41.9,
    "percent_salari": 24.6,
    "comunitat": "catalunya"
  },
  {
    "centil": 52,
    "numero_total": 29311,
    "sme_total": 23511,
    "numero_home": 17396,
    "sme_home": 23510,
    "numero_dona": 11915,
    "sme_dona": 23512,
    "maxim": 23645,
    "percent_asalariat": 43,
    "percent_salari": 25.41,
    "comunitat": "catalunya"
  },
  {
    "centil": 53,
    "numero_total": 30158,
    "sme_total": 23786,
    "numero_home": 18079,
    "sme_home": 23788,
    "numero_dona": 12079,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 44.1,
    "percent_salari": 26.26,
    "comunitat": "catalunya"
  },
  {
    "centil": 54,
    "numero_total": 30809,
    "sme_total": 24052,
    "numero_home": 18424,
    "sme_home": 24051,
    "numero_dona": 12385,
    "sme_dona": 24054,
    "maxim": 24198,
    "percent_asalariat": 45.3,
    "percent_salari": 27.14,
    "comunitat": "catalunya"
  },
  {
    "centil": 55,
    "numero_total": 29956,
    "sme_total": 24348,
    "numero_home": 17570,
    "sme_home": 24347,
    "numero_dona": 12386,
    "sme_dona": 24349,
    "maxim": 24501,
    "percent_asalariat": 46.4,
    "percent_salari": 28,
    "comunitat": "catalunya"
  },
  {
    "centil": 56,
    "numero_total": 30256,
    "sme_total": 24655,
    "numero_home": 17428,
    "sme_home": 24655,
    "numero_dona": 12828,
    "sme_dona": 24656,
    "maxim": 24811,
    "percent_asalariat": 47.5,
    "percent_salari": 28.88,
    "comunitat": "catalunya"
  },
  {
    "centil": 57,
    "numero_total": 29922,
    "sme_total": 24967,
    "numero_home": 17421,
    "sme_home": 24966,
    "numero_dona": 12501,
    "sme_dona": 24969,
    "maxim": 25122,
    "percent_asalariat": 48.6,
    "percent_salari": 29.76,
    "comunitat": "catalunya"
  },
  {
    "centil": 58,
    "numero_total": 29998,
    "sme_total": 25285,
    "numero_home": 17106,
    "sme_home": 25285,
    "numero_dona": 12892,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 49.8,
    "percent_salari": 30.66,
    "comunitat": "catalunya"
  },
  {
    "centil": 59,
    "numero_total": 30542,
    "sme_total": 25620,
    "numero_home": 17675,
    "sme_home": 25620,
    "numero_dona": 12867,
    "sme_dona": 25619,
    "maxim": 25792,
    "percent_asalariat": 50.9,
    "percent_salari": 31.58,
    "comunitat": "catalunya"
  },
  {
    "centil": 60,
    "numero_total": 30982,
    "sme_total": 25965,
    "numero_home": 18263,
    "sme_home": 25965,
    "numero_dona": 12719,
    "sme_dona": 25964,
    "maxim": 26139,
    "percent_asalariat": 52.1,
    "percent_salari": 32.54,
    "comunitat": "catalunya"
  },
  {
    "centil": 61,
    "numero_total": 31279,
    "sme_total": 26326,
    "numero_home": 18250,
    "sme_home": 26325,
    "numero_dona": 13029,
    "sme_dona": 26326,
    "maxim": 26509,
    "percent_asalariat": 53.2,
    "percent_salari": 33.51,
    "comunitat": "catalunya"
  },
  {
    "centil": 62,
    "numero_total": 30838,
    "sme_total": 26693,
    "numero_home": 17881,
    "sme_home": 26692,
    "numero_dona": 12957,
    "sme_dona": 26696,
    "maxim": 26874,
    "percent_asalariat": 54.4,
    "percent_salari": 34.48,
    "comunitat": "catalunya"
  },
  {
    "centil": 63,
    "numero_total": 30541,
    "sme_total": 27046,
    "numero_home": 16916,
    "sme_home": 27046,
    "numero_dona": 13625,
    "sme_dona": 27045,
    "maxim": 27221,
    "percent_asalariat": 55.5,
    "percent_salari": 35.46,
    "comunitat": "catalunya"
  },
  {
    "centil": 64,
    "numero_total": 32389,
    "sme_total": 27416,
    "numero_home": 18473,
    "sme_home": 27417,
    "numero_dona": 13916,
    "sme_dona": 27414,
    "maxim": 27616,
    "percent_asalariat": 56.7,
    "percent_salari": 36.51,
    "comunitat": "catalunya"
  },
  {
    "centil": 65,
    "numero_total": 32419,
    "sme_total": 27823,
    "numero_home": 19097,
    "sme_home": 27823,
    "numero_dona": 13322,
    "sme_dona": 27824,
    "maxim": 28031,
    "percent_asalariat": 57.9,
    "percent_salari": 37.57,
    "comunitat": "catalunya"
  },
  {
    "centil": 66,
    "numero_total": 31966,
    "sme_total": 28249,
    "numero_home": 18870,
    "sme_home": 28248,
    "numero_dona": 13096,
    "sme_dona": 28250,
    "maxim": 28476,
    "percent_asalariat": 59.1,
    "percent_salari": 38.64,
    "comunitat": "catalunya"
  },
  {
    "centil": 67,
    "numero_total": 32078,
    "sme_total": 28711,
    "numero_home": 18715,
    "sme_home": 28712,
    "numero_dona": 13363,
    "sme_dona": 28710,
    "maxim": 28951,
    "percent_asalariat": 60.3,
    "percent_salari": 39.73,
    "comunitat": "catalunya"
  },
  {
    "centil": 68,
    "numero_total": 31996,
    "sme_total": 29198,
    "numero_home": 18804,
    "sme_home": 29198,
    "numero_dona": 13192,
    "sme_dona": 29198,
    "maxim": 29450,
    "percent_asalariat": 61.5,
    "percent_salari": 40.83,
    "comunitat": "catalunya"
  },
  {
    "centil": 69,
    "numero_total": 32452,
    "sme_total": 29707,
    "numero_home": 19060,
    "sme_home": 29707,
    "numero_dona": 13392,
    "sme_dona": 29708,
    "maxim": 29970,
    "percent_asalariat": 62.7,
    "percent_salari": 41.97,
    "comunitat": "catalunya"
  },
  {
    "centil": 70,
    "numero_total": 31890,
    "sme_total": 30216,
    "numero_home": 18629,
    "sme_home": 30217,
    "numero_dona": 13261,
    "sme_dona": 30215,
    "maxim": 30487,
    "percent_asalariat": 63.9,
    "percent_salari": 43.11,
    "comunitat": "catalunya"
  },
  {
    "centil": 71,
    "numero_total": 31694,
    "sme_total": 30763,
    "numero_home": 18393,
    "sme_home": 30763,
    "numero_dona": 13301,
    "sme_dona": 30763,
    "maxim": 31037,
    "percent_asalariat": 65.1,
    "percent_salari": 44.27,
    "comunitat": "catalunya"
  },
  {
    "centil": 72,
    "numero_total": 31318,
    "sme_total": 31320,
    "numero_home": 18216,
    "sme_home": 31321,
    "numero_dona": 13102,
    "sme_dona": 31320,
    "maxim": 31602,
    "percent_asalariat": 66.3,
    "percent_salari": 45.43,
    "comunitat": "catalunya"
  },
  {
    "centil": 73,
    "numero_total": 31409,
    "sme_total": 31891,
    "numero_home": 17698,
    "sme_home": 31889,
    "numero_dona": 13711,
    "sme_dona": 31895,
    "maxim": 32176,
    "percent_asalariat": 67.5,
    "percent_salari": 46.61,
    "comunitat": "catalunya"
  },
  {
    "centil": 74,
    "numero_total": 33289,
    "sme_total": 32477,
    "numero_home": 18027,
    "sme_home": 32475,
    "numero_dona": 15262,
    "sme_dona": 32480,
    "maxim": 32786,
    "percent_asalariat": 68.7,
    "percent_salari": 47.89,
    "comunitat": "catalunya"
  },
  {
    "centil": 75,
    "numero_total": 32332,
    "sme_total": 33093,
    "numero_home": 17687,
    "sme_home": 33095,
    "numero_dona": 14645,
    "sme_dona": 33092,
    "maxim": 33413,
    "percent_asalariat": 69.9,
    "percent_salari": 49.15,
    "comunitat": "catalunya"
  },
  {
    "centil": 76,
    "numero_total": 30192,
    "sme_total": 33735,
    "numero_home": 16993,
    "sme_home": 33735,
    "numero_dona": 13199,
    "sme_dona": 33735,
    "maxim": 34056,
    "percent_asalariat": 71,
    "percent_salari": 50.36,
    "comunitat": "catalunya"
  },
  {
    "centil": 77,
    "numero_total": 29921,
    "sme_total": 34385,
    "numero_home": 16850,
    "sme_home": 34387,
    "numero_dona": 13071,
    "sme_dona": 34383,
    "maxim": 34722,
    "percent_asalariat": 72.2,
    "percent_salari": 51.57,
    "comunitat": "catalunya"
  },
  {
    "centil": 78,
    "numero_total": 29810,
    "sme_total": 35048,
    "numero_home": 16362,
    "sme_home": 35047,
    "numero_dona": 13448,
    "sme_dona": 35050,
    "maxim": 35374,
    "percent_asalariat": 73.3,
    "percent_salari": 52.81,
    "comunitat": "catalunya"
  },
  {
    "centil": 79,
    "numero_total": 29944,
    "sme_total": 35705,
    "numero_home": 16053,
    "sme_home": 35704,
    "numero_dona": 13891,
    "sme_dona": 35705,
    "maxim": 36027,
    "percent_asalariat": 74.4,
    "percent_salari": 54.07,
    "comunitat": "catalunya"
  },
  {
    "centil": 80,
    "numero_total": 30721,
    "sme_total": 36376,
    "numero_home": 16516,
    "sme_home": 36373,
    "numero_dona": 14205,
    "sme_dona": 36379,
    "maxim": 36730,
    "percent_asalariat": 75.5,
    "percent_salari": 55.39,
    "comunitat": "catalunya"
  },
  {
    "centil": 81,
    "numero_total": 31340,
    "sme_total": 37098,
    "numero_home": 16996,
    "sme_home": 37101,
    "numero_dona": 14344,
    "sme_dona": 37095,
    "maxim": 37490,
    "percent_asalariat": 76.7,
    "percent_salari": 56.77,
    "comunitat": "catalunya"
  },
  {
    "centil": 82,
    "numero_total": 30296,
    "sme_total": 37890,
    "numero_home": 16534,
    "sme_home": 37889,
    "numero_dona": 13762,
    "sme_dona": 37892,
    "maxim": 38304,
    "percent_asalariat": 77.9,
    "percent_salari": 58.12,
    "comunitat": "catalunya"
  },
  {
    "centil": 83,
    "numero_total": 30319,
    "sme_total": 38744,
    "numero_home": 17171,
    "sme_home": 38746,
    "numero_dona": 13148,
    "sme_dona": 38742,
    "maxim": 39197,
    "percent_asalariat": 79,
    "percent_salari": 59.51,
    "comunitat": "catalunya"
  },
  {
    "centil": 84,
    "numero_total": 31620,
    "sme_total": 39673,
    "numero_home": 17618,
    "sme_home": 39670,
    "numero_dona": 14002,
    "sme_dona": 39676,
    "maxim": 40137,
    "percent_asalariat": 80.2,
    "percent_salari": 61,
    "comunitat": "catalunya"
  },
  {
    "centil": 85,
    "numero_total": 32360,
    "sme_total": 40650,
    "numero_home": 17927,
    "sme_home": 40651,
    "numero_dona": 14433,
    "sme_dona": 40648,
    "maxim": 41170,
    "percent_asalariat": 81.4,
    "percent_salari": 62.55,
    "comunitat": "catalunya"
  },
  {
    "centil": 86,
    "numero_total": 33862,
    "sme_total": 41736,
    "numero_home": 19332,
    "sme_home": 41738,
    "numero_dona": 14530,
    "sme_dona": 41733,
    "maxim": 42306,
    "percent_asalariat": 82.6,
    "percent_salari": 64.22,
    "comunitat": "catalunya"
  },
  {
    "centil": 87,
    "numero_total": 34531,
    "sme_total": 42898,
    "numero_home": 20153,
    "sme_home": 42904,
    "numero_dona": 14378,
    "sme_dona": 42890,
    "maxim": 43519,
    "percent_asalariat": 83.9,
    "percent_salari": 65.97,
    "comunitat": "catalunya"
  },
  {
    "centil": 88,
    "numero_total": 35009,
    "sme_total": 44181,
    "numero_home": 20446,
    "sme_home": 44179,
    "numero_dona": 14563,
    "sme_dona": 44183,
    "maxim": 44857,
    "percent_asalariat": 85.2,
    "percent_salari": 67.8,
    "comunitat": "catalunya"
  },
  {
    "centil": 89,
    "numero_total": 34003,
    "sme_total": 45566,
    "numero_home": 20177,
    "sme_home": 45570,
    "numero_dona": 13826,
    "sme_dona": 45561,
    "maxim": 46326,
    "percent_asalariat": 86.5,
    "percent_salari": 69.63,
    "comunitat": "catalunya"
  },
  {
    "centil": 90,
    "numero_total": 33696,
    "sme_total": 47152,
    "numero_home": 20356,
    "sme_home": 47152,
    "numero_dona": 13340,
    "sme_dona": 47151,
    "maxim": 48005,
    "percent_asalariat": 87.8,
    "percent_salari": 71.51,
    "comunitat": "catalunya"
  },
  {
    "centil": 91,
    "numero_total": 33747,
    "sme_total": 48927,
    "numero_home": 20465,
    "sme_home": 48936,
    "numero_dona": 13282,
    "sme_dona": 48914,
    "maxim": 49888,
    "percent_asalariat": 89,
    "percent_salari": 73.46,
    "comunitat": "catalunya"
  },
  {
    "centil": 92,
    "numero_total": 33480,
    "sme_total": 50928,
    "numero_home": 20651,
    "sme_home": 50927,
    "numero_dona": 12829,
    "sme_dona": 50929,
    "maxim": 52064,
    "percent_asalariat": 90.3,
    "percent_salari": 75.48,
    "comunitat": "catalunya"
  },
  {
    "centil": 93,
    "numero_total": 32811,
    "sme_total": 53356,
    "numero_home": 20344,
    "sme_home": 53356,
    "numero_dona": 12467,
    "sme_dona": 53355,
    "maxim": 54742,
    "percent_asalariat": 91.5,
    "percent_salari": 77.55,
    "comunitat": "catalunya"
  },
  {
    "centil": 94,
    "numero_total": 32604,
    "sme_total": 56279,
    "numero_home": 20749,
    "sme_home": 56273,
    "numero_dona": 11855,
    "sme_dona": 56289,
    "maxim": 57976,
    "percent_asalariat": 92.7,
    "percent_salari": 79.72,
    "comunitat": "catalunya"
  },
  {
    "centil": 95,
    "numero_total": 31974,
    "sme_total": 59888,
    "numero_home": 20118,
    "sme_home": 59887,
    "numero_dona": 11856,
    "sme_dona": 59891,
    "maxim": 61939,
    "percent_asalariat": 93.9,
    "percent_salari": 81.98,
    "comunitat": "catalunya"
  },
  {
    "centil": 96,
    "numero_total": 31408,
    "sme_total": 64349,
    "numero_home": 19436,
    "sme_home": 64335,
    "numero_dona": 11972,
    "sme_dona": 64372,
    "maxim": 66966,
    "percent_asalariat": 95.1,
    "percent_salari": 84.37,
    "comunitat": "catalunya"
  },
  {
    "centil": 97,
    "numero_total": 31940,
    "sme_total": 70208,
    "numero_home": 19760,
    "sme_home": 70197,
    "numero_dona": 12180,
    "sme_dona": 70227,
    "maxim": 73778,
    "percent_asalariat": 96.3,
    "percent_salari": 87.02,
    "comunitat": "catalunya"
  },
  {
    "centil": 98,
    "numero_total": 32035,
    "sme_total": 78430,
    "numero_home": 20067,
    "sme_home": 78468,
    "numero_dona": 11968,
    "sme_dona": 78367,
    "maxim": 83931,
    "percent_asalariat": 97.5,
    "percent_salari": 89.99,
    "comunitat": "catalunya"
  },
  {
    "centil": 99,
    "numero_total": 32887,
    "sme_total": 92485,
    "numero_home": 21752,
    "sme_home": 92599,
    "numero_dona": 11135,
    "sme_dona": 92262,
    "maxim": 104199,
    "percent_asalariat": 98.7,
    "percent_salari": 93.59,
    "comunitat": "catalunya"
  },
  {
    "centil": 100,
    "numero_total": 34363,
    "sme_total": 157889,
    "numero_home": 25675,
    "sme_home": 161412,
    "numero_dona": 8688,
    "sme_dona": 147477,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "catalunya"
  },
  {
    "centil": 1,
    "numero_total": 4208,
    "sme_total": 14058,
    "numero_home": 2210,
    "sme_home": 14059,
    "numero_dona": 1998,
    "sme_dona": 14057,
    "maxim": 14139,
    "percent_asalariat": 1.5,
    "percent_salari": 0.88,
    "comunitat": "extremadura"
  },
  {
    "centil": 2,
    "numero_total": 4484,
    "sme_total": 14216,
    "numero_home": 2311,
    "sme_home": 14216,
    "numero_dona": 2173,
    "sme_dona": 14217,
    "maxim": 14300,
    "percent_asalariat": 3.2,
    "percent_salari": 1.82,
    "comunitat": "extremadura"
  },
  {
    "centil": 3,
    "numero_total": 4225,
    "sme_total": 14378,
    "numero_home": 2255,
    "sme_home": 14378,
    "numero_dona": 1970,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 4.7,
    "percent_salari": 2.73,
    "comunitat": "extremadura"
  },
  {
    "centil": 4,
    "numero_total": 4093,
    "sme_total": 14538,
    "numero_home": 2151,
    "sme_home": 14537,
    "numero_dona": 1942,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 6.2,
    "percent_salari": 3.61,
    "comunitat": "extremadura"
  },
  {
    "centil": 5,
    "numero_total": 4172,
    "sme_total": 14698,
    "numero_home": 2160,
    "sme_home": 14699,
    "numero_dona": 2012,
    "sme_dona": 14696,
    "maxim": 14776,
    "percent_asalariat": 7.7,
    "percent_salari": 4.52,
    "comunitat": "extremadura"
  },
  {
    "centil": 6,
    "numero_total": 4179,
    "sme_total": 14856,
    "numero_home": 2167,
    "sme_home": 14856,
    "numero_dona": 2012,
    "sme_dona": 14855,
    "maxim": 14934,
    "percent_asalariat": 9.3,
    "percent_salari": 5.44,
    "comunitat": "extremadura"
  },
  {
    "centil": 7,
    "numero_total": 4393,
    "sme_total": 15013,
    "numero_home": 2443,
    "sme_home": 15013,
    "numero_dona": 1950,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 10.9,
    "percent_salari": 6.42,
    "comunitat": "extremadura"
  },
  {
    "centil": 8,
    "numero_total": 4009,
    "sme_total": 15168,
    "numero_home": 2179,
    "sme_home": 15168,
    "numero_dona": 1830,
    "sme_dona": 15168,
    "maxim": 15248,
    "percent_asalariat": 12.3,
    "percent_salari": 7.32,
    "comunitat": "extremadura"
  },
  {
    "centil": 9,
    "numero_total": 3960,
    "sme_total": 15328,
    "numero_home": 2159,
    "sme_home": 15330,
    "numero_dona": 1801,
    "sme_dona": 15326,
    "maxim": 15407,
    "percent_asalariat": 13.8,
    "percent_salari": 8.22,
    "comunitat": "extremadura"
  },
  {
    "centil": 10,
    "numero_total": 4025,
    "sme_total": 15485,
    "numero_home": 2291,
    "sme_home": 15485,
    "numero_dona": 1734,
    "sme_dona": 15486,
    "maxim": 15567,
    "percent_asalariat": 15.3,
    "percent_salari": 9.15,
    "comunitat": "extremadura"
  },
  {
    "centil": 11,
    "numero_total": 4366,
    "sme_total": 15646,
    "numero_home": 2429,
    "sme_home": 15643,
    "numero_dona": 1937,
    "sme_dona": 15649,
    "maxim": 15726,
    "percent_asalariat": 16.9,
    "percent_salari": 10.16,
    "comunitat": "extremadura"
  },
  {
    "centil": 12,
    "numero_total": 4084,
    "sme_total": 15802,
    "numero_home": 2243,
    "sme_home": 15802,
    "numero_dona": 1841,
    "sme_dona": 15803,
    "maxim": 15885,
    "percent_asalariat": 18.3,
    "percent_salari": 11.12,
    "comunitat": "extremadura"
  },
  {
    "centil": 13,
    "numero_total": 3797,
    "sme_total": 15966,
    "numero_home": 2124,
    "sme_home": 15966,
    "numero_dona": 1673,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 19.7,
    "percent_salari": 12.02,
    "comunitat": "extremadura"
  },
  {
    "centil": 14,
    "numero_total": 3685,
    "sme_total": 16126,
    "numero_home": 2039,
    "sme_home": 16127,
    "numero_dona": 1646,
    "sme_dona": 16125,
    "maxim": 16207,
    "percent_asalariat": 21.1,
    "percent_salari": 12.9,
    "comunitat": "extremadura"
  },
  {
    "centil": 15,
    "numero_total": 3838,
    "sme_total": 16289,
    "numero_home": 2115,
    "sme_home": 16290,
    "numero_dona": 1723,
    "sme_dona": 16287,
    "maxim": 16371,
    "percent_asalariat": 22.5,
    "percent_salari": 13.83,
    "comunitat": "extremadura"
  },
  {
    "centil": 16,
    "numero_total": 3343,
    "sme_total": 16453,
    "numero_home": 1895,
    "sme_home": 16454,
    "numero_dona": 1448,
    "sme_dona": 16451,
    "maxim": 16533,
    "percent_asalariat": 23.7,
    "percent_salari": 14.64,
    "comunitat": "extremadura"
  },
  {
    "centil": 17,
    "numero_total": 3310,
    "sme_total": 16611,
    "numero_home": 1882,
    "sme_home": 16611,
    "numero_dona": 1428,
    "sme_dona": 16611,
    "maxim": 16692,
    "percent_asalariat": 24.9,
    "percent_salari": 15.46,
    "comunitat": "extremadura"
  },
  {
    "centil": 18,
    "numero_total": 3434,
    "sme_total": 16774,
    "numero_home": 1920,
    "sme_home": 16773,
    "numero_dona": 1514,
    "sme_dona": 16775,
    "maxim": 16855,
    "percent_asalariat": 26.2,
    "percent_salari": 16.31,
    "comunitat": "extremadura"
  },
  {
    "centil": 19,
    "numero_total": 3321,
    "sme_total": 16941,
    "numero_home": 1914,
    "sme_home": 16941,
    "numero_dona": 1407,
    "sme_dona": 16941,
    "maxim": 17023,
    "percent_asalariat": 27.4,
    "percent_salari": 17.15,
    "comunitat": "extremadura"
  },
  {
    "centil": 20,
    "numero_total": 3431,
    "sme_total": 17108,
    "numero_home": 2093,
    "sme_home": 17108,
    "numero_dona": 1338,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 28.6,
    "percent_salari": 18.02,
    "comunitat": "extremadura"
  },
  {
    "centil": 21,
    "numero_total": 3104,
    "sme_total": 17280,
    "numero_home": 1879,
    "sme_home": 17282,
    "numero_dona": 1225,
    "sme_dona": 17278,
    "maxim": 17369,
    "percent_asalariat": 29.8,
    "percent_salari": 18.82,
    "comunitat": "extremadura"
  },
  {
    "centil": 22,
    "numero_total": 3301,
    "sme_total": 17456,
    "numero_home": 2066,
    "sme_home": 17457,
    "numero_dona": 1235,
    "sme_dona": 17454,
    "maxim": 17543,
    "percent_asalariat": 31,
    "percent_salari": 19.67,
    "comunitat": "extremadura"
  },
  {
    "centil": 23,
    "numero_total": 3657,
    "sme_total": 17630,
    "numero_home": 2344,
    "sme_home": 17631,
    "numero_dona": 1313,
    "sme_dona": 17630,
    "maxim": 17718,
    "percent_asalariat": 32.3,
    "percent_salari": 20.63,
    "comunitat": "extremadura"
  },
  {
    "centil": 24,
    "numero_total": 3655,
    "sme_total": 17803,
    "numero_home": 2422,
    "sme_home": 17803,
    "numero_dona": 1233,
    "sme_dona": 17803,
    "maxim": 17891,
    "percent_asalariat": 33.7,
    "percent_salari": 21.59,
    "comunitat": "extremadura"
  },
  {
    "centil": 25,
    "numero_total": 4086,
    "sme_total": 17973,
    "numero_home": 2942,
    "sme_home": 17972,
    "numero_dona": 1144,
    "sme_dona": 17977,
    "maxim": 18060,
    "percent_asalariat": 35.1,
    "percent_salari": 22.68,
    "comunitat": "extremadura"
  },
  {
    "centil": 26,
    "numero_total": 3618,
    "sme_total": 18151,
    "numero_home": 2506,
    "sme_home": 18152,
    "numero_dona": 1112,
    "sme_dona": 18150,
    "maxim": 18239,
    "percent_asalariat": 36.5,
    "percent_salari": 23.66,
    "comunitat": "extremadura"
  },
  {
    "centil": 27,
    "numero_total": 3551,
    "sme_total": 18328,
    "numero_home": 2462,
    "sme_home": 18328,
    "numero_dona": 1089,
    "sme_dona": 18328,
    "maxim": 18417,
    "percent_asalariat": 37.8,
    "percent_salari": 24.62,
    "comunitat": "extremadura"
  },
  {
    "centil": 28,
    "numero_total": 3640,
    "sme_total": 18507,
    "numero_home": 2526,
    "sme_home": 18508,
    "numero_dona": 1114,
    "sme_dona": 18504,
    "maxim": 18596,
    "percent_asalariat": 39.1,
    "percent_salari": 25.62,
    "comunitat": "extremadura"
  },
  {
    "centil": 29,
    "numero_total": 3704,
    "sme_total": 18687,
    "numero_home": 2624,
    "sme_home": 18689,
    "numero_dona": 1080,
    "sme_dona": 18685,
    "maxim": 18778,
    "percent_asalariat": 40.5,
    "percent_salari": 26.65,
    "comunitat": "extremadura"
  },
  {
    "centil": 30,
    "numero_total": 3853,
    "sme_total": 18863,
    "numero_home": 2737,
    "sme_home": 18861,
    "numero_dona": 1116,
    "sme_dona": 18867,
    "maxim": 18953,
    "percent_asalariat": 41.9,
    "percent_salari": 27.73,
    "comunitat": "extremadura"
  },
  {
    "centil": 31,
    "numero_total": 4498,
    "sme_total": 19056,
    "numero_home": 3496,
    "sme_home": 19060,
    "numero_dona": 1002,
    "sme_dona": 19042,
    "maxim": 19133,
    "percent_asalariat": 43.5,
    "percent_salari": 29,
    "comunitat": "extremadura"
  },
  {
    "centil": 32,
    "numero_total": 3245,
    "sme_total": 19222,
    "numero_home": 2330,
    "sme_home": 19221,
    "numero_dona": 915,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 44.7,
    "percent_salari": 29.93,
    "comunitat": "extremadura"
  },
  {
    "centil": 33,
    "numero_total": 3257,
    "sme_total": 19410,
    "numero_home": 2176,
    "sme_home": 19410,
    "numero_dona": 1081,
    "sme_dona": 19410,
    "maxim": 19503,
    "percent_asalariat": 45.9,
    "percent_salari": 30.86,
    "comunitat": "extremadura"
  },
  {
    "centil": 34,
    "numero_total": 2786,
    "sme_total": 19597,
    "numero_home": 1845,
    "sme_home": 19597,
    "numero_dona": 941,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 46.9,
    "percent_salari": 31.67,
    "comunitat": "extremadura"
  },
  {
    "centil": 35,
    "numero_total": 3084,
    "sme_total": 19784,
    "numero_home": 2083,
    "sme_home": 19785,
    "numero_dona": 1001,
    "sme_dona": 19783,
    "maxim": 19879,
    "percent_asalariat": 48,
    "percent_salari": 32.58,
    "comunitat": "extremadura"
  },
  {
    "centil": 36,
    "numero_total": 2838,
    "sme_total": 19975,
    "numero_home": 1876,
    "sme_home": 19975,
    "numero_dona": 962,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 49.1,
    "percent_salari": 33.42,
    "comunitat": "extremadura"
  },
  {
    "centil": 37,
    "numero_total": 2855,
    "sme_total": 20163,
    "numero_home": 1893,
    "sme_home": 20164,
    "numero_dona": 962,
    "sme_dona": 20160,
    "maxim": 20263,
    "percent_asalariat": 50.1,
    "percent_salari": 34.28,
    "comunitat": "extremadura"
  },
  {
    "centil": 38,
    "numero_total": 2735,
    "sme_total": 20357,
    "numero_home": 1885,
    "sme_home": 20358,
    "numero_dona": 850,
    "sme_dona": 20355,
    "maxim": 20459,
    "percent_asalariat": 51.1,
    "percent_salari": 35.1,
    "comunitat": "extremadura"
  },
  {
    "centil": 39,
    "numero_total": 2801,
    "sme_total": 20558,
    "numero_home": 1900,
    "sme_home": 20558,
    "numero_dona": 901,
    "sme_dona": 20559,
    "maxim": 20653,
    "percent_asalariat": 52.1,
    "percent_salari": 35.96,
    "comunitat": "extremadura"
  },
  {
    "centil": 40,
    "numero_total": 2704,
    "sme_total": 20753,
    "numero_home": 1762,
    "sme_home": 20754,
    "numero_dona": 942,
    "sme_dona": 20752,
    "maxim": 20854,
    "percent_asalariat": 53.1,
    "percent_salari": 36.79,
    "comunitat": "extremadura"
  },
  {
    "centil": 41,
    "numero_total": 2639,
    "sme_total": 20954,
    "numero_home": 1678,
    "sme_home": 20954,
    "numero_dona": 961,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 54.1,
    "percent_salari": 37.61,
    "comunitat": "extremadura"
  },
  {
    "centil": 42,
    "numero_total": 2737,
    "sme_total": 21155,
    "numero_home": 1732,
    "sme_home": 21155,
    "numero_dona": 1005,
    "sme_dona": 21156,
    "maxim": 21267,
    "percent_asalariat": 55.1,
    "percent_salari": 38.47,
    "comunitat": "extremadura"
  },
  {
    "centil": 43,
    "numero_total": 2591,
    "sme_total": 21375,
    "numero_home": 1665,
    "sme_home": 21374,
    "numero_dona": 926,
    "sme_dona": 21377,
    "maxim": 21483,
    "percent_asalariat": 56,
    "percent_salari": 39.29,
    "comunitat": "extremadura"
  },
  {
    "centil": 44,
    "numero_total": 2762,
    "sme_total": 21594,
    "numero_home": 1673,
    "sme_home": 21593,
    "numero_dona": 1089,
    "sme_dona": 21596,
    "maxim": 21701,
    "percent_asalariat": 57,
    "percent_salari": 40.18,
    "comunitat": "extremadura"
  },
  {
    "centil": 45,
    "numero_total": 2647,
    "sme_total": 21812,
    "numero_home": 1580,
    "sme_home": 21813,
    "numero_dona": 1067,
    "sme_dona": 21812,
    "maxim": 21927,
    "percent_asalariat": 58,
    "percent_salari": 41.03,
    "comunitat": "extremadura"
  },
  {
    "centil": 46,
    "numero_total": 2703,
    "sme_total": 22038,
    "numero_home": 1610,
    "sme_home": 22039,
    "numero_dona": 1093,
    "sme_dona": 22036,
    "maxim": 22151,
    "percent_asalariat": 59,
    "percent_salari": 41.92,
    "comunitat": "extremadura"
  },
  {
    "centil": 47,
    "numero_total": 2611,
    "sme_total": 22264,
    "numero_home": 1500,
    "sme_home": 22265,
    "numero_dona": 1111,
    "sme_dona": 22264,
    "maxim": 22380,
    "percent_asalariat": 60,
    "percent_salari": 42.78,
    "comunitat": "extremadura"
  },
  {
    "centil": 48,
    "numero_total": 2729,
    "sme_total": 22498,
    "numero_home": 1649,
    "sme_home": 22496,
    "numero_dona": 1080,
    "sme_dona": 22502,
    "maxim": 22616,
    "percent_asalariat": 60.9,
    "percent_salari": 43.69,
    "comunitat": "extremadura"
  },
  {
    "centil": 49,
    "numero_total": 2494,
    "sme_total": 22743,
    "numero_home": 1536,
    "sme_home": 22741,
    "numero_dona": 958,
    "sme_dona": 22746,
    "maxim": 22865,
    "percent_asalariat": 61.9,
    "percent_salari": 44.53,
    "comunitat": "extremadura"
  },
  {
    "centil": 50,
    "numero_total": 2484,
    "sme_total": 22990,
    "numero_home": 1500,
    "sme_home": 22990,
    "numero_dona": 984,
    "sme_dona": 22991,
    "maxim": 23114,
    "percent_asalariat": 62.8,
    "percent_salari": 45.38,
    "comunitat": "extremadura"
  },
  {
    "centil": 51,
    "numero_total": 2460,
    "sme_total": 23245,
    "numero_home": 1488,
    "sme_home": 23249,
    "numero_dona": 972,
    "sme_dona": 23239,
    "maxim": 23377,
    "percent_asalariat": 63.7,
    "percent_salari": 46.23,
    "comunitat": "extremadura"
  },
  {
    "centil": 52,
    "numero_total": 2525,
    "sme_total": 23509,
    "numero_home": 1495,
    "sme_home": 23509,
    "numero_dona": 1030,
    "sme_dona": 23510,
    "maxim": 23645,
    "percent_asalariat": 64.6,
    "percent_salari": 47.11,
    "comunitat": "extremadura"
  },
  {
    "centil": 53,
    "numero_total": 2497,
    "sme_total": 23782,
    "numero_home": 1479,
    "sme_home": 23782,
    "numero_dona": 1018,
    "sme_dona": 23782,
    "maxim": 23925,
    "percent_asalariat": 65.5,
    "percent_salari": 47.99,
    "comunitat": "extremadura"
  },
  {
    "centil": 54,
    "numero_total": 2337,
    "sme_total": 24057,
    "numero_home": 1387,
    "sme_home": 24053,
    "numero_dona": 950,
    "sme_dona": 24062,
    "maxim": 24198,
    "percent_asalariat": 66.4,
    "percent_salari": 48.83,
    "comunitat": "extremadura"
  },
  {
    "centil": 55,
    "numero_total": 2385,
    "sme_total": 24348,
    "numero_home": 1389,
    "sme_home": 24350,
    "numero_dona": 996,
    "sme_dona": 24346,
    "maxim": 24501,
    "percent_asalariat": 67.2,
    "percent_salari": 49.69,
    "comunitat": "extremadura"
  },
  {
    "centil": 56,
    "numero_total": 2376,
    "sme_total": 24657,
    "numero_home": 1424,
    "sme_home": 24654,
    "numero_dona": 952,
    "sme_dona": 24660,
    "maxim": 24811,
    "percent_asalariat": 68.1,
    "percent_salari": 50.56,
    "comunitat": "extremadura"
  },
  {
    "centil": 57,
    "numero_total": 2441,
    "sme_total": 24967,
    "numero_home": 1377,
    "sme_home": 24968,
    "numero_dona": 1064,
    "sme_dona": 24967,
    "maxim": 25122,
    "percent_asalariat": 69,
    "percent_salari": 51.46,
    "comunitat": "extremadura"
  },
  {
    "centil": 58,
    "numero_total": 2469,
    "sme_total": 25285,
    "numero_home": 1356,
    "sme_home": 25285,
    "numero_dona": 1113,
    "sme_dona": 25286,
    "maxim": 25450,
    "percent_asalariat": 69.9,
    "percent_salari": 52.39,
    "comunitat": "extremadura"
  },
  {
    "centil": 59,
    "numero_total": 2394,
    "sme_total": 25618,
    "numero_home": 1282,
    "sme_home": 25619,
    "numero_dona": 1112,
    "sme_dona": 25618,
    "maxim": 25792,
    "percent_asalariat": 70.8,
    "percent_salari": 53.3,
    "comunitat": "extremadura"
  },
  {
    "centil": 60,
    "numero_total": 2362,
    "sme_total": 25961,
    "numero_home": 1311,
    "sme_home": 25957,
    "numero_dona": 1051,
    "sme_dona": 25966,
    "maxim": 26139,
    "percent_asalariat": 71.6,
    "percent_salari": 54.21,
    "comunitat": "extremadura"
  },
  {
    "centil": 61,
    "numero_total": 2402,
    "sme_total": 26318,
    "numero_home": 1334,
    "sme_home": 26319,
    "numero_dona": 1068,
    "sme_dona": 26317,
    "maxim": 26509,
    "percent_asalariat": 72.5,
    "percent_salari": 55.15,
    "comunitat": "extremadura"
  },
  {
    "centil": 62,
    "numero_total": 2281,
    "sme_total": 26694,
    "numero_home": 1243,
    "sme_home": 26689,
    "numero_dona": 1038,
    "sme_dona": 26700,
    "maxim": 26874,
    "percent_asalariat": 73.3,
    "percent_salari": 56.05,
    "comunitat": "extremadura"
  },
  {
    "centil": 63,
    "numero_total": 2198,
    "sme_total": 27039,
    "numero_home": 1184,
    "sme_home": 27036,
    "numero_dona": 1014,
    "sme_dona": 27043,
    "maxim": 27221,
    "percent_asalariat": 74.1,
    "percent_salari": 56.93,
    "comunitat": "extremadura"
  },
  {
    "centil": 64,
    "numero_total": 2177,
    "sme_total": 27414,
    "numero_home": 1208,
    "sme_home": 27415,
    "numero_dona": 969,
    "sme_dona": 27412,
    "maxim": 27616,
    "percent_asalariat": 74.9,
    "percent_salari": 57.82,
    "comunitat": "extremadura"
  },
  {
    "centil": 65,
    "numero_total": 2222,
    "sme_total": 27818,
    "numero_home": 1284,
    "sme_home": 27820,
    "numero_dona": 938,
    "sme_dona": 27817,
    "maxim": 28031,
    "percent_asalariat": 75.8,
    "percent_salari": 58.73,
    "comunitat": "extremadura"
  },
  {
    "centil": 66,
    "numero_total": 2259,
    "sme_total": 28258,
    "numero_home": 1256,
    "sme_home": 28260,
    "numero_dona": 1003,
    "sme_dona": 28256,
    "maxim": 28476,
    "percent_asalariat": 76.6,
    "percent_salari": 59.68,
    "comunitat": "extremadura"
  },
  {
    "centil": 67,
    "numero_total": 2183,
    "sme_total": 28713,
    "numero_home": 1215,
    "sme_home": 28709,
    "numero_dona": 968,
    "sme_dona": 28717,
    "maxim": 28951,
    "percent_asalariat": 77.4,
    "percent_salari": 60.61,
    "comunitat": "extremadura"
  },
  {
    "centil": 68,
    "numero_total": 2107,
    "sme_total": 29203,
    "numero_home": 1157,
    "sme_home": 29196,
    "numero_dona": 950,
    "sme_dona": 29210,
    "maxim": 29450,
    "percent_asalariat": 78.1,
    "percent_salari": 61.52,
    "comunitat": "extremadura"
  },
  {
    "centil": 69,
    "numero_total": 2162,
    "sme_total": 29703,
    "numero_home": 1210,
    "sme_home": 29701,
    "numero_dona": 952,
    "sme_dona": 29706,
    "maxim": 29970,
    "percent_asalariat": 78.9,
    "percent_salari": 62.48,
    "comunitat": "extremadura"
  },
  {
    "centil": 70,
    "numero_total": 2087,
    "sme_total": 30217,
    "numero_home": 1141,
    "sme_home": 30216,
    "numero_dona": 946,
    "sme_dona": 30219,
    "maxim": 30487,
    "percent_asalariat": 79.7,
    "percent_salari": 63.41,
    "comunitat": "extremadura"
  },
  {
    "centil": 71,
    "numero_total": 2206,
    "sme_total": 30759,
    "numero_home": 1211,
    "sme_home": 30754,
    "numero_dona": 995,
    "sme_dona": 30765,
    "maxim": 31037,
    "percent_asalariat": 80.5,
    "percent_salari": 64.42,
    "comunitat": "extremadura"
  },
  {
    "centil": 72,
    "numero_total": 2215,
    "sme_total": 31310,
    "numero_home": 1200,
    "sme_home": 31314,
    "numero_dona": 1015,
    "sme_dona": 31306,
    "maxim": 31602,
    "percent_asalariat": 81.3,
    "percent_salari": 65.45,
    "comunitat": "extremadura"
  },
  {
    "centil": 73,
    "numero_total": 2145,
    "sme_total": 31884,
    "numero_home": 1163,
    "sme_home": 31884,
    "numero_dona": 982,
    "sme_dona": 31885,
    "maxim": 32176,
    "percent_asalariat": 82.1,
    "percent_salari": 66.46,
    "comunitat": "extremadura"
  },
  {
    "centil": 74,
    "numero_total": 2221,
    "sme_total": 32468,
    "numero_home": 1207,
    "sme_home": 32469,
    "numero_dona": 1014,
    "sme_dona": 32467,
    "maxim": 32786,
    "percent_asalariat": 82.9,
    "percent_salari": 67.53,
    "comunitat": "extremadura"
  },
  {
    "centil": 75,
    "numero_total": 2165,
    "sme_total": 33098,
    "numero_home": 1124,
    "sme_home": 33102,
    "numero_dona": 1041,
    "sme_dona": 33094,
    "maxim": 33413,
    "percent_asalariat": 83.7,
    "percent_salari": 68.6,
    "comunitat": "extremadura"
  },
  {
    "centil": 76,
    "numero_total": 2221,
    "sme_total": 33731,
    "numero_home": 1106,
    "sme_home": 33726,
    "numero_dona": 1115,
    "sme_dona": 33737,
    "maxim": 34056,
    "percent_asalariat": 84.5,
    "percent_salari": 69.71,
    "comunitat": "extremadura"
  },
  {
    "centil": 77,
    "numero_total": 2070,
    "sme_total": 34394,
    "numero_home": 1015,
    "sme_home": 34390,
    "numero_dona": 1055,
    "sme_dona": 34397,
    "maxim": 34722,
    "percent_asalariat": 85.3,
    "percent_salari": 70.77,
    "comunitat": "extremadura"
  },
  {
    "centil": 78,
    "numero_total": 2206,
    "sme_total": 35058,
    "numero_home": 1115,
    "sme_home": 35055,
    "numero_dona": 1091,
    "sme_dona": 35061,
    "maxim": 35374,
    "percent_asalariat": 86.1,
    "percent_salari": 71.91,
    "comunitat": "extremadura"
  },
  {
    "centil": 79,
    "numero_total": 2407,
    "sme_total": 35698,
    "numero_home": 1168,
    "sme_home": 35706,
    "numero_dona": 1239,
    "sme_dona": 35690,
    "maxim": 36027,
    "percent_asalariat": 87,
    "percent_salari": 73.19,
    "comunitat": "extremadura"
  },
  {
    "centil": 80,
    "numero_total": 2359,
    "sme_total": 36375,
    "numero_home": 1070,
    "sme_home": 36375,
    "numero_dona": 1289,
    "sme_dona": 36375,
    "maxim": 36730,
    "percent_asalariat": 87.8,
    "percent_salari": 74.46,
    "comunitat": "extremadura"
  },
  {
    "centil": 81,
    "numero_total": 2422,
    "sme_total": 37111,
    "numero_home": 1174,
    "sme_home": 37113,
    "numero_dona": 1248,
    "sme_dona": 37109,
    "maxim": 37490,
    "percent_asalariat": 88.7,
    "percent_salari": 75.8,
    "comunitat": "extremadura"
  },
  {
    "centil": 82,
    "numero_total": 2384,
    "sme_total": 37900,
    "numero_home": 1139,
    "sme_home": 37901,
    "numero_dona": 1245,
    "sme_dona": 37898,
    "maxim": 38304,
    "percent_asalariat": 89.6,
    "percent_salari": 77.14,
    "comunitat": "extremadura"
  },
  {
    "centil": 83,
    "numero_total": 2263,
    "sme_total": 38733,
    "numero_home": 1105,
    "sme_home": 38729,
    "numero_dona": 1158,
    "sme_dona": 38736,
    "maxim": 39197,
    "percent_asalariat": 90.4,
    "percent_salari": 78.44,
    "comunitat": "extremadura"
  },
  {
    "centil": 84,
    "numero_total": 2016,
    "sme_total": 39667,
    "numero_home": 1041,
    "sme_home": 39669,
    "numero_dona": 975,
    "sme_dona": 39665,
    "maxim": 40137,
    "percent_asalariat": 91.1,
    "percent_salari": 79.62,
    "comunitat": "extremadura"
  },
  {
    "centil": 85,
    "numero_total": 2126,
    "sme_total": 40638,
    "numero_home": 1103,
    "sme_home": 40647,
    "numero_dona": 1023,
    "sme_dona": 40629,
    "maxim": 41170,
    "percent_asalariat": 91.9,
    "percent_salari": 80.91,
    "comunitat": "extremadura"
  },
  {
    "centil": 86,
    "numero_total": 1940,
    "sme_total": 41728,
    "numero_home": 1024,
    "sme_home": 41736,
    "numero_dona": 916,
    "sme_dona": 41718,
    "maxim": 42306,
    "percent_asalariat": 92.6,
    "percent_salari": 82.11,
    "comunitat": "extremadura"
  },
  {
    "centil": 87,
    "numero_total": 1841,
    "sme_total": 42896,
    "numero_home": 944,
    "sme_home": 42902,
    "numero_dona": 897,
    "sme_dona": 42889,
    "maxim": 43519,
    "percent_asalariat": 93.3,
    "percent_salari": 83.28,
    "comunitat": "extremadura"
  },
  {
    "centil": 88,
    "numero_total": 1666,
    "sme_total": 44160,
    "numero_home": 905,
    "sme_home": 44167,
    "numero_dona": 761,
    "sme_dona": 44152,
    "maxim": 44857,
    "percent_asalariat": 93.9,
    "percent_salari": 84.37,
    "comunitat": "extremadura"
  },
  {
    "centil": 89,
    "numero_total": 1563,
    "sme_total": 45574,
    "numero_home": 863,
    "sme_home": 45567,
    "numero_dona": 700,
    "sme_dona": 45582,
    "maxim": 46326,
    "percent_asalariat": 94.5,
    "percent_salari": 85.43,
    "comunitat": "extremadura"
  },
  {
    "centil": 90,
    "numero_total": 1547,
    "sme_total": 47126,
    "numero_home": 810,
    "sme_home": 47124,
    "numero_dona": 737,
    "sme_dona": 47127,
    "maxim": 48005,
    "percent_asalariat": 95,
    "percent_salari": 86.51,
    "comunitat": "extremadura"
  },
  {
    "centil": 91,
    "numero_total": 1505,
    "sme_total": 48923,
    "numero_home": 843,
    "sme_home": 48915,
    "numero_dona": 662,
    "sme_dona": 48934,
    "maxim": 49888,
    "percent_asalariat": 95.6,
    "percent_salari": 87.6,
    "comunitat": "extremadura"
  },
  {
    "centil": 92,
    "numero_total": 1377,
    "sme_total": 50937,
    "numero_home": 754,
    "sme_home": 50917,
    "numero_dona": 623,
    "sme_dona": 50962,
    "maxim": 52064,
    "percent_asalariat": 96.1,
    "percent_salari": 88.64,
    "comunitat": "extremadura"
  },
  {
    "centil": 93,
    "numero_total": 1446,
    "sme_total": 53369,
    "numero_home": 864,
    "sme_home": 53391,
    "numero_dona": 582,
    "sme_dona": 53337,
    "maxim": 54742,
    "percent_asalariat": 96.6,
    "percent_salari": 89.79,
    "comunitat": "extremadura"
  },
  {
    "centil": 94,
    "numero_total": 1418,
    "sme_total": 56317,
    "numero_home": 860,
    "sme_home": 56344,
    "numero_dona": 558,
    "sme_dona": 56277,
    "maxim": 57976,
    "percent_asalariat": 97.1,
    "percent_salari": 90.97,
    "comunitat": "extremadura"
  },
  {
    "centil": 95,
    "numero_total": 1448,
    "sme_total": 59939,
    "numero_home": 861,
    "sme_home": 59931,
    "numero_dona": 587,
    "sme_dona": 59950,
    "maxim": 61939,
    "percent_asalariat": 97.7,
    "percent_salari": 92.26,
    "comunitat": "extremadura"
  },
  {
    "centil": 96,
    "numero_total": 1471,
    "sme_total": 64268,
    "numero_home": 889,
    "sme_home": 64217,
    "numero_dona": 582,
    "sme_dona": 64344,
    "maxim": 66966,
    "percent_asalariat": 98.2,
    "percent_salari": 93.66,
    "comunitat": "extremadura"
  },
  {
    "centil": 97,
    "numero_total": 1472,
    "sme_total": 70157,
    "numero_home": 881,
    "sme_home": 70178,
    "numero_dona": 591,
    "sme_dona": 70127,
    "maxim": 73778,
    "percent_asalariat": 98.8,
    "percent_salari": 95.2,
    "comunitat": "extremadura"
  },
  {
    "centil": 98,
    "numero_total": 1490,
    "sme_total": 78411,
    "numero_home": 890,
    "sme_home": 78398,
    "numero_dona": 600,
    "sme_dona": 78431,
    "maxim": 83931,
    "percent_asalariat": 99.3,
    "percent_salari": 96.93,
    "comunitat": "extremadura"
  },
  {
    "centil": 99,
    "numero_total": 1221,
    "sme_total": 91814,
    "numero_home": 815,
    "sme_home": 92283,
    "numero_dona": 406,
    "sme_dona": 90873,
    "maxim": 104199,
    "percent_asalariat": 99.7,
    "percent_salari": 98.59,
    "comunitat": "extremadura"
  },
  {
    "centil": 100,
    "numero_total": 707,
    "sme_total": 133923,
    "numero_home": 579,
    "sme_home": 135897,
    "numero_dona": 128,
    "sme_dona": 124995,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "extremadura"
  },
  {
    "centil": 1,
    "numero_total": 7773,
    "sme_total": 14054,
    "numero_home": 3258,
    "sme_home": 14049,
    "numero_dona": 4515,
    "sme_dona": 14058,
    "maxim": 14139,
    "percent_asalariat": 1.1,
    "percent_salari": 0.54,
    "comunitat": "galicia"
  },
  {
    "centil": 2,
    "numero_total": 7839,
    "sme_total": 14218,
    "numero_home": 3041,
    "sme_home": 14217,
    "numero_dona": 4798,
    "sme_dona": 14219,
    "maxim": 14300,
    "percent_asalariat": 2.1,
    "percent_salari": 1.1,
    "comunitat": "galicia"
  },
  {
    "centil": 3,
    "numero_total": 7549,
    "sme_total": 14379,
    "numero_home": 2750,
    "sme_home": 14378,
    "numero_dona": 4799,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 3.1,
    "percent_salari": 1.64,
    "comunitat": "galicia"
  },
  {
    "centil": 4,
    "numero_total": 7568,
    "sme_total": 14537,
    "numero_home": 2823,
    "sme_home": 14537,
    "numero_dona": 4745,
    "sme_dona": 14536,
    "maxim": 14618,
    "percent_asalariat": 4.2,
    "percent_salari": 2.18,
    "comunitat": "galicia"
  },
  {
    "centil": 5,
    "numero_total": 7662,
    "sme_total": 14697,
    "numero_home": 2902,
    "sme_home": 14696,
    "numero_dona": 4760,
    "sme_dona": 14698,
    "maxim": 14776,
    "percent_asalariat": 5.2,
    "percent_salari": 2.74,
    "comunitat": "galicia"
  },
  {
    "centil": 6,
    "numero_total": 8151,
    "sme_total": 14856,
    "numero_home": 3027,
    "sme_home": 14857,
    "numero_dona": 5124,
    "sme_dona": 14856,
    "maxim": 14934,
    "percent_asalariat": 6.3,
    "percent_salari": 3.35,
    "comunitat": "galicia"
  },
  {
    "centil": 7,
    "numero_total": 7960,
    "sme_total": 15011,
    "numero_home": 3172,
    "sme_home": 15013,
    "numero_dona": 4788,
    "sme_dona": 15010,
    "maxim": 15091,
    "percent_asalariat": 7.4,
    "percent_salari": 3.94,
    "comunitat": "galicia"
  },
  {
    "centil": 8,
    "numero_total": 9097,
    "sme_total": 15163,
    "numero_home": 3538,
    "sme_home": 15165,
    "numero_dona": 5559,
    "sme_dona": 15162,
    "maxim": 15248,
    "percent_asalariat": 8.6,
    "percent_salari": 4.63,
    "comunitat": "galicia"
  },
  {
    "centil": 9,
    "numero_total": 8234,
    "sme_total": 15327,
    "numero_home": 3411,
    "sme_home": 15327,
    "numero_dona": 4823,
    "sme_dona": 15327,
    "maxim": 15407,
    "percent_asalariat": 9.8,
    "percent_salari": 5.25,
    "comunitat": "galicia"
  },
  {
    "centil": 10,
    "numero_total": 8002,
    "sme_total": 15487,
    "numero_home": 3396,
    "sme_home": 15487,
    "numero_dona": 4606,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 10.8,
    "percent_salari": 5.87,
    "comunitat": "galicia"
  },
  {
    "centil": 11,
    "numero_total": 8328,
    "sme_total": 15645,
    "numero_home": 3416,
    "sme_home": 15644,
    "numero_dona": 4912,
    "sme_dona": 15645,
    "maxim": 15726,
    "percent_asalariat": 12,
    "percent_salari": 6.52,
    "comunitat": "galicia"
  },
  {
    "centil": 12,
    "numero_total": 8273,
    "sme_total": 15805,
    "numero_home": 3433,
    "sme_home": 15806,
    "numero_dona": 4840,
    "sme_dona": 15805,
    "maxim": 15885,
    "percent_asalariat": 13.1,
    "percent_salari": 7.17,
    "comunitat": "galicia"
  },
  {
    "centil": 13,
    "numero_total": 8829,
    "sme_total": 15966,
    "numero_home": 3679,
    "sme_home": 15965,
    "numero_dona": 5150,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 14.3,
    "percent_salari": 7.87,
    "comunitat": "galicia"
  },
  {
    "centil": 14,
    "numero_total": 9045,
    "sme_total": 16128,
    "numero_home": 3775,
    "sme_home": 16128,
    "numero_dona": 5270,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 15.5,
    "percent_salari": 8.59,
    "comunitat": "galicia"
  },
  {
    "centil": 15,
    "numero_total": 8479,
    "sme_total": 16288,
    "numero_home": 3749,
    "sme_home": 16288,
    "numero_dona": 4730,
    "sme_dona": 16288,
    "maxim": 16371,
    "percent_asalariat": 16.7,
    "percent_salari": 9.28,
    "comunitat": "galicia"
  },
  {
    "centil": 16,
    "numero_total": 8115,
    "sme_total": 16451,
    "numero_home": 3652,
    "sme_home": 16453,
    "numero_dona": 4463,
    "sme_dona": 16450,
    "maxim": 16533,
    "percent_asalariat": 17.8,
    "percent_salari": 9.94,
    "comunitat": "galicia"
  },
  {
    "centil": 17,
    "numero_total": 8490,
    "sme_total": 16607,
    "numero_home": 3951,
    "sme_home": 16606,
    "numero_dona": 4539,
    "sme_dona": 16608,
    "maxim": 16692,
    "percent_asalariat": 18.9,
    "percent_salari": 10.64,
    "comunitat": "galicia"
  },
  {
    "centil": 18,
    "numero_total": 7892,
    "sme_total": 16773,
    "numero_home": 3714,
    "sme_home": 16773,
    "numero_dona": 4178,
    "sme_dona": 16773,
    "maxim": 16855,
    "percent_asalariat": 20,
    "percent_salari": 11.3,
    "comunitat": "galicia"
  },
  {
    "centil": 19,
    "numero_total": 7728,
    "sme_total": 16939,
    "numero_home": 3589,
    "sme_home": 16940,
    "numero_dona": 4139,
    "sme_dona": 16938,
    "maxim": 17023,
    "percent_asalariat": 21.1,
    "percent_salari": 11.95,
    "comunitat": "galicia"
  },
  {
    "centil": 20,
    "numero_total": 7759,
    "sme_total": 17110,
    "numero_home": 3783,
    "sme_home": 17112,
    "numero_dona": 3976,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 22.1,
    "percent_salari": 12.61,
    "comunitat": "galicia"
  },
  {
    "centil": 21,
    "numero_total": 7859,
    "sme_total": 17282,
    "numero_home": 3929,
    "sme_home": 17281,
    "numero_dona": 3930,
    "sme_dona": 17282,
    "maxim": 17369,
    "percent_asalariat": 23.2,
    "percent_salari": 13.29,
    "comunitat": "galicia"
  },
  {
    "centil": 22,
    "numero_total": 7769,
    "sme_total": 17456,
    "numero_home": 3971,
    "sme_home": 17457,
    "numero_dona": 3798,
    "sme_dona": 17454,
    "maxim": 17543,
    "percent_asalariat": 24.2,
    "percent_salari": 13.96,
    "comunitat": "galicia"
  },
  {
    "centil": 23,
    "numero_total": 8212,
    "sme_total": 17631,
    "numero_home": 4447,
    "sme_home": 17632,
    "numero_dona": 3765,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 25.3,
    "percent_salari": 14.68,
    "comunitat": "galicia"
  },
  {
    "centil": 24,
    "numero_total": 7672,
    "sme_total": 17807,
    "numero_home": 4045,
    "sme_home": 17809,
    "numero_dona": 3627,
    "sme_dona": 17806,
    "maxim": 17891,
    "percent_asalariat": 26.4,
    "percent_salari": 15.36,
    "comunitat": "galicia"
  },
  {
    "centil": 25,
    "numero_total": 8307,
    "sme_total": 17976,
    "numero_home": 4574,
    "sme_home": 17975,
    "numero_dona": 3733,
    "sme_dona": 17976,
    "maxim": 18060,
    "percent_asalariat": 27.5,
    "percent_salari": 16.1,
    "comunitat": "galicia"
  },
  {
    "centil": 26,
    "numero_total": 8025,
    "sme_total": 18150,
    "numero_home": 4638,
    "sme_home": 18150,
    "numero_dona": 3387,
    "sme_dona": 18150,
    "maxim": 18239,
    "percent_asalariat": 28.6,
    "percent_salari": 16.83,
    "comunitat": "galicia"
  },
  {
    "centil": 27,
    "numero_total": 7539,
    "sme_total": 18329,
    "numero_home": 4170,
    "sme_home": 18331,
    "numero_dona": 3369,
    "sme_dona": 18327,
    "maxim": 18417,
    "percent_asalariat": 29.6,
    "percent_salari": 17.52,
    "comunitat": "galicia"
  },
  {
    "centil": 28,
    "numero_total": 7541,
    "sme_total": 18505,
    "numero_home": 4398,
    "sme_home": 18506,
    "numero_dona": 3143,
    "sme_dona": 18504,
    "maxim": 18596,
    "percent_asalariat": 30.7,
    "percent_salari": 18.21,
    "comunitat": "galicia"
  },
  {
    "centil": 29,
    "numero_total": 7711,
    "sme_total": 18687,
    "numero_home": 4746,
    "sme_home": 18687,
    "numero_dona": 2965,
    "sme_dona": 18687,
    "maxim": 18778,
    "percent_asalariat": 31.7,
    "percent_salari": 18.93,
    "comunitat": "galicia"
  },
  {
    "centil": 30,
    "numero_total": 7976,
    "sme_total": 18863,
    "numero_home": 5001,
    "sme_home": 18863,
    "numero_dona": 2975,
    "sme_dona": 18863,
    "maxim": 18953,
    "percent_asalariat": 32.8,
    "percent_salari": 19.67,
    "comunitat": "galicia"
  },
  {
    "centil": 31,
    "numero_total": 8075,
    "sme_total": 19040,
    "numero_home": 5020,
    "sme_home": 19041,
    "numero_dona": 3055,
    "sme_dona": 19040,
    "maxim": 19133,
    "percent_asalariat": 33.9,
    "percent_salari": 20.44,
    "comunitat": "galicia"
  },
  {
    "centil": 32,
    "numero_total": 8018,
    "sme_total": 19225,
    "numero_home": 5150,
    "sme_home": 19224,
    "numero_dona": 2868,
    "sme_dona": 19227,
    "maxim": 19317,
    "percent_asalariat": 35,
    "percent_salari": 21.21,
    "comunitat": "galicia"
  },
  {
    "centil": 33,
    "numero_total": 7943,
    "sme_total": 19408,
    "numero_home": 5124,
    "sme_home": 19408,
    "numero_dona": 2819,
    "sme_dona": 19408,
    "maxim": 19503,
    "percent_asalariat": 36.1,
    "percent_salari": 21.97,
    "comunitat": "galicia"
  },
  {
    "centil": 34,
    "numero_total": 7728,
    "sme_total": 19597,
    "numero_home": 4903,
    "sme_home": 19598,
    "numero_dona": 2825,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 37.1,
    "percent_salari": 22.72,
    "comunitat": "galicia"
  },
  {
    "centil": 35,
    "numero_total": 7706,
    "sme_total": 19781,
    "numero_home": 4918,
    "sme_home": 19781,
    "numero_dona": 2788,
    "sme_dona": 19782,
    "maxim": 19879,
    "percent_asalariat": 38.2,
    "percent_salari": 23.48,
    "comunitat": "galicia"
  },
  {
    "centil": 36,
    "numero_total": 7611,
    "sme_total": 19974,
    "numero_home": 4773,
    "sme_home": 19974,
    "numero_dona": 2838,
    "sme_dona": 19975,
    "maxim": 20069,
    "percent_asalariat": 39.2,
    "percent_salari": 24.24,
    "comunitat": "galicia"
  },
  {
    "centil": 37,
    "numero_total": 7730,
    "sme_total": 20169,
    "numero_home": 4989,
    "sme_home": 20169,
    "numero_dona": 2741,
    "sme_dona": 20169,
    "maxim": 20263,
    "percent_asalariat": 40.2,
    "percent_salari": 25.01,
    "comunitat": "galicia"
  },
  {
    "centil": 38,
    "numero_total": 7495,
    "sme_total": 20364,
    "numero_home": 4733,
    "sme_home": 20364,
    "numero_dona": 2762,
    "sme_dona": 20365,
    "maxim": 20459,
    "percent_asalariat": 41.3,
    "percent_salari": 25.77,
    "comunitat": "galicia"
  },
  {
    "centil": 39,
    "numero_total": 7551,
    "sme_total": 20557,
    "numero_home": 4794,
    "sme_home": 20556,
    "numero_dona": 2757,
    "sme_dona": 20559,
    "maxim": 20653,
    "percent_asalariat": 42.3,
    "percent_salari": 26.54,
    "comunitat": "galicia"
  },
  {
    "centil": 40,
    "numero_total": 7312,
    "sme_total": 20752,
    "numero_home": 4528,
    "sme_home": 20753,
    "numero_dona": 2784,
    "sme_dona": 20751,
    "maxim": 20854,
    "percent_asalariat": 43.3,
    "percent_salari": 27.3,
    "comunitat": "galicia"
  },
  {
    "centil": 41,
    "numero_total": 7238,
    "sme_total": 20957,
    "numero_home": 4401,
    "sme_home": 20957,
    "numero_dona": 2837,
    "sme_dona": 20958,
    "maxim": 21055,
    "percent_asalariat": 44.3,
    "percent_salari": 28.05,
    "comunitat": "galicia"
  },
  {
    "centil": 42,
    "numero_total": 7343,
    "sme_total": 21162,
    "numero_home": 4552,
    "sme_home": 21162,
    "numero_dona": 2791,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 45.3,
    "percent_salari": 28.83,
    "comunitat": "galicia"
  },
  {
    "centil": 43,
    "numero_total": 7418,
    "sme_total": 21375,
    "numero_home": 4524,
    "sme_home": 21374,
    "numero_dona": 2894,
    "sme_dona": 21377,
    "maxim": 21483,
    "percent_asalariat": 46.3,
    "percent_salari": 29.61,
    "comunitat": "galicia"
  },
  {
    "centil": 44,
    "numero_total": 7690,
    "sme_total": 21593,
    "numero_home": 4780,
    "sme_home": 21592,
    "numero_dona": 2910,
    "sme_dona": 21593,
    "maxim": 21701,
    "percent_asalariat": 47.3,
    "percent_salari": 30.44,
    "comunitat": "galicia"
  },
  {
    "centil": 45,
    "numero_total": 8598,
    "sme_total": 21814,
    "numero_home": 5639,
    "sme_home": 21814,
    "numero_dona": 2959,
    "sme_dona": 21813,
    "maxim": 21927,
    "percent_asalariat": 48.5,
    "percent_salari": 31.37,
    "comunitat": "galicia"
  },
  {
    "centil": 46,
    "numero_total": 7534,
    "sme_total": 22036,
    "numero_home": 4668,
    "sme_home": 22036,
    "numero_dona": 2866,
    "sme_dona": 22036,
    "maxim": 22151,
    "percent_asalariat": 49.5,
    "percent_salari": 32.2,
    "comunitat": "galicia"
  },
  {
    "centil": 47,
    "numero_total": 7755,
    "sme_total": 22265,
    "numero_home": 4789,
    "sme_home": 22266,
    "numero_dona": 2966,
    "sme_dona": 22264,
    "maxim": 22380,
    "percent_asalariat": 50.5,
    "percent_salari": 33.06,
    "comunitat": "galicia"
  },
  {
    "centil": 48,
    "numero_total": 7498,
    "sme_total": 22496,
    "numero_home": 4554,
    "sme_home": 22496,
    "numero_dona": 2944,
    "sme_dona": 22495,
    "maxim": 22616,
    "percent_asalariat": 51.6,
    "percent_salari": 33.89,
    "comunitat": "galicia"
  },
  {
    "centil": 49,
    "numero_total": 7945,
    "sme_total": 22740,
    "numero_home": 4915,
    "sme_home": 22740,
    "numero_dona": 3030,
    "sme_dona": 22740,
    "maxim": 22865,
    "percent_asalariat": 52.6,
    "percent_salari": 34.79,
    "comunitat": "galicia"
  },
  {
    "centil": 50,
    "numero_total": 8059,
    "sme_total": 22990,
    "numero_home": 4947,
    "sme_home": 22991,
    "numero_dona": 3112,
    "sme_dona": 22990,
    "maxim": 23114,
    "percent_asalariat": 53.7,
    "percent_salari": 35.71,
    "comunitat": "galicia"
  },
  {
    "centil": 51,
    "numero_total": 7796,
    "sme_total": 23243,
    "numero_home": 4709,
    "sme_home": 23243,
    "numero_dona": 3087,
    "sme_dona": 23243,
    "maxim": 23377,
    "percent_asalariat": 54.8,
    "percent_salari": 36.61,
    "comunitat": "galicia"
  },
  {
    "centil": 52,
    "numero_total": 8100,
    "sme_total": 23510,
    "numero_home": 4891,
    "sme_home": 23510,
    "numero_dona": 3209,
    "sme_dona": 23509,
    "maxim": 23645,
    "percent_asalariat": 55.9,
    "percent_salari": 37.56,
    "comunitat": "galicia"
  },
  {
    "centil": 53,
    "numero_total": 8046,
    "sme_total": 23785,
    "numero_home": 4895,
    "sme_home": 23785,
    "numero_dona": 3151,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 57,
    "percent_salari": 38.51,
    "comunitat": "galicia"
  },
  {
    "centil": 54,
    "numero_total": 8064,
    "sme_total": 24052,
    "numero_home": 4825,
    "sme_home": 24050,
    "numero_dona": 3239,
    "sme_dona": 24055,
    "maxim": 24198,
    "percent_asalariat": 58.1,
    "percent_salari": 39.48,
    "comunitat": "galicia"
  },
  {
    "centil": 55,
    "numero_total": 7863,
    "sme_total": 24348,
    "numero_home": 4604,
    "sme_home": 24348,
    "numero_dona": 3259,
    "sme_dona": 24347,
    "maxim": 24501,
    "percent_asalariat": 59.2,
    "percent_salari": 40.43,
    "comunitat": "galicia"
  },
  {
    "centil": 56,
    "numero_total": 7810,
    "sme_total": 24654,
    "numero_home": 4589,
    "sme_home": 24654,
    "numero_dona": 3221,
    "sme_dona": 24654,
    "maxim": 24811,
    "percent_asalariat": 60.2,
    "percent_salari": 41.39,
    "comunitat": "galicia"
  },
  {
    "centil": 57,
    "numero_total": 7541,
    "sme_total": 24966,
    "numero_home": 4401,
    "sme_home": 24966,
    "numero_dona": 3140,
    "sme_dona": 24967,
    "maxim": 25122,
    "percent_asalariat": 61.2,
    "percent_salari": 42.32,
    "comunitat": "galicia"
  },
  {
    "centil": 58,
    "numero_total": 7485,
    "sme_total": 25285,
    "numero_home": 4478,
    "sme_home": 25286,
    "numero_dona": 3007,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 62.3,
    "percent_salari": 43.26,
    "comunitat": "galicia"
  },
  {
    "centil": 59,
    "numero_total": 7536,
    "sme_total": 25622,
    "numero_home": 4607,
    "sme_home": 25623,
    "numero_dona": 2929,
    "sme_dona": 25621,
    "maxim": 25792,
    "percent_asalariat": 63.3,
    "percent_salari": 44.22,
    "comunitat": "galicia"
  },
  {
    "centil": 60,
    "numero_total": 7491,
    "sme_total": 25965,
    "numero_home": 4464,
    "sme_home": 25964,
    "numero_dona": 3027,
    "sme_dona": 25966,
    "maxim": 26139,
    "percent_asalariat": 64.3,
    "percent_salari": 45.19,
    "comunitat": "galicia"
  },
  {
    "centil": 61,
    "numero_total": 7826,
    "sme_total": 26327,
    "numero_home": 4498,
    "sme_home": 26327,
    "numero_dona": 3328,
    "sme_dona": 26327,
    "maxim": 26509,
    "percent_asalariat": 65.4,
    "percent_salari": 46.21,
    "comunitat": "galicia"
  },
  {
    "centil": 62,
    "numero_total": 7308,
    "sme_total": 26687,
    "numero_home": 4240,
    "sme_home": 26688,
    "numero_dona": 3068,
    "sme_dona": 26685,
    "maxim": 26874,
    "percent_asalariat": 66.4,
    "percent_salari": 47.18,
    "comunitat": "galicia"
  },
  {
    "centil": 63,
    "numero_total": 6573,
    "sme_total": 27048,
    "numero_home": 3944,
    "sme_home": 27046,
    "numero_dona": 2629,
    "sme_dona": 27050,
    "maxim": 27221,
    "percent_asalariat": 67.2,
    "percent_salari": 48.07,
    "comunitat": "galicia"
  },
  {
    "centil": 64,
    "numero_total": 7465,
    "sme_total": 27416,
    "numero_home": 4257,
    "sme_home": 27417,
    "numero_dona": 3208,
    "sme_dona": 27416,
    "maxim": 27616,
    "percent_asalariat": 68.3,
    "percent_salari": 49.09,
    "comunitat": "galicia"
  },
  {
    "centil": 65,
    "numero_total": 7259,
    "sme_total": 27821,
    "numero_home": 4347,
    "sme_home": 27823,
    "numero_dona": 2912,
    "sme_dona": 27818,
    "maxim": 28031,
    "percent_asalariat": 69.2,
    "percent_salari": 50.09,
    "comunitat": "galicia"
  },
  {
    "centil": 66,
    "numero_total": 7308,
    "sme_total": 28252,
    "numero_home": 4372,
    "sme_home": 28252,
    "numero_dona": 2936,
    "sme_dona": 28252,
    "maxim": 28476,
    "percent_asalariat": 70.2,
    "percent_salari": 51.12,
    "comunitat": "galicia"
  },
  {
    "centil": 67,
    "numero_total": 7141,
    "sme_total": 28709,
    "numero_home": 4291,
    "sme_home": 28707,
    "numero_dona": 2850,
    "sme_dona": 28711,
    "maxim": 28951,
    "percent_asalariat": 71.2,
    "percent_salari": 52.14,
    "comunitat": "galicia"
  },
  {
    "centil": 68,
    "numero_total": 7028,
    "sme_total": 29200,
    "numero_home": 4358,
    "sme_home": 29200,
    "numero_dona": 2670,
    "sme_dona": 29200,
    "maxim": 29450,
    "percent_asalariat": 72.2,
    "percent_salari": 53.16,
    "comunitat": "galicia"
  },
  {
    "centil": 69,
    "numero_total": 7077,
    "sme_total": 29707,
    "numero_home": 4298,
    "sme_home": 29705,
    "numero_dona": 2779,
    "sme_dona": 29710,
    "maxim": 29970,
    "percent_asalariat": 73.1,
    "percent_salari": 54.2,
    "comunitat": "galicia"
  },
  {
    "centil": 70,
    "numero_total": 6971,
    "sme_total": 30216,
    "numero_home": 4164,
    "sme_home": 30214,
    "numero_dona": 2807,
    "sme_dona": 30220,
    "maxim": 30487,
    "percent_asalariat": 74.1,
    "percent_salari": 55.25,
    "comunitat": "galicia"
  },
  {
    "centil": 71,
    "numero_total": 6867,
    "sme_total": 30758,
    "numero_home": 4017,
    "sme_home": 30760,
    "numero_dona": 2850,
    "sme_dona": 30757,
    "maxim": 31037,
    "percent_asalariat": 75,
    "percent_salari": 56.3,
    "comunitat": "galicia"
  },
  {
    "centil": 72,
    "numero_total": 6768,
    "sme_total": 31311,
    "numero_home": 3978,
    "sme_home": 31312,
    "numero_dona": 2790,
    "sme_dona": 31310,
    "maxim": 31602,
    "percent_asalariat": 75.9,
    "percent_salari": 57.35,
    "comunitat": "galicia"
  },
  {
    "centil": 73,
    "numero_total": 6475,
    "sme_total": 31875,
    "numero_home": 3791,
    "sme_home": 31884,
    "numero_dona": 2684,
    "sme_dona": 31863,
    "maxim": 32176,
    "percent_asalariat": 76.8,
    "percent_salari": 58.38,
    "comunitat": "galicia"
  },
  {
    "centil": 74,
    "numero_total": 6472,
    "sme_total": 32474,
    "numero_home": 3842,
    "sme_home": 32476,
    "numero_dona": 2630,
    "sme_dona": 32472,
    "maxim": 32786,
    "percent_asalariat": 77.7,
    "percent_salari": 59.42,
    "comunitat": "galicia"
  },
  {
    "centil": 75,
    "numero_total": 7919,
    "sme_total": 33103,
    "numero_home": 3874,
    "sme_home": 33098,
    "numero_dona": 4045,
    "sme_dona": 33107,
    "maxim": 33413,
    "percent_asalariat": 78.8,
    "percent_salari": 60.73,
    "comunitat": "galicia"
  },
  {
    "centil": 76,
    "numero_total": 6606,
    "sme_total": 33739,
    "numero_home": 3718,
    "sme_home": 33733,
    "numero_dona": 2888,
    "sme_dona": 33747,
    "maxim": 34056,
    "percent_asalariat": 79.7,
    "percent_salari": 61.84,
    "comunitat": "galicia"
  },
  {
    "centil": 77,
    "numero_total": 6794,
    "sme_total": 34393,
    "numero_home": 3672,
    "sme_home": 34390,
    "numero_dona": 3122,
    "sme_dona": 34397,
    "maxim": 34722,
    "percent_asalariat": 80.6,
    "percent_salari": 63,
    "comunitat": "galicia"
  },
  {
    "centil": 78,
    "numero_total": 7472,
    "sme_total": 35044,
    "numero_home": 3890,
    "sme_home": 35047,
    "numero_dona": 3582,
    "sme_dona": 35042,
    "maxim": 35374,
    "percent_asalariat": 81.6,
    "percent_salari": 64.3,
    "comunitat": "galicia"
  },
  {
    "centil": 79,
    "numero_total": 6648,
    "sme_total": 35703,
    "numero_home": 3434,
    "sme_home": 35712,
    "numero_dona": 3214,
    "sme_dona": 35693,
    "maxim": 36027,
    "percent_asalariat": 82.5,
    "percent_salari": 65.48,
    "comunitat": "galicia"
  },
  {
    "centil": 80,
    "numero_total": 7050,
    "sme_total": 36389,
    "numero_home": 3580,
    "sme_home": 36383,
    "numero_dona": 3470,
    "sme_dona": 36395,
    "maxim": 36730,
    "percent_asalariat": 83.5,
    "percent_salari": 66.75,
    "comunitat": "galicia"
  },
  {
    "centil": 81,
    "numero_total": 7892,
    "sme_total": 37115,
    "numero_home": 3861,
    "sme_home": 37110,
    "numero_dona": 4031,
    "sme_dona": 37120,
    "maxim": 37490,
    "percent_asalariat": 84.5,
    "percent_salari": 68.21,
    "comunitat": "galicia"
  },
  {
    "centil": 82,
    "numero_total": 7449,
    "sme_total": 37895,
    "numero_home": 3912,
    "sme_home": 37895,
    "numero_dona": 3537,
    "sme_dona": 37895,
    "maxim": 38304,
    "percent_asalariat": 85.5,
    "percent_salari": 69.61,
    "comunitat": "galicia"
  },
  {
    "centil": 83,
    "numero_total": 7148,
    "sme_total": 38757,
    "numero_home": 3782,
    "sme_home": 38752,
    "numero_dona": 3366,
    "sme_dona": 38762,
    "maxim": 39197,
    "percent_asalariat": 86.5,
    "percent_salari": 70.99,
    "comunitat": "galicia"
  },
  {
    "centil": 84,
    "numero_total": 7135,
    "sme_total": 39671,
    "numero_home": 3940,
    "sme_home": 39678,
    "numero_dona": 3195,
    "sme_dona": 39663,
    "maxim": 40137,
    "percent_asalariat": 87.5,
    "percent_salari": 72.4,
    "comunitat": "galicia"
  },
  {
    "centil": 85,
    "numero_total": 6493,
    "sme_total": 40635,
    "numero_home": 3610,
    "sme_home": 40636,
    "numero_dona": 2883,
    "sme_dona": 40634,
    "maxim": 41170,
    "percent_asalariat": 88.4,
    "percent_salari": 73.71,
    "comunitat": "galicia"
  },
  {
    "centil": 86,
    "numero_total": 6507,
    "sme_total": 41724,
    "numero_home": 3596,
    "sme_home": 41724,
    "numero_dona": 2911,
    "sme_dona": 41724,
    "maxim": 42306,
    "percent_asalariat": 89.2,
    "percent_salari": 75.06,
    "comunitat": "galicia"
  },
  {
    "centil": 87,
    "numero_total": 5990,
    "sme_total": 42890,
    "numero_home": 3347,
    "sme_home": 42888,
    "numero_dona": 2643,
    "sme_dona": 42893,
    "maxim": 43519,
    "percent_asalariat": 90.1,
    "percent_salari": 76.34,
    "comunitat": "galicia"
  },
  {
    "centil": 88,
    "numero_total": 5706,
    "sme_total": 44167,
    "numero_home": 3280,
    "sme_home": 44178,
    "numero_dona": 2426,
    "sme_dona": 44151,
    "maxim": 44857,
    "percent_asalariat": 90.8,
    "percent_salari": 77.59,
    "comunitat": "galicia"
  },
  {
    "centil": 89,
    "numero_total": 5650,
    "sme_total": 45572,
    "numero_home": 3294,
    "sme_home": 45563,
    "numero_dona": 2356,
    "sme_dona": 45585,
    "maxim": 46326,
    "percent_asalariat": 91.6,
    "percent_salari": 78.87,
    "comunitat": "galicia"
  },
  {
    "centil": 90,
    "numero_total": 5944,
    "sme_total": 47157,
    "numero_home": 3383,
    "sme_home": 47151,
    "numero_dona": 2561,
    "sme_dona": 47165,
    "maxim": 48005,
    "percent_asalariat": 92.4,
    "percent_salari": 80.26,
    "comunitat": "galicia"
  },
  {
    "centil": 91,
    "numero_total": 5960,
    "sme_total": 48920,
    "numero_home": 3582,
    "sme_home": 48941,
    "numero_dona": 2378,
    "sme_dona": 48889,
    "maxim": 49888,
    "percent_asalariat": 93.2,
    "percent_salari": 81.71,
    "comunitat": "galicia"
  },
  {
    "centil": 92,
    "numero_total": 5752,
    "sme_total": 50926,
    "numero_home": 3491,
    "sme_home": 50931,
    "numero_dona": 2261,
    "sme_dona": 50919,
    "maxim": 52064,
    "percent_asalariat": 94,
    "percent_salari": 83.17,
    "comunitat": "galicia"
  },
  {
    "centil": 93,
    "numero_total": 5887,
    "sme_total": 53369,
    "numero_home": 3686,
    "sme_home": 53362,
    "numero_dona": 2201,
    "sme_dona": 53380,
    "maxim": 54742,
    "percent_asalariat": 94.8,
    "percent_salari": 84.73,
    "comunitat": "galicia"
  },
  {
    "centil": 94,
    "numero_total": 5800,
    "sme_total": 56291,
    "numero_home": 3600,
    "sme_home": 56278,
    "numero_dona": 2200,
    "sme_dona": 56312,
    "maxim": 57976,
    "percent_asalariat": 95.6,
    "percent_salari": 86.36,
    "comunitat": "galicia"
  },
  {
    "centil": 95,
    "numero_total": 5499,
    "sme_total": 59895,
    "numero_home": 3405,
    "sme_home": 59895,
    "numero_dona": 2094,
    "sme_dona": 59894,
    "maxim": 61939,
    "percent_asalariat": 96.3,
    "percent_salari": 87.99,
    "comunitat": "galicia"
  },
  {
    "centil": 96,
    "numero_total": 5566,
    "sme_total": 64318,
    "numero_home": 3518,
    "sme_home": 64297,
    "numero_dona": 2048,
    "sme_dona": 64354,
    "maxim": 66966,
    "percent_asalariat": 97.1,
    "percent_salari": 89.77,
    "comunitat": "galicia"
  },
  {
    "centil": 97,
    "numero_total": 5631,
    "sme_total": 70240,
    "numero_home": 3351,
    "sme_home": 70212,
    "numero_dona": 2280,
    "sme_dona": 70282,
    "maxim": 73778,
    "percent_asalariat": 97.9,
    "percent_salari": 91.74,
    "comunitat": "galicia"
  },
  {
    "centil": 98,
    "numero_total": 6015,
    "sme_total": 78431,
    "numero_home": 3570,
    "sme_home": 78440,
    "numero_dona": 2445,
    "sme_dona": 78418,
    "maxim": 83931,
    "percent_asalariat": 98.7,
    "percent_salari": 94.09,
    "comunitat": "galicia"
  },
  {
    "centil": 99,
    "numero_total": 5384,
    "sme_total": 92160,
    "numero_home": 3462,
    "sme_home": 92438,
    "numero_dona": 1922,
    "sme_dona": 91660,
    "maxim": 104199,
    "percent_asalariat": 99.4,
    "percent_salari": 96.55,
    "comunitat": "galicia"
  },
  {
    "centil": 100,
    "numero_total": 4376,
    "sme_total": 158466,
    "numero_home": 3334,
    "sme_home": 160662,
    "numero_dona": 1042,
    "sme_dona": 151438,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "galicia"
  },
  {
    "centil": 1,
    "numero_total": 17827,
    "sme_total": 14059,
    "numero_home": 8330,
    "sme_home": 14055,
    "numero_dona": 9497,
    "sme_dona": 14062,
    "maxim": 14139,
    "percent_asalariat": 0.7,
    "percent_salari": 0.3,
    "comunitat": "madrid"
  },
  {
    "centil": 2,
    "numero_total": 18244,
    "sme_total": 14219,
    "numero_home": 8041,
    "sme_home": 14219,
    "numero_dona": 10203,
    "sme_dona": 14220,
    "maxim": 14300,
    "percent_asalariat": 1.5,
    "percent_salari": 0.61,
    "comunitat": "madrid"
  },
  {
    "centil": 3,
    "numero_total": 19443,
    "sme_total": 14379,
    "numero_home": 8641,
    "sme_home": 14377,
    "numero_dona": 10802,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 2.3,
    "percent_salari": 0.94,
    "comunitat": "madrid"
  },
  {
    "centil": 4,
    "numero_total": 18833,
    "sme_total": 14539,
    "numero_home": 7796,
    "sme_home": 14538,
    "numero_dona": 11037,
    "sme_dona": 14539,
    "maxim": 14618,
    "percent_asalariat": 3.1,
    "percent_salari": 1.27,
    "comunitat": "madrid"
  },
  {
    "centil": 5,
    "numero_total": 19645,
    "sme_total": 14697,
    "numero_home": 8243,
    "sme_home": 14697,
    "numero_dona": 11402,
    "sme_dona": 14697,
    "maxim": 14776,
    "percent_asalariat": 4,
    "percent_salari": 1.61,
    "comunitat": "madrid"
  },
  {
    "centil": 6,
    "numero_total": 19534,
    "sme_total": 14856,
    "numero_home": 8341,
    "sme_home": 14856,
    "numero_dona": 11193,
    "sme_dona": 14857,
    "maxim": 14934,
    "percent_asalariat": 4.8,
    "percent_salari": 1.96,
    "comunitat": "madrid"
  },
  {
    "centil": 7,
    "numero_total": 19601,
    "sme_total": 15012,
    "numero_home": 8646,
    "sme_home": 15012,
    "numero_dona": 10955,
    "sme_dona": 15012,
    "maxim": 15091,
    "percent_asalariat": 5.6,
    "percent_salari": 2.31,
    "comunitat": "madrid"
  },
  {
    "centil": 8,
    "numero_total": 20321,
    "sme_total": 15167,
    "numero_home": 9590,
    "sme_home": 15165,
    "numero_dona": 10731,
    "sme_dona": 15168,
    "maxim": 15248,
    "percent_asalariat": 6.5,
    "percent_salari": 2.68,
    "comunitat": "madrid"
  },
  {
    "centil": 9,
    "numero_total": 19533,
    "sme_total": 15329,
    "numero_home": 8905,
    "sme_home": 15329,
    "numero_dona": 10628,
    "sme_dona": 15328,
    "maxim": 15407,
    "percent_asalariat": 7.3,
    "percent_salari": 3.04,
    "comunitat": "madrid"
  },
  {
    "centil": 10,
    "numero_total": 20405,
    "sme_total": 15486,
    "numero_home": 9120,
    "sme_home": 15486,
    "numero_dona": 11285,
    "sme_dona": 15486,
    "maxim": 15567,
    "percent_asalariat": 8.1,
    "percent_salari": 3.41,
    "comunitat": "madrid"
  },
  {
    "centil": 11,
    "numero_total": 20306,
    "sme_total": 15646,
    "numero_home": 9362,
    "sme_home": 15646,
    "numero_dona": 10944,
    "sme_dona": 15646,
    "maxim": 15726,
    "percent_asalariat": 9,
    "percent_salari": 3.79,
    "comunitat": "madrid"
  },
  {
    "centil": 12,
    "numero_total": 22025,
    "sme_total": 15808,
    "numero_home": 10090,
    "sme_home": 15809,
    "numero_dona": 11935,
    "sme_dona": 15808,
    "maxim": 15885,
    "percent_asalariat": 9.9,
    "percent_salari": 4.21,
    "comunitat": "madrid"
  },
  {
    "centil": 13,
    "numero_total": 20828,
    "sme_total": 15966,
    "numero_home": 9543,
    "sme_home": 15967,
    "numero_dona": 11285,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 10.8,
    "percent_salari": 4.6,
    "comunitat": "madrid"
  },
  {
    "centil": 14,
    "numero_total": 21001,
    "sme_total": 16123,
    "numero_home": 9885,
    "sme_home": 16123,
    "numero_dona": 11116,
    "sme_dona": 16124,
    "maxim": 16207,
    "percent_asalariat": 11.7,
    "percent_salari": 5.01,
    "comunitat": "madrid"
  },
  {
    "centil": 15,
    "numero_total": 20017,
    "sme_total": 16288,
    "numero_home": 9457,
    "sme_home": 16288,
    "numero_dona": 10560,
    "sme_dona": 16288,
    "maxim": 16371,
    "percent_asalariat": 12.5,
    "percent_salari": 5.4,
    "comunitat": "madrid"
  },
  {
    "centil": 16,
    "numero_total": 20783,
    "sme_total": 16452,
    "numero_home": 10185,
    "sme_home": 16453,
    "numero_dona": 10598,
    "sme_dona": 16451,
    "maxim": 16533,
    "percent_asalariat": 13.4,
    "percent_salari": 5.81,
    "comunitat": "madrid"
  },
  {
    "centil": 17,
    "numero_total": 19057,
    "sme_total": 16610,
    "numero_home": 9119,
    "sme_home": 16610,
    "numero_dona": 9938,
    "sme_dona": 16610,
    "maxim": 16692,
    "percent_asalariat": 14.2,
    "percent_salari": 6.18,
    "comunitat": "madrid"
  },
  {
    "centil": 18,
    "numero_total": 18858,
    "sme_total": 16773,
    "numero_home": 9061,
    "sme_home": 16773,
    "numero_dona": 9797,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 15,
    "percent_salari": 6.56,
    "comunitat": "madrid"
  },
  {
    "centil": 19,
    "numero_total": 19060,
    "sme_total": 16940,
    "numero_home": 9236,
    "sme_home": 16940,
    "numero_dona": 9824,
    "sme_dona": 16940,
    "maxim": 17023,
    "percent_asalariat": 15.8,
    "percent_salari": 6.95,
    "comunitat": "madrid"
  },
  {
    "centil": 20,
    "numero_total": 19189,
    "sme_total": 17109,
    "numero_home": 9172,
    "sme_home": 17110,
    "numero_dona": 10017,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 16.6,
    "percent_salari": 7.34,
    "comunitat": "madrid"
  },
  {
    "centil": 21,
    "numero_total": 19028,
    "sme_total": 17281,
    "numero_home": 9458,
    "sme_home": 17281,
    "numero_dona": 9570,
    "sme_dona": 17281,
    "maxim": 17369,
    "percent_asalariat": 17.4,
    "percent_salari": 7.73,
    "comunitat": "madrid"
  },
  {
    "centil": 22,
    "numero_total": 18797,
    "sme_total": 17456,
    "numero_home": 9470,
    "sme_home": 17455,
    "numero_dona": 9327,
    "sme_dona": 17456,
    "maxim": 17543,
    "percent_asalariat": 18.2,
    "percent_salari": 8.12,
    "comunitat": "madrid"
  },
  {
    "centil": 23,
    "numero_total": 19289,
    "sme_total": 17631,
    "numero_home": 9929,
    "sme_home": 17631,
    "numero_dona": 9360,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 19,
    "percent_salari": 8.53,
    "comunitat": "madrid"
  },
  {
    "centil": 24,
    "numero_total": 19168,
    "sme_total": 17803,
    "numero_home": 10034,
    "sme_home": 17804,
    "numero_dona": 9134,
    "sme_dona": 17803,
    "maxim": 17891,
    "percent_asalariat": 19.8,
    "percent_salari": 8.93,
    "comunitat": "madrid"
  },
  {
    "centil": 25,
    "numero_total": 19307,
    "sme_total": 17977,
    "numero_home": 9901,
    "sme_home": 17976,
    "numero_dona": 9406,
    "sme_dona": 17978,
    "maxim": 18060,
    "percent_asalariat": 20.6,
    "percent_salari": 9.35,
    "comunitat": "madrid"
  },
  {
    "centil": 26,
    "numero_total": 18816,
    "sme_total": 18150,
    "numero_home": 9960,
    "sme_home": 18150,
    "numero_dona": 8856,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 21.4,
    "percent_salari": 9.76,
    "comunitat": "madrid"
  },
  {
    "centil": 27,
    "numero_total": 18315,
    "sme_total": 18328,
    "numero_home": 9466,
    "sme_home": 18328,
    "numero_dona": 8849,
    "sme_dona": 18328,
    "maxim": 18417,
    "percent_asalariat": 22.2,
    "percent_salari": 10.16,
    "comunitat": "madrid"
  },
  {
    "centil": 28,
    "numero_total": 18991,
    "sme_total": 18505,
    "numero_home": 9779,
    "sme_home": 18506,
    "numero_dona": 9212,
    "sme_dona": 18504,
    "maxim": 18596,
    "percent_asalariat": 23,
    "percent_salari": 10.58,
    "comunitat": "madrid"
  },
  {
    "centil": 29,
    "numero_total": 18433,
    "sme_total": 18687,
    "numero_home": 9756,
    "sme_home": 18687,
    "numero_dona": 8677,
    "sme_dona": 18686,
    "maxim": 18778,
    "percent_asalariat": 23.7,
    "percent_salari": 10.99,
    "comunitat": "madrid"
  },
  {
    "centil": 30,
    "numero_total": 18492,
    "sme_total": 18867,
    "numero_home": 10081,
    "sme_home": 18867,
    "numero_dona": 8411,
    "sme_dona": 18867,
    "maxim": 18953,
    "percent_asalariat": 24.5,
    "percent_salari": 11.4,
    "comunitat": "madrid"
  },
  {
    "centil": 31,
    "numero_total": 18906,
    "sme_total": 19043,
    "numero_home": 10196,
    "sme_home": 19043,
    "numero_dona": 8710,
    "sme_dona": 19042,
    "maxim": 19133,
    "percent_asalariat": 25.3,
    "percent_salari": 11.83,
    "comunitat": "madrid"
  },
  {
    "centil": 32,
    "numero_total": 19851,
    "sme_total": 19225,
    "numero_home": 11208,
    "sme_home": 19225,
    "numero_dona": 8643,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 26.2,
    "percent_salari": 12.29,
    "comunitat": "madrid"
  },
  {
    "centil": 33,
    "numero_total": 19824,
    "sme_total": 19412,
    "numero_home": 11253,
    "sme_home": 19412,
    "numero_dona": 8571,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 27,
    "percent_salari": 12.75,
    "comunitat": "madrid"
  },
  {
    "centil": 34,
    "numero_total": 20760,
    "sme_total": 19596,
    "numero_home": 12006,
    "sme_home": 19596,
    "numero_dona": 8754,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 27.9,
    "percent_salari": 13.23,
    "comunitat": "madrid"
  },
  {
    "centil": 35,
    "numero_total": 20469,
    "sme_total": 19785,
    "numero_home": 12139,
    "sme_home": 19785,
    "numero_dona": 8330,
    "sme_dona": 19785,
    "maxim": 19879,
    "percent_asalariat": 28.7,
    "percent_salari": 13.72,
    "comunitat": "madrid"
  },
  {
    "centil": 36,
    "numero_total": 21074,
    "sme_total": 19974,
    "numero_home": 12175,
    "sme_home": 19974,
    "numero_dona": 8899,
    "sme_dona": 19975,
    "maxim": 20069,
    "percent_asalariat": 29.6,
    "percent_salari": 14.22,
    "comunitat": "madrid"
  },
  {
    "centil": 37,
    "numero_total": 20464,
    "sme_total": 20165,
    "numero_home": 11694,
    "sme_home": 20167,
    "numero_dona": 8770,
    "sme_dona": 20164,
    "maxim": 20263,
    "percent_asalariat": 30.5,
    "percent_salari": 14.71,
    "comunitat": "madrid"
  },
  {
    "centil": 38,
    "numero_total": 20181,
    "sme_total": 20360,
    "numero_home": 11786,
    "sme_home": 20361,
    "numero_dona": 8395,
    "sme_dona": 20359,
    "maxim": 20459,
    "percent_asalariat": 31.3,
    "percent_salari": 15.2,
    "comunitat": "madrid"
  },
  {
    "centil": 39,
    "numero_total": 20318,
    "sme_total": 20556,
    "numero_home": 11902,
    "sme_home": 20556,
    "numero_dona": 8416,
    "sme_dona": 20556,
    "maxim": 20653,
    "percent_asalariat": 32.2,
    "percent_salari": 15.7,
    "comunitat": "madrid"
  },
  {
    "centil": 40,
    "numero_total": 19675,
    "sme_total": 20752,
    "numero_home": 11227,
    "sme_home": 20752,
    "numero_dona": 8448,
    "sme_dona": 20752,
    "maxim": 20854,
    "percent_asalariat": 33,
    "percent_salari": 16.19,
    "comunitat": "madrid"
  },
  {
    "centil": 41,
    "numero_total": 19619,
    "sme_total": 20957,
    "numero_home": 11200,
    "sme_home": 20956,
    "numero_dona": 8419,
    "sme_dona": 20958,
    "maxim": 21055,
    "percent_asalariat": 33.8,
    "percent_salari": 16.68,
    "comunitat": "madrid"
  },
  {
    "centil": 42,
    "numero_total": 19255,
    "sme_total": 21161,
    "numero_home": 11016,
    "sme_home": 21162,
    "numero_dona": 8239,
    "sme_dona": 21160,
    "maxim": 21267,
    "percent_asalariat": 34.6,
    "percent_salari": 17.16,
    "comunitat": "madrid"
  },
  {
    "centil": 43,
    "numero_total": 20183,
    "sme_total": 21376,
    "numero_home": 11843,
    "sme_home": 21376,
    "numero_dona": 8340,
    "sme_dona": 21376,
    "maxim": 21483,
    "percent_asalariat": 35.5,
    "percent_salari": 17.68,
    "comunitat": "madrid"
  },
  {
    "centil": 44,
    "numero_total": 20754,
    "sme_total": 21590,
    "numero_home": 11681,
    "sme_home": 21590,
    "numero_dona": 9073,
    "sme_dona": 21591,
    "maxim": 21701,
    "percent_asalariat": 36.4,
    "percent_salari": 18.21,
    "comunitat": "madrid"
  },
  {
    "centil": 45,
    "numero_total": 20069,
    "sme_total": 21814,
    "numero_home": 11337,
    "sme_home": 21815,
    "numero_dona": 8732,
    "sme_dona": 21813,
    "maxim": 21927,
    "percent_asalariat": 37.2,
    "percent_salari": 18.73,
    "comunitat": "madrid"
  },
  {
    "centil": 46,
    "numero_total": 20484,
    "sme_total": 22036,
    "numero_home": 11353,
    "sme_home": 22036,
    "numero_dona": 9131,
    "sme_dona": 22037,
    "maxim": 22151,
    "percent_asalariat": 38.1,
    "percent_salari": 19.27,
    "comunitat": "madrid"
  },
  {
    "centil": 47,
    "numero_total": 20215,
    "sme_total": 22264,
    "numero_home": 11418,
    "sme_home": 22264,
    "numero_dona": 8797,
    "sme_dona": 22264,
    "maxim": 22380,
    "percent_asalariat": 38.9,
    "percent_salari": 19.81,
    "comunitat": "madrid"
  },
  {
    "centil": 48,
    "numero_total": 19969,
    "sme_total": 22498,
    "numero_home": 11060,
    "sme_home": 22498,
    "numero_dona": 8909,
    "sme_dona": 22498,
    "maxim": 22616,
    "percent_asalariat": 39.7,
    "percent_salari": 20.35,
    "comunitat": "madrid"
  },
  {
    "centil": 49,
    "numero_total": 19812,
    "sme_total": 22741,
    "numero_home": 10957,
    "sme_home": 22740,
    "numero_dona": 8855,
    "sme_dona": 22743,
    "maxim": 22865,
    "percent_asalariat": 40.6,
    "percent_salari": 20.88,
    "comunitat": "madrid"
  },
  {
    "centil": 50,
    "numero_total": 19897,
    "sme_total": 22991,
    "numero_home": 10739,
    "sme_home": 22990,
    "numero_dona": 9158,
    "sme_dona": 22992,
    "maxim": 23114,
    "percent_asalariat": 41.4,
    "percent_salari": 21.43,
    "comunitat": "madrid"
  },
  {
    "centil": 51,
    "numero_total": 19985,
    "sme_total": 23245,
    "numero_home": 10706,
    "sme_home": 23245,
    "numero_dona": 9279,
    "sme_dona": 23244,
    "maxim": 23377,
    "percent_asalariat": 42.3,
    "percent_salari": 21.98,
    "comunitat": "madrid"
  },
  {
    "centil": 52,
    "numero_total": 20373,
    "sme_total": 23510,
    "numero_home": 10821,
    "sme_home": 23511,
    "numero_dona": 9552,
    "sme_dona": 23508,
    "maxim": 23645,
    "percent_asalariat": 43.1,
    "percent_salari": 22.56,
    "comunitat": "madrid"
  },
  {
    "centil": 53,
    "numero_total": 20274,
    "sme_total": 23784,
    "numero_home": 10973,
    "sme_home": 23784,
    "numero_dona": 9301,
    "sme_dona": 23785,
    "maxim": 23925,
    "percent_asalariat": 44,
    "percent_salari": 23.13,
    "comunitat": "madrid"
  },
  {
    "centil": 54,
    "numero_total": 20738,
    "sme_total": 24056,
    "numero_home": 11132,
    "sme_home": 24055,
    "numero_dona": 9606,
    "sme_dona": 24057,
    "maxim": 24198,
    "percent_asalariat": 44.8,
    "percent_salari": 23.73,
    "comunitat": "madrid"
  },
  {
    "centil": 55,
    "numero_total": 20333,
    "sme_total": 24351,
    "numero_home": 10907,
    "sme_home": 24350,
    "numero_dona": 9426,
    "sme_dona": 24351,
    "maxim": 24501,
    "percent_asalariat": 45.7,
    "percent_salari": 24.32,
    "comunitat": "madrid"
  },
  {
    "centil": 56,
    "numero_total": 20816,
    "sme_total": 24656,
    "numero_home": 11047,
    "sme_home": 24655,
    "numero_dona": 9769,
    "sme_dona": 24658,
    "maxim": 24811,
    "percent_asalariat": 46.6,
    "percent_salari": 24.93,
    "comunitat": "madrid"
  },
  {
    "centil": 57,
    "numero_total": 21134,
    "sme_total": 24966,
    "numero_home": 11308,
    "sme_home": 24966,
    "numero_dona": 9826,
    "sme_dona": 24967,
    "maxim": 25122,
    "percent_asalariat": 47.5,
    "percent_salari": 25.56,
    "comunitat": "madrid"
  },
  {
    "centil": 58,
    "numero_total": 20751,
    "sme_total": 25285,
    "numero_home": 11105,
    "sme_home": 25285,
    "numero_dona": 9646,
    "sme_dona": 25284,
    "maxim": 25450,
    "percent_asalariat": 48.3,
    "percent_salari": 26.19,
    "comunitat": "madrid"
  },
  {
    "centil": 59,
    "numero_total": 20979,
    "sme_total": 25619,
    "numero_home": 11292,
    "sme_home": 25620,
    "numero_dona": 9687,
    "sme_dona": 25618,
    "maxim": 25792,
    "percent_asalariat": 49.2,
    "percent_salari": 26.83,
    "comunitat": "madrid"
  },
  {
    "centil": 60,
    "numero_total": 21384,
    "sme_total": 25965,
    "numero_home": 11531,
    "sme_home": 25966,
    "numero_dona": 9853,
    "sme_dona": 25963,
    "maxim": 26139,
    "percent_asalariat": 50.1,
    "percent_salari": 27.49,
    "comunitat": "madrid"
  },
  {
    "centil": 61,
    "numero_total": 21585,
    "sme_total": 26326,
    "numero_home": 11460,
    "sme_home": 26326,
    "numero_dona": 10125,
    "sme_dona": 26326,
    "maxim": 26509,
    "percent_asalariat": 51,
    "percent_salari": 28.17,
    "comunitat": "madrid"
  },
  {
    "centil": 62,
    "numero_total": 21459,
    "sme_total": 26697,
    "numero_home": 11460,
    "sme_home": 26696,
    "numero_dona": 9999,
    "sme_dona": 26698,
    "maxim": 26874,
    "percent_asalariat": 51.9,
    "percent_salari": 28.85,
    "comunitat": "madrid"
  },
  {
    "centil": 63,
    "numero_total": 21735,
    "sme_total": 27043,
    "numero_home": 11461,
    "sme_home": 27044,
    "numero_dona": 10274,
    "sme_dona": 27042,
    "maxim": 27221,
    "percent_asalariat": 52.8,
    "percent_salari": 29.55,
    "comunitat": "madrid"
  },
  {
    "centil": 64,
    "numero_total": 21989,
    "sme_total": 27417,
    "numero_home": 11715,
    "sme_home": 27415,
    "numero_dona": 10274,
    "sme_dona": 27419,
    "maxim": 27616,
    "percent_asalariat": 53.8,
    "percent_salari": 30.27,
    "comunitat": "madrid"
  },
  {
    "centil": 65,
    "numero_total": 22716,
    "sme_total": 27829,
    "numero_home": 11882,
    "sme_home": 27829,
    "numero_dona": 10834,
    "sme_dona": 27830,
    "maxim": 28031,
    "percent_asalariat": 54.7,
    "percent_salari": 31.03,
    "comunitat": "madrid"
  },
  {
    "centil": 66,
    "numero_total": 22989,
    "sme_total": 28249,
    "numero_home": 11709,
    "sme_home": 28250,
    "numero_dona": 11280,
    "sme_dona": 28249,
    "maxim": 28476,
    "percent_asalariat": 55.7,
    "percent_salari": 31.8,
    "comunitat": "madrid"
  },
  {
    "centil": 67,
    "numero_total": 22833,
    "sme_total": 28710,
    "numero_home": 12084,
    "sme_home": 28709,
    "numero_dona": 10749,
    "sme_dona": 28711,
    "maxim": 28951,
    "percent_asalariat": 56.6,
    "percent_salari": 32.58,
    "comunitat": "madrid"
  },
  {
    "centil": 68,
    "numero_total": 23695,
    "sme_total": 29199,
    "numero_home": 12445,
    "sme_home": 29199,
    "numero_dona": 11250,
    "sme_dona": 29200,
    "maxim": 29450,
    "percent_asalariat": 57.6,
    "percent_salari": 33.41,
    "comunitat": "madrid"
  },
  {
    "centil": 69,
    "numero_total": 23630,
    "sme_total": 29705,
    "numero_home": 12449,
    "sme_home": 29707,
    "numero_dona": 11181,
    "sme_dona": 29703,
    "maxim": 29970,
    "percent_asalariat": 58.6,
    "percent_salari": 34.25,
    "comunitat": "madrid"
  },
  {
    "centil": 70,
    "numero_total": 24883,
    "sme_total": 30213,
    "numero_home": 13109,
    "sme_home": 30211,
    "numero_dona": 11774,
    "sme_dona": 30214,
    "maxim": 30487,
    "percent_asalariat": 59.7,
    "percent_salari": 35.14,
    "comunitat": "madrid"
  },
  {
    "centil": 71,
    "numero_total": 24390,
    "sme_total": 30764,
    "numero_home": 12703,
    "sme_home": 30763,
    "numero_dona": 11687,
    "sme_dona": 30764,
    "maxim": 31037,
    "percent_asalariat": 60.7,
    "percent_salari": 36.04,
    "comunitat": "madrid"
  },
  {
    "centil": 72,
    "numero_total": 25159,
    "sme_total": 31321,
    "numero_home": 12880,
    "sme_home": 31320,
    "numero_dona": 12279,
    "sme_dona": 31321,
    "maxim": 31602,
    "percent_asalariat": 61.8,
    "percent_salari": 36.98,
    "comunitat": "madrid"
  },
  {
    "centil": 73,
    "numero_total": 25473,
    "sme_total": 31894,
    "numero_home": 12803,
    "sme_home": 31895,
    "numero_dona": 12670,
    "sme_dona": 31894,
    "maxim": 32176,
    "percent_asalariat": 62.8,
    "percent_salari": 37.95,
    "comunitat": "madrid"
  },
  {
    "centil": 74,
    "numero_total": 25723,
    "sme_total": 32477,
    "numero_home": 12777,
    "sme_home": 32478,
    "numero_dona": 12946,
    "sme_dona": 32476,
    "maxim": 32786,
    "percent_asalariat": 63.9,
    "percent_salari": 38.94,
    "comunitat": "madrid"
  },
  {
    "centil": 75,
    "numero_total": 25644,
    "sme_total": 33097,
    "numero_home": 12825,
    "sme_home": 33096,
    "numero_dona": 12819,
    "sme_dona": 33097,
    "maxim": 33413,
    "percent_asalariat": 65,
    "percent_salari": 39.96,
    "comunitat": "madrid"
  },
  {
    "centil": 76,
    "numero_total": 25947,
    "sme_total": 33740,
    "numero_home": 12675,
    "sme_home": 33738,
    "numero_dona": 13272,
    "sme_dona": 33742,
    "maxim": 34056,
    "percent_asalariat": 66.1,
    "percent_salari": 41,
    "comunitat": "madrid"
  },
  {
    "centil": 77,
    "numero_total": 25542,
    "sme_total": 34391,
    "numero_home": 12394,
    "sme_home": 34393,
    "numero_dona": 13148,
    "sme_dona": 34389,
    "maxim": 34722,
    "percent_asalariat": 67.2,
    "percent_salari": 42.05,
    "comunitat": "madrid"
  },
  {
    "centil": 78,
    "numero_total": 25123,
    "sme_total": 35048,
    "numero_home": 12732,
    "sme_home": 35049,
    "numero_dona": 12391,
    "sme_dona": 35047,
    "maxim": 35374,
    "percent_asalariat": 68.2,
    "percent_salari": 43.1,
    "comunitat": "madrid"
  },
  {
    "centil": 79,
    "numero_total": 25078,
    "sme_total": 35708,
    "numero_home": 12465,
    "sme_home": 35709,
    "numero_dona": 12613,
    "sme_dona": 35706,
    "maxim": 36027,
    "percent_asalariat": 69.3,
    "percent_salari": 44.17,
    "comunitat": "madrid"
  },
  {
    "centil": 80,
    "numero_total": 25221,
    "sme_total": 36375,
    "numero_home": 12756,
    "sme_home": 36374,
    "numero_dona": 12465,
    "sme_dona": 36376,
    "maxim": 36730,
    "percent_asalariat": 70.3,
    "percent_salari": 45.26,
    "comunitat": "madrid"
  },
  {
    "centil": 81,
    "numero_total": 26680,
    "sme_total": 37109,
    "numero_home": 13743,
    "sme_home": 37114,
    "numero_dona": 12937,
    "sme_dona": 37104,
    "maxim": 37490,
    "percent_asalariat": 71.4,
    "percent_salari": 46.45,
    "comunitat": "madrid"
  },
  {
    "centil": 82,
    "numero_total": 26645,
    "sme_total": 37891,
    "numero_home": 14153,
    "sme_home": 37889,
    "numero_dona": 12492,
    "sme_dona": 37894,
    "maxim": 38304,
    "percent_asalariat": 72.6,
    "percent_salari": 47.65,
    "comunitat": "madrid"
  },
  {
    "centil": 83,
    "numero_total": 27135,
    "sme_total": 38748,
    "numero_home": 14497,
    "sme_home": 38749,
    "numero_dona": 12638,
    "sme_dona": 38746,
    "maxim": 39197,
    "percent_asalariat": 73.7,
    "percent_salari": 48.9,
    "comunitat": "madrid"
  },
  {
    "centil": 84,
    "numero_total": 28211,
    "sme_total": 39671,
    "numero_home": 15572,
    "sme_home": 39673,
    "numero_dona": 12639,
    "sme_dona": 39668,
    "maxim": 40137,
    "percent_asalariat": 74.9,
    "percent_salari": 50.24,
    "comunitat": "madrid"
  },
  {
    "centil": 85,
    "numero_total": 27951,
    "sme_total": 40650,
    "numero_home": 15227,
    "sme_home": 40652,
    "numero_dona": 12724,
    "sme_dona": 40648,
    "maxim": 41170,
    "percent_asalariat": 76.1,
    "percent_salari": 51.6,
    "comunitat": "madrid"
  },
  {
    "centil": 86,
    "numero_total": 28515,
    "sme_total": 41736,
    "numero_home": 15919,
    "sme_home": 41740,
    "numero_dona": 12596,
    "sme_dona": 41731,
    "maxim": 42306,
    "percent_asalariat": 77.3,
    "percent_salari": 53.02,
    "comunitat": "madrid"
  },
  {
    "centil": 87,
    "numero_total": 29114,
    "sme_total": 42911,
    "numero_home": 16653,
    "sme_home": 42914,
    "numero_dona": 12461,
    "sme_dona": 42908,
    "maxim": 43519,
    "percent_asalariat": 78.5,
    "percent_salari": 54.51,
    "comunitat": "madrid"
  },
  {
    "centil": 88,
    "numero_total": 30283,
    "sme_total": 44183,
    "numero_home": 17150,
    "sme_home": 44182,
    "numero_dona": 13133,
    "sme_dona": 44184,
    "maxim": 44857,
    "percent_asalariat": 79.8,
    "percent_salari": 56.1,
    "comunitat": "madrid"
  },
  {
    "centil": 89,
    "numero_total": 32159,
    "sme_total": 45571,
    "numero_home": 18834,
    "sme_home": 45571,
    "numero_dona": 13325,
    "sme_dona": 45570,
    "maxim": 46326,
    "percent_asalariat": 81.1,
    "percent_salari": 57.85,
    "comunitat": "madrid"
  },
  {
    "centil": 90,
    "numero_total": 32508,
    "sme_total": 47156,
    "numero_home": 18980,
    "sme_home": 47156,
    "numero_dona": 13528,
    "sme_dona": 47155,
    "maxim": 48005,
    "percent_asalariat": 82.5,
    "percent_salari": 59.68,
    "comunitat": "madrid"
  },
  {
    "centil": 91,
    "numero_total": 33730,
    "sme_total": 48936,
    "numero_home": 19551,
    "sme_home": 48934,
    "numero_dona": 14179,
    "sme_dona": 48939,
    "maxim": 49888,
    "percent_asalariat": 83.9,
    "percent_salari": 61.65,
    "comunitat": "madrid"
  },
  {
    "centil": 92,
    "numero_total": 35351,
    "sme_total": 50942,
    "numero_home": 20655,
    "sme_home": 50942,
    "numero_dona": 14696,
    "sme_dona": 50942,
    "maxim": 52064,
    "percent_asalariat": 85.4,
    "percent_salari": 63.8,
    "comunitat": "madrid"
  },
  {
    "centil": 93,
    "numero_total": 37313,
    "sme_total": 53380,
    "numero_home": 21958,
    "sme_home": 53379,
    "numero_dona": 15355,
    "sme_dona": 53381,
    "maxim": 54742,
    "percent_asalariat": 87,
    "percent_salari": 66.18,
    "comunitat": "madrid"
  },
  {
    "centil": 94,
    "numero_total": 39024,
    "sme_total": 56293,
    "numero_home": 22969,
    "sme_home": 56283,
    "numero_dona": 16055,
    "sme_dona": 56307,
    "maxim": 57976,
    "percent_asalariat": 88.6,
    "percent_salari": 68.8,
    "comunitat": "madrid"
  },
  {
    "centil": 95,
    "numero_total": 39290,
    "sme_total": 59879,
    "numero_home": 23578,
    "sme_home": 59885,
    "numero_dona": 15712,
    "sme_dona": 59871,
    "maxim": 61939,
    "percent_asalariat": 90.3,
    "percent_salari": 71.6,
    "comunitat": "madrid"
  },
  {
    "centil": 96,
    "numero_total": 40494,
    "sme_total": 64376,
    "numero_home": 24193,
    "sme_home": 64394,
    "numero_dona": 16301,
    "sme_dona": 64351,
    "maxim": 66966,
    "percent_asalariat": 92,
    "percent_salari": 74.71,
    "comunitat": "madrid"
  },
  {
    "centil": 97,
    "numero_total": 41927,
    "sme_total": 70200,
    "numero_home": 25355,
    "sme_home": 70198,
    "numero_dona": 16572,
    "sme_dona": 70204,
    "maxim": 73778,
    "percent_asalariat": 93.7,
    "percent_salari": 78.23,
    "comunitat": "madrid"
  },
  {
    "centil": 98,
    "numero_total": 43132,
    "sme_total": 78459,
    "numero_home": 26158,
    "sme_home": 78494,
    "numero_dona": 16974,
    "sme_dona": 78406,
    "maxim": 83931,
    "percent_asalariat": 95.5,
    "percent_salari": 82.26,
    "comunitat": "madrid"
  },
  {
    "centil": 99,
    "numero_total": 44668,
    "sme_total": 92639,
    "numero_home": 28742,
    "sme_home": 92757,
    "numero_dona": 15926,
    "sme_dona": 92426,
    "maxim": 104199,
    "percent_asalariat": 97.4,
    "percent_salari": 87.2,
    "comunitat": "madrid"
  },
  {
    "centil": 100,
    "numero_total": 61525,
    "sme_total": 174327,
    "numero_home": 44741,
    "sme_home": 179412,
    "numero_dona": 16784,
    "sme_dona": 160774,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "madrid"
  },
  {
    "centil": 1,
    "numero_total": 8451,
    "sme_total": 14048,
    "numero_home": 3998,
    "sme_home": 14047,
    "numero_dona": 4453,
    "sme_dona": 14049,
    "maxim": 14139,
    "percent_asalariat": 1.9,
    "percent_salari": 1.05,
    "comunitat": "murcia"
  },
  {
    "centil": 2,
    "numero_total": 6070,
    "sme_total": 14218,
    "numero_home": 2886,
    "sme_home": 14218,
    "numero_dona": 3184,
    "sme_dona": 14218,
    "maxim": 14300,
    "percent_asalariat": 3.3,
    "percent_salari": 1.82,
    "comunitat": "murcia"
  },
  {
    "centil": 3,
    "numero_total": 6032,
    "sme_total": 14378,
    "numero_home": 2855,
    "sme_home": 14379,
    "numero_dona": 3177,
    "sme_dona": 14377,
    "maxim": 14458,
    "percent_asalariat": 4.7,
    "percent_salari": 2.59,
    "comunitat": "murcia"
  },
  {
    "centil": 4,
    "numero_total": 5910,
    "sme_total": 14538,
    "numero_home": 2755,
    "sme_home": 14538,
    "numero_dona": 3155,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 6.1,
    "percent_salari": 3.35,
    "comunitat": "murcia"
  },
  {
    "centil": 5,
    "numero_total": 6009,
    "sme_total": 14697,
    "numero_home": 2901,
    "sme_home": 14695,
    "numero_dona": 3108,
    "sme_dona": 14698,
    "maxim": 14776,
    "percent_asalariat": 7.5,
    "percent_salari": 4.14,
    "comunitat": "murcia"
  },
  {
    "centil": 6,
    "numero_total": 5717,
    "sme_total": 14854,
    "numero_home": 2711,
    "sme_home": 14854,
    "numero_dona": 3006,
    "sme_dona": 14854,
    "maxim": 14934,
    "percent_asalariat": 8.8,
    "percent_salari": 4.89,
    "comunitat": "murcia"
  },
  {
    "centil": 7,
    "numero_total": 5804,
    "sme_total": 15011,
    "numero_home": 2855,
    "sme_home": 15011,
    "numero_dona": 2949,
    "sme_dona": 15011,
    "maxim": 15091,
    "percent_asalariat": 10.1,
    "percent_salari": 5.66,
    "comunitat": "murcia"
  },
  {
    "centil": 8,
    "numero_total": 5624,
    "sme_total": 15171,
    "numero_home": 2846,
    "sme_home": 15171,
    "numero_dona": 2778,
    "sme_dona": 15172,
    "maxim": 15248,
    "percent_asalariat": 11.4,
    "percent_salari": 6.42,
    "comunitat": "murcia"
  },
  {
    "centil": 9,
    "numero_total": 5623,
    "sme_total": 15327,
    "numero_home": 2927,
    "sme_home": 15328,
    "numero_dona": 2696,
    "sme_dona": 15326,
    "maxim": 15407,
    "percent_asalariat": 12.7,
    "percent_salari": 7.18,
    "comunitat": "murcia"
  },
  {
    "centil": 10,
    "numero_total": 5412,
    "sme_total": 15487,
    "numero_home": 2888,
    "sme_home": 15488,
    "numero_dona": 2524,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 14,
    "percent_salari": 7.93,
    "comunitat": "murcia"
  },
  {
    "centil": 11,
    "numero_total": 5278,
    "sme_total": 15645,
    "numero_home": 2839,
    "sme_home": 15646,
    "numero_dona": 2439,
    "sme_dona": 15645,
    "maxim": 15726,
    "percent_asalariat": 15.2,
    "percent_salari": 8.66,
    "comunitat": "murcia"
  },
  {
    "centil": 12,
    "numero_total": 5140,
    "sme_total": 15807,
    "numero_home": 2589,
    "sme_home": 15807,
    "numero_dona": 2551,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 16.4,
    "percent_salari": 9.38,
    "comunitat": "murcia"
  },
  {
    "centil": 13,
    "numero_total": 5062,
    "sme_total": 15966,
    "numero_home": 2689,
    "sme_home": 15966,
    "numero_dona": 2373,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 17.6,
    "percent_salari": 10.1,
    "comunitat": "murcia"
  },
  {
    "centil": 14,
    "numero_total": 5016,
    "sme_total": 16127,
    "numero_home": 2700,
    "sme_home": 16128,
    "numero_dona": 2316,
    "sme_dona": 16126,
    "maxim": 16207,
    "percent_asalariat": 18.7,
    "percent_salari": 10.82,
    "comunitat": "murcia"
  },
  {
    "centil": 15,
    "numero_total": 4968,
    "sme_total": 16289,
    "numero_home": 2667,
    "sme_home": 16290,
    "numero_dona": 2301,
    "sme_dona": 16288,
    "maxim": 16371,
    "percent_asalariat": 19.9,
    "percent_salari": 11.53,
    "comunitat": "murcia"
  },
  {
    "centil": 16,
    "numero_total": 5189,
    "sme_total": 16453,
    "numero_home": 2830,
    "sme_home": 16452,
    "numero_dona": 2359,
    "sme_dona": 16453,
    "maxim": 16533,
    "percent_asalariat": 21,
    "percent_salari": 12.29,
    "comunitat": "murcia"
  },
  {
    "centil": 17,
    "numero_total": 5220,
    "sme_total": 16610,
    "numero_home": 2946,
    "sme_home": 16611,
    "numero_dona": 2274,
    "sme_dona": 16609,
    "maxim": 16692,
    "percent_asalariat": 22.3,
    "percent_salari": 13.06,
    "comunitat": "murcia"
  },
  {
    "centil": 18,
    "numero_total": 5417,
    "sme_total": 16774,
    "numero_home": 3066,
    "sme_home": 16774,
    "numero_dona": 2351,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 23.5,
    "percent_salari": 13.87,
    "comunitat": "murcia"
  },
  {
    "centil": 19,
    "numero_total": 5769,
    "sme_total": 16939,
    "numero_home": 3405,
    "sme_home": 16940,
    "numero_dona": 2364,
    "sme_dona": 16938,
    "maxim": 17023,
    "percent_asalariat": 24.8,
    "percent_salari": 14.74,
    "comunitat": "murcia"
  },
  {
    "centil": 20,
    "numero_total": 4810,
    "sme_total": 17109,
    "numero_home": 2884,
    "sme_home": 17108,
    "numero_dona": 1926,
    "sme_dona": 17110,
    "maxim": 17196,
    "percent_asalariat": 25.9,
    "percent_salari": 15.47,
    "comunitat": "murcia"
  },
  {
    "centil": 21,
    "numero_total": 4727,
    "sme_total": 17281,
    "numero_home": 2793,
    "sme_home": 17281,
    "numero_dona": 1934,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 27,
    "percent_salari": 16.19,
    "comunitat": "murcia"
  },
  {
    "centil": 22,
    "numero_total": 4732,
    "sme_total": 17457,
    "numero_home": 2910,
    "sme_home": 17457,
    "numero_dona": 1822,
    "sme_dona": 17456,
    "maxim": 17543,
    "percent_asalariat": 28.1,
    "percent_salari": 16.92,
    "comunitat": "murcia"
  },
  {
    "centil": 23,
    "numero_total": 4807,
    "sme_total": 17631,
    "numero_home": 2994,
    "sme_home": 17632,
    "numero_dona": 1813,
    "sme_dona": 17630,
    "maxim": 17718,
    "percent_asalariat": 29.2,
    "percent_salari": 17.68,
    "comunitat": "murcia"
  },
  {
    "centil": 24,
    "numero_total": 5001,
    "sme_total": 17804,
    "numero_home": 2980,
    "sme_home": 17805,
    "numero_dona": 2021,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 30.4,
    "percent_salari": 18.47,
    "comunitat": "murcia"
  },
  {
    "centil": 25,
    "numero_total": 5304,
    "sme_total": 17976,
    "numero_home": 3343,
    "sme_home": 17976,
    "numero_dona": 1961,
    "sme_dona": 17976,
    "maxim": 18060,
    "percent_asalariat": 31.6,
    "percent_salari": 19.31,
    "comunitat": "murcia"
  },
  {
    "centil": 26,
    "numero_total": 5839,
    "sme_total": 18150,
    "numero_home": 4039,
    "sme_home": 18151,
    "numero_dona": 1800,
    "sme_dona": 18148,
    "maxim": 18239,
    "percent_asalariat": 32.9,
    "percent_salari": 20.25,
    "comunitat": "murcia"
  },
  {
    "centil": 27,
    "numero_total": 5171,
    "sme_total": 18330,
    "numero_home": 3442,
    "sme_home": 18332,
    "numero_dona": 1729,
    "sme_dona": 18327,
    "maxim": 18417,
    "percent_asalariat": 34.1,
    "percent_salari": 21.09,
    "comunitat": "murcia"
  },
  {
    "centil": 28,
    "numero_total": 4939,
    "sme_total": 18504,
    "numero_home": 3270,
    "sme_home": 18504,
    "numero_dona": 1669,
    "sme_dona": 18503,
    "maxim": 18596,
    "percent_asalariat": 35.3,
    "percent_salari": 21.9,
    "comunitat": "murcia"
  },
  {
    "centil": 29,
    "numero_total": 5145,
    "sme_total": 18686,
    "numero_home": 3593,
    "sme_home": 18685,
    "numero_dona": 1552,
    "sme_dona": 18686,
    "maxim": 18778,
    "percent_asalariat": 36.5,
    "percent_salari": 22.76,
    "comunitat": "murcia"
  },
  {
    "centil": 30,
    "numero_total": 5554,
    "sme_total": 18869,
    "numero_home": 4000,
    "sme_home": 18870,
    "numero_dona": 1554,
    "sme_dona": 18866,
    "maxim": 18953,
    "percent_asalariat": 37.7,
    "percent_salari": 23.69,
    "comunitat": "murcia"
  },
  {
    "centil": 31,
    "numero_total": 4857,
    "sme_total": 19042,
    "numero_home": 3390,
    "sme_home": 19042,
    "numero_dona": 1467,
    "sme_dona": 19041,
    "maxim": 19133,
    "percent_asalariat": 38.9,
    "percent_salari": 24.51,
    "comunitat": "murcia"
  },
  {
    "centil": 32,
    "numero_total": 4954,
    "sme_total": 19222,
    "numero_home": 3480,
    "sme_home": 19223,
    "numero_dona": 1474,
    "sme_dona": 19222,
    "maxim": 19317,
    "percent_asalariat": 40,
    "percent_salari": 25.35,
    "comunitat": "murcia"
  },
  {
    "centil": 33,
    "numero_total": 4914,
    "sme_total": 19411,
    "numero_home": 3546,
    "sme_home": 19411,
    "numero_dona": 1368,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 41.1,
    "percent_salari": 26.2,
    "comunitat": "murcia"
  },
  {
    "centil": 34,
    "numero_total": 5096,
    "sme_total": 19600,
    "numero_home": 3735,
    "sme_home": 19600,
    "numero_dona": 1361,
    "sme_dona": 19598,
    "maxim": 19691,
    "percent_asalariat": 42.3,
    "percent_salari": 27.09,
    "comunitat": "murcia"
  },
  {
    "centil": 35,
    "numero_total": 4817,
    "sme_total": 19785,
    "numero_home": 3480,
    "sme_home": 19784,
    "numero_dona": 1337,
    "sme_dona": 19786,
    "maxim": 19879,
    "percent_asalariat": 43.4,
    "percent_salari": 27.93,
    "comunitat": "murcia"
  },
  {
    "centil": 36,
    "numero_total": 4950,
    "sme_total": 19973,
    "numero_home": 3609,
    "sme_home": 19972,
    "numero_dona": 1341,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 44.6,
    "percent_salari": 28.81,
    "comunitat": "murcia"
  },
  {
    "centil": 37,
    "numero_total": 4561,
    "sme_total": 20167,
    "numero_home": 3338,
    "sme_home": 20167,
    "numero_dona": 1223,
    "sme_dona": 20166,
    "maxim": 20263,
    "percent_asalariat": 45.6,
    "percent_salari": 29.63,
    "comunitat": "murcia"
  },
  {
    "centil": 38,
    "numero_total": 4873,
    "sme_total": 20360,
    "numero_home": 3601,
    "sme_home": 20360,
    "numero_dona": 1272,
    "sme_dona": 20359,
    "maxim": 20459,
    "percent_asalariat": 46.7,
    "percent_salari": 30.51,
    "comunitat": "murcia"
  },
  {
    "centil": 39,
    "numero_total": 4901,
    "sme_total": 20557,
    "numero_home": 3605,
    "sme_home": 20557,
    "numero_dona": 1296,
    "sme_dona": 20555,
    "maxim": 20653,
    "percent_asalariat": 47.9,
    "percent_salari": 31.4,
    "comunitat": "murcia"
  },
  {
    "centil": 40,
    "numero_total": 4942,
    "sme_total": 20755,
    "numero_home": 3656,
    "sme_home": 20755,
    "numero_dona": 1286,
    "sme_dona": 20754,
    "maxim": 20854,
    "percent_asalariat": 49,
    "percent_salari": 32.31,
    "comunitat": "murcia"
  },
  {
    "centil": 41,
    "numero_total": 5147,
    "sme_total": 20954,
    "numero_home": 3795,
    "sme_home": 20953,
    "numero_dona": 1352,
    "sme_dona": 20958,
    "maxim": 21055,
    "percent_asalariat": 50.2,
    "percent_salari": 33.27,
    "comunitat": "murcia"
  },
  {
    "centil": 42,
    "numero_total": 4922,
    "sme_total": 21161,
    "numero_home": 3621,
    "sme_home": 21160,
    "numero_dona": 1301,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 51.3,
    "percent_salari": 34.19,
    "comunitat": "murcia"
  },
  {
    "centil": 43,
    "numero_total": 5011,
    "sme_total": 21373,
    "numero_home": 3729,
    "sme_home": 21374,
    "numero_dona": 1282,
    "sme_dona": 21373,
    "maxim": 21483,
    "percent_asalariat": 52.5,
    "percent_salari": 35.14,
    "comunitat": "murcia"
  },
  {
    "centil": 44,
    "numero_total": 4493,
    "sme_total": 21591,
    "numero_home": 3180,
    "sme_home": 21590,
    "numero_dona": 1313,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 53.5,
    "percent_salari": 36,
    "comunitat": "murcia"
  },
  {
    "centil": 45,
    "numero_total": 4195,
    "sme_total": 21814,
    "numero_home": 2902,
    "sme_home": 21814,
    "numero_dona": 1293,
    "sme_dona": 21813,
    "maxim": 21927,
    "percent_asalariat": 54.5,
    "percent_salari": 36.82,
    "comunitat": "murcia"
  },
  {
    "centil": 46,
    "numero_total": 4174,
    "sme_total": 22038,
    "numero_home": 2901,
    "sme_home": 22038,
    "numero_dona": 1273,
    "sme_dona": 22038,
    "maxim": 22151,
    "percent_asalariat": 55.5,
    "percent_salari": 37.63,
    "comunitat": "murcia"
  },
  {
    "centil": 47,
    "numero_total": 4174,
    "sme_total": 22265,
    "numero_home": 2854,
    "sme_home": 22264,
    "numero_dona": 1320,
    "sme_dona": 22268,
    "maxim": 22380,
    "percent_asalariat": 56.4,
    "percent_salari": 38.46,
    "comunitat": "murcia"
  },
  {
    "centil": 48,
    "numero_total": 4030,
    "sme_total": 22496,
    "numero_home": 2640,
    "sme_home": 22494,
    "numero_dona": 1390,
    "sme_dona": 22500,
    "maxim": 22616,
    "percent_asalariat": 57.3,
    "percent_salari": 39.26,
    "comunitat": "murcia"
  },
  {
    "centil": 49,
    "numero_total": 4077,
    "sme_total": 22740,
    "numero_home": 2684,
    "sme_home": 22740,
    "numero_dona": 1393,
    "sme_dona": 22740,
    "maxim": 22865,
    "percent_asalariat": 58.3,
    "percent_salari": 40.08,
    "comunitat": "murcia"
  },
  {
    "centil": 50,
    "numero_total": 3897,
    "sme_total": 22989,
    "numero_home": 2502,
    "sme_home": 22989,
    "numero_dona": 1395,
    "sme_dona": 22989,
    "maxim": 23114,
    "percent_asalariat": 59.2,
    "percent_salari": 40.88,
    "comunitat": "murcia"
  },
  {
    "centil": 51,
    "numero_total": 3910,
    "sme_total": 23244,
    "numero_home": 2521,
    "sme_home": 23245,
    "numero_dona": 1389,
    "sme_dona": 23241,
    "maxim": 23377,
    "percent_asalariat": 60.1,
    "percent_salari": 41.69,
    "comunitat": "murcia"
  },
  {
    "centil": 52,
    "numero_total": 3914,
    "sme_total": 23510,
    "numero_home": 2474,
    "sme_home": 23510,
    "numero_dona": 1440,
    "sme_dona": 23510,
    "maxim": 23645,
    "percent_asalariat": 61,
    "percent_salari": 42.5,
    "comunitat": "murcia"
  },
  {
    "centil": 53,
    "numero_total": 4013,
    "sme_total": 23781,
    "numero_home": 2596,
    "sme_home": 23782,
    "numero_dona": 1417,
    "sme_dona": 23781,
    "maxim": 23925,
    "percent_asalariat": 61.9,
    "percent_salari": 43.35,
    "comunitat": "murcia"
  },
  {
    "centil": 54,
    "numero_total": 3945,
    "sme_total": 24057,
    "numero_home": 2493,
    "sme_home": 24055,
    "numero_dona": 1452,
    "sme_dona": 24061,
    "maxim": 24198,
    "percent_asalariat": 62.8,
    "percent_salari": 44.19,
    "comunitat": "murcia"
  },
  {
    "centil": 55,
    "numero_total": 4005,
    "sme_total": 24351,
    "numero_home": 2520,
    "sme_home": 24349,
    "numero_dona": 1485,
    "sme_dona": 24355,
    "maxim": 24501,
    "percent_asalariat": 63.7,
    "percent_salari": 45.06,
    "comunitat": "murcia"
  },
  {
    "centil": 56,
    "numero_total": 3998,
    "sme_total": 24654,
    "numero_home": 2484,
    "sme_home": 24655,
    "numero_dona": 1514,
    "sme_dona": 24654,
    "maxim": 24811,
    "percent_asalariat": 64.7,
    "percent_salari": 45.93,
    "comunitat": "murcia"
  },
  {
    "centil": 57,
    "numero_total": 3961,
    "sme_total": 24968,
    "numero_home": 2498,
    "sme_home": 24970,
    "numero_dona": 1463,
    "sme_dona": 24964,
    "maxim": 25122,
    "percent_asalariat": 65.6,
    "percent_salari": 46.81,
    "comunitat": "murcia"
  },
  {
    "centil": 58,
    "numero_total": 3903,
    "sme_total": 25285,
    "numero_home": 2466,
    "sme_home": 25283,
    "numero_dona": 1437,
    "sme_dona": 25289,
    "maxim": 25450,
    "percent_asalariat": 66.5,
    "percent_salari": 47.68,
    "comunitat": "murcia"
  },
  {
    "centil": 59,
    "numero_total": 3861,
    "sme_total": 25621,
    "numero_home": 2384,
    "sme_home": 25620,
    "numero_dona": 1477,
    "sme_dona": 25622,
    "maxim": 25792,
    "percent_asalariat": 67.4,
    "percent_salari": 48.56,
    "comunitat": "murcia"
  },
  {
    "centil": 60,
    "numero_total": 3808,
    "sme_total": 25960,
    "numero_home": 2348,
    "sme_home": 25959,
    "numero_dona": 1460,
    "sme_dona": 25961,
    "maxim": 26139,
    "percent_asalariat": 68.2,
    "percent_salari": 49.44,
    "comunitat": "murcia"
  },
  {
    "centil": 61,
    "numero_total": 3944,
    "sme_total": 26324,
    "numero_home": 2453,
    "sme_home": 26324,
    "numero_dona": 1491,
    "sme_dona": 26323,
    "maxim": 26509,
    "percent_asalariat": 69.2,
    "percent_salari": 50.36,
    "comunitat": "murcia"
  },
  {
    "centil": 62,
    "numero_total": 4277,
    "sme_total": 26704,
    "numero_home": 2511,
    "sme_home": 26698,
    "numero_dona": 1766,
    "sme_dona": 26712,
    "maxim": 26874,
    "percent_asalariat": 70.1,
    "percent_salari": 51.37,
    "comunitat": "murcia"
  },
  {
    "centil": 63,
    "numero_total": 3979,
    "sme_total": 27038,
    "numero_home": 2379,
    "sme_home": 27041,
    "numero_dona": 1600,
    "sme_dona": 27034,
    "maxim": 27221,
    "percent_asalariat": 71.1,
    "percent_salari": 52.33,
    "comunitat": "murcia"
  },
  {
    "centil": 64,
    "numero_total": 3691,
    "sme_total": 27414,
    "numero_home": 2270,
    "sme_home": 27416,
    "numero_dona": 1421,
    "sme_dona": 27410,
    "maxim": 27616,
    "percent_asalariat": 71.9,
    "percent_salari": 53.23,
    "comunitat": "murcia"
  },
  {
    "centil": 65,
    "numero_total": 3878,
    "sme_total": 27824,
    "numero_home": 2431,
    "sme_home": 27823,
    "numero_dona": 1447,
    "sme_dona": 27827,
    "maxim": 28031,
    "percent_asalariat": 72.8,
    "percent_salari": 54.19,
    "comunitat": "murcia"
  },
  {
    "centil": 66,
    "numero_total": 4060,
    "sme_total": 28252,
    "numero_home": 2478,
    "sme_home": 28252,
    "numero_dona": 1582,
    "sme_dona": 28252,
    "maxim": 28476,
    "percent_asalariat": 73.7,
    "percent_salari": 55.2,
    "comunitat": "murcia"
  },
  {
    "centil": 67,
    "numero_total": 3885,
    "sme_total": 28709,
    "numero_home": 2443,
    "sme_home": 28710,
    "numero_dona": 1442,
    "sme_dona": 28709,
    "maxim": 28951,
    "percent_asalariat": 74.6,
    "percent_salari": 56.19,
    "comunitat": "murcia"
  },
  {
    "centil": 68,
    "numero_total": 3844,
    "sme_total": 29198,
    "numero_home": 2448,
    "sme_home": 29200,
    "numero_dona": 1396,
    "sme_dona": 29195,
    "maxim": 29450,
    "percent_asalariat": 75.5,
    "percent_salari": 57.19,
    "comunitat": "murcia"
  },
  {
    "centil": 69,
    "numero_total": 3762,
    "sme_total": 29709,
    "numero_home": 2364,
    "sme_home": 29710,
    "numero_dona": 1398,
    "sme_dona": 29708,
    "maxim": 29970,
    "percent_asalariat": 76.4,
    "percent_salari": 58.18,
    "comunitat": "murcia"
  },
  {
    "centil": 70,
    "numero_total": 3730,
    "sme_total": 30215,
    "numero_home": 2353,
    "sme_home": 30213,
    "numero_dona": 1377,
    "sme_dona": 30219,
    "maxim": 30487,
    "percent_asalariat": 77.2,
    "percent_salari": 59.18,
    "comunitat": "murcia"
  },
  {
    "centil": 71,
    "numero_total": 3820,
    "sme_total": 30764,
    "numero_home": 2336,
    "sme_home": 30760,
    "numero_dona": 1484,
    "sme_dona": 30770,
    "maxim": 31037,
    "percent_asalariat": 78.1,
    "percent_salari": 60.22,
    "comunitat": "murcia"
  },
  {
    "centil": 72,
    "numero_total": 3660,
    "sme_total": 31310,
    "numero_home": 2240,
    "sme_home": 31309,
    "numero_dona": 1420,
    "sme_dona": 31313,
    "maxim": 31602,
    "percent_asalariat": 79,
    "percent_salari": 61.24,
    "comunitat": "murcia"
  },
  {
    "centil": 73,
    "numero_total": 3486,
    "sme_total": 31887,
    "numero_home": 2214,
    "sme_home": 31889,
    "numero_dona": 1272,
    "sme_dona": 31884,
    "maxim": 32176,
    "percent_asalariat": 79.8,
    "percent_salari": 62.23,
    "comunitat": "murcia"
  },
  {
    "centil": 74,
    "numero_total": 3482,
    "sme_total": 32479,
    "numero_home": 2094,
    "sme_home": 32478,
    "numero_dona": 1388,
    "sme_dona": 32480,
    "maxim": 32786,
    "percent_asalariat": 80.6,
    "percent_salari": 63.23,
    "comunitat": "murcia"
  },
  {
    "centil": 75,
    "numero_total": 3553,
    "sme_total": 33102,
    "numero_home": 2031,
    "sme_home": 33102,
    "numero_dona": 1522,
    "sme_dona": 33103,
    "maxim": 33413,
    "percent_asalariat": 81.4,
    "percent_salari": 64.27,
    "comunitat": "murcia"
  },
  {
    "centil": 76,
    "numero_total": 4001,
    "sme_total": 33735,
    "numero_home": 2074,
    "sme_home": 33735,
    "numero_dona": 1927,
    "sme_dona": 33735,
    "maxim": 34056,
    "percent_asalariat": 82.3,
    "percent_salari": 65.47,
    "comunitat": "murcia"
  },
  {
    "centil": 77,
    "numero_total": 3804,
    "sme_total": 34377,
    "numero_home": 2074,
    "sme_home": 34385,
    "numero_dona": 1730,
    "sme_dona": 34367,
    "maxim": 34722,
    "percent_asalariat": 83.2,
    "percent_salari": 66.63,
    "comunitat": "murcia"
  },
  {
    "centil": 78,
    "numero_total": 3294,
    "sme_total": 35048,
    "numero_home": 1998,
    "sme_home": 35050,
    "numero_dona": 1296,
    "sme_dona": 35046,
    "maxim": 35374,
    "percent_asalariat": 84,
    "percent_salari": 67.66,
    "comunitat": "murcia"
  },
  {
    "centil": 79,
    "numero_total": 3232,
    "sme_total": 35703,
    "numero_home": 1836,
    "sme_home": 35702,
    "numero_dona": 1396,
    "sme_dona": 35706,
    "maxim": 36027,
    "percent_asalariat": 84.7,
    "percent_salari": 68.68,
    "comunitat": "murcia"
  },
  {
    "centil": 80,
    "numero_total": 3326,
    "sme_total": 36373,
    "numero_home": 1815,
    "sme_home": 36374,
    "numero_dona": 1511,
    "sme_dona": 36373,
    "maxim": 36730,
    "percent_asalariat": 85.5,
    "percent_salari": 69.76,
    "comunitat": "murcia"
  },
  {
    "centil": 81,
    "numero_total": 3466,
    "sme_total": 37109,
    "numero_home": 1872,
    "sme_home": 37114,
    "numero_dona": 1594,
    "sme_dona": 37103,
    "maxim": 37490,
    "percent_asalariat": 86.3,
    "percent_salari": 70.9,
    "comunitat": "murcia"
  },
  {
    "centil": 82,
    "numero_total": 3353,
    "sme_total": 37896,
    "numero_home": 1841,
    "sme_home": 37898,
    "numero_dona": 1512,
    "sme_dona": 37894,
    "maxim": 38304,
    "percent_asalariat": 87,
    "percent_salari": 72.02,
    "comunitat": "murcia"
  },
  {
    "centil": 83,
    "numero_total": 3657,
    "sme_total": 38739,
    "numero_home": 1920,
    "sme_home": 38742,
    "numero_dona": 1737,
    "sme_dona": 38736,
    "maxim": 39197,
    "percent_asalariat": 87.9,
    "percent_salari": 73.28,
    "comunitat": "murcia"
  },
  {
    "centil": 84,
    "numero_total": 3190,
    "sme_total": 39665,
    "numero_home": 1810,
    "sme_home": 39667,
    "numero_dona": 1380,
    "sme_dona": 39662,
    "maxim": 40137,
    "percent_asalariat": 88.6,
    "percent_salari": 74.4,
    "comunitat": "murcia"
  },
  {
    "centil": 85,
    "numero_total": 3100,
    "sme_total": 40647,
    "numero_home": 1742,
    "sme_home": 40649,
    "numero_dona": 1358,
    "sme_dona": 40644,
    "maxim": 41170,
    "percent_asalariat": 89.3,
    "percent_salari": 75.52,
    "comunitat": "murcia"
  },
  {
    "centil": 86,
    "numero_total": 3474,
    "sme_total": 41735,
    "numero_home": 1882,
    "sme_home": 41729,
    "numero_dona": 1592,
    "sme_dona": 41742,
    "maxim": 42306,
    "percent_asalariat": 90.1,
    "percent_salari": 76.81,
    "comunitat": "murcia"
  },
  {
    "centil": 87,
    "numero_total": 3334,
    "sme_total": 42901,
    "numero_home": 1890,
    "sme_home": 42906,
    "numero_dona": 1444,
    "sme_dona": 42893,
    "maxim": 43519,
    "percent_asalariat": 90.9,
    "percent_salari": 78.08,
    "comunitat": "murcia"
  },
  {
    "centil": 88,
    "numero_total": 3280,
    "sme_total": 44169,
    "numero_home": 1896,
    "sme_home": 44186,
    "numero_dona": 1384,
    "sme_dona": 44146,
    "maxim": 44857,
    "percent_asalariat": 91.7,
    "percent_salari": 79.36,
    "comunitat": "murcia"
  },
  {
    "centil": 89,
    "numero_total": 3127,
    "sme_total": 45573,
    "numero_home": 1864,
    "sme_home": 45580,
    "numero_dona": 1263,
    "sme_dona": 45561,
    "maxim": 46326,
    "percent_asalariat": 92.4,
    "percent_salari": 80.63,
    "comunitat": "murcia"
  },
  {
    "centil": 90,
    "numero_total": 3025,
    "sme_total": 47161,
    "numero_home": 1738,
    "sme_home": 47175,
    "numero_dona": 1287,
    "sme_dona": 47142,
    "maxim": 48005,
    "percent_asalariat": 93.1,
    "percent_salari": 81.89,
    "comunitat": "murcia"
  },
  {
    "centil": 91,
    "numero_total": 3206,
    "sme_total": 48930,
    "numero_home": 1895,
    "sme_home": 48932,
    "numero_dona": 1311,
    "sme_dona": 48928,
    "maxim": 49888,
    "percent_asalariat": 93.8,
    "percent_salari": 83.29,
    "comunitat": "murcia"
  },
  {
    "centil": 92,
    "numero_total": 3488,
    "sme_total": 50934,
    "numero_home": 2089,
    "sme_home": 50930,
    "numero_dona": 1399,
    "sme_dona": 50940,
    "maxim": 52064,
    "percent_asalariat": 94.6,
    "percent_salari": 84.86,
    "comunitat": "murcia"
  },
  {
    "centil": 93,
    "numero_total": 3275,
    "sme_total": 53363,
    "numero_home": 2001,
    "sme_home": 53379,
    "numero_dona": 1274,
    "sme_dona": 53339,
    "maxim": 54742,
    "percent_asalariat": 95.4,
    "percent_salari": 86.41,
    "comunitat": "murcia"
  },
  {
    "centil": 94,
    "numero_total": 3215,
    "sme_total": 56327,
    "numero_home": 2072,
    "sme_home": 56313,
    "numero_dona": 1143,
    "sme_dona": 56353,
    "maxim": 57976,
    "percent_asalariat": 96.1,
    "percent_salari": 88.02,
    "comunitat": "murcia"
  },
  {
    "centil": 95,
    "numero_total": 3050,
    "sme_total": 59851,
    "numero_home": 1968,
    "sme_home": 59851,
    "numero_dona": 1082,
    "sme_dona": 59851,
    "maxim": 61939,
    "percent_asalariat": 96.8,
    "percent_salari": 89.64,
    "comunitat": "murcia"
  },
  {
    "centil": 96,
    "numero_total": 3012,
    "sme_total": 64310,
    "numero_home": 2018,
    "sme_home": 64327,
    "numero_dona": 994,
    "sme_dona": 64277,
    "maxim": 66966,
    "percent_asalariat": 97.5,
    "percent_salari": 91.36,
    "comunitat": "murcia"
  },
  {
    "centil": 97,
    "numero_total": 2981,
    "sme_total": 70155,
    "numero_home": 1889,
    "sme_home": 70156,
    "numero_dona": 1092,
    "sme_dona": 70153,
    "maxim": 73778,
    "percent_asalariat": 98.2,
    "percent_salari": 93.22,
    "comunitat": "murcia"
  },
  {
    "centil": 98,
    "numero_total": 2868,
    "sme_total": 78472,
    "numero_home": 1781,
    "sme_home": 78436,
    "numero_dona": 1087,
    "sme_dona": 78531,
    "maxim": 83931,
    "percent_asalariat": 98.9,
    "percent_salari": 95.21,
    "comunitat": "murcia"
  },
  {
    "centil": 99,
    "numero_total": 3069,
    "sme_total": 92347,
    "numero_home": 1968,
    "sme_home": 92457,
    "numero_dona": 1101,
    "sme_dona": 92152,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.73,
    "comunitat": "murcia"
  },
  {
    "centil": 100,
    "numero_total": 1872,
    "sme_total": 136734,
    "numero_home": 1453,
    "sme_home": 140824,
    "numero_dona": 419,
    "sme_dona": 122551,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "murcia"
  },
  {
    "centil": 1,
    "numero_total": 778,
    "sme_total": 14057,
    "numero_home": 307,
    "sme_home": 14056,
    "numero_dona": 471,
    "sme_dona": 14058,
    "maxim": 14139,
    "percent_asalariat": 0.8,
    "percent_salari": 0.44,
    "comunitat": "rioja"
  },
  {
    "centil": 2,
    "numero_total": 774,
    "sme_total": 14220,
    "numero_home": 304,
    "sme_home": 14221,
    "numero_dona": 470,
    "sme_dona": 14219,
    "maxim": 14300,
    "percent_asalariat": 1.7,
    "percent_salari": 0.89,
    "comunitat": "rioja"
  },
  {
    "centil": 3,
    "numero_total": 667,
    "sme_total": 14378,
    "numero_home": 247,
    "sme_home": 14376,
    "numero_dona": 420,
    "sme_dona": 14380,
    "maxim": 14458,
    "percent_asalariat": 2.4,
    "percent_salari": 1.27,
    "comunitat": "rioja"
  },
  {
    "centil": 4,
    "numero_total": 793,
    "sme_total": 14540,
    "numero_home": 315,
    "sme_home": 14537,
    "numero_dona": 478,
    "sme_dona": 14543,
    "maxim": 14618,
    "percent_asalariat": 3.3,
    "percent_salari": 1.74,
    "comunitat": "rioja"
  },
  {
    "centil": 5,
    "numero_total": 938,
    "sme_total": 14701,
    "numero_home": 358,
    "sme_home": 14702,
    "numero_dona": 580,
    "sme_dona": 14700,
    "maxim": 14776,
    "percent_asalariat": 4.3,
    "percent_salari": 2.29,
    "comunitat": "rioja"
  },
  {
    "centil": 6,
    "numero_total": 866,
    "sme_total": 14854,
    "numero_home": 327,
    "sme_home": 14859,
    "numero_dona": 539,
    "sme_dona": 14851,
    "maxim": 14934,
    "percent_asalariat": 5.3,
    "percent_salari": 2.81,
    "comunitat": "rioja"
  },
  {
    "centil": 7,
    "numero_total": 922,
    "sme_total": 15018,
    "numero_home": 379,
    "sme_home": 15019,
    "numero_dona": 543,
    "sme_dona": 15017,
    "maxim": 15091,
    "percent_asalariat": 6.3,
    "percent_salari": 3.37,
    "comunitat": "rioja"
  },
  {
    "centil": 8,
    "numero_total": 891,
    "sme_total": 15172,
    "numero_home": 361,
    "sme_home": 15171,
    "numero_dona": 530,
    "sme_dona": 15172,
    "maxim": 15248,
    "percent_asalariat": 7.2,
    "percent_salari": 3.92,
    "comunitat": "rioja"
  },
  {
    "centil": 9,
    "numero_total": 909,
    "sme_total": 15326,
    "numero_home": 326,
    "sme_home": 15325,
    "numero_dona": 583,
    "sme_dona": 15327,
    "maxim": 15407,
    "percent_asalariat": 8.2,
    "percent_salari": 4.48,
    "comunitat": "rioja"
  },
  {
    "centil": 10,
    "numero_total": 910,
    "sme_total": 15490,
    "numero_home": 364,
    "sme_home": 15492,
    "numero_dona": 546,
    "sme_dona": 15488,
    "maxim": 15567,
    "percent_asalariat": 9.2,
    "percent_salari": 5.05,
    "comunitat": "rioja"
  },
  {
    "centil": 11,
    "numero_total": 793,
    "sme_total": 15646,
    "numero_home": 331,
    "sme_home": 15647,
    "numero_dona": 462,
    "sme_dona": 15646,
    "maxim": 15726,
    "percent_asalariat": 10.1,
    "percent_salari": 5.55,
    "comunitat": "rioja"
  },
  {
    "centil": 12,
    "numero_total": 918,
    "sme_total": 15805,
    "numero_home": 358,
    "sme_home": 15802,
    "numero_dona": 560,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 11.1,
    "percent_salari": 6.13,
    "comunitat": "rioja"
  },
  {
    "centil": 13,
    "numero_total": 887,
    "sme_total": 15961,
    "numero_home": 333,
    "sme_home": 15961,
    "numero_dona": 554,
    "sme_dona": 15961,
    "maxim": 16046,
    "percent_asalariat": 12.1,
    "percent_salari": 6.7,
    "comunitat": "rioja"
  },
  {
    "centil": 14,
    "numero_total": 850,
    "sme_total": 16129,
    "numero_home": 305,
    "sme_home": 16129,
    "numero_dona": 545,
    "sme_dona": 16128,
    "maxim": 16207,
    "percent_asalariat": 13,
    "percent_salari": 7.26,
    "comunitat": "rioja"
  },
  {
    "centil": 15,
    "numero_total": 943,
    "sme_total": 16285,
    "numero_home": 369,
    "sme_home": 16289,
    "numero_dona": 574,
    "sme_dona": 16283,
    "maxim": 16371,
    "percent_asalariat": 14,
    "percent_salari": 7.88,
    "comunitat": "rioja"
  },
  {
    "centil": 16,
    "numero_total": 918,
    "sme_total": 16451,
    "numero_home": 371,
    "sme_home": 16450,
    "numero_dona": 547,
    "sme_dona": 16451,
    "maxim": 16533,
    "percent_asalariat": 15,
    "percent_salari": 8.48,
    "comunitat": "rioja"
  },
  {
    "centil": 17,
    "numero_total": 899,
    "sme_total": 16612,
    "numero_home": 352,
    "sme_home": 16612,
    "numero_dona": 547,
    "sme_dona": 16612,
    "maxim": 16692,
    "percent_asalariat": 16,
    "percent_salari": 9.09,
    "comunitat": "rioja"
  },
  {
    "centil": 18,
    "numero_total": 955,
    "sme_total": 16773,
    "numero_home": 405,
    "sme_home": 16772,
    "numero_dona": 550,
    "sme_dona": 16774,
    "maxim": 16855,
    "percent_asalariat": 17,
    "percent_salari": 9.73,
    "comunitat": "rioja"
  },
  {
    "centil": 19,
    "numero_total": 970,
    "sme_total": 16940,
    "numero_home": 410,
    "sme_home": 16940,
    "numero_dona": 560,
    "sme_dona": 16940,
    "maxim": 17023,
    "percent_asalariat": 18.1,
    "percent_salari": 10.4,
    "comunitat": "rioja"
  },
  {
    "centil": 20,
    "numero_total": 922,
    "sme_total": 17111,
    "numero_home": 375,
    "sme_home": 17116,
    "numero_dona": 547,
    "sme_dona": 17108,
    "maxim": 17196,
    "percent_asalariat": 19.1,
    "percent_salari": 11.03,
    "comunitat": "rioja"
  },
  {
    "centil": 21,
    "numero_total": 963,
    "sme_total": 17281,
    "numero_home": 425,
    "sme_home": 17281,
    "numero_dona": 538,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 20.1,
    "percent_salari": 11.7,
    "comunitat": "rioja"
  },
  {
    "centil": 22,
    "numero_total": 920,
    "sme_total": 17457,
    "numero_home": 429,
    "sme_home": 17460,
    "numero_dona": 491,
    "sme_dona": 17454,
    "maxim": 17543,
    "percent_asalariat": 21.2,
    "percent_salari": 12.35,
    "comunitat": "rioja"
  },
  {
    "centil": 23,
    "numero_total": 930,
    "sme_total": 17632,
    "numero_home": 405,
    "sme_home": 17630,
    "numero_dona": 525,
    "sme_dona": 17632,
    "maxim": 17718,
    "percent_asalariat": 22.2,
    "percent_salari": 13.01,
    "comunitat": "rioja"
  },
  {
    "centil": 24,
    "numero_total": 912,
    "sme_total": 17806,
    "numero_home": 420,
    "sme_home": 17809,
    "numero_dona": 492,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 23.2,
    "percent_salari": 13.67,
    "comunitat": "rioja"
  },
  {
    "centil": 25,
    "numero_total": 879,
    "sme_total": 17978,
    "numero_home": 440,
    "sme_home": 17976,
    "numero_dona": 439,
    "sme_dona": 17981,
    "maxim": 18060,
    "percent_asalariat": 24.1,
    "percent_salari": 14.31,
    "comunitat": "rioja"
  },
  {
    "centil": 26,
    "numero_total": 951,
    "sme_total": 18147,
    "numero_home": 510,
    "sme_home": 18149,
    "numero_dona": 441,
    "sme_dona": 18144,
    "maxim": 18239,
    "percent_asalariat": 25.2,
    "percent_salari": 15,
    "comunitat": "rioja"
  },
  {
    "centil": 27,
    "numero_total": 942,
    "sme_total": 18326,
    "numero_home": 497,
    "sme_home": 18327,
    "numero_dona": 445,
    "sme_dona": 18325,
    "maxim": 18417,
    "percent_asalariat": 26.2,
    "percent_salari": 15.7,
    "comunitat": "rioja"
  },
  {
    "centil": 28,
    "numero_total": 885,
    "sme_total": 18503,
    "numero_home": 481,
    "sme_home": 18503,
    "numero_dona": 404,
    "sme_dona": 18503,
    "maxim": 18596,
    "percent_asalariat": 27.2,
    "percent_salari": 16.36,
    "comunitat": "rioja"
  },
  {
    "centil": 29,
    "numero_total": 944,
    "sme_total": 18684,
    "numero_home": 510,
    "sme_home": 18688,
    "numero_dona": 434,
    "sme_dona": 18680,
    "maxim": 18778,
    "percent_asalariat": 28.2,
    "percent_salari": 17.07,
    "comunitat": "rioja"
  },
  {
    "centil": 30,
    "numero_total": 873,
    "sme_total": 18862,
    "numero_home": 489,
    "sme_home": 18862,
    "numero_dona": 384,
    "sme_dona": 18862,
    "maxim": 18953,
    "percent_asalariat": 29.1,
    "percent_salari": 17.73,
    "comunitat": "rioja"
  },
  {
    "centil": 31,
    "numero_total": 900,
    "sme_total": 19044,
    "numero_home": 500,
    "sme_home": 19047,
    "numero_dona": 400,
    "sme_dona": 19039,
    "maxim": 19133,
    "percent_asalariat": 30.1,
    "percent_salari": 18.42,
    "comunitat": "rioja"
  },
  {
    "centil": 32,
    "numero_total": 957,
    "sme_total": 19228,
    "numero_home": 552,
    "sme_home": 19228,
    "numero_dona": 405,
    "sme_dona": 19227,
    "maxim": 19317,
    "percent_asalariat": 31.2,
    "percent_salari": 19.17,
    "comunitat": "rioja"
  },
  {
    "centil": 33,
    "numero_total": 984,
    "sme_total": 19410,
    "numero_home": 569,
    "sme_home": 19409,
    "numero_dona": 415,
    "sme_dona": 19412,
    "maxim": 19503,
    "percent_asalariat": 32.2,
    "percent_salari": 19.94,
    "comunitat": "rioja"
  },
  {
    "centil": 34,
    "numero_total": 1041,
    "sme_total": 19597,
    "numero_home": 606,
    "sme_home": 19598,
    "numero_dona": 435,
    "sme_dona": 19595,
    "maxim": 19691,
    "percent_asalariat": 33.4,
    "percent_salari": 20.76,
    "comunitat": "rioja"
  },
  {
    "centil": 35,
    "numero_total": 960,
    "sme_total": 19787,
    "numero_home": 561,
    "sme_home": 19786,
    "numero_dona": 399,
    "sme_dona": 19788,
    "maxim": 19879,
    "percent_asalariat": 34.4,
    "percent_salari": 21.53,
    "comunitat": "rioja"
  },
  {
    "centil": 36,
    "numero_total": 1004,
    "sme_total": 19977,
    "numero_home": 564,
    "sme_home": 19974,
    "numero_dona": 440,
    "sme_dona": 19980,
    "maxim": 20069,
    "percent_asalariat": 35.5,
    "percent_salari": 22.34,
    "comunitat": "rioja"
  },
  {
    "centil": 37,
    "numero_total": 1099,
    "sme_total": 20168,
    "numero_home": 645,
    "sme_home": 20169,
    "numero_dona": 454,
    "sme_dona": 20167,
    "maxim": 20263,
    "percent_asalariat": 36.7,
    "percent_salari": 23.23,
    "comunitat": "rioja"
  },
  {
    "centil": 38,
    "numero_total": 1072,
    "sme_total": 20364,
    "numero_home": 678,
    "sme_home": 20365,
    "numero_dona": 394,
    "sme_dona": 20360,
    "maxim": 20459,
    "percent_asalariat": 37.9,
    "percent_salari": 24.11,
    "comunitat": "rioja"
  },
  {
    "centil": 39,
    "numero_total": 1106,
    "sme_total": 20557,
    "numero_home": 670,
    "sme_home": 20559,
    "numero_dona": 436,
    "sme_dona": 20554,
    "maxim": 20653,
    "percent_asalariat": 39.1,
    "percent_salari": 25.03,
    "comunitat": "rioja"
  },
  {
    "centil": 40,
    "numero_total": 1164,
    "sme_total": 20752,
    "numero_home": 704,
    "sme_home": 20751,
    "numero_dona": 460,
    "sme_dona": 20754,
    "maxim": 20854,
    "percent_asalariat": 40.4,
    "percent_salari": 26,
    "comunitat": "rioja"
  },
  {
    "centil": 41,
    "numero_total": 1072,
    "sme_total": 20955,
    "numero_home": 656,
    "sme_home": 20952,
    "numero_dona": 416,
    "sme_dona": 20959,
    "maxim": 21055,
    "percent_asalariat": 41.5,
    "percent_salari": 26.91,
    "comunitat": "rioja"
  },
  {
    "centil": 42,
    "numero_total": 1115,
    "sme_total": 21161,
    "numero_home": 723,
    "sme_home": 21162,
    "numero_dona": 392,
    "sme_dona": 21160,
    "maxim": 21267,
    "percent_asalariat": 42.7,
    "percent_salari": 27.86,
    "comunitat": "rioja"
  },
  {
    "centil": 43,
    "numero_total": 1081,
    "sme_total": 21378,
    "numero_home": 691,
    "sme_home": 21378,
    "numero_dona": 390,
    "sme_dona": 21378,
    "maxim": 21483,
    "percent_asalariat": 43.9,
    "percent_salari": 28.79,
    "comunitat": "rioja"
  },
  {
    "centil": 44,
    "numero_total": 1075,
    "sme_total": 21594,
    "numero_home": 643,
    "sme_home": 21595,
    "numero_dona": 432,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 45.1,
    "percent_salari": 29.73,
    "comunitat": "rioja"
  },
  {
    "centil": 45,
    "numero_total": 1103,
    "sme_total": 21813,
    "numero_home": 679,
    "sme_home": 21810,
    "numero_dona": 424,
    "sme_dona": 21817,
    "maxim": 21927,
    "percent_asalariat": 46.3,
    "percent_salari": 30.7,
    "comunitat": "rioja"
  },
  {
    "centil": 46,
    "numero_total": 1202,
    "sme_total": 22040,
    "numero_home": 783,
    "sme_home": 22042,
    "numero_dona": 419,
    "sme_dona": 22036,
    "maxim": 22151,
    "percent_asalariat": 47.6,
    "percent_salari": 31.77,
    "comunitat": "rioja"
  },
  {
    "centil": 47,
    "numero_total": 1037,
    "sme_total": 22267,
    "numero_home": 681,
    "sme_home": 22268,
    "numero_dona": 356,
    "sme_dona": 22265,
    "maxim": 22380,
    "percent_asalariat": 48.7,
    "percent_salari": 32.7,
    "comunitat": "rioja"
  },
  {
    "centil": 48,
    "numero_total": 1037,
    "sme_total": 22496,
    "numero_home": 630,
    "sme_home": 22496,
    "numero_dona": 407,
    "sme_dona": 22495,
    "maxim": 22616,
    "percent_asalariat": 49.9,
    "percent_salari": 33.64,
    "comunitat": "rioja"
  },
  {
    "centil": 49,
    "numero_total": 1040,
    "sme_total": 22740,
    "numero_home": 660,
    "sme_home": 22741,
    "numero_dona": 380,
    "sme_dona": 22738,
    "maxim": 22865,
    "percent_asalariat": 51,
    "percent_salari": 34.59,
    "comunitat": "rioja"
  },
  {
    "centil": 50,
    "numero_total": 1049,
    "sme_total": 22990,
    "numero_home": 643,
    "sme_home": 22991,
    "numero_dona": 406,
    "sme_dona": 22988,
    "maxim": 23114,
    "percent_asalariat": 52.2,
    "percent_salari": 35.57,
    "comunitat": "rioja"
  },
  {
    "centil": 51,
    "numero_total": 1089,
    "sme_total": 23246,
    "numero_home": 690,
    "sme_home": 23247,
    "numero_dona": 399,
    "sme_dona": 23243,
    "maxim": 23377,
    "percent_asalariat": 53.3,
    "percent_salari": 36.59,
    "comunitat": "rioja"
  },
  {
    "centil": 52,
    "numero_total": 1063,
    "sme_total": 23510,
    "numero_home": 687,
    "sme_home": 23508,
    "numero_dona": 376,
    "sme_dona": 23515,
    "maxim": 23645,
    "percent_asalariat": 54.5,
    "percent_salari": 37.59,
    "comunitat": "rioja"
  },
  {
    "centil": 53,
    "numero_total": 1012,
    "sme_total": 23785,
    "numero_home": 626,
    "sme_home": 23784,
    "numero_dona": 386,
    "sme_dona": 23785,
    "maxim": 23925,
    "percent_asalariat": 55.6,
    "percent_salari": 38.57,
    "comunitat": "rioja"
  },
  {
    "centil": 54,
    "numero_total": 933,
    "sme_total": 24060,
    "numero_home": 581,
    "sme_home": 24060,
    "numero_dona": 352,
    "sme_dona": 24060,
    "maxim": 24198,
    "percent_asalariat": 56.6,
    "percent_salari": 39.47,
    "comunitat": "rioja"
  },
  {
    "centil": 55,
    "numero_total": 1048,
    "sme_total": 24350,
    "numero_home": 650,
    "sme_home": 24349,
    "numero_dona": 398,
    "sme_dona": 24352,
    "maxim": 24501,
    "percent_asalariat": 57.8,
    "percent_salari": 40.5,
    "comunitat": "rioja"
  },
  {
    "centil": 56,
    "numero_total": 1082,
    "sme_total": 24655,
    "numero_home": 696,
    "sme_home": 24656,
    "numero_dona": 386,
    "sme_dona": 24653,
    "maxim": 24811,
    "percent_asalariat": 58.9,
    "percent_salari": 41.58,
    "comunitat": "rioja"
  },
  {
    "centil": 57,
    "numero_total": 1102,
    "sme_total": 24969,
    "numero_home": 698,
    "sme_home": 24969,
    "numero_dona": 404,
    "sme_dona": 24969,
    "maxim": 25122,
    "percent_asalariat": 60.2,
    "percent_salari": 42.69,
    "comunitat": "rioja"
  },
  {
    "centil": 58,
    "numero_total": 1126,
    "sme_total": 25289,
    "numero_home": 745,
    "sme_home": 25287,
    "numero_dona": 381,
    "sme_dona": 25293,
    "maxim": 25450,
    "percent_asalariat": 61.4,
    "percent_salari": 43.84,
    "comunitat": "rioja"
  },
  {
    "centil": 59,
    "numero_total": 1094,
    "sme_total": 25623,
    "numero_home": 707,
    "sme_home": 25622,
    "numero_dona": 387,
    "sme_dona": 25626,
    "maxim": 25792,
    "percent_asalariat": 62.6,
    "percent_salari": 44.97,
    "comunitat": "rioja"
  },
  {
    "centil": 60,
    "numero_total": 999,
    "sme_total": 25973,
    "numero_home": 638,
    "sme_home": 25971,
    "numero_dona": 361,
    "sme_dona": 25976,
    "maxim": 26139,
    "percent_asalariat": 63.7,
    "percent_salari": 46.01,
    "comunitat": "rioja"
  },
  {
    "centil": 61,
    "numero_total": 999,
    "sme_total": 26322,
    "numero_home": 631,
    "sme_home": 26322,
    "numero_dona": 368,
    "sme_dona": 26323,
    "maxim": 26509,
    "percent_asalariat": 64.8,
    "percent_salari": 47.07,
    "comunitat": "rioja"
  },
  {
    "centil": 62,
    "numero_total": 900,
    "sme_total": 26692,
    "numero_home": 570,
    "sme_home": 26692,
    "numero_dona": 330,
    "sme_dona": 26692,
    "maxim": 26874,
    "percent_asalariat": 65.7,
    "percent_salari": 48.04,
    "comunitat": "rioja"
  },
  {
    "centil": 63,
    "numero_total": 954,
    "sme_total": 27047,
    "numero_home": 577,
    "sme_home": 27044,
    "numero_dona": 377,
    "sme_dona": 27051,
    "maxim": 27221,
    "percent_asalariat": 66.8,
    "percent_salari": 49.08,
    "comunitat": "rioja"
  },
  {
    "centil": 64,
    "numero_total": 1114,
    "sme_total": 27412,
    "numero_home": 646,
    "sme_home": 27412,
    "numero_dona": 468,
    "sme_dona": 27413,
    "maxim": 27616,
    "percent_asalariat": 68,
    "percent_salari": 50.31,
    "comunitat": "rioja"
  },
  {
    "centil": 65,
    "numero_total": 1005,
    "sme_total": 27823,
    "numero_home": 597,
    "sme_home": 27825,
    "numero_dona": 408,
    "sme_dona": 27819,
    "maxim": 28031,
    "percent_asalariat": 69.1,
    "percent_salari": 51.44,
    "comunitat": "rioja"
  },
  {
    "centil": 66,
    "numero_total": 1018,
    "sme_total": 28247,
    "numero_home": 640,
    "sme_home": 28250,
    "numero_dona": 378,
    "sme_dona": 28242,
    "maxim": 28476,
    "percent_asalariat": 70.2,
    "percent_salari": 52.6,
    "comunitat": "rioja"
  },
  {
    "centil": 67,
    "numero_total": 1000,
    "sme_total": 28710,
    "numero_home": 635,
    "sme_home": 28713,
    "numero_dona": 365,
    "sme_dona": 28706,
    "maxim": 28951,
    "percent_asalariat": 71.3,
    "percent_salari": 53.76,
    "comunitat": "rioja"
  },
  {
    "centil": 68,
    "numero_total": 967,
    "sme_total": 29200,
    "numero_home": 648,
    "sme_home": 29199,
    "numero_dona": 319,
    "sme_dona": 29202,
    "maxim": 29450,
    "percent_asalariat": 72.3,
    "percent_salari": 54.9,
    "comunitat": "rioja"
  },
  {
    "centil": 69,
    "numero_total": 965,
    "sme_total": 29699,
    "numero_home": 620,
    "sme_home": 29697,
    "numero_dona": 345,
    "sme_dona": 29701,
    "maxim": 29970,
    "percent_asalariat": 73.4,
    "percent_salari": 56.06,
    "comunitat": "rioja"
  },
  {
    "centil": 70,
    "numero_total": 963,
    "sme_total": 30218,
    "numero_home": 588,
    "sme_home": 30219,
    "numero_dona": 375,
    "sme_dona": 30217,
    "maxim": 30487,
    "percent_asalariat": 74.4,
    "percent_salari": 57.23,
    "comunitat": "rioja"
  },
  {
    "centil": 71,
    "numero_total": 899,
    "sme_total": 30769,
    "numero_home": 532,
    "sme_home": 30769,
    "numero_dona": 367,
    "sme_dona": 30770,
    "maxim": 31037,
    "percent_asalariat": 75.4,
    "percent_salari": 58.34,
    "comunitat": "rioja"
  },
  {
    "centil": 72,
    "numero_total": 902,
    "sme_total": 31312,
    "numero_home": 532,
    "sme_home": 31312,
    "numero_dona": 370,
    "sme_dona": 31311,
    "maxim": 31602,
    "percent_asalariat": 76.4,
    "percent_salari": 59.48,
    "comunitat": "rioja"
  },
  {
    "centil": 73,
    "numero_total": 945,
    "sme_total": 31897,
    "numero_home": 525,
    "sme_home": 31886,
    "numero_dona": 420,
    "sme_dona": 31910,
    "maxim": 32176,
    "percent_asalariat": 77.4,
    "percent_salari": 60.7,
    "comunitat": "rioja"
  },
  {
    "centil": 74,
    "numero_total": 919,
    "sme_total": 32498,
    "numero_home": 501,
    "sme_home": 32487,
    "numero_dona": 418,
    "sme_dona": 32512,
    "maxim": 32786,
    "percent_asalariat": 78.4,
    "percent_salari": 61.9,
    "comunitat": "rioja"
  },
  {
    "centil": 75,
    "numero_total": 965,
    "sme_total": 33083,
    "numero_home": 521,
    "sme_home": 33088,
    "numero_dona": 444,
    "sme_dona": 33076,
    "maxim": 33413,
    "percent_asalariat": 79.5,
    "percent_salari": 63.19,
    "comunitat": "rioja"
  },
  {
    "centil": 76,
    "numero_total": 890,
    "sme_total": 33742,
    "numero_home": 503,
    "sme_home": 33745,
    "numero_dona": 387,
    "sme_dona": 33739,
    "maxim": 34056,
    "percent_asalariat": 80.5,
    "percent_salari": 64.4,
    "comunitat": "rioja"
  },
  {
    "centil": 77,
    "numero_total": 941,
    "sme_total": 34379,
    "numero_home": 513,
    "sme_home": 34380,
    "numero_dona": 428,
    "sme_dona": 34377,
    "maxim": 34722,
    "percent_asalariat": 81.5,
    "percent_salari": 65.71,
    "comunitat": "rioja"
  },
  {
    "centil": 78,
    "numero_total": 832,
    "sme_total": 35047,
    "numero_home": 469,
    "sme_home": 35049,
    "numero_dona": 363,
    "sme_dona": 35043,
    "maxim": 35374,
    "percent_asalariat": 82.4,
    "percent_salari": 66.88,
    "comunitat": "rioja"
  },
  {
    "centil": 79,
    "numero_total": 839,
    "sme_total": 35689,
    "numero_home": 488,
    "sme_home": 35683,
    "numero_dona": 351,
    "sme_dona": 35698,
    "maxim": 36027,
    "percent_asalariat": 83.3,
    "percent_salari": 68.09,
    "comunitat": "rioja"
  },
  {
    "centil": 80,
    "numero_total": 873,
    "sme_total": 36401,
    "numero_home": 453,
    "sme_home": 36397,
    "numero_dona": 420,
    "sme_dona": 36406,
    "maxim": 36730,
    "percent_asalariat": 84.3,
    "percent_salari": 69.37,
    "comunitat": "rioja"
  },
  {
    "centil": 81,
    "numero_total": 882,
    "sme_total": 37123,
    "numero_home": 477,
    "sme_home": 37126,
    "numero_dona": 405,
    "sme_dona": 37120,
    "maxim": 37490,
    "percent_asalariat": 85.2,
    "percent_salari": 70.69,
    "comunitat": "rioja"
  },
  {
    "centil": 82,
    "numero_total": 849,
    "sme_total": 37901,
    "numero_home": 458,
    "sme_home": 37896,
    "numero_dona": 391,
    "sme_dona": 37908,
    "maxim": 38304,
    "percent_asalariat": 86.2,
    "percent_salari": 71.99,
    "comunitat": "rioja"
  },
  {
    "centil": 83,
    "numero_total": 820,
    "sme_total": 38761,
    "numero_home": 467,
    "sme_home": 38757,
    "numero_dona": 353,
    "sme_dona": 38766,
    "maxim": 39197,
    "percent_asalariat": 87.1,
    "percent_salari": 73.27,
    "comunitat": "rioja"
  },
  {
    "centil": 84,
    "numero_total": 841,
    "sme_total": 39654,
    "numero_home": 469,
    "sme_home": 39649,
    "numero_dona": 372,
    "sme_dona": 39660,
    "maxim": 40137,
    "percent_asalariat": 88,
    "percent_salari": 74.62,
    "comunitat": "rioja"
  },
  {
    "centil": 85,
    "numero_total": 820,
    "sme_total": 40594,
    "numero_home": 460,
    "sme_home": 40598,
    "numero_dona": 360,
    "sme_dona": 40587,
    "maxim": 41170,
    "percent_asalariat": 88.9,
    "percent_salari": 75.96,
    "comunitat": "rioja"
  },
  {
    "centil": 86,
    "numero_total": 863,
    "sme_total": 41726,
    "numero_home": 485,
    "sme_home": 41720,
    "numero_dona": 378,
    "sme_dona": 41733,
    "maxim": 42306,
    "percent_asalariat": 89.8,
    "percent_salari": 77.41,
    "comunitat": "rioja"
  },
  {
    "centil": 87,
    "numero_total": 836,
    "sme_total": 42895,
    "numero_home": 469,
    "sme_home": 42918,
    "numero_dona": 367,
    "sme_dona": 42865,
    "maxim": 43519,
    "percent_asalariat": 90.7,
    "percent_salari": 78.86,
    "comunitat": "rioja"
  },
  {
    "centil": 88,
    "numero_total": 869,
    "sme_total": 44176,
    "numero_home": 507,
    "sme_home": 44179,
    "numero_dona": 362,
    "sme_dona": 44171,
    "maxim": 44857,
    "percent_asalariat": 91.7,
    "percent_salari": 80.41,
    "comunitat": "rioja"
  },
  {
    "centil": 89,
    "numero_total": 788,
    "sme_total": 45593,
    "numero_home": 466,
    "sme_home": 45593,
    "numero_dona": 322,
    "sme_dona": 45594,
    "maxim": 46326,
    "percent_asalariat": 92.5,
    "percent_salari": 81.86,
    "comunitat": "rioja"
  },
  {
    "centil": 90,
    "numero_total": 808,
    "sme_total": 47180,
    "numero_home": 445,
    "sme_home": 47151,
    "numero_dona": 363,
    "sme_dona": 47215,
    "maxim": 48005,
    "percent_asalariat": 93.4,
    "percent_salari": 83.4,
    "comunitat": "rioja"
  },
  {
    "centil": 91,
    "numero_total": 733,
    "sme_total": 48925,
    "numero_home": 403,
    "sme_home": 48919,
    "numero_dona": 330,
    "sme_dona": 48933,
    "maxim": 49888,
    "percent_asalariat": 94.2,
    "percent_salari": 84.84,
    "comunitat": "rioja"
  },
  {
    "centil": 92,
    "numero_total": 637,
    "sme_total": 50968,
    "numero_home": 356,
    "sme_home": 50974,
    "numero_dona": 281,
    "sme_dona": 50959,
    "maxim": 52064,
    "percent_asalariat": 94.9,
    "percent_salari": 86.15,
    "comunitat": "rioja"
  },
  {
    "centil": 93,
    "numero_total": 580,
    "sme_total": 53326,
    "numero_home": 365,
    "sme_home": 53351,
    "numero_dona": 215,
    "sme_dona": 53285,
    "maxim": 54742,
    "percent_asalariat": 95.5,
    "percent_salari": 87.4,
    "comunitat": "rioja"
  },
  {
    "centil": 94,
    "numero_total": 588,
    "sme_total": 56283,
    "numero_home": 379,
    "sme_home": 56252,
    "numero_dona": 209,
    "sme_dona": 56340,
    "maxim": 57976,
    "percent_asalariat": 96.2,
    "percent_salari": 88.74,
    "comunitat": "rioja"
  },
  {
    "centil": 95,
    "numero_total": 626,
    "sme_total": 59926,
    "numero_home": 383,
    "sme_home": 59953,
    "numero_dona": 243,
    "sme_dona": 59884,
    "maxim": 61939,
    "percent_asalariat": 96.9,
    "percent_salari": 90.25,
    "comunitat": "rioja"
  },
  {
    "centil": 96,
    "numero_total": 660,
    "sme_total": 64348,
    "numero_home": 407,
    "sme_home": 64340,
    "numero_dona": 253,
    "sme_dona": 64362,
    "maxim": 66966,
    "percent_asalariat": 97.6,
    "percent_salari": 91.96,
    "comunitat": "rioja"
  },
  {
    "centil": 97,
    "numero_total": 710,
    "sme_total": 70100,
    "numero_home": 391,
    "sme_home": 70114,
    "numero_dona": 319,
    "sme_dona": 70082,
    "maxim": 73778,
    "percent_asalariat": 98.4,
    "percent_salari": 93.97,
    "comunitat": "rioja"
  },
  {
    "centil": 98,
    "numero_total": 627,
    "sme_total": 78342,
    "numero_home": 394,
    "sme_home": 78386,
    "numero_dona": 233,
    "sme_dona": 78268,
    "maxim": 83931,
    "percent_asalariat": 99,
    "percent_salari": 95.95,
    "comunitat": "rioja"
  },
  {
    "centil": 99,
    "numero_total": 502,
    "sme_total": 92284,
    "numero_home": 346,
    "sme_home": 92772,
    "numero_dona": 156,
    "sme_dona": 91201,
    "maxim": 104199,
    "percent_asalariat": 99.6,
    "percent_salari": 97.82,
    "comunitat": "rioja"
  },
  {
    "centil": 100,
    "numero_total": 374,
    "sme_total": 144595,
    "numero_home": 296,
    "sme_home": 148276,
    "numero_dona": 78,
    "sme_dona": 130627,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "rioja"
  },
  {
    "centil": 1,
    "numero_total": 135143,
    "sme_total": 14057,
    "numero_home": 61776,
    "sme_home": 14055,
    "numero_dona": 73367,
    "sme_dona": 14059,
    "maxim": 14139,
    "percent_asalariat": 1,
    "percent_salari": 0.48,
    "comunitat": "total"
  },
  {
    "centil": 2,
    "numero_total": 135143,
    "sme_total": 14219,
    "numero_home": 59665,
    "sme_home": 14219,
    "numero_dona": 75478,
    "sme_dona": 14219,
    "maxim": 14300,
    "percent_asalariat": 2,
    "percent_salari": 0.97,
    "comunitat": "total"
  },
  {
    "centil": 3,
    "numero_total": 135143,
    "sme_total": 14379,
    "numero_home": 59614,
    "sme_home": 14379,
    "numero_dona": 75529,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 3,
    "percent_salari": 1.46,
    "comunitat": "total"
  },
  {
    "centil": 4,
    "numero_total": 135143,
    "sme_total": 14538,
    "numero_home": 58769,
    "sme_home": 14538,
    "numero_dona": 76374,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 4,
    "percent_salari": 1.96,
    "comunitat": "total"
  },
  {
    "centil": 5,
    "numero_total": 135143,
    "sme_total": 14697,
    "numero_home": 59329,
    "sme_home": 14698,
    "numero_dona": 75814,
    "sme_dona": 14697,
    "maxim": 14776,
    "percent_asalariat": 5,
    "percent_salari": 2.46,
    "comunitat": "total"
  },
  {
    "centil": 6,
    "numero_total": 135143,
    "sme_total": 14855,
    "numero_home": 59704,
    "sme_home": 14855,
    "numero_dona": 75439,
    "sme_dona": 14855,
    "maxim": 14934,
    "percent_asalariat": 6,
    "percent_salari": 2.97,
    "comunitat": "total"
  },
  {
    "centil": 7,
    "numero_total": 135143,
    "sme_total": 15012,
    "numero_home": 61298,
    "sme_home": 15013,
    "numero_dona": 73845,
    "sme_dona": 15012,
    "maxim": 15091,
    "percent_asalariat": 7,
    "percent_salari": 3.48,
    "comunitat": "total"
  },
  {
    "centil": 8,
    "numero_total": 135143,
    "sme_total": 15169,
    "numero_home": 62255,
    "sme_home": 15169,
    "numero_dona": 72888,
    "sme_dona": 15169,
    "maxim": 15248,
    "percent_asalariat": 8,
    "percent_salari": 4,
    "comunitat": "total"
  },
  {
    "centil": 9,
    "numero_total": 135144,
    "sme_total": 15329,
    "numero_home": 62295,
    "sme_home": 15329,
    "numero_dona": 72849,
    "sme_dona": 15328,
    "maxim": 15407,
    "percent_asalariat": 9,
    "percent_salari": 4.52,
    "comunitat": "total"
  },
  {
    "centil": 10,
    "numero_total": 135143,
    "sme_total": 15486,
    "numero_home": 62803,
    "sme_home": 15486,
    "numero_dona": 72340,
    "sme_dona": 15487,
    "maxim": 15567,
    "percent_asalariat": 10,
    "percent_salari": 5.05,
    "comunitat": "total"
  },
  {
    "centil": 11,
    "numero_total": 135143,
    "sme_total": 15646,
    "numero_home": 63051,
    "sme_home": 15646,
    "numero_dona": 72092,
    "sme_dona": 15646,
    "maxim": 15726,
    "percent_asalariat": 11,
    "percent_salari": 5.59,
    "comunitat": "total"
  },
  {
    "centil": 12,
    "numero_total": 135143,
    "sme_total": 15806,
    "numero_home": 63255,
    "sme_home": 15806,
    "numero_dona": 71888,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 12,
    "percent_salari": 6.13,
    "comunitat": "total"
  },
  {
    "centil": 13,
    "numero_total": 135143,
    "sme_total": 15966,
    "numero_home": 64114,
    "sme_home": 15967,
    "numero_dona": 71029,
    "sme_dona": 15966,
    "maxim": 16046,
    "percent_asalariat": 13,
    "percent_salari": 6.67,
    "comunitat": "total"
  },
  {
    "centil": 14,
    "numero_total": 135143,
    "sme_total": 16126,
    "numero_home": 64982,
    "sme_home": 16126,
    "numero_dona": 70161,
    "sme_dona": 16126,
    "maxim": 16207,
    "percent_asalariat": 14,
    "percent_salari": 7.22,
    "comunitat": "total"
  },
  {
    "centil": 15,
    "numero_total": 135143,
    "sme_total": 16289,
    "numero_home": 65622,
    "sme_home": 16289,
    "numero_dona": 69521,
    "sme_dona": 16289,
    "maxim": 16371,
    "percent_asalariat": 15,
    "percent_salari": 7.78,
    "comunitat": "total"
  },
  {
    "centil": 16,
    "numero_total": 135143,
    "sme_total": 16452,
    "numero_home": 66817,
    "sme_home": 16453,
    "numero_dona": 68326,
    "sme_dona": 16452,
    "maxim": 16533,
    "percent_asalariat": 16,
    "percent_salari": 8.34,
    "comunitat": "total"
  },
  {
    "centil": 17,
    "numero_total": 135144,
    "sme_total": 16610,
    "numero_home": 67398,
    "sme_home": 16610,
    "numero_dona": 67746,
    "sme_dona": 16610,
    "maxim": 16692,
    "percent_asalariat": 17,
    "percent_salari": 8.91,
    "comunitat": "total"
  },
  {
    "centil": 18,
    "numero_total": 135143,
    "sme_total": 16773,
    "numero_home": 67815,
    "sme_home": 16773,
    "numero_dona": 67328,
    "sme_dona": 16773,
    "maxim": 16855,
    "percent_asalariat": 18,
    "percent_salari": 9.49,
    "comunitat": "total"
  },
  {
    "centil": 19,
    "numero_total": 135143,
    "sme_total": 16940,
    "numero_home": 68810,
    "sme_home": 16940,
    "numero_dona": 66333,
    "sme_dona": 16939,
    "maxim": 17023,
    "percent_asalariat": 19,
    "percent_salari": 10.06,
    "comunitat": "total"
  },
  {
    "centil": 20,
    "numero_total": 135143,
    "sme_total": 17109,
    "numero_home": 70215,
    "sme_home": 17109,
    "numero_dona": 64928,
    "sme_dona": 17109,
    "maxim": 17196,
    "percent_asalariat": 20,
    "percent_salari": 10.65,
    "comunitat": "total"
  },
  {
    "centil": 21,
    "numero_total": 135143,
    "sme_total": 17281,
    "numero_home": 71373,
    "sme_home": 17282,
    "numero_dona": 63770,
    "sme_dona": 17281,
    "maxim": 17369,
    "percent_asalariat": 21,
    "percent_salari": 11.24,
    "comunitat": "total"
  },
  {
    "centil": 22,
    "numero_total": 135143,
    "sme_total": 17456,
    "numero_home": 72452,
    "sme_home": 17456,
    "numero_dona": 62691,
    "sme_dona": 17455,
    "maxim": 17543,
    "percent_asalariat": 22,
    "percent_salari": 11.84,
    "comunitat": "total"
  },
  {
    "centil": 23,
    "numero_total": 135143,
    "sme_total": 17631,
    "numero_home": 73750,
    "sme_home": 17631,
    "numero_dona": 61393,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 23,
    "percent_salari": 12.44,
    "comunitat": "total"
  },
  {
    "centil": 24,
    "numero_total": 135143,
    "sme_total": 17804,
    "numero_home": 73017,
    "sme_home": 17805,
    "numero_dona": 62126,
    "sme_dona": 17803,
    "maxim": 17891,
    "percent_asalariat": 24,
    "percent_salari": 13.05,
    "comunitat": "total"
  },
  {
    "centil": 25,
    "numero_total": 135144,
    "sme_total": 17976,
    "numero_home": 74747,
    "sme_home": 17976,
    "numero_dona": 60397,
    "sme_dona": 17976,
    "maxim": 18060,
    "percent_asalariat": 25,
    "percent_salari": 13.66,
    "comunitat": "total"
  },
  {
    "centil": 26,
    "numero_total": 135143,
    "sme_total": 18149,
    "numero_home": 76754,
    "sme_home": 18149,
    "numero_dona": 58389,
    "sme_dona": 18149,
    "maxim": 18239,
    "percent_asalariat": 26,
    "percent_salari": 14.28,
    "comunitat": "total"
  },
  {
    "centil": 27,
    "numero_total": 135143,
    "sme_total": 18328,
    "numero_home": 77696,
    "sme_home": 18328,
    "numero_dona": 57447,
    "sme_dona": 18327,
    "maxim": 18417,
    "percent_asalariat": 27,
    "percent_salari": 14.91,
    "comunitat": "total"
  },
  {
    "centil": 28,
    "numero_total": 135143,
    "sme_total": 18506,
    "numero_home": 78408,
    "sme_home": 18506,
    "numero_dona": 56735,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 28,
    "percent_salari": 15.54,
    "comunitat": "total"
  },
  {
    "centil": 29,
    "numero_total": 135143,
    "sme_total": 18686,
    "numero_home": 79050,
    "sme_home": 18686,
    "numero_dona": 56093,
    "sme_dona": 18686,
    "maxim": 18778,
    "percent_asalariat": 29,
    "percent_salari": 16.18,
    "comunitat": "total"
  },
  {
    "centil": 30,
    "numero_total": 135143,
    "sme_total": 18866,
    "numero_home": 80710,
    "sme_home": 18867,
    "numero_dona": 54433,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 30,
    "percent_salari": 16.83,
    "comunitat": "total"
  },
  {
    "centil": 31,
    "numero_total": 135143,
    "sme_total": 19043,
    "numero_home": 80706,
    "sme_home": 19043,
    "numero_dona": 54437,
    "sme_dona": 19042,
    "maxim": 19133,
    "percent_asalariat": 31,
    "percent_salari": 17.48,
    "comunitat": "total"
  },
  {
    "centil": 32,
    "numero_total": 135143,
    "sme_total": 19224,
    "numero_home": 81722,
    "sme_home": 19224,
    "numero_dona": 53421,
    "sme_dona": 19224,
    "maxim": 19317,
    "percent_asalariat": 32,
    "percent_salari": 18.14,
    "comunitat": "total"
  },
  {
    "centil": 33,
    "numero_total": 135143,
    "sme_total": 19411,
    "numero_home": 81877,
    "sme_home": 19410,
    "numero_dona": 53266,
    "sme_dona": 19411,
    "maxim": 19503,
    "percent_asalariat": 33,
    "percent_salari": 18.8,
    "comunitat": "total"
  },
  {
    "centil": 34,
    "numero_total": 135144,
    "sme_total": 19597,
    "numero_home": 82366,
    "sme_home": 19597,
    "numero_dona": 52778,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 34,
    "percent_salari": 19.47,
    "comunitat": "total"
  },
  {
    "centil": 35,
    "numero_total": 135143,
    "sme_total": 19784,
    "numero_home": 83116,
    "sme_home": 19785,
    "numero_dona": 52027,
    "sme_dona": 19784,
    "maxim": 19879,
    "percent_asalariat": 35,
    "percent_salari": 20.15,
    "comunitat": "total"
  },
  {
    "centil": 36,
    "numero_total": 135143,
    "sme_total": 19974,
    "numero_home": 82633,
    "sme_home": 19974,
    "numero_dona": 52510,
    "sme_dona": 19974,
    "maxim": 20069,
    "percent_asalariat": 36,
    "percent_salari": 20.83,
    "comunitat": "total"
  },
  {
    "centil": 37,
    "numero_total": 135143,
    "sme_total": 20167,
    "numero_home": 83298,
    "sme_home": 20167,
    "numero_dona": 51845,
    "sme_dona": 20166,
    "maxim": 20263,
    "percent_asalariat": 37,
    "percent_salari": 21.52,
    "comunitat": "total"
  },
  {
    "centil": 38,
    "numero_total": 135143,
    "sme_total": 20361,
    "numero_home": 84443,
    "sme_home": 20361,
    "numero_dona": 50700,
    "sme_dona": 20361,
    "maxim": 20459,
    "percent_asalariat": 38,
    "percent_salari": 22.21,
    "comunitat": "total"
  },
  {
    "centil": 39,
    "numero_total": 135143,
    "sme_total": 20556,
    "numero_home": 84931,
    "sme_home": 20556,
    "numero_dona": 50212,
    "sme_dona": 20557,
    "maxim": 20653,
    "percent_asalariat": 39,
    "percent_salari": 22.92,
    "comunitat": "total"
  },
  {
    "centil": 40,
    "numero_total": 135143,
    "sme_total": 20753,
    "numero_home": 83657,
    "sme_home": 20754,
    "numero_dona": 51486,
    "sme_dona": 20753,
    "maxim": 20854,
    "percent_asalariat": 40,
    "percent_salari": 23.63,
    "comunitat": "total"
  },
  {
    "centil": 41,
    "numero_total": 135143,
    "sme_total": 20955,
    "numero_home": 83768,
    "sme_home": 20955,
    "numero_dona": 51375,
    "sme_dona": 20956,
    "maxim": 21055,
    "percent_asalariat": 41,
    "percent_salari": 24.34,
    "comunitat": "total"
  },
  {
    "centil": 42,
    "numero_total": 135144,
    "sme_total": 21161,
    "numero_home": 84057,
    "sme_home": 21160,
    "numero_dona": 51087,
    "sme_dona": 21161,
    "maxim": 21267,
    "percent_asalariat": 42,
    "percent_salari": 25.07,
    "comunitat": "total"
  },
  {
    "centil": 43,
    "numero_total": 135143,
    "sme_total": 21375,
    "numero_home": 83840,
    "sme_home": 21375,
    "numero_dona": 51303,
    "sme_dona": 21375,
    "maxim": 21483,
    "percent_asalariat": 43,
    "percent_salari": 25.8,
    "comunitat": "total"
  },
  {
    "centil": 44,
    "numero_total": 135143,
    "sme_total": 21591,
    "numero_home": 82825,
    "sme_home": 21591,
    "numero_dona": 52318,
    "sme_dona": 21592,
    "maxim": 21701,
    "percent_asalariat": 44,
    "percent_salari": 26.54,
    "comunitat": "total"
  },
  {
    "centil": 45,
    "numero_total": 135143,
    "sme_total": 21814,
    "numero_home": 83205,
    "sme_home": 21814,
    "numero_dona": 51938,
    "sme_dona": 21814,
    "maxim": 21927,
    "percent_asalariat": 45,
    "percent_salari": 27.28,
    "comunitat": "total"
  },
  {
    "centil": 46,
    "numero_total": 135143,
    "sme_total": 22037,
    "numero_home": 82571,
    "sme_home": 22037,
    "numero_dona": 52572,
    "sme_dona": 22037,
    "maxim": 22151,
    "percent_asalariat": 46,
    "percent_salari": 28.04,
    "comunitat": "total"
  },
  {
    "centil": 47,
    "numero_total": 135143,
    "sme_total": 22265,
    "numero_home": 82650,
    "sme_home": 22265,
    "numero_dona": 52493,
    "sme_dona": 22265,
    "maxim": 22380,
    "percent_asalariat": 47,
    "percent_salari": 28.8,
    "comunitat": "total"
  },
  {
    "centil": 48,
    "numero_total": 135143,
    "sme_total": 22498,
    "numero_home": 81911,
    "sme_home": 22497,
    "numero_dona": 53232,
    "sme_dona": 22499,
    "maxim": 22616,
    "percent_asalariat": 48,
    "percent_salari": 29.57,
    "comunitat": "total"
  },
  {
    "centil": 49,
    "numero_total": 135143,
    "sme_total": 22740,
    "numero_home": 82212,
    "sme_home": 22740,
    "numero_dona": 52931,
    "sme_dona": 22741,
    "maxim": 22865,
    "percent_asalariat": 49,
    "percent_salari": 30.34,
    "comunitat": "total"
  },
  {
    "centil": 50,
    "numero_total": 135144,
    "sme_total": 22990,
    "numero_home": 82234,
    "sme_home": 22990,
    "numero_dona": 52910,
    "sme_dona": 22990,
    "maxim": 23114,
    "percent_asalariat": 50,
    "percent_salari": 31.13,
    "comunitat": "total"
  },
  {
    "centil": 51,
    "numero_total": 135143,
    "sme_total": 23245,
    "numero_home": 81299,
    "sme_home": 23245,
    "numero_dona": 53844,
    "sme_dona": 23245,
    "maxim": 23377,
    "percent_asalariat": 51,
    "percent_salari": 31.92,
    "comunitat": "total"
  },
  {
    "centil": 52,
    "numero_total": 135143,
    "sme_total": 23510,
    "numero_home": 80949,
    "sme_home": 23510,
    "numero_dona": 54194,
    "sme_dona": 23511,
    "maxim": 23645,
    "percent_asalariat": 52,
    "percent_salari": 32.73,
    "comunitat": "total"
  },
  {
    "centil": 53,
    "numero_total": 135143,
    "sme_total": 23784,
    "numero_home": 81087,
    "sme_home": 23784,
    "numero_dona": 54056,
    "sme_dona": 23784,
    "maxim": 23925,
    "percent_asalariat": 53,
    "percent_salari": 33.54,
    "comunitat": "total"
  },
  {
    "centil": 54,
    "numero_total": 135143,
    "sme_total": 24056,
    "numero_home": 80703,
    "sme_home": 24055,
    "numero_dona": 54440,
    "sme_dona": 24057,
    "maxim": 24198,
    "percent_asalariat": 54,
    "percent_salari": 34.36,
    "comunitat": "total"
  },
  {
    "centil": 55,
    "numero_total": 135143,
    "sme_total": 24349,
    "numero_home": 79547,
    "sme_home": 24348,
    "numero_dona": 55596,
    "sme_dona": 24350,
    "maxim": 24501,
    "percent_asalariat": 55,
    "percent_salari": 35.2,
    "comunitat": "total"
  },
  {
    "centil": 56,
    "numero_total": 135143,
    "sme_total": 24655,
    "numero_home": 79084,
    "sme_home": 24654,
    "numero_dona": 56059,
    "sme_dona": 24656,
    "maxim": 24811,
    "percent_asalariat": 56,
    "percent_salari": 36.04,
    "comunitat": "total"
  },
  {
    "centil": 57,
    "numero_total": 135143,
    "sme_total": 24967,
    "numero_home": 78855,
    "sme_home": 24966,
    "numero_dona": 56288,
    "sme_dona": 24968,
    "maxim": 25122,
    "percent_asalariat": 57,
    "percent_salari": 36.89,
    "comunitat": "total"
  },
  {
    "centil": 58,
    "numero_total": 135143,
    "sme_total": 25285,
    "numero_home": 78363,
    "sme_home": 25285,
    "numero_dona": 56780,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 58,
    "percent_salari": 37.76,
    "comunitat": "total"
  },
  {
    "centil": 59,
    "numero_total": 135144,
    "sme_total": 25620,
    "numero_home": 78294,
    "sme_home": 25620,
    "numero_dona": 56850,
    "sme_dona": 25619,
    "maxim": 25792,
    "percent_asalariat": 59,
    "percent_salari": 38.63,
    "comunitat": "total"
  },
  {
    "centil": 60,
    "numero_total": 135143,
    "sme_total": 25964,
    "numero_home": 78720,
    "sme_home": 25964,
    "numero_dona": 56423,
    "sme_dona": 25964,
    "maxim": 26139,
    "percent_asalariat": 60,
    "percent_salari": 39.52,
    "comunitat": "total"
  },
  {
    "centil": 61,
    "numero_total": 135143,
    "sme_total": 26324,
    "numero_home": 78291,
    "sme_home": 26324,
    "numero_dona": 56852,
    "sme_dona": 26324,
    "maxim": 26509,
    "percent_asalariat": 61,
    "percent_salari": 40.42,
    "comunitat": "total"
  },
  {
    "centil": 62,
    "numero_total": 135143,
    "sme_total": 26697,
    "numero_home": 77891,
    "sme_home": 26696,
    "numero_dona": 57252,
    "sme_dona": 26698,
    "maxim": 26874,
    "percent_asalariat": 62,
    "percent_salari": 41.33,
    "comunitat": "total"
  },
  {
    "centil": 63,
    "numero_total": 135143,
    "sme_total": 27043,
    "numero_home": 75824,
    "sme_home": 27044,
    "numero_dona": 59319,
    "sme_dona": 27043,
    "maxim": 27221,
    "percent_asalariat": 63,
    "percent_salari": 42.26,
    "comunitat": "total"
  },
  {
    "centil": 64,
    "numero_total": 135143,
    "sme_total": 27416,
    "numero_home": 77759,
    "sme_home": 27416,
    "numero_dona": 57384,
    "sme_dona": 27415,
    "maxim": 27616,
    "percent_asalariat": 64,
    "percent_salari": 43.2,
    "comunitat": "total"
  },
  {
    "centil": 65,
    "numero_total": 135143,
    "sme_total": 27824,
    "numero_home": 78867,
    "sme_home": 27824,
    "numero_dona": 56276,
    "sme_dona": 27824,
    "maxim": 28031,
    "percent_asalariat": 65,
    "percent_salari": 44.15,
    "comunitat": "total"
  },
  {
    "centil": 66,
    "numero_total": 135143,
    "sme_total": 28250,
    "numero_home": 77747,
    "sme_home": 28250,
    "numero_dona": 57396,
    "sme_dona": 28250,
    "maxim": 28476,
    "percent_asalariat": 66,
    "percent_salari": 45.11,
    "comunitat": "total"
  },
  {
    "centil": 67,
    "numero_total": 135144,
    "sme_total": 28711,
    "numero_home": 78856,
    "sme_home": 28711,
    "numero_dona": 56288,
    "sme_dona": 28711,
    "maxim": 28951,
    "percent_asalariat": 67,
    "percent_salari": 46.09,
    "comunitat": "total"
  },
  {
    "centil": 68,
    "numero_total": 135143,
    "sme_total": 29198,
    "numero_home": 79147,
    "sme_home": 29198,
    "numero_dona": 55996,
    "sme_dona": 29199,
    "maxim": 29450,
    "percent_asalariat": 68,
    "percent_salari": 47.09,
    "comunitat": "total"
  },
  {
    "centil": 69,
    "numero_total": 135143,
    "sme_total": 29706,
    "numero_home": 78870,
    "sme_home": 29706,
    "numero_dona": 56273,
    "sme_dona": 29707,
    "maxim": 29970,
    "percent_asalariat": 69,
    "percent_salari": 48.11,
    "comunitat": "total"
  },
  {
    "centil": 70,
    "numero_total": 135143,
    "sme_total": 30216,
    "numero_home": 78279,
    "sme_home": 30216,
    "numero_dona": 56864,
    "sme_dona": 30216,
    "maxim": 30487,
    "percent_asalariat": 70,
    "percent_salari": 49.14,
    "comunitat": "total"
  },
  {
    "centil": 71,
    "numero_total": 135143,
    "sme_total": 30762,
    "numero_home": 77246,
    "sme_home": 30762,
    "numero_dona": 57897,
    "sme_dona": 30763,
    "maxim": 31037,
    "percent_asalariat": 71,
    "percent_salari": 50.19,
    "comunitat": "total"
  },
  {
    "centil": 72,
    "numero_total": 135143,
    "sme_total": 31319,
    "numero_home": 76735,
    "sme_home": 31320,
    "numero_dona": 58408,
    "sme_dona": 31319,
    "maxim": 31602,
    "percent_asalariat": 72,
    "percent_salari": 51.26,
    "comunitat": "total"
  },
  {
    "centil": 73,
    "numero_total": 135143,
    "sme_total": 31890,
    "numero_home": 74974,
    "sme_home": 31889,
    "numero_dona": 60169,
    "sme_dona": 31891,
    "maxim": 32176,
    "percent_asalariat": 73,
    "percent_salari": 52.36,
    "comunitat": "total"
  },
  {
    "centil": 74,
    "numero_total": 135143,
    "sme_total": 32477,
    "numero_home": 74517,
    "sme_home": 32476,
    "numero_dona": 60626,
    "sme_dona": 32477,
    "maxim": 32786,
    "percent_asalariat": 74,
    "percent_salari": 53.47,
    "comunitat": "total"
  },
  {
    "centil": 75,
    "numero_total": 135144,
    "sme_total": 33097,
    "numero_home": 73450,
    "sme_home": 33097,
    "numero_dona": 61694,
    "sme_dona": 33097,
    "maxim": 33413,
    "percent_asalariat": 75,
    "percent_salari": 54.6,
    "comunitat": "total"
  },
  {
    "centil": 76,
    "numero_total": 135143,
    "sme_total": 33737,
    "numero_home": 72323,
    "sme_home": 33735,
    "numero_dona": 62820,
    "sme_dona": 33738,
    "maxim": 34056,
    "percent_asalariat": 76,
    "percent_salari": 55.75,
    "comunitat": "total"
  },
  {
    "centil": 77,
    "numero_total": 135143,
    "sme_total": 34387,
    "numero_home": 71686,
    "sme_home": 34388,
    "numero_dona": 63457,
    "sme_dona": 34385,
    "maxim": 34722,
    "percent_asalariat": 77,
    "percent_salari": 56.93,
    "comunitat": "total"
  },
  {
    "centil": 78,
    "numero_total": 135143,
    "sme_total": 35054,
    "numero_home": 72830,
    "sme_home": 35053,
    "numero_dona": 62313,
    "sme_dona": 35056,
    "maxim": 35374,
    "percent_asalariat": 78,
    "percent_salari": 58.12,
    "comunitat": "total"
  },
  {
    "centil": 79,
    "numero_total": 135143,
    "sme_total": 35708,
    "numero_home": 71255,
    "sme_home": 35707,
    "numero_dona": 63888,
    "sme_dona": 35709,
    "maxim": 36027,
    "percent_asalariat": 79,
    "percent_salari": 59.35,
    "comunitat": "total"
  },
  {
    "centil": 80,
    "numero_total": 135143,
    "sme_total": 36371,
    "numero_home": 70949,
    "sme_home": 36372,
    "numero_dona": 64194,
    "sme_dona": 36369,
    "maxim": 36730,
    "percent_asalariat": 80,
    "percent_salari": 60.59,
    "comunitat": "total"
  },
  {
    "centil": 81,
    "numero_total": 135143,
    "sme_total": 37108,
    "numero_home": 72473,
    "sme_home": 37108,
    "numero_dona": 62670,
    "sme_dona": 37107,
    "maxim": 37490,
    "percent_asalariat": 81,
    "percent_salari": 61.86,
    "comunitat": "total"
  },
  {
    "centil": 82,
    "numero_total": 135143,
    "sme_total": 37894,
    "numero_home": 72937,
    "sme_home": 37893,
    "numero_dona": 62206,
    "sme_dona": 37896,
    "maxim": 38304,
    "percent_asalariat": 82,
    "percent_salari": 63.15,
    "comunitat": "total"
  },
  {
    "centil": 83,
    "numero_total": 135143,
    "sme_total": 38744,
    "numero_home": 73772,
    "sme_home": 38747,
    "numero_dona": 61371,
    "sme_dona": 38741,
    "maxim": 39197,
    "percent_asalariat": 83,
    "percent_salari": 64.48,
    "comunitat": "total"
  },
  {
    "centil": 84,
    "numero_total": 135144,
    "sme_total": 39672,
    "numero_home": 75314,
    "sme_home": 39672,
    "numero_dona": 59830,
    "sme_dona": 39672,
    "maxim": 40137,
    "percent_asalariat": 84,
    "percent_salari": 65.84,
    "comunitat": "total"
  },
  {
    "centil": 85,
    "numero_total": 135143,
    "sme_total": 40643,
    "numero_home": 75433,
    "sme_home": 40646,
    "numero_dona": 59710,
    "sme_dona": 40641,
    "maxim": 41170,
    "percent_asalariat": 85,
    "percent_salari": 67.22,
    "comunitat": "total"
  },
  {
    "centil": 86,
    "numero_total": 135143,
    "sme_total": 41734,
    "numero_home": 76880,
    "sme_home": 41736,
    "numero_dona": 58263,
    "sme_dona": 41732,
    "maxim": 42306,
    "percent_asalariat": 86,
    "percent_salari": 68.65,
    "comunitat": "total"
  },
  {
    "centil": 87,
    "numero_total": 135143,
    "sme_total": 42905,
    "numero_home": 77847,
    "sme_home": 42908,
    "numero_dona": 57296,
    "sme_dona": 42901,
    "maxim": 43519,
    "percent_asalariat": 87,
    "percent_salari": 70.12,
    "comunitat": "total"
  },
  {
    "centil": 88,
    "numero_total": 135143,
    "sme_total": 44178,
    "numero_home": 78315,
    "sme_home": 44177,
    "numero_dona": 56828,
    "sme_dona": 44178,
    "maxim": 44857,
    "percent_asalariat": 88,
    "percent_salari": 71.63,
    "comunitat": "total"
  },
  {
    "centil": 89,
    "numero_total": 135143,
    "sme_total": 45571,
    "numero_home": 80162,
    "sme_home": 45572,
    "numero_dona": 54981,
    "sme_dona": 45569,
    "maxim": 46326,
    "percent_asalariat": 89,
    "percent_salari": 73.19,
    "comunitat": "total"
  },
  {
    "centil": 90,
    "numero_total": 135143,
    "sme_total": 47150,
    "numero_home": 80380,
    "sme_home": 47151,
    "numero_dona": 54763,
    "sme_dona": 47149,
    "maxim": 48005,
    "percent_asalariat": 90,
    "percent_salari": 74.8,
    "comunitat": "total"
  },
  {
    "centil": 91,
    "numero_total": 135143,
    "sme_total": 48928,
    "numero_home": 81016,
    "sme_home": 48932,
    "numero_dona": 54127,
    "sme_dona": 48923,
    "maxim": 49888,
    "percent_asalariat": 91,
    "percent_salari": 76.47,
    "comunitat": "total"
  },
  {
    "centil": 92,
    "numero_total": 135144,
    "sme_total": 50932,
    "numero_home": 82459,
    "sme_home": 50933,
    "numero_dona": 52685,
    "sme_dona": 50930,
    "maxim": 52064,
    "percent_asalariat": 92,
    "percent_salari": 78.21,
    "comunitat": "total"
  },
  {
    "centil": 93,
    "numero_total": 135143,
    "sme_total": 53364,
    "numero_home": 83328,
    "sme_home": 53365,
    "numero_dona": 51815,
    "sme_dona": 53363,
    "maxim": 54742,
    "percent_asalariat": 93,
    "percent_salari": 80.04,
    "comunitat": "total"
  },
  {
    "centil": 94,
    "numero_total": 135143,
    "sme_total": 56293,
    "numero_home": 84025,
    "sme_home": 56289,
    "numero_dona": 51118,
    "sme_dona": 56300,
    "maxim": 57976,
    "percent_asalariat": 94,
    "percent_salari": 81.96,
    "comunitat": "total"
  },
  {
    "centil": 95,
    "numero_total": 135143,
    "sme_total": 59885,
    "numero_home": 84061,
    "sme_home": 59887,
    "numero_dona": 51082,
    "sme_dona": 59882,
    "maxim": 61939,
    "percent_asalariat": 95,
    "percent_salari": 84.01,
    "comunitat": "total"
  },
  {
    "centil": 96,
    "numero_total": 135143,
    "sme_total": 64345,
    "numero_home": 84107,
    "sme_home": 64342,
    "numero_dona": 51036,
    "sme_dona": 64352,
    "maxim": 66966,
    "percent_asalariat": 96,
    "percent_salari": 86.21,
    "comunitat": "total"
  },
  {
    "centil": 97,
    "numero_total": 135143,
    "sme_total": 70193,
    "numero_home": 83412,
    "sme_home": 70186,
    "numero_dona": 51731,
    "sme_dona": 70204,
    "maxim": 73778,
    "percent_asalariat": 97,
    "percent_salari": 88.61,
    "comunitat": "total"
  },
  {
    "centil": 98,
    "numero_total": 135143,
    "sme_total": 78424,
    "numero_home": 84534,
    "sme_home": 78444,
    "numero_dona": 50609,
    "sme_dona": 78390,
    "maxim": 83931,
    "percent_asalariat": 98,
    "percent_salari": 91.29,
    "comunitat": "total"
  },
  {
    "centil": 99,
    "numero_total": 135143,
    "sme_total": 92395,
    "numero_home": 89067,
    "sme_home": 92541,
    "numero_dona": 46076,
    "sme_dona": 92114,
    "maxim": 104199,
    "percent_asalariat": 99,
    "percent_salari": 94.45,
    "comunitat": "total"
  },
  {
    "centil": 100,
    "numero_total": 135144,
    "sme_total": 162280,
    "numero_home": 101423,
    "sme_home": 165816,
    "numero_dona": 33721,
    "sme_dona": 151644,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "total"
  },
  {
    "centil": 1,
    "numero_total": 14707,
    "sme_total": 14060,
    "numero_home": 6556,
    "sme_home": 14058,
    "numero_dona": 8151,
    "sme_dona": 14061,
    "maxim": 14139,
    "percent_asalariat": 1,
    "percent_salari": 0.52,
    "comunitat": "valencia"
  },
  {
    "centil": 2,
    "numero_total": 15268,
    "sme_total": 14219,
    "numero_home": 6508,
    "sme_home": 14219,
    "numero_dona": 8760,
    "sme_dona": 14219,
    "maxim": 14300,
    "percent_asalariat": 2,
    "percent_salari": 1.06,
    "comunitat": "valencia"
  },
  {
    "centil": 3,
    "numero_total": 15028,
    "sme_total": 14380,
    "numero_home": 6572,
    "sme_home": 14380,
    "numero_dona": 8456,
    "sme_dona": 14379,
    "maxim": 14458,
    "percent_asalariat": 3.1,
    "percent_salari": 1.6,
    "comunitat": "valencia"
  },
  {
    "centil": 4,
    "numero_total": 15394,
    "sme_total": 14538,
    "numero_home": 6573,
    "sme_home": 14537,
    "numero_dona": 8821,
    "sme_dona": 14538,
    "maxim": 14618,
    "percent_asalariat": 4.1,
    "percent_salari": 2.16,
    "comunitat": "valencia"
  },
  {
    "centil": 5,
    "numero_total": 15183,
    "sme_total": 14698,
    "numero_home": 6661,
    "sme_home": 14698,
    "numero_dona": 8522,
    "sme_dona": 14698,
    "maxim": 14776,
    "percent_asalariat": 5.1,
    "percent_salari": 2.72,
    "comunitat": "valencia"
  },
  {
    "centil": 6,
    "numero_total": 15589,
    "sme_total": 14855,
    "numero_home": 6942,
    "sme_home": 14855,
    "numero_dona": 8647,
    "sme_dona": 14855,
    "maxim": 14934,
    "percent_asalariat": 6.2,
    "percent_salari": 3.3,
    "comunitat": "valencia"
  },
  {
    "centil": 7,
    "numero_total": 15531,
    "sme_total": 15014,
    "numero_home": 7017,
    "sme_home": 15014,
    "numero_dona": 8514,
    "sme_dona": 15013,
    "maxim": 15091,
    "percent_asalariat": 7.3,
    "percent_salari": 3.88,
    "comunitat": "valencia"
  },
  {
    "centil": 8,
    "numero_total": 15816,
    "sme_total": 15171,
    "numero_home": 7199,
    "sme_home": 15171,
    "numero_dona": 8617,
    "sme_dona": 15171,
    "maxim": 15248,
    "percent_asalariat": 8.3,
    "percent_salari": 4.48,
    "comunitat": "valencia"
  },
  {
    "centil": 9,
    "numero_total": 15978,
    "sme_total": 15329,
    "numero_home": 7320,
    "sme_home": 15329,
    "numero_dona": 8658,
    "sme_dona": 15328,
    "maxim": 15407,
    "percent_asalariat": 9.4,
    "percent_salari": 5.09,
    "comunitat": "valencia"
  },
  {
    "centil": 10,
    "numero_total": 16048,
    "sme_total": 15486,
    "numero_home": 7409,
    "sme_home": 15486,
    "numero_dona": 8639,
    "sme_dona": 15486,
    "maxim": 15567,
    "percent_asalariat": 10.5,
    "percent_salari": 5.72,
    "comunitat": "valencia"
  },
  {
    "centil": 11,
    "numero_total": 15787,
    "sme_total": 15647,
    "numero_home": 7334,
    "sme_home": 15647,
    "numero_dona": 8453,
    "sme_dona": 15647,
    "maxim": 15726,
    "percent_asalariat": 11.6,
    "percent_salari": 6.33,
    "comunitat": "valencia"
  },
  {
    "centil": 12,
    "numero_total": 15245,
    "sme_total": 15805,
    "numero_home": 7221,
    "sme_home": 15805,
    "numero_dona": 8024,
    "sme_dona": 15806,
    "maxim": 15885,
    "percent_asalariat": 12.6,
    "percent_salari": 6.94,
    "comunitat": "valencia"
  },
  {
    "centil": 13,
    "numero_total": 15601,
    "sme_total": 15967,
    "numero_home": 7352,
    "sme_home": 15967,
    "numero_dona": 8249,
    "sme_dona": 15967,
    "maxim": 16046,
    "percent_asalariat": 13.7,
    "percent_salari": 7.56,
    "comunitat": "valencia"
  },
  {
    "centil": 14,
    "numero_total": 15938,
    "sme_total": 16127,
    "numero_home": 7832,
    "sme_home": 16128,
    "numero_dona": 8106,
    "sme_dona": 16127,
    "maxim": 16207,
    "percent_asalariat": 14.8,
    "percent_salari": 8.2,
    "comunitat": "valencia"
  },
  {
    "centil": 15,
    "numero_total": 16425,
    "sme_total": 16289,
    "numero_home": 7980,
    "sme_home": 16289,
    "numero_dona": 8445,
    "sme_dona": 16290,
    "maxim": 16371,
    "percent_asalariat": 15.9,
    "percent_salari": 8.87,
    "comunitat": "valencia"
  },
  {
    "centil": 16,
    "numero_total": 16949,
    "sme_total": 16454,
    "numero_home": 8458,
    "sme_home": 16454,
    "numero_dona": 8491,
    "sme_dona": 16453,
    "maxim": 16533,
    "percent_asalariat": 17,
    "percent_salari": 9.57,
    "comunitat": "valencia"
  },
  {
    "centil": 17,
    "numero_total": 17453,
    "sme_total": 16611,
    "numero_home": 8744,
    "sme_home": 16610,
    "numero_dona": 8709,
    "sme_dona": 16612,
    "maxim": 16692,
    "percent_asalariat": 18.2,
    "percent_salari": 10.3,
    "comunitat": "valencia"
  },
  {
    "centil": 18,
    "numero_total": 17214,
    "sme_total": 16772,
    "numero_home": 8794,
    "sme_home": 16772,
    "numero_dona": 8420,
    "sme_dona": 16772,
    "maxim": 16855,
    "percent_asalariat": 19.4,
    "percent_salari": 11.02,
    "comunitat": "valencia"
  },
  {
    "centil": 19,
    "numero_total": 18086,
    "sme_total": 16940,
    "numero_home": 9338,
    "sme_home": 16941,
    "numero_dona": 8748,
    "sme_dona": 16939,
    "maxim": 17023,
    "percent_asalariat": 20.6,
    "percent_salari": 11.78,
    "comunitat": "valencia"
  },
  {
    "centil": 20,
    "numero_total": 17893,
    "sme_total": 17109,
    "numero_home": 9559,
    "sme_home": 17108,
    "numero_dona": 8334,
    "sme_dona": 17109,
    "maxim": 17196,
    "percent_asalariat": 21.8,
    "percent_salari": 12.55,
    "comunitat": "valencia"
  },
  {
    "centil": 21,
    "numero_total": 16717,
    "sme_total": 17281,
    "numero_home": 9107,
    "sme_home": 17281,
    "numero_dona": 7610,
    "sme_dona": 17280,
    "maxim": 17369,
    "percent_asalariat": 23,
    "percent_salari": 13.27,
    "comunitat": "valencia"
  },
  {
    "centil": 22,
    "numero_total": 17406,
    "sme_total": 17453,
    "numero_home": 9688,
    "sme_home": 17454,
    "numero_dona": 7718,
    "sme_dona": 17453,
    "maxim": 17543,
    "percent_asalariat": 24.2,
    "percent_salari": 14.03,
    "comunitat": "valencia"
  },
  {
    "centil": 23,
    "numero_total": 16542,
    "sme_total": 17631,
    "numero_home": 9443,
    "sme_home": 17631,
    "numero_dona": 7099,
    "sme_dona": 17631,
    "maxim": 17718,
    "percent_asalariat": 25.3,
    "percent_salari": 14.76,
    "comunitat": "valencia"
  },
  {
    "centil": 24,
    "numero_total": 16747,
    "sme_total": 17804,
    "numero_home": 9153,
    "sme_home": 17804,
    "numero_dona": 7594,
    "sme_dona": 17804,
    "maxim": 17891,
    "percent_asalariat": 26.4,
    "percent_salari": 15.51,
    "comunitat": "valencia"
  },
  {
    "centil": 25,
    "numero_total": 16523,
    "sme_total": 17976,
    "numero_home": 9067,
    "sme_home": 17976,
    "numero_dona": 7456,
    "sme_dona": 17975,
    "maxim": 18060,
    "percent_asalariat": 27.5,
    "percent_salari": 16.25,
    "comunitat": "valencia"
  },
  {
    "centil": 26,
    "numero_total": 16429,
    "sme_total": 18147,
    "numero_home": 9292,
    "sme_home": 18148,
    "numero_dona": 7137,
    "sme_dona": 18146,
    "maxim": 18239,
    "percent_asalariat": 28.7,
    "percent_salari": 17,
    "comunitat": "valencia"
  },
  {
    "centil": 27,
    "numero_total": 16073,
    "sme_total": 18328,
    "numero_home": 9317,
    "sme_home": 18329,
    "numero_dona": 6756,
    "sme_dona": 18326,
    "maxim": 18417,
    "percent_asalariat": 29.8,
    "percent_salari": 17.73,
    "comunitat": "valencia"
  },
  {
    "centil": 28,
    "numero_total": 16108,
    "sme_total": 18505,
    "numero_home": 9533,
    "sme_home": 18505,
    "numero_dona": 6575,
    "sme_dona": 18505,
    "maxim": 18596,
    "percent_asalariat": 30.8,
    "percent_salari": 18.48,
    "comunitat": "valencia"
  },
  {
    "centil": 29,
    "numero_total": 15869,
    "sme_total": 18688,
    "numero_home": 9590,
    "sme_home": 18689,
    "numero_dona": 6279,
    "sme_dona": 18687,
    "maxim": 18778,
    "percent_asalariat": 31.9,
    "percent_salari": 19.22,
    "comunitat": "valencia"
  },
  {
    "centil": 30,
    "numero_total": 15902,
    "sme_total": 18866,
    "numero_home": 9796,
    "sme_home": 18867,
    "numero_dona": 6106,
    "sme_dona": 18865,
    "maxim": 18953,
    "percent_asalariat": 33,
    "percent_salari": 19.97,
    "comunitat": "valencia"
  },
  {
    "centil": 31,
    "numero_total": 16289,
    "sme_total": 19042,
    "numero_home": 10268,
    "sme_home": 19041,
    "numero_dona": 6021,
    "sme_dona": 19043,
    "maxim": 19133,
    "percent_asalariat": 34.1,
    "percent_salari": 20.75,
    "comunitat": "valencia"
  },
  {
    "centil": 32,
    "numero_total": 16394,
    "sme_total": 19225,
    "numero_home": 10203,
    "sme_home": 19225,
    "numero_dona": 6191,
    "sme_dona": 19225,
    "maxim": 19317,
    "percent_asalariat": 35.2,
    "percent_salari": 21.54,
    "comunitat": "valencia"
  },
  {
    "centil": 33,
    "numero_total": 16519,
    "sme_total": 19411,
    "numero_home": 10498,
    "sme_home": 19411,
    "numero_dona": 6021,
    "sme_dona": 19410,
    "maxim": 19503,
    "percent_asalariat": 36.4,
    "percent_salari": 22.34,
    "comunitat": "valencia"
  },
  {
    "centil": 34,
    "numero_total": 16945,
    "sme_total": 19598,
    "numero_home": 10831,
    "sme_home": 19598,
    "numero_dona": 6114,
    "sme_dona": 19597,
    "maxim": 19691,
    "percent_asalariat": 37.5,
    "percent_salari": 23.17,
    "comunitat": "valencia"
  },
  {
    "centil": 35,
    "numero_total": 17112,
    "sme_total": 19784,
    "numero_home": 11367,
    "sme_home": 19784,
    "numero_dona": 5745,
    "sme_dona": 19785,
    "maxim": 19879,
    "percent_asalariat": 38.7,
    "percent_salari": 24.02,
    "comunitat": "valencia"
  },
  {
    "centil": 36,
    "numero_total": 16749,
    "sme_total": 19973,
    "numero_home": 10845,
    "sme_home": 19974,
    "numero_dona": 5904,
    "sme_dona": 19973,
    "maxim": 20069,
    "percent_asalariat": 39.8,
    "percent_salari": 24.85,
    "comunitat": "valencia"
  },
  {
    "centil": 37,
    "numero_total": 17241,
    "sme_total": 20168,
    "numero_home": 11511,
    "sme_home": 20168,
    "numero_dona": 5730,
    "sme_dona": 20166,
    "maxim": 20263,
    "percent_asalariat": 41,
    "percent_salari": 25.72,
    "comunitat": "valencia"
  },
  {
    "centil": 38,
    "numero_total": 17123,
    "sme_total": 20361,
    "numero_home": 11479,
    "sme_home": 20361,
    "numero_dona": 5644,
    "sme_dona": 20361,
    "maxim": 20459,
    "percent_asalariat": 42.1,
    "percent_salari": 26.6,
    "comunitat": "valencia"
  },
  {
    "centil": 39,
    "numero_total": 16540,
    "sme_total": 20557,
    "numero_home": 11200,
    "sme_home": 20556,
    "numero_dona": 5340,
    "sme_dona": 20557,
    "maxim": 20653,
    "percent_asalariat": 43.3,
    "percent_salari": 27.45,
    "comunitat": "valencia"
  },
  {
    "centil": 40,
    "numero_total": 17170,
    "sme_total": 20754,
    "numero_home": 11723,
    "sme_home": 20754,
    "numero_dona": 5447,
    "sme_dona": 20753,
    "maxim": 20854,
    "percent_asalariat": 44.4,
    "percent_salari": 28.34,
    "comunitat": "valencia"
  },
  {
    "centil": 41,
    "numero_total": 16531,
    "sme_total": 20956,
    "numero_home": 11205,
    "sme_home": 20955,
    "numero_dona": 5326,
    "sme_dona": 20957,
    "maxim": 21055,
    "percent_asalariat": 45.6,
    "percent_salari": 29.21,
    "comunitat": "valencia"
  },
  {
    "centil": 42,
    "numero_total": 16353,
    "sme_total": 21160,
    "numero_home": 11095,
    "sme_home": 21159,
    "numero_dona": 5258,
    "sme_dona": 21162,
    "maxim": 21267,
    "percent_asalariat": 46.7,
    "percent_salari": 30.07,
    "comunitat": "valencia"
  },
  {
    "centil": 43,
    "numero_total": 16206,
    "sme_total": 21374,
    "numero_home": 10822,
    "sme_home": 21374,
    "numero_dona": 5384,
    "sme_dona": 21374,
    "maxim": 21483,
    "percent_asalariat": 47.8,
    "percent_salari": 30.94,
    "comunitat": "valencia"
  },
  {
    "centil": 44,
    "numero_total": 15854,
    "sme_total": 21592,
    "numero_home": 10458,
    "sme_home": 21592,
    "numero_dona": 5396,
    "sme_dona": 21591,
    "maxim": 21701,
    "percent_asalariat": 48.9,
    "percent_salari": 31.79,
    "comunitat": "valencia"
  },
  {
    "centil": 45,
    "numero_total": 15675,
    "sme_total": 21814,
    "numero_home": 10386,
    "sme_home": 21814,
    "numero_dona": 5289,
    "sme_dona": 21814,
    "maxim": 21927,
    "percent_asalariat": 49.9,
    "percent_salari": 32.65,
    "comunitat": "valencia"
  },
  {
    "centil": 46,
    "numero_total": 15741,
    "sme_total": 22036,
    "numero_home": 10237,
    "sme_home": 22035,
    "numero_dona": 5504,
    "sme_dona": 22039,
    "maxim": 22151,
    "percent_asalariat": 51,
    "percent_salari": 33.52,
    "comunitat": "valencia"
  },
  {
    "centil": 47,
    "numero_total": 14599,
    "sme_total": 22265,
    "numero_home": 9463,
    "sme_home": 22265,
    "numero_dona": 5136,
    "sme_dona": 22265,
    "maxim": 22380,
    "percent_asalariat": 52,
    "percent_salari": 34.33,
    "comunitat": "valencia"
  },
  {
    "centil": 48,
    "numero_total": 14277,
    "sme_total": 22497,
    "numero_home": 9172,
    "sme_home": 22497,
    "numero_dona": 5105,
    "sme_dona": 22499,
    "maxim": 22616,
    "percent_asalariat": 53,
    "percent_salari": 35.13,
    "comunitat": "valencia"
  },
  {
    "centil": 49,
    "numero_total": 14246,
    "sme_total": 22739,
    "numero_home": 9231,
    "sme_home": 22739,
    "numero_dona": 5015,
    "sme_dona": 22739,
    "maxim": 22865,
    "percent_asalariat": 53.9,
    "percent_salari": 35.94,
    "comunitat": "valencia"
  },
  {
    "centil": 50,
    "numero_total": 13829,
    "sme_total": 22988,
    "numero_home": 8933,
    "sme_home": 22988,
    "numero_dona": 4896,
    "sme_dona": 22989,
    "maxim": 23114,
    "percent_asalariat": 54.9,
    "percent_salari": 36.74,
    "comunitat": "valencia"
  },
  {
    "centil": 51,
    "numero_total": 13957,
    "sme_total": 23246,
    "numero_home": 9005,
    "sme_home": 23246,
    "numero_dona": 4952,
    "sme_dona": 23245,
    "maxim": 23377,
    "percent_asalariat": 55.8,
    "percent_salari": 37.55,
    "comunitat": "valencia"
  },
  {
    "centil": 52,
    "numero_total": 14114,
    "sme_total": 23512,
    "numero_home": 8792,
    "sme_home": 23510,
    "numero_dona": 5322,
    "sme_dona": 23513,
    "maxim": 23645,
    "percent_asalariat": 56.8,
    "percent_salari": 38.38,
    "comunitat": "valencia"
  },
  {
    "centil": 53,
    "numero_total": 14063,
    "sme_total": 23786,
    "numero_home": 8689,
    "sme_home": 23784,
    "numero_dona": 5374,
    "sme_dona": 23788,
    "maxim": 23925,
    "percent_asalariat": 57.7,
    "percent_salari": 39.22,
    "comunitat": "valencia"
  },
  {
    "centil": 54,
    "numero_total": 14372,
    "sme_total": 24057,
    "numero_home": 8879,
    "sme_home": 24058,
    "numero_dona": 5493,
    "sme_dona": 24056,
    "maxim": 24198,
    "percent_asalariat": 58.7,
    "percent_salari": 40.08,
    "comunitat": "valencia"
  },
  {
    "centil": 55,
    "numero_total": 14151,
    "sme_total": 24349,
    "numero_home": 8685,
    "sme_home": 24349,
    "numero_dona": 5466,
    "sme_dona": 24350,
    "maxim": 24501,
    "percent_asalariat": 59.7,
    "percent_salari": 40.95,
    "comunitat": "valencia"
  },
  {
    "centil": 56,
    "numero_total": 13912,
    "sme_total": 24653,
    "numero_home": 8513,
    "sme_home": 24653,
    "numero_dona": 5399,
    "sme_dona": 24654,
    "maxim": 24811,
    "percent_asalariat": 60.6,
    "percent_salari": 41.8,
    "comunitat": "valencia"
  },
  {
    "centil": 57,
    "numero_total": 13892,
    "sme_total": 24967,
    "numero_home": 8535,
    "sme_home": 24966,
    "numero_dona": 5357,
    "sme_dona": 24968,
    "maxim": 25122,
    "percent_asalariat": 61.6,
    "percent_salari": 42.67,
    "comunitat": "valencia"
  },
  {
    "centil": 58,
    "numero_total": 13921,
    "sme_total": 25285,
    "numero_home": 8566,
    "sme_home": 25285,
    "numero_dona": 5355,
    "sme_dona": 25285,
    "maxim": 25450,
    "percent_asalariat": 62.5,
    "percent_salari": 43.55,
    "comunitat": "valencia"
  },
  {
    "centil": 59,
    "numero_total": 13699,
    "sme_total": 25618,
    "numero_home": 8408,
    "sme_home": 25618,
    "numero_dona": 5291,
    "sme_dona": 25619,
    "maxim": 25792,
    "percent_asalariat": 63.4,
    "percent_salari": 44.43,
    "comunitat": "valencia"
  },
  {
    "centil": 60,
    "numero_total": 13564,
    "sme_total": 25964,
    "numero_home": 8312,
    "sme_home": 25963,
    "numero_dona": 5252,
    "sme_dona": 25966,
    "maxim": 26139,
    "percent_asalariat": 64.4,
    "percent_salari": 45.31,
    "comunitat": "valencia"
  },
  {
    "centil": 61,
    "numero_total": 13835,
    "sme_total": 26322,
    "numero_home": 8413,
    "sme_home": 26323,
    "numero_dona": 5422,
    "sme_dona": 26322,
    "maxim": 26509,
    "percent_asalariat": 65.3,
    "percent_salari": 46.22,
    "comunitat": "valencia"
  },
  {
    "centil": 62,
    "numero_total": 14410,
    "sme_total": 26699,
    "numero_home": 8562,
    "sme_home": 26699,
    "numero_dona": 5848,
    "sme_dona": 26700,
    "maxim": 26874,
    "percent_asalariat": 66.3,
    "percent_salari": 47.18,
    "comunitat": "valencia"
  },
  {
    "centil": 63,
    "numero_total": 15974,
    "sme_total": 27042,
    "numero_home": 8667,
    "sme_home": 27045,
    "numero_dona": 7307,
    "sme_dona": 27040,
    "maxim": 27221,
    "percent_asalariat": 67.4,
    "percent_salari": 48.27,
    "comunitat": "valencia"
  },
  {
    "centil": 64,
    "numero_total": 14455,
    "sme_total": 27414,
    "numero_home": 8383,
    "sme_home": 27415,
    "numero_dona": 6072,
    "sme_dona": 27414,
    "maxim": 27616,
    "percent_asalariat": 68.4,
    "percent_salari": 49.26,
    "comunitat": "valencia"
  },
  {
    "centil": 65,
    "numero_total": 14261,
    "sme_total": 27824,
    "numero_home": 8449,
    "sme_home": 27824,
    "numero_dona": 5812,
    "sme_dona": 27824,
    "maxim": 28031,
    "percent_asalariat": 69.3,
    "percent_salari": 50.25,
    "comunitat": "valencia"
  },
  {
    "centil": 66,
    "numero_total": 14082,
    "sme_total": 28250,
    "numero_home": 8265,
    "sme_home": 28251,
    "numero_dona": 5817,
    "sme_dona": 28249,
    "maxim": 28476,
    "percent_asalariat": 70.3,
    "percent_salari": 51.24,
    "comunitat": "valencia"
  },
  {
    "centil": 67,
    "numero_total": 14116,
    "sme_total": 28709,
    "numero_home": 8471,
    "sme_home": 28708,
    "numero_dona": 5645,
    "sme_dona": 28710,
    "maxim": 28951,
    "percent_asalariat": 71.2,
    "percent_salari": 52.26,
    "comunitat": "valencia"
  },
  {
    "centil": 68,
    "numero_total": 13914,
    "sme_total": 29196,
    "numero_home": 8454,
    "sme_home": 29195,
    "numero_dona": 5460,
    "sme_dona": 29197,
    "maxim": 29450,
    "percent_asalariat": 72.2,
    "percent_salari": 53.27,
    "comunitat": "valencia"
  },
  {
    "centil": 69,
    "numero_total": 13769,
    "sme_total": 29707,
    "numero_home": 8301,
    "sme_home": 29708,
    "numero_dona": 5468,
    "sme_dona": 29706,
    "maxim": 29970,
    "percent_asalariat": 73.1,
    "percent_salari": 54.3,
    "comunitat": "valencia"
  },
  {
    "centil": 70,
    "numero_total": 13739,
    "sme_total": 30214,
    "numero_home": 8323,
    "sme_home": 30216,
    "numero_dona": 5416,
    "sme_dona": 30211,
    "maxim": 30487,
    "percent_asalariat": 74.1,
    "percent_salari": 55.34,
    "comunitat": "valencia"
  },
  {
    "centil": 71,
    "numero_total": 13734,
    "sme_total": 30764,
    "numero_home": 8148,
    "sme_home": 30761,
    "numero_dona": 5586,
    "sme_dona": 30767,
    "maxim": 31037,
    "percent_asalariat": 75,
    "percent_salari": 56.39,
    "comunitat": "valencia"
  },
  {
    "centil": 72,
    "numero_total": 14292,
    "sme_total": 31328,
    "numero_home": 7966,
    "sme_home": 31324,
    "numero_dona": 6326,
    "sme_dona": 31334,
    "maxim": 31602,
    "percent_asalariat": 76,
    "percent_salari": 57.51,
    "comunitat": "valencia"
  },
  {
    "centil": 73,
    "numero_total": 15169,
    "sme_total": 31898,
    "numero_home": 7973,
    "sme_home": 31893,
    "numero_dona": 7196,
    "sme_dona": 31905,
    "maxim": 32176,
    "percent_asalariat": 77,
    "percent_salari": 58.72,
    "comunitat": "valencia"
  },
  {
    "centil": 74,
    "numero_total": 13565,
    "sme_total": 32481,
    "numero_home": 7591,
    "sme_home": 32480,
    "numero_dona": 5974,
    "sme_dona": 32481,
    "maxim": 32786,
    "percent_asalariat": 77.9,
    "percent_salari": 59.83,
    "comunitat": "valencia"
  },
  {
    "centil": 75,
    "numero_total": 14276,
    "sme_total": 33107,
    "numero_home": 7757,
    "sme_home": 33104,
    "numero_dona": 6519,
    "sme_dona": 33110,
    "maxim": 33413,
    "percent_asalariat": 78.9,
    "percent_salari": 61.01,
    "comunitat": "valencia"
  },
  {
    "centil": 76,
    "numero_total": 14338,
    "sme_total": 33746,
    "numero_home": 7565,
    "sme_home": 33740,
    "numero_dona": 6773,
    "sme_dona": 33754,
    "maxim": 34056,
    "percent_asalariat": 79.9,
    "percent_salari": 62.22,
    "comunitat": "valencia"
  },
  {
    "centil": 77,
    "numero_total": 13734,
    "sme_total": 34389,
    "numero_home": 7347,
    "sme_home": 34388,
    "numero_dona": 6387,
    "sme_dona": 34391,
    "maxim": 34722,
    "percent_asalariat": 80.8,
    "percent_salari": 63.4,
    "comunitat": "valencia"
  },
  {
    "centil": 78,
    "numero_total": 16287,
    "sme_total": 35095,
    "numero_home": 8543,
    "sme_home": 35081,
    "numero_dona": 7744,
    "sme_dona": 35110,
    "maxim": 35374,
    "percent_asalariat": 81.9,
    "percent_salari": 64.83,
    "comunitat": "valencia"
  },
  {
    "centil": 79,
    "numero_total": 15403,
    "sme_total": 35718,
    "numero_home": 8063,
    "sme_home": 35716,
    "numero_dona": 7340,
    "sme_dona": 35721,
    "maxim": 36027,
    "percent_asalariat": 82.9,
    "percent_salari": 66.21,
    "comunitat": "valencia"
  },
  {
    "centil": 80,
    "numero_total": 13901,
    "sme_total": 36372,
    "numero_home": 7427,
    "sme_home": 36374,
    "numero_dona": 6474,
    "sme_dona": 36369,
    "maxim": 36730,
    "percent_asalariat": 83.9,
    "percent_salari": 67.47,
    "comunitat": "valencia"
  },
  {
    "centil": 81,
    "numero_total": 13414,
    "sme_total": 37105,
    "numero_home": 7463,
    "sme_home": 37104,
    "numero_dona": 5951,
    "sme_dona": 37105,
    "maxim": 37490,
    "percent_asalariat": 84.8,
    "percent_salari": 68.72,
    "comunitat": "valencia"
  },
  {
    "centil": 82,
    "numero_total": 12819,
    "sme_total": 37893,
    "numero_home": 7100,
    "sme_home": 37892,
    "numero_dona": 5719,
    "sme_dona": 37895,
    "maxim": 38304,
    "percent_asalariat": 85.7,
    "percent_salari": 69.93,
    "comunitat": "valencia"
  },
  {
    "centil": 83,
    "numero_total": 12901,
    "sme_total": 38744,
    "numero_home": 7141,
    "sme_home": 38745,
    "numero_dona": 5760,
    "sme_dona": 38742,
    "maxim": 39197,
    "percent_asalariat": 86.6,
    "percent_salari": 71.18,
    "comunitat": "valencia"
  },
  {
    "centil": 84,
    "numero_total": 12733,
    "sme_total": 39669,
    "numero_home": 7258,
    "sme_home": 39667,
    "numero_dona": 5475,
    "sme_dona": 39671,
    "maxim": 40137,
    "percent_asalariat": 87.4,
    "percent_salari": 72.45,
    "comunitat": "valencia"
  },
  {
    "centil": 85,
    "numero_total": 12590,
    "sme_total": 40648,
    "numero_home": 7132,
    "sme_home": 40646,
    "numero_dona": 5458,
    "sme_dona": 40651,
    "maxim": 41170,
    "percent_asalariat": 88.3,
    "percent_salari": 73.73,
    "comunitat": "valencia"
  },
  {
    "centil": 86,
    "numero_total": 12633,
    "sme_total": 41733,
    "numero_home": 7277,
    "sme_home": 41736,
    "numero_dona": 5356,
    "sme_dona": 41729,
    "maxim": 42306,
    "percent_asalariat": 89.1,
    "percent_salari": 75.05,
    "comunitat": "valencia"
  },
  {
    "centil": 87,
    "numero_total": 12623,
    "sme_total": 42912,
    "numero_home": 7452,
    "sme_home": 42914,
    "numero_dona": 5171,
    "sme_dona": 42909,
    "maxim": 43519,
    "percent_asalariat": 90,
    "percent_salari": 76.4,
    "comunitat": "valencia"
  },
  {
    "centil": 88,
    "numero_total": 12368,
    "sme_total": 44181,
    "numero_home": 7169,
    "sme_home": 44178,
    "numero_dona": 5199,
    "sme_dona": 44184,
    "maxim": 44857,
    "percent_asalariat": 90.8,
    "percent_salari": 77.77,
    "comunitat": "valencia"
  },
  {
    "centil": 89,
    "numero_total": 12278,
    "sme_total": 45571,
    "numero_home": 7244,
    "sme_home": 45573,
    "numero_dona": 5034,
    "sme_dona": 45569,
    "maxim": 46326,
    "percent_asalariat": 91.7,
    "percent_salari": 79.17,
    "comunitat": "valencia"
  },
  {
    "centil": 90,
    "numero_total": 12342,
    "sme_total": 47143,
    "numero_home": 7439,
    "sme_home": 47149,
    "numero_dona": 4903,
    "sme_dona": 47133,
    "maxim": 48005,
    "percent_asalariat": 92.5,
    "percent_salari": 80.62,
    "comunitat": "valencia"
  },
  {
    "centil": 91,
    "numero_total": 11920,
    "sme_total": 48930,
    "numero_home": 7285,
    "sme_home": 48927,
    "numero_dona": 4635,
    "sme_dona": 48934,
    "maxim": 49888,
    "percent_asalariat": 93.3,
    "percent_salari": 82.08,
    "comunitat": "valencia"
  },
  {
    "centil": 92,
    "numero_total": 11486,
    "sme_total": 50918,
    "numero_home": 7170,
    "sme_home": 50920,
    "numero_dona": 4316,
    "sme_dona": 50914,
    "maxim": 52064,
    "percent_asalariat": 94.1,
    "percent_salari": 83.55,
    "comunitat": "valencia"
  },
  {
    "centil": 93,
    "numero_total": 10992,
    "sme_total": 53371,
    "numero_home": 6926,
    "sme_home": 53366,
    "numero_dona": 4066,
    "sme_dona": 53379,
    "maxim": 54742,
    "percent_asalariat": 94.8,
    "percent_salari": 85.01,
    "comunitat": "valencia"
  },
  {
    "centil": 94,
    "numero_total": 10831,
    "sme_total": 56300,
    "numero_home": 6828,
    "sme_home": 56309,
    "numero_dona": 4003,
    "sme_dona": 56285,
    "maxim": 57976,
    "percent_asalariat": 95.6,
    "percent_salari": 86.54,
    "comunitat": "valencia"
  },
  {
    "centil": 95,
    "numero_total": 11313,
    "sme_total": 59870,
    "numero_home": 7139,
    "sme_home": 59885,
    "numero_dona": 4174,
    "sme_dona": 59845,
    "maxim": 61939,
    "percent_asalariat": 96.4,
    "percent_salari": 88.23,
    "comunitat": "valencia"
  },
  {
    "centil": 96,
    "numero_total": 11024,
    "sme_total": 64349,
    "numero_home": 7014,
    "sme_home": 64347,
    "numero_dona": 4010,
    "sme_dona": 64353,
    "maxim": 66966,
    "percent_asalariat": 97.1,
    "percent_salari": 90.01,
    "comunitat": "valencia"
  },
  {
    "centil": 97,
    "numero_total": 11584,
    "sme_total": 70237,
    "numero_home": 6944,
    "sme_home": 70245,
    "numero_dona": 4640,
    "sme_dona": 70226,
    "maxim": 73778,
    "percent_asalariat": 97.9,
    "percent_salari": 92.04,
    "comunitat": "valencia"
  },
  {
    "centil": 98,
    "numero_total": 11206,
    "sme_total": 78311,
    "numero_home": 7176,
    "sme_home": 78326,
    "numero_dona": 4030,
    "sme_dona": 78284,
    "maxim": 83931,
    "percent_asalariat": 98.7,
    "percent_salari": 94.24,
    "comunitat": "valencia"
  },
  {
    "centil": 99,
    "numero_total": 11228,
    "sme_total": 92173,
    "numero_home": 7728,
    "sme_home": 92378,
    "numero_dona": 3500,
    "sme_dona": 91719,
    "maxim": 104199,
    "percent_asalariat": 99.4,
    "percent_salari": 96.83,
    "comunitat": "valencia"
  },
  {
    "centil": 100,
    "numero_total": 8579,
    "sme_total": 147781,
    "numero_home": 6918,
    "sme_home": 150089,
    "numero_dona": 1661,
    "sme_dona": 138168,
    "maxim": 719762,
    "percent_asalariat": 100,
    "percent_salari": 100,
    "comunitat": "valencia"
  }
]